/*! For license information please see frontegg.production.min.js.LICENSE.txt */ !function(t, e) {
    "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.Frontegg = e() : t.Frontegg = e();
}(window, ()=>(()=>{
        var t = {
            3952: (t, e, a)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.createConditionEvaluator = void 0;
                const n = a(2904), s = a(9475);
                e.createConditionEvaluator = function(t) {
                    const e = (0, s.useSanitizer)(t.condition.op);
                    if (!e) return ()=>!1;
                    const { isSanitized: a, sanitizedValue: i } = e(t.condition.value);
                    if (!a || void 0 === i) return ()=>!1;
                    const o = (0, n.useOperation)(t.condition.op, i);
                    return (e)=>{
                        const a = e[t.condition.attribute];
                        if (void 0 === a || !o) return !1;
                        const { isValid: n } = o(a);
                        return t.condition.negate ? !n : n;
                    };
                };
            },
            9838: function(t, e, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(t, e, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(e, a);
                    s && !("get" in s ? !e.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return e[a];
                        }
                    }), Object.defineProperty(t, n, s);
                } : function(t, e, a, n) {
                    void 0 === n && (n = a), t[n] = e[a];
                }), s = this && this.__exportStar || function(t, e) {
                    for(var a in t)"default" === a || Object.prototype.hasOwnProperty.call(e, a) || n(e, t, a);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), s(a(3952), e), s(a(963), e);
            },
            963: (t, e)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            },
            3998: (t, e, a)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.evaluateFeatureFlag = void 0;
                const n = a(9243);
                e.evaluateFeatureFlag = function(t, e) {
                    if (!t.on) return {
                        treatment: t.offTreatment
                    };
                    const a = function(t, e) {
                        var a;
                        return null === (a = t.rules) || void 0 === a ? void 0 : a.find((t)=>(0, n.createRuleEvaluator)({
                                rule: t
                            })(e) === n.RuleEvaluationResultEnum.Treatable);
                    }(t, e);
                    return a ? {
                        treatment: a.treatment
                    } : {
                        treatment: t.defaultTreatment
                    };
                };
            },
            2152: function(t, e, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(t, e, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(e, a);
                    s && !("get" in s ? !e.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return e[a];
                        }
                    }), Object.defineProperty(t, n, s);
                } : function(t, e, a, n) {
                    void 0 === n && (n = a), t[n] = e[a];
                }), s = this && this.__exportStar || function(t, e) {
                    for(var a in t)"default" === a || Object.prototype.hasOwnProperty.call(e, a) || n(e, t, a);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), s(a(3998), e);
            },
            5875: (t, e, a)=>{
                "use strict";
                e.Me = e.a_ = void 0;
                a(2152), a(3856), a(9243), a(2752);
                var n = a(7254);
                Object.defineProperty(e, "a_", {
                    enumerable: !0,
                    get: function() {
                        return n.evaluateIsEntitledToFeature;
                    }
                }), Object.defineProperty(e, "Me", {
                    enumerable: !0,
                    get: function() {
                        return n.evaluateIsEntitledToPermissions;
                    }
                });
            },
            6849: function(t, e, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(t, e, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(e, a);
                    s && !("get" in s ? !e.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return e[a];
                        }
                    }), Object.defineProperty(t, n, s);
                } : function(t, e, a, n) {
                    void 0 === n && (n = a), t[n] = e[a];
                }), s = this && this.__exportStar || function(t, e) {
                    for(var a in t)"default" === a || Object.prototype.hasOwnProperty.call(e, a) || n(e, t, a);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.BooleanOperationsMapper = void 0;
                const i = a(2752), o = a(6715);
                s(a(6715), e), s(a(4965), e), e.BooleanOperationsMapper = {
                    [i.OperationEnum.Is]: (t)=>(0, o.useIsOperation)(t)
                };
            },
            6715: (t, e)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.useIsOperation = void 0, e.useIsOperation = function(t) {
                    return (e)=>({
                            isValid: e === t.boolean
                        });
                };
            },
            4965: (t, e, a)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.BooleanSanitizersMapper = e.singleBooleanSanitizer = void 0;
                const n = a(2752);
                e.singleBooleanSanitizer = (t)=>{
                    const e = void 0 !== t.boolean && ((t)=>"boolean" == typeof t)(t.boolean) ? {
                        boolean: t.boolean
                    } : void 0;
                    return {
                        isSanitized: !!e,
                        sanitizedValue: e
                    };
                }, e.BooleanSanitizersMapper = {
                    [n.OperationEnum.Is]: e.singleBooleanSanitizer
                };
            },
            2904: (t, e, a)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.useOperation = void 0;
                const n = a(5018), s = a(3922), i = a(3147), o = a(6849), r = {
                    ...n.StringOperationsMapper,
                    ...s.NumericOperationsMapper,
                    ...i.DateOperationsMapper,
                    ...o.BooleanOperationsMapper
                };
                e.useOperation = function(t, e) {
                    const a = r[t];
                    return a ? a(e) : void 0;
                };
            },
            9475: (t, e, a)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.useSanitizer = void 0;
                const n = a(6849), s = a(1016), i = a(6891), o = a(3922), r = {
                    ...s.StringSanitizersMapper,
                    ...o.NumericSanitizersMapper,
                    ...i.DateSanitizersMapper,
                    ...n.BooleanSanitizersMapper
                };
                e.useSanitizer = function(t) {
                    return r[t];
                };
            },
            3147: function(t, e, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(t, e, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(e, a);
                    s && !("get" in s ? !e.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return e[a];
                        }
                    }), Object.defineProperty(t, n, s);
                } : function(t, e, a, n) {
                    void 0 === n && (n = a), t[n] = e[a];
                }), s = this && this.__exportStar || function(t, e) {
                    for(var a in t)"default" === a || Object.prototype.hasOwnProperty.call(e, a) || n(e, t, a);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.DateOperationsMapper = void 0;
                const i = a(2752), o = a(1641);
                s(a(1641), e), s(a(1626), e), e.DateOperationsMapper = {
                    [i.OperationEnum.On]: (t)=>(0, o.useDateOnOperation)(t),
                    [i.OperationEnum.OnOrAfter]: (t)=>(0, o.useDateOnOrAfterOperation)(t),
                    [i.OperationEnum.OnOrBefore]: (t)=>(0, o.useDateOnOrBeforeOperation)(t),
                    [i.OperationEnum.BetweenDate]: (t)=>(0, o.useDateBetweenOperation)(t)
                };
            },
            1641: (t, e)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.useDateBetweenOperation = e.useDateOnOrBeforeOperation = e.useDateOnOrAfterOperation = e.useDateOnOperation = void 0, e.useDateOnOperation = function(t) {
                    return (e)=>({
                            isValid: e.getTime() === t.date.getTime()
                        });
                }, e.useDateOnOrAfterOperation = function(t) {
                    return (e)=>({
                            isValid: e.getTime() >= t.date.getTime()
                        });
                }, e.useDateOnOrBeforeOperation = function(t) {
                    return (e)=>({
                            isValid: e.getTime() <= t.date.getTime()
                        });
                }, e.useDateBetweenOperation = function(t) {
                    return (e)=>({
                            isValid: e.getTime() >= t.start.getTime() && e.getTime() <= t.end.getTime()
                        });
                };
            },
            6891: (t, e, a)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.DateSanitizersMapper = e.sanitizeDateRange = e.sanitizeSingleDate = e.isValidDate = e.sanitizeDateValue = void 0;
                const n = a(2752);
                e.sanitizeDateValue = (t)=>new Date(t), e.isValidDate = (t)=>t instanceof Date && !isNaN(t), e.sanitizeSingleDate = (t)=>{
                    const a = t.date ? (0, e.sanitizeDateValue)(t.date) : void 0, n = a && (0, e.isValidDate)(a) ? {
                        date: a
                    } : void 0;
                    return {
                        isSanitized: !!n,
                        sanitizedValue: n
                    };
                }, e.sanitizeDateRange = (t)=>{
                    const a = t.start ? (0, e.sanitizeDateValue)(t.start) : void 0, n = t.end ? (0, e.sanitizeDateValue)(t.end) : void 0, s = a && n && (0, e.isValidDate)(a) && (0, e.isValidDate)(n) ? {
                        start: a,
                        end: n
                    } : void 0;
                    return {
                        isSanitized: !!s,
                        sanitizedValue: s
                    };
                }, e.DateSanitizersMapper = {
                    [n.OperationEnum.On]: e.sanitizeSingleDate,
                    [n.OperationEnum.OnOrAfter]: e.sanitizeSingleDate,
                    [n.OperationEnum.OnOrBefore]: e.sanitizeSingleDate,
                    [n.OperationEnum.BetweenDate]: e.sanitizeDateRange
                };
            },
            1626: (t, e)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            },
            3922: function(t, e, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(t, e, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(e, a);
                    s && !("get" in s ? !e.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return e[a];
                        }
                    }), Object.defineProperty(t, n, s);
                } : function(t, e, a, n) {
                    void 0 === n && (n = a), t[n] = e[a];
                }), s = this && this.__exportStar || function(t, e) {
                    for(var a in t)"default" === a || Object.prototype.hasOwnProperty.call(e, a) || n(e, t, a);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.NumericOperationsMapper = void 0;
                const i = a(2752), o = a(9194);
                e.NumericOperationsMapper = {
                    [i.OperationEnum.Equal]: (t)=>(0, o.useEqualsOperation)(t),
                    [i.OperationEnum.GreaterThan]: (t)=>(0, o.useGreaterThanOperation)(t),
                    [i.OperationEnum.GreaterThanEqual]: (t)=>(0, o.useGreaterThanEqualOperation)(t),
                    [i.OperationEnum.LesserThan]: (t)=>(0, o.useLesserThanOperation)(t),
                    [i.OperationEnum.LesserThanEqual]: (t)=>(0, o.useLesserThanEqualOperation)(t),
                    [i.OperationEnum.BetweenNumeric]: (t)=>(0, o.useBetweenNumericOperation)(t)
                }, s(a(9194), e), s(a(5168), e), s(a(7695), e);
            },
            9194: (t, e)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.useBetweenNumericOperation = e.useLesserThanEqualOperation = e.useLesserThanOperation = e.useGreaterThanEqualOperation = e.useGreaterThanOperation = e.useEqualsOperation = void 0, e.useEqualsOperation = function(t) {
                    return (e)=>({
                            isValid: e === t.number
                        });
                }, e.useGreaterThanOperation = function(t) {
                    return (e)=>({
                            isValid: e > t.number
                        });
                }, e.useGreaterThanEqualOperation = function(t) {
                    return (e)=>({
                            isValid: e >= t.number
                        });
                }, e.useLesserThanOperation = function(t) {
                    return (e)=>({
                            isValid: e < t.number
                        });
                }, e.useLesserThanEqualOperation = function(t) {
                    return (e)=>({
                            isValid: e <= t.number
                        });
                }, e.useBetweenNumericOperation = function(t) {
                    return (e)=>({
                            isValid: e >= t.start && e <= t.end
                        });
                };
            },
            5168: (t, e, a)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.NumericSanitizersMapper = e.sanitizeNumericRange = e.sanitizeSingleNumber = void 0;
                const n = a(2752), s = (t)=>"number" == typeof t;
                e.sanitizeSingleNumber = (t)=>{
                    const e = void 0 !== t.number && s(t.number) ? {
                        number: t.number
                    } : void 0;
                    return {
                        isSanitized: !!e,
                        sanitizedValue: e
                    };
                }, e.sanitizeNumericRange = (t)=>{
                    const e = void 0 !== t.start && void 0 !== t.end && s(t.start) && s(t.end) ? {
                        start: t.start,
                        end: t.end
                    } : void 0;
                    return {
                        isSanitized: !!e,
                        sanitizedValue: e
                    };
                }, e.NumericSanitizersMapper = {
                    [n.OperationEnum.Equal]: e.sanitizeSingleNumber,
                    [n.OperationEnum.GreaterThan]: e.sanitizeSingleNumber,
                    [n.OperationEnum.GreaterThanEqual]: e.sanitizeSingleNumber,
                    [n.OperationEnum.LesserThan]: e.sanitizeSingleNumber,
                    [n.OperationEnum.LesserThanEqual]: e.sanitizeSingleNumber,
                    [n.OperationEnum.BetweenNumeric]: e.sanitizeNumericRange
                };
            },
            7695: (t, e)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            },
            5018: function(t, e, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(t, e, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(e, a);
                    s && !("get" in s ? !e.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return e[a];
                        }
                    }), Object.defineProperty(t, n, s);
                } : function(t, e, a, n) {
                    void 0 === n && (n = a), t[n] = e[a];
                }), s = this && this.__exportStar || function(t, e) {
                    for(var a in t)"default" === a || Object.prototype.hasOwnProperty.call(e, a) || n(e, t, a);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.StringOperationsMapper = void 0;
                const i = a(2752), o = a(5154);
                s(a(5154), e), s(a(4503), e), e.StringOperationsMapper = {
                    [i.OperationEnum.StartsWith]: (t)=>(0, o.useStartsWithOperation)(t),
                    [i.OperationEnum.EndsWith]: (t)=>(0, o.useEndsWithOperation)(t),
                    [i.OperationEnum.Contains]: (t)=>(0, o.useContainsOperation)(t),
                    [i.OperationEnum.InList]: (t)=>(0, o.useInListOperation)(t),
                    [i.OperationEnum.Matches]: (t)=>(0, o.useMatchesOperation)(t)
                };
            },
            5154: (t, e)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.useMatchesOperation = e.useInListOperation = e.useContainsOperation = e.useEndsWithOperation = e.useStartsWithOperation = void 0, e.useStartsWithOperation = function(t) {
                    return (e)=>({
                            isValid: t.list.some((t)=>e.startsWith(t))
                        });
                }, e.useEndsWithOperation = function(t) {
                    return (e)=>({
                            isValid: t.list.some((t)=>e.endsWith(t))
                        });
                }, e.useContainsOperation = function(t) {
                    return (e)=>({
                            isValid: t.list.some((t)=>e.includes(t))
                        });
                }, e.useInListOperation = function(t) {
                    return (e)=>({
                            isValid: t.list.includes(e)
                        });
                }, e.useMatchesOperation = function(t) {
                    return (e)=>{
                        let a;
                        try {
                            a = new RegExp(t.string);
                        } catch (t) {
                            return {
                                isValid: !1
                            };
                        }
                        return {
                            isValid: a.test(e)
                        };
                    };
                };
            },
            1016: (t, e, a)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.StringSanitizersMapper = e.sanitizeListString = e.sanitizeSingleString = void 0;
                const n = a(2752), s = (t)=>"string" == typeof t;
                e.sanitizeSingleString = (t)=>{
                    const e = void 0 !== t.string && s(t.string) ? {
                        string: t.string
                    } : void 0;
                    return {
                        isSanitized: !!e,
                        sanitizedValue: e
                    };
                }, e.sanitizeListString = (t)=>{
                    const e = void 0 !== t.list && t.list.every((t)=>s(t)) ? {
                        list: t.list
                    } : void 0;
                    return {
                        isSanitized: !!e,
                        sanitizedValue: e
                    };
                }, e.StringSanitizersMapper = {
                    [n.OperationEnum.Matches]: e.sanitizeSingleString,
                    [n.OperationEnum.Contains]: e.sanitizeListString,
                    [n.OperationEnum.StartsWith]: e.sanitizeListString,
                    [n.OperationEnum.EndsWith]: e.sanitizeListString,
                    [n.OperationEnum.InList]: e.sanitizeListString
                };
            },
            4503: (t, e)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            },
            2752: function(t, e, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(t, e, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(e, a);
                    s && !("get" in s ? !e.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return e[a];
                        }
                    }), Object.defineProperty(t, n, s);
                } : function(t, e, a, n) {
                    void 0 === n && (n = a), t[n] = e[a];
                }), s = this && this.__exportStar || function(t, e) {
                    for(var a in t)"default" === a || Object.prototype.hasOwnProperty.call(e, a) || n(e, t, a);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), s(a(7158), e);
            },
            7158: (t, e)=>{
                "use strict";
                var a;
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.OperationEnum = void 0, (a = e.OperationEnum || (e.OperationEnum = {})).InList = "in_list", a.StartsWith = "starts_with", a.EndsWith = "ends_with", a.Contains = "contains", a.Matches = "matches", a.Equal = "equal", a.GreaterThan = "greater_than", a.GreaterThanEqual = "greater_than_equal", a.LesserThan = "lower_than", a.LesserThanEqual = "lower_than_equal", a.BetweenNumeric = "between_numeric", a.Is = "is", a.On = "on", a.BetweenDate = "between_date", a.OnOrAfter = "on_or_after", a.OnOrBefore = "on_or_before";
            },
            3856: function(t, e, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(t, e, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(e, a);
                    s && !("get" in s ? !e.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return e[a];
                        }
                    }), Object.defineProperty(t, n, s);
                } : function(t, e, a, n) {
                    void 0 === n && (n = a), t[n] = e[a];
                }), s = this && this.__exportStar || function(t, e) {
                    for(var a in t)"default" === a || Object.prototype.hasOwnProperty.call(e, a) || n(e, t, a);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), s(a(6334), e);
            },
            6334: (t, e, a)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.evaluatePlan = void 0;
                const n = a(9243);
                e.evaluatePlan = function(t, e) {
                    const a = function(t, e) {
                        var a;
                        return null === (a = t.rules) || void 0 === a ? void 0 : a.find((t)=>(0, n.createRuleEvaluator)({
                                rule: t
                            })(e) === n.RuleEvaluationResultEnum.Treatable);
                    }(t, e);
                    return a ? {
                        treatment: a.treatment
                    } : {
                        treatment: t.defaultTreatment
                    };
                };
            },
            9243: function(t, e, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(t, e, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(e, a);
                    s && !("get" in s ? !e.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return e[a];
                        }
                    }), Object.defineProperty(t, n, s);
                } : function(t, e, a, n) {
                    void 0 === n && (n = a), t[n] = e[a];
                }), s = this && this.__exportStar || function(t, e) {
                    for(var a in t)"default" === a || Object.prototype.hasOwnProperty.call(e, a) || n(e, t, a);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), s(a(5546), e), s(a(4874), e);
            },
            4874: (t, e, a)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.createRuleEvaluator = void 0;
                const n = a(5546), s = a(9838);
                e.createRuleEvaluator = function(t) {
                    return (e)=>t.rule.conditions.every((t)=>(0, s.createConditionEvaluator)({
                                condition: t
                            })(e)) ? n.RuleEvaluationResultEnum.Treatable : n.RuleEvaluationResultEnum.Insufficient;
                };
            },
            5546: (t, e)=>{
                "use strict";
                var a, n;
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.RuleEvaluationResultEnum = e.TreatmentEnum = e.ConditionLogicEnum = void 0, (e.ConditionLogicEnum || (e.ConditionLogicEnum = {})).And = "and", (n = e.TreatmentEnum || (e.TreatmentEnum = {})).True = "true", n.False = "false", (a = e.RuleEvaluationResultEnum || (e.RuleEvaluationResultEnum = {})).Treatable = "treatable", a.Insufficient = "insufficient";
            },
            7254: function(t, e, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(t, e, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(e, a);
                    s && !("get" in s ? !e.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return e[a];
                        }
                    }), Object.defineProperty(t, n, s);
                } : function(t, e, a, n) {
                    void 0 === n && (n = a), t[n] = e[a];
                }), s = this && this.__exportStar || function(t, e) {
                    for(var a in t)"default" === a || Object.prototype.hasOwnProperty.call(e, a) || n(e, t, a);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), s(a(7416), e), s(a(3817), e), s(a(395), e), s(a(6816), e);
            },
            1711: (t, e, a)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.directEntitlementEvalutor = void 0;
                const n = a(395);
                e.directEntitlementEvalutor = function(t, e, a = {}) {
                    const s = e.features[t];
                    let i = !1;
                    return s && null !== s.expireTime && (i = s.expireTime !== n.NO_EXPIRATION_TIME && s.expireTime < Date.now(), !i) ? {
                        isEntitled: !0
                    } : {
                        isEntitled: !1,
                        justification: i ? n.NotEntitledJustification.BUNDLE_EXPIRED : n.NotEntitledJustification.MISSING_FEATURE
                    };
                };
            },
            1343: (t, e, a)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.featureFlagEvaluator = void 0;
                const n = a(395), s = a(2152), i = a(8552), o = a(9243);
                e.featureFlagEvaluator = function(t, e, a = {}) {
                    const r = e.features[t];
                    if (r && r.featureFlag) {
                        const t = (0, i.prepareAttributes)(a), { treatment: e } = (0, s.evaluateFeatureFlag)(r.featureFlag, t);
                        if (e === o.TreatmentEnum.True) return {
                            isEntitled: !0
                        };
                    }
                    return {
                        isEntitled: !1,
                        justification: n.NotEntitledJustification.MISSING_FEATURE
                    };
                };
            },
            2031: (t, e, a)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.getIsEntitledEvaluators = void 0;
                const n = a(1711), s = a(1343), i = a(3155);
                e.getIsEntitledEvaluators = function() {
                    return [
                        n.directEntitlementEvalutor,
                        s.featureFlagEvaluator,
                        i.planTargetingRulesEvalutor
                    ];
                };
            },
            3155: (t, e, a)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.planTargetingRulesEvalutor = void 0;
                const n = a(395), s = a(8552), i = a(9243), o = a(3856);
                e.planTargetingRulesEvalutor = function(t, e, a = {}) {
                    const r = e.features[t];
                    if (r && r.planIds && r.planIds.length > 0) {
                        const t = (0, s.prepareAttributes)(a), n = e.plans;
                        for (const e of r.planIds){
                            const a = n[e];
                            if (a) {
                                const { treatment: e } = (0, o.evaluatePlan)(a, t);
                                if (e === i.TreatmentEnum.True) return {
                                    isEntitled: !0
                                };
                            }
                        }
                    }
                    return {
                        isEntitled: !1,
                        justification: n.NotEntitledJustification.MISSING_FEATURE
                    };
                };
            },
            7416: function(t, e, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(t, e, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(e, a);
                    s && !("get" in s ? !e.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return e[a];
                        }
                    }), Object.defineProperty(t, n, s);
                } : function(t, e, a, n) {
                    void 0 === n && (n = a), t[n] = e[a];
                }), s = this && this.__exportStar || function(t, e) {
                    for(var a in t)"default" === a || Object.prototype.hasOwnProperty.call(e, a) || n(e, t, a);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), s(a(9398), e);
            },
            9398: (t, e, a)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.evaluateIsEntitledToFeature = void 0;
                const n = a(395), s = a(6816), i = a(2031);
                e.evaluateIsEntitledToFeature = function(t, e, a = {}) {
                    if (!e) return {
                        isEntitled: !1,
                        justification: n.NotEntitledJustification.MISSING_FEATURE
                    };
                    const o = [];
                    for (const n of (0, i.getIsEntitledEvaluators)())if (o.push(n(t, e, a)), !(0, s.shouldContinue)(o)) break;
                    return (0, s.getResult)(o);
                };
            },
            3817: function(t, e, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(t, e, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(e, a);
                    s && !("get" in s ? !e.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return e[a];
                        }
                    }), Object.defineProperty(t, n, s);
                } : function(t, e, a, n) {
                    void 0 === n && (n = a), t[n] = e[a];
                }), s = this && this.__exportStar || function(t, e) {
                    for(var a in t)"default" === a || Object.prototype.hasOwnProperty.call(e, a) || n(e, t, a);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), s(a(1474), e);
            },
            1474: (t, e, a)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.evaluateIsEntitledToPermissions = void 0;
                const n = a(9398), s = a(395), i = a(6816), o = a(7943);
                e.evaluateIsEntitledToPermissions = function(t, e, a) {
                    if (!e) return {
                        isEntitled: !1,
                        justification: s.NotEntitledJustification.MISSING_PERMISSION
                    };
                    if (!(0, o.checkPermission)(e.permissions, t)) return {
                        isEntitled: !1,
                        justification: s.NotEntitledJustification.MISSING_PERMISSION
                    };
                    const r = function(t, e) {
                        return Object.keys(e.features).filter((a)=>e.features[a].linkedPermissions.includes(t));
                    }(t, e);
                    if (!r.length) return {
                        isEntitled: !0
                    };
                    const l = [];
                    for (const t of r)if (l.push((0, n.evaluateIsEntitledToFeature)(t, e, a)), !(0, i.shouldContinue)(l)) break;
                    return (0, i.getResult)(l);
                };
            },
            395: (t, e)=>{
                "use strict";
                var a;
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.NO_EXPIRATION_TIME = e.NotEntitledJustification = void 0, (a = e.NotEntitledJustification || (e.NotEntitledJustification = {})).MISSING_FEATURE = "MISSING_FEATURE", a.MISSING_PERMISSION = "MISSING_PERMISSION", a.BUNDLE_EXPIRED = "BUNDLE_EXPIRED", e.NO_EXPIRATION_TIME = -1;
            },
            8552: (t, e, a)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.modifyObjectKeysWithPrefix = e.defaultFronteggAttributesMapper = e.prepareAttributes = void 0;
                const n = a(1857);
                function s(t) {
                    return {
                        email: t.email,
                        emailVerified: t.email_verified,
                        tenantId: t.tenantId,
                        userId: t.id
                    };
                }
                function i(t, e) {
                    return Object.keys(t).reduce((a, n)=>(a[`${e}${n}`] = t[n], a), {});
                }
                e.prepareAttributes = function(t = {}, e) {
                    const { custom: a = {}, jwt: o = {} } = t, r = (0, n.flatten)(o);
                    return {
                        ...a,
                        ...i(e ? e(o) : s(o), "frontegg."),
                        ...i(r, "jwt.")
                    };
                }, e.defaultFronteggAttributesMapper = s, e.modifyObjectKeysWithPrefix = i;
            },
            8843: (t, e, a)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.shouldContinue = e.getResult = void 0;
                const n = a(395);
                e.getResult = function(t) {
                    let e = !1;
                    for (const a of t){
                        if (a.isEntitled) return a;
                        a.justification === n.NotEntitledJustification.BUNDLE_EXPIRED && (e = !0);
                    }
                    return {
                        isEntitled: !1,
                        justification: e ? n.NotEntitledJustification.BUNDLE_EXPIRED : n.NotEntitledJustification.MISSING_FEATURE
                    };
                }, e.shouldContinue = function(t) {
                    return t.every(({ isEntitled: t })=>!t);
                };
            },
            1857: (t, e)=>{
                "use strict";
                function a(t) {
                    return t;
                }
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.flatten = void 0, e.flatten = function(t, e) {
                    const n = (null == (e = e || {}) ? void 0 : e.delimiter) || ".", s = null == e ? void 0 : e.maxDepth, i = (null == e ? void 0 : e.transformKey) || a, o = {};
                    return function t(a, r, l) {
                        l = l || 1, Object.keys(a).forEach(function(c) {
                            const u = a[c], d = (null == e ? void 0 : e.safe) && Array.isArray(u), g = Object.prototype.toString.call(u), p = (h = u) && h.constructor && "function" == typeof h.constructor.isBuffer && h.constructor.isBuffer(h);
                            var h;
                            const y = "[object Object]" === g || "[object Array]" === g, S = r ? r + n + i(c) : i(c);
                            if (!d && !p && y && Object.keys(u).length && (!(null == e ? void 0 : e.maxDepth) || s && l < s)) return t(u, S, l + 1);
                            o[S] = u;
                        });
                    }(t), o;
                };
            },
            6816: function(t, e, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(t, e, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(e, a);
                    s && !("get" in s ? !e.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return e[a];
                        }
                    }), Object.defineProperty(t, n, s);
                } : function(t, e, a, n) {
                    void 0 === n && (n = a), t[n] = e[a];
                }), s = this && this.__exportStar || function(t, e) {
                    for(var a in t)"default" === a || Object.prototype.hasOwnProperty.call(e, a) || n(e, t, a);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), s(a(7943), e), s(a(8552), e), s(a(8843), e);
            },
            7943: (t, e)=>{
                "use strict";
                function a(t) {
                    return new RegExp("^" + t.replace(/\./g, "\\.").replace(/\*/g, ".*") + "$", "gs");
                }
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.createPermissionCheckRegex = e.checkPermission = void 0, e.checkPermission = function(t, e) {
                    return Object.keys(t).some((t)=>a(t).test(e));
                }, e.createPermissionCheckRegex = a;
            },
            2743: (t)=>{
                "use strict";
                var e = function(t) {
                    return function(t) {
                        return !!t && "object" == typeof t;
                    }(t) && !function(t) {
                        var e = Object.prototype.toString.call(t);
                        return "[object RegExp]" === e || "[object Date]" === e || function(t) {
                            return t.$$typeof === a;
                        }(t);
                    }(t);
                }, a = "function" == typeof Symbol && Symbol.for ? Symbol.for("react.element") : 60103;
                function n(t, e) {
                    var a;
                    return !1 !== e.clone && e.isMergeableObject(t) ? r((a = t, Array.isArray(a) ? [] : {}), t, e) : t;
                }
                function s(t, e, a) {
                    return t.concat(e).map(function(t) {
                        return n(t, a);
                    });
                }
                function i(t) {
                    return Object.keys(t).concat(function(t) {
                        return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(t).filter(function(e) {
                            return t.propertyIsEnumerable(e);
                        }) : [];
                    }(t));
                }
                function o(t, e) {
                    try {
                        return e in t;
                    } catch (t) {
                        return !1;
                    }
                }
                function r(t, a, l) {
                    (l = l || {}).arrayMerge = l.arrayMerge || s, l.isMergeableObject = l.isMergeableObject || e, l.cloneUnlessOtherwiseSpecified = n;
                    var c = Array.isArray(a);
                    return c === Array.isArray(t) ? c ? l.arrayMerge(t, a, l) : function(t, e, a) {
                        var s = {};
                        return a.isMergeableObject(t) && i(t).forEach(function(e) {
                            s[e] = n(t[e], a);
                        }), i(e).forEach(function(i) {
                            (function(t, e) {
                                return o(t, e) && !(Object.hasOwnProperty.call(t, e) && Object.propertyIsEnumerable.call(t, e));
                            })(t, i) || (o(t, i) && a.isMergeableObject(e[i]) ? s[i] = (function(t, e) {
                                if (!e.customMerge) return r;
                                var a = e.customMerge(t);
                                return "function" == typeof a ? a : r;
                            })(i, a)(t[i], e[i], a) : s[i] = n(e[i], a));
                        }), s;
                    }(t, a, l) : n(a, l);
                }
                r.all = function(t, e) {
                    if (!Array.isArray(t)) throw new Error("first argument should be an array");
                    return t.reduce(function(t, a) {
                        return r(t, a, e);
                    }, {});
                };
                var l = r;
                t.exports = l;
            },
            8792: (t)=>{
                "use strict";
                t.exports = function t(e, a) {
                    if (e === a) return !0;
                    if (e && a && "object" == typeof e && "object" == typeof a) {
                        if (e.constructor !== a.constructor) return !1;
                        var n, s, i;
                        if (Array.isArray(e)) {
                            if ((n = e.length) != a.length) return !1;
                            for(s = n; 0 != s--;)if (!t(e[s], a[s])) return !1;
                            return !0;
                        }
                        if (e.constructor === RegExp) return e.source === a.source && e.flags === a.flags;
                        if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === a.valueOf();
                        if (e.toString !== Object.prototype.toString) return e.toString() === a.toString();
                        if ((n = (i = Object.keys(e)).length) !== Object.keys(a).length) return !1;
                        for(s = n; 0 != s--;)if (!Object.prototype.hasOwnProperty.call(a, i[s])) return !1;
                        for(s = n; 0 != s--;){
                            var o = i[s];
                            if (!t(e[o], a[o])) return !1;
                        }
                        return !0;
                    }
                    return e != e && a != a;
                };
            },
            5302: (t, e, a)=>{
                const n = a(9537);
                function s(t, e, a) {
                    return "function" == typeof a.join ? a.join(t) : t[0] + e + t[1];
                }
                function i(t, e, a) {
                    return "function" != typeof a.isValid || a.isValid(t, e);
                }
                function o(t) {
                    return n(t) || Array.isArray(t) || "function" == typeof t;
                }
                t.exports = function(t, e, a) {
                    if (n(a) || (a = {
                        default: a
                    }), !o(t)) return void 0 !== a.default ? a.default : t;
                    "number" == typeof e && (e = String(e));
                    const r = Array.isArray(e), l = "string" == typeof e, c = a.separator || ".", u = a.joinChar || ("string" == typeof c ? c : ".");
                    if (!l && !r) return t;
                    if (l && e in t) return i(e, t, a) ? t[e] : a.default;
                    let d = r ? e : function(t, e, a) {
                        return "function" == typeof a.split ? a.split(t) : t.split(e);
                    }(e, c, a), g = d.length, p = 0;
                    do {
                        let e = d[p];
                        for("number" == typeof e && (e = String(e)); e && "\\" === e.slice(-1);)e = s([
                            e.slice(0, -1),
                            d[++p] || ""
                        ], u, a);
                        if (e in t) {
                            if (!i(e, t, a)) return a.default;
                            t = t[e];
                        } else {
                            let n = !1, o = p + 1;
                            for(; o < g;)if (e = s([
                                e,
                                d[o++]
                            ], u, a), n = e in t) {
                                if (!i(e, t, a)) return a.default;
                                t = t[e], p = o - 1;
                                break;
                            }
                            if (!n) return a.default;
                        }
                    }while (++p < g && o(t));
                    return p === g ? t : a.default;
                };
            },
            2685: (t, e, a)=>{
                "use strict";
                var n = a(9537);
                function s(t) {
                    return !0 === n(t) && "[object Object]" === Object.prototype.toString.call(t);
                }
                t.exports = function(t) {
                    var e, a;
                    return !1 !== s(t) && "function" == typeof (e = t.constructor) && !1 !== s(a = e.prototype) && !1 !== a.hasOwnProperty("isPrototypeOf");
                };
            },
            5858: (t)=>{
                "use strict";
                t.exports = function(t) {
                    return "object" == typeof t ? null === t : "function" != typeof t;
                };
            },
            9537: (t)=>{
                "use strict";
                t.exports = function(t) {
                    return null != t && "object" == typeof t && !1 === Array.isArray(t);
                };
            },
            1098: (t, e, a)=>{
                "use strict";
                const { deleteProperty: n } = Reflect, s = a(5858), i = a(2685), o = (t)=>"object" == typeof t && null !== t || "function" == typeof t, r = (t)=>{
                    if (!s(t)) throw new TypeError("Object keys must be strings or symbols");
                    if (((t)=>"__proto__" === t || "constructor" === t || "prototype" === t)(t)) throw new Error(`Cannot set unsafe key: "${t}"`);
                }, l = (t, e)=>e && "function" == typeof e.split ? e.split(t) : "symbol" == typeof t ? [
                        t
                    ] : Array.isArray(t) ? t : ((t, e, a)=>{
                        const n = ((t)=>Array.isArray(t) ? t.flat().map(String).join(",") : t)(e ? ((t, e)=>{
                            if ("string" != typeof t || !e) return t;
                            let a = t + ";";
                            return void 0 !== e.arrays && (a += `arrays=${e.arrays};`), void 0 !== e.separator && (a += `separator=${e.separator};`), void 0 !== e.split && (a += `split=${e.split};`), void 0 !== e.merge && (a += `merge=${e.merge};`), void 0 !== e.preservePaths && (a += `preservePaths=${e.preservePaths};`), a;
                        })(t, e) : t);
                        r(n);
                        const s = u.cache.get(n) || a();
                        return u.cache.set(n, s), s;
                    })(t, e, ()=>((t, e = {})=>{
                            const a = e.separator || ".", n = "/" !== a && e.preservePaths;
                            if ("string" == typeof t && !1 !== n && /\//.test(t)) return [
                                t
                            ];
                            const s = [];
                            let i = "";
                            const o = (t)=>{
                                let e;
                                "" !== t.trim() && Number.isInteger(e = Number(t)) ? s.push(e) : s.push(t);
                            };
                            for(let e = 0; e < t.length; e++){
                                const n = t[e];
                                "\\" !== n ? n !== a ? i += n : (o(i), i = "") : i += t[++e];
                            }
                            return i && o(i), s;
                        })(t, e)), c = (t, e, a, s)=>{
                    if (r(e), void 0 === a) n(t, e);
                    else if (s && s.merge) {
                        const n = "function" === s.merge ? s.merge : Object.assign;
                        n && i(t[e]) && i(a) ? t[e] = n(t[e], a) : t[e] = a;
                    } else t[e] = a;
                    return t;
                }, u = (t, e, a, n)=>{
                    if (!e || !o(t)) return t;
                    const s = l(e, n);
                    let i = t;
                    for(let t = 0; t < s.length; t++){
                        const e = s[t], l = s[t + 1];
                        if (r(e), void 0 === l) {
                            c(i, e, a, n);
                            break;
                        }
                        "number" != typeof l || Array.isArray(i[e]) ? (o(i[e]) || (i[e] = {}), i = i[e]) : i = i[e] = [];
                    }
                    return t;
                };
                u.split = l, u.cache = new Map, u.clear = ()=>{
                    u.cache = new Map;
                }, t.exports = u;
            },
            7048: (t, e, a)=>{
                var n = a(4319).default;
                function s() {
                    "use strict";
                    t.exports = s = function() {
                        return e;
                    }, t.exports.__esModule = !0, t.exports.default = t.exports;
                    var e = {}, a = Object.prototype, i = a.hasOwnProperty, o = Object.defineProperty || function(t, e, a) {
                        t[e] = a.value;
                    }, r = "function" == typeof Symbol ? Symbol : {}, l = r.iterator || "@@iterator", c = r.asyncIterator || "@@asyncIterator", u = r.toStringTag || "@@toStringTag";
                    function d(t, e, a) {
                        return Object.defineProperty(t, e, {
                            value: a,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), t[e];
                    }
                    try {
                        d({}, "");
                    } catch (t) {
                        d = function(t, e, a) {
                            return t[e] = a;
                        };
                    }
                    function g(t, e, a, n) {
                        var s = e && e.prototype instanceof y ? e : y, i = Object.create(s.prototype), r = new k(n || []);
                        return o(i, "_invoke", {
                            value: E(t, a, r)
                        }), i;
                    }
                    function p(t, e, a) {
                        try {
                            return {
                                type: "normal",
                                arg: t.call(e, a)
                            };
                        } catch (t) {
                            return {
                                type: "throw",
                                arg: t
                            };
                        }
                    }
                    e.wrap = g;
                    var h = {};
                    function y() {}
                    function S() {}
                    function v() {}
                    var f = {};
                    d(f, l, function() {
                        return this;
                    });
                    var m = Object.getPrototypeOf, b = m && m(m(_([])));
                    b && b !== a && i.call(b, l) && (f = b);
                    var A = v.prototype = y.prototype = Object.create(f);
                    function w(t) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(e) {
                            d(t, e, function(t) {
                                return this._invoke(e, t);
                            });
                        });
                    }
                    function T(t, e) {
                        function a(s, o, r, l) {
                            var c = p(t[s], t, o);
                            if ("throw" !== c.type) {
                                var u = c.arg, d = u.value;
                                return d && "object" == n(d) && i.call(d, "__await") ? e.resolve(d.__await).then(function(t) {
                                    a("next", t, r, l);
                                }, function(t) {
                                    a("throw", t, r, l);
                                }) : e.resolve(d).then(function(t) {
                                    u.value = t, r(u);
                                }, function(t) {
                                    return a("throw", t, r, l);
                                });
                            }
                            l(c.arg);
                        }
                        var s;
                        o(this, "_invoke", {
                            value: function(t, n) {
                                function i() {
                                    return new e(function(e, s) {
                                        a(t, n, e, s);
                                    });
                                }
                                return s = s ? s.then(i, i) : i();
                            }
                        });
                    }
                    function E(t, e, a) {
                        var n = "suspendedStart";
                        return function(s, i) {
                            if ("executing" === n) throw new Error("Generator is already running");
                            if ("completed" === n) {
                                if ("throw" === s) throw i;
                                return {
                                    value: void 0,
                                    done: !0
                                };
                            }
                            for(a.method = s, a.arg = i;;){
                                var o = a.delegate;
                                if (o) {
                                    var r = I(o, a);
                                    if (r) {
                                        if (r === h) continue;
                                        return r;
                                    }
                                }
                                if ("next" === a.method) a.sent = a._sent = a.arg;
                                else if ("throw" === a.method) {
                                    if ("suspendedStart" === n) throw n = "completed", a.arg;
                                    a.dispatchException(a.arg);
                                } else "return" === a.method && a.abrupt("return", a.arg);
                                n = "executing";
                                var l = p(t, e, a);
                                if ("normal" === l.type) {
                                    if (n = a.done ? "completed" : "suspendedYield", l.arg === h) continue;
                                    return {
                                        value: l.arg,
                                        done: a.done
                                    };
                                }
                                "throw" === l.type && (n = "completed", a.method = "throw", a.arg = l.arg);
                            }
                        };
                    }
                    function I(t, e) {
                        var a = e.method, n = t.iterator[a];
                        if (void 0 === n) return e.delegate = null, "throw" === a && t.iterator.return && (e.method = "return", e.arg = void 0, I(t, e), "throw" === e.method) || "return" !== a && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + a + "' method")), h;
                        var s = p(n, t.iterator, e.arg);
                        if ("throw" === s.type) return e.method = "throw", e.arg = s.arg, e.delegate = null, h;
                        var i = s.arg;
                        return i ? i.done ? (e[t.resultName] = i.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, h) : i : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, h);
                    }
                    function O(t) {
                        var e = {
                            tryLoc: t[0]
                        };
                        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
                    }
                    function P(t) {
                        var e = t.completion || {};
                        e.type = "normal", delete e.arg, t.completion = e;
                    }
                    function k(t) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], t.forEach(O, this), this.reset(!0);
                    }
                    function _(t) {
                        if (t) {
                            var e = t[l];
                            if (e) return e.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var a = -1, n = function e() {
                                    for(; ++a < t.length;)if (i.call(t, a)) return e.value = t[a], e.done = !1, e;
                                    return e.value = void 0, e.done = !0, e;
                                };
                                return n.next = n;
                            }
                        }
                        return {
                            next: R
                        };
                    }
                    function R() {
                        return {
                            value: void 0,
                            done: !0
                        };
                    }
                    return S.prototype = v, o(A, "constructor", {
                        value: v,
                        configurable: !0
                    }), o(v, "constructor", {
                        value: S,
                        configurable: !0
                    }), S.displayName = d(v, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
                        var e = "function" == typeof t && t.constructor;
                        return !!e && (e === S || "GeneratorFunction" === (e.displayName || e.name));
                    }, e.mark = function(t) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(t, v) : (t.__proto__ = v, d(t, u, "GeneratorFunction")), t.prototype = Object.create(A), t;
                    }, e.awrap = function(t) {
                        return {
                            __await: t
                        };
                    }, w(T.prototype), d(T.prototype, c, function() {
                        return this;
                    }), e.AsyncIterator = T, e.async = function(t, a, n, s, i) {
                        void 0 === i && (i = Promise);
                        var o = new T(g(t, a, n, s), i);
                        return e.isGeneratorFunction(a) ? o : o.next().then(function(t) {
                            return t.done ? t.value : o.next();
                        });
                    }, w(A), d(A, u, "Generator"), d(A, l, function() {
                        return this;
                    }), d(A, "toString", function() {
                        return "[object Generator]";
                    }), e.keys = function(t) {
                        var e = Object(t), a = [];
                        for(var n in e)a.push(n);
                        return a.reverse(), function t() {
                            for(; a.length;){
                                var n = a.pop();
                                if (n in e) return t.value = n, t.done = !1, t;
                            }
                            return t.done = !0, t;
                        };
                    }, e.values = _, k.prototype = {
                        constructor: k,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(P), !t) for(var e in this)"t" === e.charAt(0) && i.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
                        },
                        stop: function() {
                            this.done = !0;
                            var t = this.tryEntries[0].completion;
                            if ("throw" === t.type) throw t.arg;
                            return this.rval;
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var e = this;
                            function a(a, n) {
                                return o.type = "throw", o.arg = t, e.next = a, n && (e.method = "next", e.arg = void 0), !!n;
                            }
                            for(var n = this.tryEntries.length - 1; n >= 0; --n){
                                var s = this.tryEntries[n], o = s.completion;
                                if ("root" === s.tryLoc) return a("end");
                                if (s.tryLoc <= this.prev) {
                                    var r = i.call(s, "catchLoc"), l = i.call(s, "finallyLoc");
                                    if (r && l) {
                                        if (this.prev < s.catchLoc) return a(s.catchLoc, !0);
                                        if (this.prev < s.finallyLoc) return a(s.finallyLoc);
                                    } else if (r) {
                                        if (this.prev < s.catchLoc) return a(s.catchLoc, !0);
                                    } else {
                                        if (!l) throw new Error("try statement without catch or finally");
                                        if (this.prev < s.finallyLoc) return a(s.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(t, e) {
                            for(var a = this.tryEntries.length - 1; a >= 0; --a){
                                var n = this.tryEntries[a];
                                if (n.tryLoc <= this.prev && i.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
                                    var s = n;
                                    break;
                                }
                            }
                            s && ("break" === t || "continue" === t) && s.tryLoc <= e && e <= s.finallyLoc && (s = null);
                            var o = s ? s.completion : {};
                            return o.type = t, o.arg = e, s ? (this.method = "next", this.next = s.finallyLoc, h) : this.complete(o);
                        },
                        complete: function(t, e) {
                            if ("throw" === t.type) throw t.arg;
                            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), h;
                        },
                        finish: function(t) {
                            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                                var a = this.tryEntries[e];
                                if (a.finallyLoc === t) return this.complete(a.completion, a.afterLoc), P(a), h;
                            }
                        },
                        catch: function(t) {
                            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                                var a = this.tryEntries[e];
                                if (a.tryLoc === t) {
                                    var n = a.completion;
                                    if ("throw" === n.type) {
                                        var s = n.arg;
                                        P(a);
                                    }
                                    return s;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(t, e, a) {
                            return this.delegate = {
                                iterator: _(t),
                                resultName: e,
                                nextLoc: a
                            }, "next" === this.method && (this.arg = void 0), h;
                        }
                    }, e;
                }
                t.exports = s, t.exports.__esModule = !0, t.exports.default = t.exports;
            },
            4319: (t)=>{
                function e(a) {
                    return t.exports = e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                        return typeof t;
                    } : function(t) {
                        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                    }, t.exports.__esModule = !0, t.exports.default = t.exports, e(a);
                }
                t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
            },
            5799: (t, e, a)=>{
                var n = a(7048)();
                t.exports = n;
                try {
                    regeneratorRuntime = n;
                } catch (t) {
                    "object" == typeof globalThis ? globalThis.regeneratorRuntime = n : Function("r", "regeneratorRuntime = r")(n);
                }
            }
        }, e = {};
        function a(n) {
            var s = e[n];
            if (void 0 !== s) return s.exports;
            var i = e[n] = {
                exports: {}
            };
            return t[n].call(i.exports, i, i.exports, a), i.exports;
        }
        a.n = (t)=>{
            var e = t && t.__esModule ? ()=>t.default : ()=>t;
            return a.d(e, {
                a: e
            }), e;
        }, a.d = (t, e)=>{
            for(var n in e)a.o(e, n) && !a.o(t, n) && Object.defineProperty(t, n, {
                enumerable: !0,
                get: e[n]
            });
        }, a.o = (t, e)=>Object.prototype.hasOwnProperty.call(t, e), a.r = (t)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        };
        var n = {};
        return (()=>{
            "use strict";
            a.r(n), a.d(n, {
                AdminPortal: ()=>ig,
                AdminPortalRenderer: ()=>lg,
                AppHolder: ()=>c,
                CheckoutDialog: ()=>og,
                FronteggApp: ()=>ng,
                HostedLogin: ()=>sg,
                LoginBoxRenderer: ()=>dg,
                createElement: ()=>Yd,
                defaultTheme: ()=>cg,
                formatName: ()=>Jd,
                getOverriddenMetadata: ()=>ag,
                getThemeAdminByName: ()=>rg,
                getThemeByName: ()=>ug,
                initialize: ()=>vg,
                mockFlagsList: ()=>tg,
                restoreSearchParams: ()=>Qd,
                waitThemeSetter: ()=>Xd
            });
            var t = {};
            a.r(t), a.d(t, {
                ApplicationAccessType: ()=>Ka,
                AuthStrategyEnum: ()=>N,
                ContextHolder: ()=>C,
                DirectoryApi: ()=>ra,
                FRONTEGG_SEPARATE_TABS_BY_TENANT: ()=>te,
                FeatureFlags: ()=>Xt,
                FeatureFlagsApi: ()=>Qt,
                FetchClient: ()=>xt,
                FronteggApiError: ()=>V,
                FronteggContext: ()=>U,
                FronteggFrameworks: ()=>Mt,
                GENERIC_ERROR_CODE: ()=>Ut,
                GENERIC_ERROR_MESSAGE: ()=>Lt,
                GetUsersFilterPreset: ()=>Ga,
                GroupManagedByEnum: ()=>Fa,
                GroupRelations: ()=>Ma,
                ISubscriptionCancellationPolicy: ()=>G,
                ISubscriptionStatus: ()=>F,
                InsightCode: ()=>Va,
                LOAD_AUTHORIZATION_FF: ()=>qt,
                MFAStrategyEnum: ()=>Kt,
                MachineToMachineAuthStrategy: ()=>M,
                NotEntitledJustification: ()=>ja,
                PaginationOrderEnum: ()=>Ft,
                PaymentMethodType: ()=>x,
                PermissionAssignmentTypeEnum: ()=>Oa,
                ProviderType: ()=>$,
                RecommendationActionKey: ()=>Wa,
                RecommendationCode: ()=>Ba,
                RecommendationSeverity: ()=>Ha,
                RequestSource: ()=>Nt,
                RestrictionType: ()=>Wt,
                ScimConnectionSource: ()=>Na,
                SecondaryAuthStrategy: ()=>Ht,
                SecurityCategory: ()=>za,
                SocialLoginProviders: ()=>D,
                SortByEnum: ()=>xa,
                SubAccountAccessTypeEnum: ()=>Pa,
                TenantSortByEnum: ()=>Ea,
                TenantType: ()=>Ia,
                UserManagedByEnum: ()=>Ta,
                WebAuthnDeviceType: ()=>zt,
                api: ()=>qa,
                createApiClient: ()=>Ja,
                default: ()=>Ya,
                fetch: ()=>Gt,
                fronteggAuthApiRoutesRegex: ()=>ka,
                fronteggEntitlementsV2Url: ()=>Da,
                fronteggHeaders: ()=>Dt,
                fronteggRefreshTokenUrl: ()=>_a,
                fronteggSilentRefreshTokenUrl: ()=>Ra,
                fronteggTenantsUrl: ()=>La,
                fronteggTenantsV3Url: ()=>Ua,
                fronteggUsersUrl: ()=>Ca,
                getCurrentUserTenantsFunction: ()=>re,
                getTabTenantFromSessionStorage: ()=>oe,
                providersArray: ()=>$a,
                removeTabTenantFromSessionStorage: ()=>ie,
                setTabTenantInSessionStorage: ()=>se
            });
            var e = {};
            a.r(e), a.d(e, {
                ACR_VALUE: ()=>ln,
                AMR_ADDITIONAL_VALUE: ()=>un,
                AMR_MFA_VALUE: ()=>cn,
                AcceptInvitationStep: ()=>tn,
                ActivateAccountStep: ()=>Gn,
                AdminPortalPages: ()=>zn,
                AdminPortalPagesForEvents: ()=>Hn,
                AllAccountsStateKeys: ()=>Mo,
                ApiStateKeys: ()=>Ds,
                AuthStrategyEnum: ()=>N,
                AuthenticationTypes: ()=>Wn,
                DEFAULT_RETRY_CONFIG: ()=>An,
                FRONTEGG_AFTER_AUTH_REDIRECT_URL: ()=>mn,
                ForgotPasswordStep: ()=>Ws,
                FronteggNativeModule: ()=>S,
                GTMEventAction: ()=>Kn,
                GroupRelations: ()=>ai,
                GroupsStateKeys: ()=>ei,
                HOSTED_LOGIN_VERIFIER_KEY: ()=>bn,
                ImpersonateStep: ()=>li,
                LoginActionTypes: ()=>Sn,
                LoginFlow: ()=>hn,
                LoginStep: ()=>pn,
                MFAStep: ()=>qn,
                MachineToMachineAuthStrategy: ()=>M,
                PasswordRotationStep: ()=>Js,
                PaymentMethodType: ()=>tc,
                PaymentProvider: ()=>nc,
                QuickLoginStrategy: ()=>yn,
                REQUEST_NAME: ()=>Bn,
                ResetPhoneNumberStep: ()=>nr,
                RolesStateKeys: ()=>gr,
                SHOULD_STEP_UP_KEY: ()=>dn,
                SSOStateKeys: ()=>ao,
                STEP_UP_MAX_AGE_PARAM_NAME: ()=>gn,
                SamlVendors: ()=>no,
                SecurityCenterStateKeys: ()=>_r,
                SignUpStage: ()=>Kr,
                SubscriptionCancellationPolicy: ()=>ic,
                SubscriptionStatus: ()=>sc,
                TENANT_ID_PARAM_KEY: ()=>es,
                TeamStateKeys: ()=>bs,
                UserVerifiedOriginTypes: ()=>Vn,
                authStrategyLoginStepMap: ()=>vn,
                base64ToFormData: ()=>Ii,
                base64urlDecode: ()=>Ei,
                base64urlEncode: ()=>Ti,
                buildAuditsActions: ()=>zc,
                buildAuthActions: ()=>zl,
                buildConnectivityActions: ()=>Zl,
                buildSubscriptionsActions: ()=>Nc,
                buildVendorActions: ()=>xc,
                createAuditsState: ()=>Hc,
                createAuthState: ()=>Hl,
                createConnectivityState: ()=>ql,
                createFronteggStore: ()=>bd,
                createProxy: ()=>Za,
                createRandomString: ()=>Ki,
                createStore: ()=>Ad,
                createSubscriptionsState: ()=>Dc,
                createVendorState: ()=>Fc,
                deepClone: ()=>_n,
                deepResetState: ()=>Rn,
                defaultFronteggRoutes: ()=>fn,
                delay: ()=>wn,
                errorHandler: ()=>Un,
                errorTraceId: ()=>On,
                extractPhoneNumber: ()=>fs,
                generateCodeChallenge: ()=>zi,
                generateCodeChallengeNative: ()=>Hi,
                generateCodeChallengePureJs: ()=>Wi,
                getBaseNameWithoutSlashSuffix: ()=>rs,
                getEntitlements: ()=>to,
                getFeatureEntitlements: ()=>Zi,
                getMfaStepForEnrolledUsers: ()=>ns,
                getMfaStepForNotEnrolledUsers: ()=>ss,
                getNumberOfMfaDevices: ()=>as,
                getPathAndSearchParamsFromUrl: ()=>Zn,
                getPermissionEntitlements: ()=>Qi,
                getRedirectUrl: ()=>Xn,
                getSearchParam: ()=>ts,
                getSearchParamsFromUrl: ()=>Qn,
                getUri: ()=>vs,
                hmac: ()=>Vi,
                isAbsoluteUrl: ()=>Yn,
                isAuthRoute: ()=>ms,
                isEmailPayload: ()=>os,
                isEntitlementsDeeplyEqual: ()=>eo,
                isError: ()=>Ln,
                isFronteggApiError: ()=>Cn,
                isMfaRequired: ()=>hs,
                isOauthCallbackRoute: ()=>is,
                isProxy: ()=>kn,
                isResetPasswordRequired: ()=>ys,
                isSteppedUp: ()=>cs,
                mapMetaDataObjectToActions: ()=>Ss,
                omitProps: ()=>Pn,
                publicKeyCredentialToJSON: ()=>Oi,
                readFileAsText: ()=>Pi,
                redirectByStepUpUrl: ()=>ds,
                reportGTMEvent: ()=>Jn,
                retry: ()=>Tn,
                retryIfNeeded: ()=>En,
                setAfterAuthRedirectUrlForStepUp: ()=>us,
                sha256: ()=>Bi,
                shouldShowPasswordRotationPromptFunc: ()=>ls,
                snapshot: ()=>k,
                subscribe: ()=>P,
                withRetryConfig: ()=>In
            });
            var s = {};
            function i(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            function o(t) {
                return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, o(t);
            }
            function r(t, e) {
                for(var a = 0; a < e.length; a++){
                    var n = e[a];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, (s = n.key, i = void 0, i = function(t) {
                        if ("object" !== o(t) || null === t) return t;
                        var e = t[Symbol.toPrimitive];
                        if (void 0 !== e) {
                            var a = e.call(t, "string");
                            if ("object" !== o(a)) return a;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    }(s), "symbol" === o(i) ? i : String(i)), n);
                }
                var s, i;
            }
            function l(t, e, a) {
                return e && r(t.prototype, e), a && r(t, a), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), t;
            }
            a.r(s), a.d(s, {
                AccountDetailsPageTabs: ()=>Dd,
                AccountPageFields: ()=>Od,
                DomainRestrictionsTabFields: ()=>Ud,
                GeneralSettingsTabFields: ()=>Cd,
                InviteUserModalFields: ()=>Id,
                IpRestrictionsTabFields: ()=>Ld,
                Metadata: ()=>qd,
                PrivacyPageFields: ()=>Ed,
                ProfilePageFields: ()=>Td,
                SecurityPageTabs: ()=>_d,
                SessionManagementTabFields: ()=>Rd,
                SignupFields: ()=>wd,
                SubscriptionsPageFields: ()=>kd,
                UsersTableColumns: ()=>Pd,
                alpha: ()=>jd,
                fieldAppearance: ()=>Nd,
                tabAppearance: ()=>Md
            });
            var c = function() {
                function t() {
                    i(this, t);
                }
                return l(t, null, [
                    {
                        key: "setInstance",
                        value: function(e, a) {
                            t._apps[e] = a;
                        }
                    },
                    {
                        key: "getInstance",
                        value: function(e) {
                            var a = t._apps[e];
                            if (!a) throw Error("[".concat(e, "] FronteggApp not found"));
                            return a;
                        }
                    }
                ]), t;
            }();
            function u(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for(var a = 0, n = new Array(e); a < e; a++)n[a] = t[a];
                return n;
            }
            function d(t, e) {
                return function(t) {
                    if (Array.isArray(t)) return t;
                }(t) || function(t, e) {
                    var a = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                    if (null != a) {
                        var n, s, i, o, r = [], l = !0, c = !1;
                        try {
                            if (i = (a = a.call(t)).next, 0 === e) {
                                if (Object(a) !== a) return;
                                l = !1;
                            } else for(; !(l = (n = i.call(a)).done) && (r.push(n.value), r.length !== e); l = !0);
                        } catch (t) {
                            c = !0, s = t;
                        } finally{
                            try {
                                if (!l && null != a.return && (o = a.return(), Object(o) !== o)) return;
                            } finally{
                                if (c) throw s;
                            }
                        }
                        return r;
                    }
                }(t, e) || function(t, e) {
                    if (t) {
                        if ("string" == typeof t) return u(t, e);
                        var a = Object.prototype.toString.call(t).slice(8, -1);
                        return "Object" === a && t.constructor && (a = t.constructor.name), "Map" === a || "Set" === a ? Array.from(t) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? u(t, e) : void 0;
                    }
                }(t, e) || function() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function g(t, e, a, n, s, i, o) {
                try {
                    var r = t[i](o), l = r.value;
                } catch (t) {
                    return void a(t);
                }
                r.done ? e(l) : Promise.resolve(l).then(n, s);
            }
            function p(t) {
                return function() {
                    var e = this, a = arguments;
                    return new Promise(function(n, s) {
                        var i = t.apply(e, a);
                        function o(t) {
                            g(i, n, s, o, r, "next", t);
                        }
                        function r(t) {
                            g(i, n, s, o, r, "throw", t);
                        }
                        o(void 0);
                    });
                };
            }
            c._apps = {};
            var h = a(5799), y = a.n(h);
            const S = new class {
                constructor(){
                    this.loginWithSSO = (t)=>{
                        if (this.isIOSNativeBridgeAvailable()) {
                            var e, a, n;
                            null == (e = window.webkit) || null == (a = e.messageHandlers) || null == (n = a.FronteggNativeBridge) || n.postMessage(JSON.stringify({
                                action: "loginWithSSO",
                                payload: t
                            }));
                        } else {
                            if (!this.isAndroidNativeBridgeAvailable()) throw new Error("FronteggNativeBridge is not available");
                            var s;
                            null == (s = window.FronteggNativeBridge) || s.loginWithSSO(t);
                        }
                    }, this.loginWithSocialLogin = (t)=>{
                        if (this.isIOSNativeBridgeAvailable()) {
                            var e, a, n;
                            null == (e = window.webkit) || null == (a = e.messageHandlers) || null == (n = a.FronteggNativeBridge) || n.postMessage(JSON.stringify({
                                action: "loginWithSocialLogin",
                                payload: t
                            }));
                        } else {
                            if (!this.isAndroidNativeBridgeAvailable()) throw new Error("FronteggNativeBridge is not available");
                            var s;
                            null == (s = window.FronteggNativeBridge) || s.loginWithSocialLogin(t);
                        }
                    }, this.loginWithSocialLoginProvider = (t)=>{
                        if (this.isIOSNativeBridgeAvailable()) {
                            var e, a, n;
                            null == (e = window.webkit) || null == (a = e.messageHandlers) || null == (n = a.FronteggNativeBridge) || n.postMessage(JSON.stringify({
                                action: "loginWithSocialLoginProvider",
                                payload: t
                            }));
                        } else {
                            if (!this.isAndroidNativeBridgeAvailable()) throw new Error("FronteggNativeBridge is not available");
                            var s;
                            null == (s = window.FronteggNativeBridge) || s.loginWithSocialLoginProvider(t);
                        }
                    }, this.loginWithCustomSocialLoginProvider = (t)=>{
                        if (this.isIOSNativeBridgeAvailable()) {
                            var e, a, n;
                            null == (e = window.webkit) || null == (a = e.messageHandlers) || null == (n = a.FronteggNativeBridge) || n.postMessage(JSON.stringify({
                                action: "loginWithCustomSocialLoginProvider",
                                payload: t
                            }));
                        } else {
                            if (!this.isAndroidNativeBridgeAvailable()) throw new Error("FronteggNativeBridge is not available");
                            var s;
                            null == (s = window.FronteggNativeBridge) || s.loginWithCustomSocialLoginProvider(t);
                        }
                    }, this.suggestSavePassword = (t, e)=>{
                        if (this.isIOSNativeBridgeAvailable()) {
                            var a, n, s;
                            null == (a = window.webkit) || null == (n = a.messageHandlers) || null == (s = n.FronteggNativeBridge) || s.postMessage(JSON.stringify({
                                action: "suggestSavePassword",
                                payload: JSON.stringify({
                                    email: t,
                                    password: e
                                })
                            }));
                        } else {
                            if (!this.isAndroidNativeBridgeAvailable()) throw new Error("FronteggNativeBridge is not available");
                            var i;
                            null == (i = window.FronteggNativeBridge) || i.suggestSavePassword(t, e);
                        }
                    }, this.promptSocialLoginConsent = ()=>{
                        var t, e;
                        return null != (t = null == (e = window.FronteggNativeBridgeFunctions) ? void 0 : e.shouldPromptSocialLoginConsent) && t;
                    };
                }
                isIOSNativeBridgeAvailable() {
                    var t, e;
                    return null != (null == (t = window.webkit) || null == (e = t.messageHandlers) ? void 0 : e.FronteggNativeBridge);
                }
                isAndroidNativeBridgeAvailable() {
                    return null != window.FronteggNativeBridge;
                }
                isSocialLoginAvailable() {
                    return this.isAvailable("loginWithSocialLogin");
                }
                isSocialLoginProviderAvailable() {
                    return this.isAvailable("loginWithSocialLoginProvider");
                }
                isCustomSocialLoginProviderAvailable() {
                    return this.isAvailable("loginWithCustomSocialLoginProvider");
                }
                isLoginWithSSOAvailable() {
                    return this.isAvailable("loginWithSSO");
                }
                isSuggestSavePasswordAvailable() {
                    return this.isAvailable("suggestSavePassword");
                }
                isAvailable(t) {
                    var e, a;
                    return !(!this.isIOSNativeBridgeAvailable() && !this.isAndroidNativeBridgeAvailable()) && null != (e = null == (a = window.FronteggNativeBridgeFunctions) ? void 0 : a[t]) && e;
                }
            };
            function v() {
                return v = Object.assign ? Object.assign.bind() : function(t) {
                    for(var e = 1; e < arguments.length; e++){
                        var a = arguments[e];
                        for(var n in a)Object.prototype.hasOwnProperty.call(a, n) && (t[n] = a[n]);
                    }
                    return t;
                }, v.apply(this, arguments);
            }
            function f(t, e) {
                if (null == t) return {};
                var a, n, s = {}, i = Object.keys(t);
                for(n = 0; n < i.length; n++)a = i[n], e.indexOf(a) >= 0 || (s[a] = t[a]);
                return s;
            }
            Symbol();
            const m = Symbol(), b = Object.getPrototypeOf, A = new WeakMap, w = (t, e = !0)=>{
                A.set(t, e);
            }, T = (t)=>"object" == typeof t && null !== t, E = new WeakMap, I = new WeakSet;
            const [O] = function(t = Object.is, e = (t, e)=>new Proxy(t, e), a = (t)=>T(t) && !I.has(t) && (Array.isArray(t) || !(Symbol.iterator in t)) && !(t instanceof WeakMap) && !(t instanceof WeakSet) && !(t instanceof Error) && !(t instanceof Number) && !(t instanceof Date) && !(t instanceof String) && !(t instanceof RegExp) && !(t instanceof ArrayBuffer), n = (t)=>{
                switch(t.status){
                    case "fulfilled":
                        return t.value;
                    case "rejected":
                        throw t.reason;
                    default:
                        throw t;
                }
            }, s = new WeakMap, i = (t, e, a = n)=>{
                const o = s.get(t);
                if ((null == o ? void 0 : o[0]) === e) return o[1];
                const r = Array.isArray(t) ? [] : Object.create(Object.getPrototypeOf(t));
                return w(r, !0), s.set(t, [
                    e,
                    r
                ]), Reflect.ownKeys(t).forEach((e)=>{
                    if (Object.getOwnPropertyDescriptor(r, e)) return;
                    const n = Reflect.get(t, e), { enumerable: s } = Reflect.getOwnPropertyDescriptor(t, e), o = {
                        value: n,
                        enumerable: s,
                        configurable: !0
                    };
                    if (I.has(n)) w(n, !1);
                    else if (n instanceof Promise) delete o.value, o.get = ()=>a(n);
                    else if (E.has(n)) {
                        const [t, e] = E.get(n);
                        o.value = i(t, e(), a);
                    }
                    Object.defineProperty(r, e, o);
                }), Object.preventExtensions(r);
            }, o = new WeakMap, r = [
                1,
                1
            ], l = (n)=>{
                if (!T(n)) throw new Error("object required");
                const s = o.get(n);
                if (s) return s;
                let c = r[0];
                const u = new Set, d = (t, e = ++r[0])=>{
                    c !== e && (c = e, u.forEach((a)=>a(t, e)));
                };
                let g = r[1];
                const p = (t)=>(e, a)=>{
                        const n = [
                            ...e
                        ];
                        n[1] = [
                            t,
                            ...n[1]
                        ], d(n, a);
                    }, h = new Map, y = (t)=>{
                    const e = h.get(t);
                    var a;
                    e && (h.delete(t), null == (a = e[1]) || a.call(e));
                }, S = Array.isArray(n) ? [] : Object.create(Object.getPrototypeOf(n)), v = e(S, {
                    deleteProperty (t, e) {
                        const a = Reflect.get(t, e);
                        y(e);
                        const n = Reflect.deleteProperty(t, e);
                        return n && d([
                            "delete",
                            [
                                e
                            ],
                            a
                        ]), n;
                    },
                    set (e, n, s, i) {
                        const r = Reflect.has(e, n), c = Reflect.get(e, n, i);
                        if (r && (t(c, s) || o.has(s) && t(c, o.get(s)))) return !0;
                        var g;
                        y(n), T(s) && (s = ((t)=>t && (A.has(t) ? A.get(t) : b(t) === Object.prototype || b(t) === Array.prototype))(g = s) && g[m] || s);
                        let S = s;
                        if (s instanceof Promise) s.then((t)=>{
                            s.status = "fulfilled", s.value = t, d([
                                "resolve",
                                [
                                    n
                                ],
                                t
                            ]);
                        }).catch((t)=>{
                            s.status = "rejected", s.reason = t, d([
                                "reject",
                                [
                                    n
                                ],
                                t
                            ]);
                        });
                        else {
                            !E.has(s) && a(s) && (S = l(s));
                            const t = !I.has(S) && E.get(S);
                            t && ((t, e)=>{
                                if (u.size) {
                                    const a = e[3](p(t));
                                    h.set(t, [
                                        e,
                                        a
                                    ]);
                                } else h.set(t, [
                                    e
                                ]);
                            })(n, t);
                        }
                        return Reflect.set(e, n, S, i), d([
                            "set",
                            [
                                n
                            ],
                            s,
                            c
                        ]), !0;
                    }
                });
                o.set(n, v);
                const f = [
                    S,
                    (t = ++r[1])=>(g === t || u.size || (g = t, h.forEach(([e])=>{
                            const a = e[1](t);
                            a > c && (c = a);
                        })), c),
                    i,
                    (t)=>(u.add(t), 1 === u.size && h.forEach(([t, e], a)=>{
                            const n = t[3](p(a));
                            h.set(a, [
                                t,
                                n
                            ]);
                        }), ()=>{
                            u.delete(t), 0 === u.size && h.forEach(([t, e], a)=>{
                                e && (e(), h.set(a, [
                                    t
                                ]));
                            });
                        })
                ];
                return E.set(v, f), Reflect.ownKeys(n).forEach((t)=>{
                    const e = Object.getOwnPropertyDescriptor(n, t);
                    "value" in e && (v[t] = n[t], delete e.value, delete e.writable), Object.defineProperty(S, t, e);
                }), v;
            }) {
                return [
                    l,
                    E,
                    I,
                    t,
                    e,
                    a,
                    n,
                    s,
                    i,
                    o,
                    r
                ];
            }();
            function P(t, e, a) {
                const n = E.get(t);
                let s;
                const i = [], o = n[3];
                let r = !1;
                const l = o((t)=>{
                    i.push(t), a ? e(i.splice(0)) : s || (s = Promise.resolve().then(()=>{
                        s = void 0, r && e(i.splice(0));
                    }));
                });
                return r = !0, ()=>{
                    r = !1, l();
                };
            }
            function k(t, e) {
                const a = E.get(t), [n, s, i] = a;
                return i(n, s(), e);
            }
            const _ = [
                "enabled",
                "name"
            ], R = Symbol();
            class C {
                constructor(){
                    this.context = null, this.accessToken = null, this.user = null, this.requestSource = null, this.onRedirectTo = (t)=>window.location.href = t, this.logout = ()=>window.location.href = "/account/logout", this.entitlementsOptions = null, this.appName = null, this.sessionContext = void 0, this.basename = null, this.cdnUrl = null, this.assetsUrl = null, this.setContext = (t)=>{
                        this.context = t;
                    }, this.setAccessToken = (t)=>{
                        this.accessToken = t;
                    }, this.setUser = (t)=>{
                        this.user = t;
                    }, this.setRequestSource = (t)=>{
                        this.requestSource = t;
                    }, this.setOnRedirectTo = (t)=>{
                        this.onRedirectTo = t;
                    }, this.setLogout = (t)=>{
                        this.logout = t;
                    }, this.setEntitlementsOptions = (t)=>{
                        this.entitlementsOptions = t;
                    }, this.setSessionContext = (t)=>{
                        this.sessionContext = t;
                    }, this.setAppName = (t)=>{
                        this.appName = t;
                    }, this.getContext = ()=>{
                        var t;
                        return null != (t = this.context) ? t : {
                            baseUrl: window.location.href,
                            tokenResolver: ()=>"my-authentication-token",
                            logLevel: "error"
                        };
                    }, this.getAccessToken = ()=>this.accessToken, this.getRequestSource = ()=>this.requestSource, this.getUser = ()=>this.user, this.shouldLoadEntitlements = ()=>{
                        var t;
                        return (null == (t = this.entitlementsOptions) ? void 0 : t.enabled) || !1;
                    }, this.isSessionPerTenantEnabled = ()=>{
                        var t;
                        return (null == (t = this.sessionContext) ? void 0 : t.enableSessionPerTenant) || !1;
                    }, this.shouldSkipUserLoad = ()=>{
                        var t;
                        return (null == (t = this.sessionContext) ? void 0 : t.skipUserLoading) || !1;
                    }, this.getAppName = ()=>this.appName, this.setCdnUrl = (t)=>{
                        this.cdnUrl = t;
                    }, this.getCdnUrl = ()=>this.cdnUrl, this.setAssetsUrl = (t)=>{
                        this.assetsUrl = t;
                    }, this.getAssetsUrl = ()=>this.assetsUrl;
                }
                static default() {
                    return C.getInstance(L);
                }
                static for(t) {
                    return C.getInstance(t);
                }
                static getInstance(t = "default") {
                    return C._apps || (C._apps = {}), C._apps[t] || (C._apps[t] = new C), C._apps[t];
                }
                static createInstance(t = "default") {
                    return C._apps[t] = new C, C._apps[t].appName = t, C._apps[t];
                }
                static setContext(t, e = "default") {
                    C.for(e).context = t;
                }
                static setAccessToken(t, e = L) {
                    C.for(e).accessToken = t;
                }
                static setUser(t, e = "default") {
                    C.for(e).user = t;
                }
                static setRequestSource(t, e = "default") {
                    C.for(e).requestSource = t;
                }
                static setOnRedirectTo(t, e = "default") {
                    C.for(e).onRedirectTo = t;
                }
                static setLogout(t, e, a = "default") {
                    const n = C.for(a);
                    n.logout = (a)=>{
                        a ? t(a) : n.onRedirectTo(e, void 0);
                    };
                }
                static setEntitlementsOptions(t, e = "default") {
                    C.for(e).entitlementsOptions = t;
                }
                static setSessionContext(t, e = "default") {
                    C.for(e).sessionContext = t;
                }
                static setAppName(t) {
                    C.for(t).appName = t;
                }
                static getContext(t = "default") {
                    var e;
                    return null != (e = C.for(t).context) ? e : {
                        baseUrl: window.location.href,
                        tokenResolver: ()=>"my-authentication-token",
                        logLevel: "error"
                    };
                }
                static getAccessToken(t = "default") {
                    return C.for(t).accessToken;
                }
                static getRequestSource(t = "default") {
                    return C.for(t).requestSource;
                }
                static getBasename(t = "default") {
                    return C.for(t).basename;
                }
                getBasename() {
                    return this.basename;
                }
                static setBasename(t, e = L) {
                    C.for(e).basename = t;
                }
                setBasename(t) {
                    this.basename = t;
                }
                static getUser(t = "default") {
                    return C.for(t).user;
                }
                static onRedirectTo(t, e, a = "default") {
                    return C.for(a).onRedirectTo(t, e);
                }
                static logout(t, e = "default") {
                    return C.for(e).logout(t);
                }
                static shouldLoadEntitlements(t = "default") {
                    var e;
                    return (null == (e = C.for(t).entitlementsOptions) ? void 0 : e.enabled) || !1;
                }
                static isSessionPerTenantEnabled(t = "default") {
                    var e;
                    return (null == (e = C.for(t).sessionContext) ? void 0 : e.enableSessionPerTenant) || !1;
                }
                static getAppName(t = "default") {
                    return C.for(t).appName;
                }
            }
            C._apps = void 0;
            const L = "default", U = {
                getContext: ()=>C.getContext(L),
                getAccessToken: ()=>C.getAccessToken(L),
                setAccessToken: (t)=>C.setAccessToken(t, L),
                getUser: ()=>C.getUser(L),
                setUser: (t)=>C.setUser(t, L),
                onRedirectTo: (t, e)=>C.onRedirectTo(t, e, L),
                setOnRedirectTo: (t)=>C.setOnRedirectTo(t, L),
                logout: (t)=>C.logout(t, L),
                getRequestSource: ()=>C.getRequestSource(L),
                setRequestSource: (t)=>C.setRequestSource(t, L),
                isSessionPerTenantEnabled: ()=>C.isSessionPerTenantEnabled(L),
                shouldLoadEntitlements: ()=>C.shouldLoadEntitlements(L),
                getAppName: ()=>C.getAppName(L),
                setEntitlementsOptions: (t)=>C.setEntitlementsOptions(t, L),
                setSessionContext: (t)=>C.setSessionContext(t, L),
                getBasename: ()=>C.getBasename(L),
                setBasename: (t)=>C.setBasename(t, L)
            };
            let D, N, M, F, x, G, $, j, B;
            !function(t) {
                t.Microsoft = "microsoft", t.Facebook = "facebook", t.Google = "google", t.Github = "github", t.Slack = "slack", t.Apple = "apple", t.Linkedin = "linkedin";
            }(D || (D = {})), function(t) {
                t.EmailAndPassword = "EmailAndPassword", t.MagicLink = "MagicLink", t.Code = "Code", t.NoLocalAuthentication = "NoLocalAuthentication", t.SmsCode = "SmsCode";
            }(N || (N = {})), function(t) {
                t.ClientCredentials = "ClientCredentials", t.AccessToken = "AccessToken";
            }(M || (M = {})), function(t) {
                t.ACTIVE = "active", t.CANCELED = "canceled", t.INCOMPLETE = "incomplete", t.EXPIRED = "expired", t.TRIALING = "trialing", t.TRIAL_ENDED = "trialEnded";
            }(F || (F = {})), function(t) {
                t.UNKNWON = "unknown", t.CARD = "card";
            }(x || (x = {})), function(t) {
                t.AT_PERIOD_END = "atPeriodEnd";
            }(G || (G = {})), function(t) {
                t.Stripe = "Stripe";
            }($ || ($ = {})), function(t) {
                t.CHANGE_TO_DEFAULT = "change_to_default", t.RETAIN_TRIAL = "retain_trial";
            }(j || (j = {})), function(t) {
                t.CREATE = "create_customer";
            }(B || (B = {}));
            class V extends Error {
                constructor(t, e, a, n, s){
                    super(t), this._statusCode = void 0, this._traceId = void 0, this._errorCode = void 0, this._errorContext = void 0, this._statusCode = e, this._traceId = a, this._errorCode = n, this._errorContext = s;
                }
                get statusCode() {
                    return this._statusCode;
                }
                get traceId() {
                    return this._traceId;
                }
                get errorCode() {
                    return this._errorCode;
                }
                get errorContext() {
                    return this._errorContext;
                }
            }
            const W = {
                v1: "/identity/resources/users/webauthn/v1/devices"
            }, H = {
                v1: "/identity/resources/auth/v1",
                v2: "/identity/resources/auth/v2"
            }, z = {
                v1: "/identity/resources/users/v1",
                v2: "/identity/resources/users/v2",
                v3: "/identity/resources/users/v3",
                roles: {
                    v3: "/identity/resources/users/v3/roles"
                },
                groups: {
                    v3: "/identity/resources/users/v3/groups"
                },
                tenants: {
                    me: {
                        v1: "/identity/resources/users/v1/me/tenants",
                        v3: "/identity/resources/users/v3/me/tenants"
                    }
                },
                apiTokens: {
                    v1: "/identity/resources/users/api-tokens/v1"
                },
                accessTokens: {
                    v1: "/identity/resources/users/access-tokens/v1"
                },
                sessions: {
                    v1: "/identity/resources/users/sessions/v1",
                    currentUser: {
                        v1: "/identity/resources/users/sessions/v1/me"
                    },
                    configurations: {
                        v1: "/identity/resources/configurations/sessions/v1"
                    }
                },
                invitation: {
                    resendAll: {
                        v1: "/identity/resources/users/v1/invitation/reset/all"
                    }
                },
                passwords: {
                    resetBreachedPasswords: {
                        v1: "/identity/resources/users/v1/passwords/breached/reset/bulk"
                    }
                },
                authorization: {
                    v1: "/identity/resources/users/v1/me/authorization"
                },
                temporary: {
                    v1: "/identity/resources/users/temporary/v1",
                    configuration: {
                        v1: "/identity/resources/users/temporary/v1/configuration"
                    }
                }
            }, K = {
                v1: "/identity/resources/configurations/v1"
            }, q = {
                emailDomain: {
                    v1: "/identity/resources/configurations/restrictions/v1/email-domain"
                },
                ip: {
                    v1: "/identity/resources/configurations/v1/restrictions/ip"
                }
            }, J = {
                v1: "/identity/resources/sso/v1",
                v2: "/identity/resources/sso/v2",
                custom: {
                    v1: "/identity/resources/sso/custom/v1"
                }
            }, Y = {
                v1: "/identity/resources/permissions/v1"
            }, X = {
                apiTokens: {
                    v1: "/identity/resources/tenants/api-tokens/v1",
                    v2: "/identity/resources/tenants/api-tokens/v2"
                },
                accessTokens: {
                    v1: "/identity/resources/tenants/access-tokens/v1"
                },
                invites: {
                    user: {
                        v1: "/identity/resources/tenants/invites/v1/user"
                    },
                    verify: {
                        v1: "/identity/resources/tenants/invites/v1/verify"
                    },
                    configuration: {
                        v1: "/identity/resources/tenants/invites/v1/configuration"
                    }
                },
                users: {
                    v1: "/identity/resources/tenants/users/v1"
                }
            }, Q = {
                v1: "/identity/resources/roles/v1",
                v2: "/identity/resources/roles/v2"
            }, Z = {
                v1: "/identity/resources/sub-tenants/users/v1",
                v2: "/identity/resources/sub-tenants/users/v2"
            }, tt = {
                v1: "/identity/resources/impersonation/v1"
            }, et = {
                v1: "/identity/resources/applications/v1"
            }, at = {
                v1: "/identity/resources/groups/v1",
                configurations: {
                    v1: "/identity/resources/groups/v1/config"
                },
                getByIds: {
                    v1: "/identity/resources/groups/v1/bulkGet"
                }
            }, nt = {
                v1: "/identity/resources/users/phone-numbers/v1"
            }, st = {
                v1: "/team/resources/sso/v1",
                v2: "/team/resources/sso/v2"
            }, it = {
                v1: "/team/resources/members/v1"
            }, ot = {
                v1: "/team/resources/roles/v1"
            }, rt = {
                v1: "/team/resources/stats/v1"
            }, lt = {
                v1: "/team/resources/profile"
            }, ct = {
                v1: "/tenants/resources/account-settings/v1"
            }, ut = {
                v1: "/tenants/resources/hierarchy/v1",
                tree: {
                    v1: "/tenants/resources/hierarchy/v1/tree"
                },
                parents: {
                    v1: "/tenants/resources/hierarchy/v1/parents"
                },
                v2: "/tenants/resources/hierarchy/v2",
                metadata: {
                    v2: "/tenants/resources/hierarchy/v2/metadata"
                }
            }, dt = {
                v1: "/tenants/resources/sub-tenants/v1"
            }, gt = {
                v1: "/integrations/resources/configurations/v1",
                v2: "/integrations/resources/configurations/v2"
            }, pt = {
                subscriptions: {
                    v1: "/subscriptions/resources/billing/subscriptions/v1"
                },
                plans: {
                    v1: "/subscriptions/resources/billing/plans/v1"
                },
                invoices: {
                    v1: "/subscriptions/resources/billing/invoices/v1"
                },
                paymentMethods: {
                    v1: "/subscriptions/resources/billing/payment-methods/v1"
                },
                summaries: {
                    v1: "/subscriptions/resources/billing/summaries/v1"
                },
                tenantConfiguration: {
                    v1: "/subscriptions/resources/billing/tenant-configurations/v1"
                },
                configurations: {
                    vendorPublicConfigurations: {
                        v1: "/subscriptions/resources/billing/configurations/vendor-public-configurations/v1"
                    }
                },
                paymentProviders: {
                    stripe: {
                        customers: {
                            v1: "/subscriptions/resources/billing/payment-providers/stripe/customers/v1"
                        },
                        publicConfigurations: {
                            v1: "/subscriptions/resources/billing/payment-providers/stripe/public-configurations/v1"
                        },
                        subscriptions: {
                            v1: "/subscriptions/resources/billing/payment-providers/stripe/subscriptions/v1"
                        },
                        setupIntents: {
                            v1: "/subscriptions/resources/billing/payment-providers/stripe/setup-intents/v1"
                        }
                    }
                }
            }, ht = {
                v1: "/subscriptions/resources/payment-providers/v1"
            }, yt = {
                v1: "/subscriptions/resources/subscriptions/v1"
            }, St = {
                v1: "/reports/resources/reports/v1",
                v2: "/reports/resources/reports/v2"
            }, vt = {
                v1: "/reports/engine/resources/triggers/v1"
            }, ft = "/notification", mt = "/audits", bt = {
                v1: "/event/resources/configurations/v1"
            }, At = "/webhook", wt = "/oauth", Tt = "/flags", Et = "/directory/resources/v1/configurations/scim2", It = "/directory/resources/scim/temp", Ot = "/entitlements/api/v2/user-entitlements", Pt = {
                v1: "/security-center/resources/recommendations/v1"
            }, kt = {
                v1: "/security-center/resources/insights/v1"
            }, _t = "/applications/resources/applications/v1", Rt = {
                v1: "/applications/resources/applications/tenant-assignments/v1"
            }, Ct = "http://localhost:3037/resources/velo/v1", Lt = "We're facing some difficulties, Please try again", Ut = "ER-ADMIN-PORTAL-GENERIC-ERROR", Dt = {
                frameWork: "x-frontegg-framework",
                fronteggSdkVersion: "x-frontegg-sdk",
                contentType: "Content-Type",
                source: "frontegg-source",
                scopedTenant: "frontegg-scoped-tenant"
            };
            let Nt, Mt, Ft;
            !function(t) {
                t.AdminPortal = "admin-portal", t.LoginBox = "login-box";
            }(Nt || (Nt = {})), function(t) {
                t.Nextjs = "nextjs", t.React = "react", t.Angular = "angular", t.Vuejs = "vuejs", t.Flutter = "flutter", t.Ios = "ios", t.Android = "android", t.Vanillajs = "vanillajs";
            }(Mt || (Mt = {})), function(t) {
                t.ASC = "ASC", t.DESC = "DESC";
            }(Ft || (Ft = {}));
            class xt {
                constructor(t){
                    this.appName = void 0, this.getFronteggContext = ()=>C.for(this.appName), this.prepareUrl = async (t, e)=>{
                        const a = this.getFronteggContext().getContext(), n = this.getContextBaseUrl(t), s = await this.buildQueryParams(a, e);
                        let i = t.startsWith("http") ? t : `${n}${t}`;
                        const o = Object.keys(s).length > 0;
                        return s && o && (i += `?${new URLSearchParams(s)}`), i;
                    }, this.buildQueryParams = async (t, e)=>{
                        e || (e = {});
                        const a = await this.getAdditionalQueryParams(t);
                        for (const t of a)e[t.key] = t.value;
                        const n = Object.keys(e);
                        for (const t of n){
                            const a = e[t];
                            e[t] = "object" == typeof a ? JSON.stringify(a) : a;
                        }
                        return e;
                    }, this.getAdditionalQueryParams = async (t)=>{
                        let e = [];
                        return t.additionalQueryParamsResolver && (e = await t.additionalQueryParamsResolver()), e;
                    }, this.getAdditionalHeaders = async (t)=>{
                        let e = [];
                        if (t.additionalHeadersResolver && (e = await t.additionalHeadersResolver()), t.tenantResolver) {
                            const a = await t.tenantResolver();
                            null != a && a.tenant && e.push({
                                key: "frontegg-login-alias",
                                value: a.tenant
                            });
                        }
                        return t.appId && e.push({
                            key: "frontegg-requested-application-id",
                            value: t.appId
                        }), e;
                    }, this.buildRequestHeaders = async (t)=>{
                        var e;
                        const a = this.getFronteggContext(), n = a.getContext(), s = xt.getMetadataHeaders(n), i = await (null != (e = null == n ? void 0 : n.tokenResolver) ? e : a.getAccessToken)(), o = a.getRequestSource(), r = xt.getScopedTenant();
                        t && (s[Dt.contentType] = t), o && (s[Dt.source] = o), i && (s.Authorization = `Bearer ${i}`), r && (s[Dt.scopedTenant] = r);
                        for (const t of (await this.getAdditionalHeaders(n)))s[`${t.key}`] = `${t.value}`;
                        return s;
                    }, this.getResponseTraceId = (t)=>{
                        var e, a;
                        return null == t || null == (e = t.headers) || null == (a = e.get) ? void 0 : a.call(e, "frontegg-trace-id");
                    }, this.sendRequest = async (t)=>{
                        var e, a, n;
                        const s = this.getFronteggContext().getContext(), i = await this.buildRequestHeaders(t.contentType), o = await this.prepareUrl(t.url, t.params), r = s.beforeRequestInterceptor, l = {
                            body: t.body ? "application/json" === t.contentType ? JSON.stringify(t.body) : t.body : null,
                            method: null != (e = t.method) ? e : "GET",
                            headers: v({}, i, t.headers),
                            credentials: null != (a = null != (n = t.credentials) ? n : s.requestCredentials) ? a : "same-origin"
                        }, c = r ? r(l, o) : l, u = await fetch(o, c);
                        if (302 === u.status) return window.location.href = await u.text(), new Promise(()=>{});
                        if (!u.ok) {
                            var d, g, p, h, y;
                            if (413 === u.status) throw new V("Error request is too large", u.status, this.getResponseTraceId(u), void 0);
                            let t, e, a, n = !0;
                            try {
                                t = await u.text(), t = JSON.parse(t);
                            } catch (t) {
                                n = !1;
                            }
                            throw null != (d = t) && d.errorCode && (e = t.errorCode), null != (g = t) && g.context && "object" == typeof t.context && (a = t.context), t.errors ? t = t.errors.join(", ") : "string" != typeof t && (t = `Error ${u.status} - ${u.statusText}`), u.status >= 400 && u.status < 500 && [
                                "warn"
                            ].includes(null != (p = s.logLevel) ? p : "") ? console.warn(t) : 500 === u.status && [
                                "warn",
                                "error"
                            ].includes(null != (h = s.logLevel) ? h : "") && console.error(t), new V(n ? t : Lt, u.status, this.getResponseTraceId(u), null != (y = e) ? y : Ut, a);
                        }
                        if ("stream" === t.responseType) return u.body;
                        if (t.responseType && "json" !== t.responseType) {
                            if ("blob" === t.responseType) {
                                const { outputFileName: e } = t.params;
                                return await u.blob().then((t)=>URL.createObjectURL(t)).then((t)=>{
                                    const a = document.createElement("a");
                                    a.href = t, a.setAttribute("download", e || "output"), a.click();
                                });
                            }
                            return await u.text();
                        }
                        try {
                            return await u.json();
                        } catch (t) {
                            return {};
                        }
                    }, this.get = async (t, e, a)=>this.sendRequest(v({
                            url: t,
                            method: "GET",
                            contentType: "application/json",
                            params: e
                        }, a)), this.post = async (t, e, a)=>this.sendRequest(v({
                            url: t,
                            method: "POST",
                            contentType: "application/json",
                            body: e
                        }, a)), this.patch = async (t, e, a)=>this.sendRequest(v({
                            url: t,
                            method: "PATCH",
                            contentType: "application/json",
                            body: e
                        }, a)), this.put = async (t, e, a)=>this.sendRequest(v({
                            url: t,
                            method: "PUT",
                            contentType: "application/json",
                            body: e
                        }, a)), this.delete = async (t, e, a)=>this.sendRequest(v({
                            url: t,
                            method: "DELETE",
                            contentType: "application/json",
                            body: e
                        }, a)), this.postDownload = async (t, e, a, n)=>this.sendRequest(v({
                            url: t,
                            method: "POST",
                            contentType: "application/json",
                            responseType: "blob",
                            body: e,
                            params: a
                        }, n)), this.extractHeadersFromOptions = (t = {})=>v({}, t.jwt ? {
                            Authorization: t.jwt
                        } : {}), this.getBaseUrl = (t, e, a = !0)=>xt.getBaseUrl(t, e, a), this.getContextBaseUrl = (t, e = !0)=>{
                        const a = this.getFronteggContext().getContext();
                        return this.getBaseUrl(a, t, e);
                    }, this.getMetadataHeaders = (t)=>xt.getMetadataHeaders(t), this.getContextMetadataHeaders = ()=>{
                        const t = this.getFronteggContext().getContext();
                        return xt.getMetadataHeaders(t);
                    }, this.appName = t;
                }
            }
            xt.getBaseUrl = (t, e, a = !0)=>{
                let n;
                n = "function" == typeof t.baseUrl ? t.baseUrl(e) : t.baseUrl;
                const s = t.urlPrefix || "frontegg", i = "frontegg" === s && !a;
                return n.endsWith("/") || (n += "/"), n.endsWith(s) || i || (n += s), n;
            }, xt.getMetadataHeaders = (t)=>{
                var e, a;
                const n = {};
                return null != t && null != (e = t.metadataHeaders) && e.fronteggSdkVersion && (n[Dt.fronteggSdkVersion] = t.metadataHeaders.fronteggSdkVersion), null != t && null != (a = t.metadataHeaders) && a.framework && (n[Dt.frameWork] = t.metadataHeaders.framework), n;
            }, xt.getScopedTenant = ()=>new URLSearchParams(window.location.search).get("tenantId") || null;
            const Gt = new xt("default");
            class $t extends Error {
                constructor(t){
                    super(t);
                }
            }
            const jt = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(t) {
                const e = String(t).replace(/=+$/, "");
                if (e.length % 4 == 1) throw new $t("'atob' failed: The string to be decoded is not correctly encoded.");
                let a = "";
                for(let t, n, s = 0, i = 0; n = e.charAt(i++); ~n && (t = s % 4 ? 64 * t + n : n, s++ % 4) && (a += String.fromCharCode(255 & t >> (-2 * s & 6))))n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(n);
                return a;
            };
            class Bt extends Error {
                constructor(t){
                    super(t);
                }
            }
            const Vt = (t, e = {})=>{
                const a = e.header ? 0 : 1;
                try {
                    return JSON.parse(((t)=>{
                        let e = t.replace(/-/g, "+").replace(/_/g, "/");
                        switch(e.length % 4){
                            case 0:
                                break;
                            case 2:
                                e += "==";
                                break;
                            case 3:
                                e += "=";
                                break;
                            default:
                                throw new Error("Illegal base64url string!");
                        }
                        try {
                            return function(t) {
                                return decodeURIComponent(jt(t).replace(/(.)/g, (t, e)=>{
                                    let a = e.charCodeAt(0).toString(16).toUpperCase();
                                    return a.length < 2 && (a = "0" + a), "%" + a;
                                }));
                            }(e);
                        } catch (t) {
                            return jt(e);
                        }
                    })(t.split(".")[a]));
                } catch (t) {
                    throw new Bt("Invalid token specified: " + t.message);
                }
            };
            let Wt, Ht, zt, Kt;
            !function(t) {
                t.ALLOW = "ALLOW", t.BLOCK = "BLOCK";
            }(Wt || (Wt = {})), function(t) {
                t.WebAuthnPlatform = "WebAuthnPlatform", t.WebAuthnCrossPlatform = "WebAuthnCrossPlatform", t.SmsCode = "SmsCode", t.SmsCodeV2 = "SmsCodeV2", t.Passkeys = "Passkeys";
            }(Ht || (Ht = {})), function(t) {
                t.Platform = "Platform", t.CrossPlatform = "CrossPlatform";
            }(zt || (zt = {})), function(t) {
                t.AuthenticatorApp = "AuthenticatorApp", t.WebAuthnPlatform = "WebAuthnPlatform", t.WebAuthnCrossPlatform = "WebAuthnCrossPlatform", t.SMS = "SMS", t.EmailCode = "EmailCode";
            }(Kt || (Kt = {}));
            const qt = "admin_portal_should_load_authorization";
            class Jt {
                constructor(t){
                    this.appName = void 0, this.fetchClient = void 0, this.get = async (t, e, a)=>this.fetchClient.get(t, e, a), this.post = async (t, e, a)=>this.fetchClient.post(t, e, a), this.patch = async (t, e, a)=>this.fetchClient.patch(t, e, a), this.put = async (t, e, a)=>this.fetchClient.put(t, e, a), this.delete = async (t, e, a)=>this.fetchClient.delete(t, e, a), this.postDownload = async (t, e, a, n)=>this.fetchClient.postDownload(t, e, a, n), this.extractHeadersFromOptions = (t = {})=>this.fetchClient.extractHeadersFromOptions(t), this.appName = t, this.fetchClient = new xt(t);
                }
            }
            const Yt = {
                flags: {}
            };
            class Xt {
                constructor(){
                    var t;
                    this._flags = {}, this._flags = null != (t = Yt.flags) ? t : {};
                }
                static getInstance(t = "default") {
                    return this._instances[t];
                }
                static set(t, e = "default") {
                    const a = new Xt;
                    return a.set(t), Xt._instances[e] = a, a;
                }
                static getFeatureFlags(t, e) {
                    const a = this.getInstance(e);
                    return t.map((t)=>"on" === (null == a ? void 0 : a._flags[t]));
                }
                get flags() {
                    var t;
                    return null != (t = this.flags) ? t : {};
                }
                set(t) {
                    var e;
                    this._flags = v({}, null != (e = null == Yt ? void 0 : Yt.flags) ? e : {}, null != t ? t : {});
                }
            }
            Xt._instances = {};
            class Qt extends Jt {
                constructor(t){
                    super(t), this.loadFeatureFlags = async ()=>this.get(Tt);
                }
            }
            const Zt = new Qt("default"), te = "FRONTEGG_SEPARATE_TABS_BY_TENANT", ee = "admin_portal_use_current_user_tenants_v1_endpoint";
            class ae extends Jt {
                constructor(t){
                    super(t), this.GetUserJwt = async (t)=>this.post(`${z.v3}/me/token`, t), this.getUsersV2 = async (t, e)=>this.get(z.v2, t, {
                            headers: this.extractHeadersFromOptions(e)
                        }), this.getUsersV3 = async (t, e)=>this.get(z.v3, t, {
                            headers: this.extractHeadersFromOptions(e)
                        }), this.getUsersRoles = async (t, e)=>this.get(z.roles.v3, v({}, t, {
                            ids: t.ids.join(",")
                        }), {
                            headers: this.extractHeadersFromOptions(e)
                        }), this.getUsersGroups = async (t, e)=>this.get(z.groups.v3, v({}, t, {
                            ids: t.ids.join(",")
                        }), {
                            headers: this.extractHeadersFromOptions(e)
                        }), this.getCurrentUserTenantsV3 = async (t)=>this.get(z.tenants.me.v3, void 0, {
                            headers: this.extractHeadersFromOptions(t)
                        }), this.getCurrentUserTenantsV1 = async (t)=>this.get(z.tenants.me.v1, void 0, {
                            headers: this.extractHeadersFromOptions(t)
                        }), this.sendResetBreachedPasswordEmails = async ()=>this.post(z.passwords.resetBreachedPasswords.v1), this.updateUserProfileV2 = async (t)=>this.put(`${z.v2}/me`, t), this.unlockMe = async (t)=>this.post(`${z.v3}/me/unlock`, t);
                }
            }
            const ne = new ae("default");
            function se(t) {
                t && sessionStorage.setItem(te, t);
            }
            function ie() {
                sessionStorage.removeItem(te);
            }
            function oe(t) {
                return C.for(t).isSessionPerTenantEnabled() ? sessionStorage.getItem(te) : null;
            }
            function re(t) {
                if (C.for(t).shouldSkipUserLoad()) return async ()=>({
                        tenants: [],
                        activeTenant: {}
                    });
                const e = new ae(t), [a] = Xt.getFeatureFlags([
                    ee
                ], t);
                return C.for(t).isSessionPerTenantEnabled() || a ? e.getCurrentUserTenantsV1 : e.getCurrentUserTenantsV3;
            }
            class le extends Jt {
                constructor(t){
                    super(t), this.switchTenant = async (t)=>(C.for(this.appName).isSessionPerTenantEnabled() && se(t.tenantId), this.put(`${z.v1}/tenant`, t)), this.getTenants = async ()=>this.get(`${z.v2}/me/tenants`), this.getSubTenants = async (t)=>this.get(ut.v1, void 0, {
                            headers: this.extractHeadersFromOptions(t)
                        }), this.getSubTenantsAsTree = async (t)=>this.get(ut.tree.v1, void 0, {
                            headers: this.extractHeadersFromOptions(t)
                        }), this.getParentTenants = async (t)=>this.get(ut.parents.v1, void 0, {
                            headers: this.extractHeadersFromOptions(t)
                        }), this.getParentTenantsById = async (t, e)=>this.get(`${ut.parents.v1}/${t}`, void 0, {
                            headers: this.extractHeadersFromOptions(e)
                        }), this.getTenantsUsersCount = async (t, e)=>this.post(`${X.users.v1}/count`, t, {
                            headers: this.extractHeadersFromOptions(e)
                        }), this.searchSubTenants = async (t, e)=>this.get(ut.v2, t, {
                            headers: this.extractHeadersFromOptions(e)
                        }), this.getHierarchyMetadata = async (t, e)=>this.get(ut.metadata.v2, v({}, t, {
                            _tenantIds: t._tenantIds.join(",")
                        }), {
                            headers: this.extractHeadersFromOptions(e)
                        });
                }
            }
            const ce = new le("default");
            class ue extends Jt {
                constructor(t){
                    super(t), this.loadEntitlementsV2 = async ()=>this.get(Ot);
                }
            }
            const de = new ue("default");
            class ge extends Jt {
                constructor(t){
                    super(t), this.getGlobalSecurityPolicy = async ()=>this.get(K.v1), this.getMfaPolicy = async ()=>this.get(`${K.v1}/mfa-policy`), this.getVendorMfaPolicy = async ()=>this.get(`${K.v1}/mfa-policy/vendor`), this.saveMfaPolicy = async (t)=>t.id ? this.patch(`${K.v1}/mfa-policy`, t) : this.post(`${K.v1}/mfa-policy`, t), this.getLockoutPolicy = async ()=>this.get(`${K.v1}/lockout-policy`), this.getVendorLockoutPolicy = async ()=>this.get(`${K.v1}/lockout-policy/vendor`), this.saveLockoutPolicy = async (t)=>t.id ? this.patch(`${K.v1}/lockout-policy`, t) : this.post(`${K.v1}/lockout-policy`, t), this.getCaptchaPolicy = async ()=>{
                        try {
                            return await this.get(`${K.v1}/captcha-policy/public`);
                        } catch  {
                            return null;
                        }
                    }, this.getPasswordHistoryPolicy = async ()=>this.get(`${K.v1}/password-history-policy`), this.getVendorPasswordHistoryPolicy = async ()=>this.get(`${K.v1}/password-history-policy/vendor`), this.savePasswordHistoryPolicy = async (t)=>t.id ? this.patch(`${K.v1}/password-history-policy`, t) : this.post(`${K.v1}/password-history-policy`, t), this.getPasswordRotationPolicy = async ()=>{
                        try {
                            return await this.get(`${K.v1}/password-rotation`);
                        } catch (t) {
                            return {};
                        }
                    }, this.getVendorPasswordRotationPolicy = async ()=>{
                        try {
                            return await this.get(`${K.v1}/password-rotation/vendor`);
                        } catch (t) {
                            return {};
                        }
                    }, this.savePasswordRotationPolicy = async (t)=>this.post(`${K.v1}/password-rotation`, t), this.getPasswordConfigPolicy = async ()=>this.get(`${K.v1}/password`), this.getDomainRestrictions = async ()=>this.get(`${q.emailDomain.v1}`), this.getDomainRestrictionsConfig = async ()=>this.get(`${q.emailDomain.v1}/config`), this.createDomainRestriction = async (t)=>this.post(`${q.emailDomain.v1}`, t), this.updateDomainRestrictionConfig = async (t)=>this.post(`${q.emailDomain.v1}/config`, t), this.deleteDomainRestriction = async (t)=>this.delete(`${q.emailDomain.v1}/${t}`), this.getIPRestrictions = async (t)=>this.get(`${q.ip.v1}`, t), this.getIPRestrictionsConfig = async ()=>this.get(`${q.ip.v1}/config`), this.createIPRestriction = async (t)=>this.post(`${q.ip.v1}`, t), this.bulkCreateIPRestriction = async (t)=>this.post(`${q.ip.v1}/bulk`, t), this.updateIPRestrictionConfig = async (t)=>this.post(`${q.ip.v1}/config`, t), this.deleteIPRestriction = async (t)=>this.delete(`${q.ip.v1}/${t}`), this.testCurrentIp = async ()=>this.post(`${q.ip.v1}/verify`), this.testCurrentIpInAllowList = async ()=>this.post(`${q.ip.v1}/verify/allow`);
                }
            }
            const pe = new ge("default"), he = [
                "type"
            ], ye = [
                "type"
            ], Se = [
                "type"
            ];
            class ve extends Jt {
                constructor(t){
                    super(t), this.tenantsApi = new le(this.appName), this.entitlementsApi = new ue(this.appName), this.securityPolicy = new ge(this.appName), this.generateLoginResponse = async (t)=>{
                        if (!t.accessToken) return t;
                        const e = C.for(this.appName);
                        e.setAccessToken(t.accessToken);
                        const a = await this.getMeAndEntitlements(), n = v({}, t, t.accessToken ? Vt(t.accessToken) : {}, a);
                        return e.setUser(n), n;
                    }, this.generateLoginResponseV2 = async (t)=>{
                        if (!t.accessToken) return {
                            user: t
                        };
                        const e = C.for(this.appName);
                        e.setAccessToken(t.accessToken);
                        const [a, n] = await Promise.all([
                            this.getMeAndEntitlements(),
                            this.tenantsApi.getTenants()
                        ]), s = v({}, t, t.accessToken ? Vt(t.accessToken) : {}, a);
                        return e.setUser(s), {
                            user: s,
                            tenants: n
                        };
                    }, this.generateLoginResponseV3 = async (t)=>{
                        const { accessToken: e } = t;
                        if (!e) return {
                            user: t
                        };
                        const a = C.for(this.appName);
                        a.setAccessToken(e);
                        const [n, s] = await Promise.all([
                            this.getMeAndEntitlements(),
                            re(this.appName)()
                        ]), i = v({}, t, e ? Vt(e) : {}, n);
                        return a.isSessionPerTenantEnabled() && se(i.tenantId), a.setUser(i), {
                            user: i,
                            tenants: s.tenants,
                            activeTenant: s.activeTenant
                        };
                    }, this.generateLoginResponseFromOAuthResponse = async (t)=>{
                        const e = C.for(this.appName);
                        e.setAccessToken(t.id_token);
                        const a = await this.getMeAndEntitlements(), n = t.id_token ? Vt(t.id_token) : {}, s = v({
                            mfaRequired: !1,
                            accessToken: t.id_token,
                            refreshToken: t.refresh_token
                        }, n, a, {
                            expiresIn: t.expires_in || 300
                        });
                        return e.setUser(s), s;
                    }, this.generateLoginResponseFromOAuthResponseV2 = async (t)=>{
                        const e = C.for(this.appName);
                        e.setAccessToken(t.id_token);
                        const [a, n] = await Promise.all([
                            this.getMeAndEntitlements(),
                            re(this.appName)()
                        ]), s = t.id_token ? Vt(t.id_token) : {}, i = v({
                            mfaRequired: !1,
                            accessToken: t.id_token,
                            refreshToken: t.refresh_token
                        }, s, a, {
                            expiresIn: t.expires_in || 300
                        });
                        return e.isSessionPerTenantEnabled() && se(i.tenantId), e.setUser(i), {
                            user: i,
                            tenants: n.tenants,
                            activeTenant: n.activeTenant
                        };
                    }, this.preLogin = async (t)=>{
                        try {
                            const { address: e } = await this.post(`${H.v1}/user/saml/prelogin`, t);
                            return e;
                        } catch  {
                            return null;
                        }
                    }, this.preLoginWithIdpType = async (t)=>this.post(`${H.v1}/user/saml/prelogin`, t), this.postLogin = async (t)=>{
                        const e = await this.post(`${H.v1}/user/saml/postlogin`, t);
                        return this.generateLoginResponse(e);
                    }, this.oidcPostLogin = async (t)=>{
                        const e = await this.post(`${H.v1}/user/oidc/postlogin`, t);
                        return this.generateLoginResponse(e);
                    }, this.login = async (t)=>{
                        const e = await this.post(`${H.v1}/user`, t);
                        return this.generateLoginResponse(e);
                    }, this.loginv2 = async (t)=>{
                        const e = await this.post(`${H.v1}/user`, t);
                        return this.generateLoginResponseV3(e);
                    }, this.loginWithMfa = async (t)=>{
                        const e = await this.post(`${H.v1}/user/mfa/verify`, t);
                        return this.generateLoginResponse(e);
                    }, this.loginWithMfaV2 = async (t)=>{
                        const e = await this.post(`${H.v1}/user/mfa/verify`, t);
                        return this.generateLoginResponseV3(e);
                    }, this.activateAccount = async (t)=>this.post(`${z.v1}/activate`, t), this.activateAccountV2 = async (t)=>{
                        const e = await this.post(`${z.v1}/activate`, t);
                        return this.generateLoginResponseV3(e);
                    }, this.activateAccountWithOTC = async (t)=>{
                        const e = await this.post(`${z.v1}/activate/code`, t);
                        return this.generateLoginResponseV3(e);
                    }, this.getActivateAccountStrategy = async (t)=>this.get(`${z.v1}/activate/strategy`, t), this.resendActivationEmail = async (t)=>this.post(`${z.v1}/activate/reset`, t), this.resendInvitationEmail = async (t)=>this.post(`${z.v1}/invitation/reset`, t), this.acceptInvitation = async (t)=>this.post(`${z.v1}/invitation/accept`, t), this.acceptInvitationWithOTC = async (t)=>this.post(`${z.v1}/invitation/accept/code`, t), this.refreshToken = async ()=>{
                        const t = oe(this.appName), e = await this.post(`${H.v1}/user/token/refresh`, {
                            tenantId: t
                        });
                        return this.generateLoginResponse(e);
                    }, this.refreshTokenV2 = async ()=>{
                        const t = oe(this.appName), e = await this.post(`${H.v1}/user/token/refresh`, {
                            tenantId: t
                        });
                        return this.generateLoginResponseV2(e);
                    }, this.refreshTokenV3 = async ()=>{
                        const t = oe(this.appName), e = await this.post(`${H.v1}/user/token/refresh`, {
                            tenantId: t
                        });
                        return this.generateLoginResponseV3(e);
                    }, this.logout = async ()=>this.post(`${H.v1}/logout`), this.OAuthLogout = async (t)=>this.get(`${wt}/logout`, t), this.forgotPassword = async (t)=>this.post(`${z.v1}/passwords/reset`, t), this.resetPassword = async (t)=>this.post(`${z.v1}/passwords/reset/verify`, t), this.loadPasswordConfig = async (t)=>this.get(`${z.v1}/passwords/config`, t), this.recoverMfaToken = async (t)=>this.post(`${H.v1}/user/mfa/recover`, t), this.enrollMfa = async ()=>this.post(`${z.v1}/mfa/enroll`), this.preEnrollMFAAuthenticatorApp = async ()=>this.post(`${z.v1}/mfa/authenticator/enroll`), this.enrollMFAAuthenticatorApp = async (t)=>this.post(`${z.v1}/mfa/authenticator/enroll/verify`, t), this.preEnrollMFASMS = async (t)=>this.post(`${z.v1}/mfa/sms/enroll`, t), this.enrollMFASMS = async (t)=>this.post(`${z.v1}/mfa/sms/enroll/verify`, t), this.preEnrollMFAWebAuthn = async ()=>this.post(`${z.v1}/mfa/webauthn/enroll`), this.enrollMFAWebAuthn = async (t)=>this.post(`${z.v1}/mfa/webauthn/enroll/verify`, t), this.verifyMfa = async (t)=>this.post(`${z.v1}/mfa/enroll/verify`, t), this.disableMfa = async (t)=>this.post(`${z.v1}/mfa/disable`, t), this.disableMFAAuthenticatorApp = async (t, e)=>this.post(`${z.v1}/mfa/authenticator/${t}/disable/verify`, e), this.preDisableMFASMS = async (t)=>this.post(`${z.v1}/mfa/sms/${t}/disable`), this.disableMFASMS = async (t, e)=>this.post(`${z.v1}/mfa/sms/${t}/disable/verify`, e), this.preDisableMFAWebAuthn = async (t)=>this.post(`${z.v1}/mfa/webauthn/${t}/disable`), this.disableMFAWebAuthn = async (t, e)=>this.post(`${z.v1}/mfa/webauthn/${t}/disable/verify`, e), this.getMFADevices = async ()=>this.get(`${z.v1}/mfa/devices`), this.preEnrollMFAAuthenticatorAppForLogin = async (t)=>this.post(`${H.v1}/user/mfa/authenticator/enroll`, t), this.enrollMFAAuthenticatorAppForLogin = async (t)=>this.post(`${H.v1}/user/mfa/authenticator/enroll/verify`, t), this.enrollMFAAuthenticatorAppForLoginV2 = async (t)=>{
                        const e = await this.post(`${H.v1}/user/mfa/authenticator/enroll/verify`, t);
                        return this.generateLoginResponseV3(e);
                    }, this.verifyMFAAuthenticatorAppForLogin = async (t, e)=>this.post(`${H.v1}/user/mfa/authenticator/${t}/verify`, e), this.preVerifyMFAEmailCode = async (t)=>this.post(`${H.v1}/user/mfa/emailcode`, t), this.verifyMFAEmailCode = async (t)=>this.post(`${H.v1}/user/mfa/emailcode/verify`, t), this.verifyMFAEmailCodeV2 = async (t)=>{
                        const e = await this.post(`${H.v1}/user/mfa/emailcode/verify`, t);
                        return this.generateLoginResponseV3(e);
                    }, this.preEnrollMFASMSForLogin = async (t)=>this.post(`${H.v1}/user/mfa/sms/enroll`, t), this.enrollMFASMSForLogin = async (t)=>this.post(`${H.v1}/user/mfa/sms/enroll/verify`, t), this.enrollMFASMSForLoginV2 = async (t)=>{
                        const e = await this.post(`${H.v1}/user/mfa/sms/enroll/verify`, t);
                        return this.generateLoginResponseV3(e);
                    }, this.preVerifyMFASMSForLogin = async (t, e)=>this.post(`${H.v1}/user/mfa/sms/${t}`, e), this.verifyMFASMSForLogin = async (t, e)=>this.post(`${H.v1}/user/mfa/sms/${t}/verify`, e), this.verifyMFASMSForLoginV2 = async (t, e)=>{
                        const a = await this.post(`${H.v1}/user/mfa/sms/${t}/verify`, e);
                        return this.generateLoginResponseV3(a);
                    }, this.preEnrollMFAWebAuthnForLogin = async (t)=>this.post(`${H.v1}/user/mfa/webauthn/enroll`, t), this.enrollMFAWebAuthnForLogin = async (t)=>this.post(`${H.v1}/user/mfa/webauthn/enroll/verify`, t), this.enrollMFAWebAuthnForLoginV2 = async (t)=>{
                        const e = await this.post(`${H.v1}/user/mfa/webauthn/enroll/verify`, t);
                        return this.generateLoginResponseV3(e);
                    }, this.preVerifyMFAWebAuthnForLogin = async (t, e)=>this.post(`${H.v1}/user/mfa/webauthn/${t}`, e), this.verifyMFAWebAuthnForLogin = async (t, e)=>this.post(`${H.v1}/user/mfa/webauthn/${t}/verify`, e), this.verifyMFAWebAuthnForLoginV2 = async (t, e)=>{
                        const a = await this.post(`${H.v1}/user/mfa/webauthn/${t}/verify`, e);
                        return this.generateLoginResponseV3(a);
                    }, this.getSamlConfiguration = async ()=>this.get(`${st.v1}/saml/configurations`), this.updateSamlConfiguration = async (t)=>this.post(`${st.v1}/saml/configurations`, t), this.getSamlVendorConfiguration = async ()=>this.get(`${st.v1}/saml/configurations/vendor-config`), this.updateSamlVendorMetadata = async (t)=>this.put(`${st.v1}/saml/configurations/metadata`, t), this.validateSamlDomain = async ()=>this.put(`${st.v1}/saml/validations/domain`), this.getSamlRoles = async ()=>this.get(`${st.v1}/saml/configurations/roles/default`), this.getSamlRolesGroups = async ()=>this.get(`${st.v2}/saml/configurations/groups`), this.updateSamlRoles = async ({ roleIds: t })=>this.post(`${st.v1}/saml/configurations/roles/default`, {
                            roleIds: t
                        }), this.createSamlGroup = async ({ roleIds: t, group: e })=>this.post(`${st.v2}/saml/configurations/groups`, {
                            group: e,
                            roleIds: t
                        }), this.updateSamlGroup = async ({ roleIds: t, group: e, id: a })=>this.patch(`${st.v2}/saml/configurations/groups/${a}`, {
                            group: e,
                            roleIds: t
                        }), this.deleteSamlGroup = async ({ id: t })=>this.delete(`${st.v2}/saml/configurations/groups/${t}`), this.getOidcConfiguration = async ()=>this.get(`${st.v1}/oidc/configurations`), this.getSSOPublicConfiguration = async ()=>this.get(`${st.v2}/configurations/public`), this.getSocialLoginProviders = async ()=>this.get(J.v1), this.getSocialLoginProvidersV2 = async ()=>this.get(J.v2), this.getSocialLoginProvidersV2ForAuthenticatedUser = async ()=>this.get(`${J.v2}/authenticated`), this.getCustomSocialLoginProvidersV1 = async ()=>this.get(J.custom.v1), this.loginViaSocialLogin = async (t)=>{
                        const e = {};
                        return t.code && (e.code = t.code), t.idToken && (e.id_token = t.idToken), t.redirectUri && (e.redirectUri = t.redirectUri), t.codeVerifier && (e.code_verifier = t.codeVerifier), t.codeVerifierPkce && (e.code_verifier_pkce = t.codeVerifierPkce), t.state && (e.state = t.state), this.post(`${H.v1}/user/sso/${t.provider}/postlogin`, {
                            metadata: t.metadata,
                            invitationToken: t.invitationToken
                        }, {
                            params: e
                        });
                    }, this.getVendorConfig = async ()=>this.get(`${K.v1}/public`), this.signUpUser = async (t)=>{
                        const { shouldActivate: e, authResponse: a, userId: n, tenantId: s, activationToken: i } = await this.post(`${z.v1}/signUp`, t), o = {
                            shouldActivate: e,
                            userId: n,
                            tenantId: s
                        };
                        if (!e && a) {
                            const { user: t, tenants: e, activeTenant: n } = await this.generateLoginResponseV3(a);
                            return v({}, o, {
                                user: t,
                                tenants: e,
                                activeTenant: n
                            });
                        }
                        return v({}, o, {
                            activationToken: i
                        });
                    }, this.getCurrentUserSessions = async ()=>this.get(z.sessions.currentUser.v1), this.getCurrentUserSession = async ()=>this.get(`${z.sessions.currentUser.v1}/current`), this.revokeSessionsForUser = async (t)=>this.post(`${z.sessions.v1}/revoke`, {
                            userId: t
                        }), this.getSessionConfigurations = async ()=>this.get(z.sessions.configurations.v1), this.createOrUpdateSessionConfigrations = async (t)=>{
                        await this.post(z.sessions.configurations.v1, t);
                    }, this.deleteSessionForUser = async (t)=>{
                        await this.delete(`${z.sessions.currentUser.v1}/${t}`);
                    }, this.deleteAllSessionsForUser = async ()=>{
                        await this.delete(`${z.sessions.currentUser.v1}/all`);
                    }, this.getUserAccessTokensData = async ()=>this.get(z.accessTokens.v1), this.getTenantAccessTokensData = async ()=>this.get(X.accessTokens.v1), this.deleteTenantAccessToken = async ({ id: t })=>{
                        await this.delete(`${X.accessTokens.v1}/${t}`);
                    }, this.deleteUserAccessToken = async ({ id: t })=>{
                        await this.delete(`${z.accessTokens.v1}/${t}`);
                    }, this.createUserAccessToken = async (t)=>this.post(z.accessTokens.v1, t), this.createTenantAccessToken = async (t)=>this.post(X.accessTokens.v1, t), this.getUserApiTokensData = async ()=>this.get(z.apiTokens.v1), this.getTenantApiTokensData = async ()=>this.get(X.apiTokens.v1), this.updateUserApiTokensData = async (t)=>this.post(z.apiTokens.v1, t), this.updateTenantApiTokensData = async (t)=>this.post(X.apiTokens.v2, t), this.deleteTenantApiToken = async ({ tokenId: t })=>{
                        await this.delete(`${X.apiTokens.v1}/${t}`);
                    }, this.deleteUserApiToken = async ({ tokenId: t })=>{
                        await this.delete(`${z.apiTokens.v1}/${t}`);
                    }, this.getUserById = async ({ userId: t })=>this.get(`${z.v1}/${t}`), this.checkIfAllowToRememberMfaDevice = async (t)=>this.get(`${K.v1}/mfa-policy/allow-remember-device`, {
                            mfaToken: t
                        }), this.passwordlessPreLogin = async (t)=>{
                        let { type: e } = t, a = f(t, he);
                        return this.post(`${H.v1}/passwordless/${e.toLocaleLowerCase()}/prelogin`, a);
                    }, this.passwordlessPostLoginV2 = async (t)=>{
                        let { type: e } = t, a = f(t, ye);
                        const n = await this.post(`${H.v1}/passwordless/${e.toLocaleLowerCase()}/postlogin`, a);
                        return this.generateLoginResponseV3(n);
                    }, this.passwordlessPostLogin = async (t)=>{
                        let { type: e } = t, a = f(t, Se);
                        return this.post(`${H.v1}/passwordless/${e.toLocaleLowerCase()}/postlogin`, a);
                    }, this.verifyInviteToken = async ({ token: t })=>this.post(X.invites.verify.v1, {
                            token: t
                        }), this.getSSOConfigurations = async ()=>this.get(`${st.v1}/configurations`), this.createSSOConfiguration = async (t)=>this.post(`${st.v1}/configurations`, t), this.updateSSOConfiguration = async (t, e)=>this.patch(`${st.v1}/configurations/${t}`, e), this.deleteSSOConfiguration = async (t)=>{
                        await this.delete(`${st.v1}/configurations/${t}`);
                    }, this.createSSOConfigurationByMetadata = async (t)=>this.post(`${st.v1}/configurations/metadata`, t), this.updateSSOConfigurationByMetadata = async (t, e)=>this.put(`${st.v1}/configurations/${t}/metadata`, e), this.createSSOConfigurationByMetadataUrl = async (t)=>this.post(`${st.v1}/configurations/metadata-url`, t), this.updateSSOConfigurationByMetadataUrl = async (t, e)=>this.put(`${st.v1}/configurations/${t}/metadata-url`, e), this.createSSODomain = async (t, e)=>this.post(`${st.v1}/configurations/${t}/domains`, e), this.deleteSSODomain = async (t, e)=>this.delete(`${st.v1}/configurations/${t}/domains/${e}`), this.validateSSODomain = async (t, e)=>this.put(`${st.v1}/configurations/${t}/domains/${e}/validate`), this.validateSSODomainV2 = async (t, e)=>this.put(`${st.v2}/configurations/${t}/domains/${e}/validate`), this.getSSODefaultRoles = async (t)=>this.get(`${st.v1}/configurations/${t}/roles`), this.setSSODefaultRoles = async (t, e)=>this.put(`${st.v1}/configurations/${t}/roles`, e), this.createSSOGroup = async (t, e)=>this.post(`${st.v1}/configurations/${t}/groups`, e), this.updateSSOGroup = async (t, { roleIds: e, group: a, id: n })=>this.patch(`${st.v1}/configurations/${t}/groups/${n}`, {
                            group: a,
                            roleIds: e
                        }), this.deleteSSOGroup = async (t, e)=>this.delete(`${st.v1}/configurations/${t}/groups/${e}`), this.getSSOGroups = async (t)=>this.get(`${st.v1}/configurations/${t}/groups`), this.preLoginV2 = async (t)=>this.post(`${H.v2}/user/sso/prelogin`, t), this.oidcPostLoginV2 = async (t)=>{
                        const e = await this.post(`${H.v2}/user/oidc/postlogin`, t);
                        return this.generateLoginResponse(e);
                    }, this.exchangeOAuthTokensV2 = async (t)=>{
                        const e = await this.post(`${wt}/token`, t);
                        return this.generateLoginResponseFromOAuthResponseV2(e);
                    }, this.silentOAuthRefreshTokenV2 = async ()=>{
                        const t = oe(this.appName), e = await this.post(`${wt}/authorize/silent`, {
                            tenantId: t
                        });
                        return this.generateLoginResponseFromOAuthResponseV2(e);
                    }, this.exchangeOAuthTokens = async (t)=>{
                        const e = await this.post(`${wt}/token`, t);
                        return this.generateLoginResponseFromOAuthResponse(e);
                    }, this.silentOAuthRefreshToken = async ()=>{
                        const t = oe(this.appName), e = await this.post(`${wt}/authorize/silent`, {
                            tenantId: t
                        });
                        return this.generateLoginResponseFromOAuthResponse(e);
                    }, this.resetPhoneNumber = async (t)=>this.post(`${z.v1}/phone/reset`, t), this.verifyResetPhoneNumber = async (t)=>this.post(`${z.v1}/phone/reset/verify`, t), this.changePhoneNumberWithVerification = async (t)=>this.post(`${z.v1}/phone`, t), this.verifyChangePhoneNumber = async (t)=>this.post(`${z.v1}/phone/verify`, t), this.changePhoneNumber = async (t)=>this.put(`${z.v1}/phone/change`, t), this.webAuthnPreLogin = async (t)=>this.post(`${H.v1}/webauthn/prelogin`, t), this.webAuthnPostLogin = async (t)=>this.post(`${H.v1}/webauthn/postlogin`, t), this.webAuthnPostLoginV2 = async (t)=>{
                        const e = await this.post(`${H.v1}/webauthn/postlogin`, t);
                        return this.generateLoginResponseV3(e);
                    }, this.webAuthnCreateNewDeviceSession = async ()=>this.post(W.v1), this.getWebAuthnDevices = async ()=>this.get(W.v1), this.deleteWebAuthnDevice = async (t)=>this.delete(`${W.v1}/${t}`), this.verifyNewDeviceSession = async (t)=>this.post(`${W.v1}/verify`, t), this.getVendorPublicAuthStrategiesConfig = async ()=>this.get(`${K.v1}/auth/strategies/public`), this.getPublicAuthStrategiesConfigForAuthenticatedUser = async ()=>this.get(`${K.v1}/auth/strategies`), this.getMFAStrategiesConfig = async ()=>this.get(`${K.v1}/mfa/strategies`), this.getUserAuthorization = async ()=>this.get(`${z.authorization.v1}`), this.getMeV2 = async ()=>this.get(`${z.v2}/me`), this.noThrowLoadEntitlements = async ()=>{
                        try {
                            return await this.entitlementsApi.loadEntitlementsV2();
                        } catch (t) {}
                    }, this.getMeAndEntitlements = async ()=>{
                        if (C.for(this.appName).shouldSkipUserLoad()) return {
                            roles: [],
                            permissions: [],
                            groups: [],
                            tenants: []
                        };
                        const t = [
                            {
                                action: this.getMeV2,
                                shouldLoad: !0
                            },
                            {
                                action: this.noThrowLoadEntitlements,
                                shouldLoad: this.shouldLoadEntitlements()
                            },
                            {
                                action: this.getUserAuthorization,
                                shouldLoad: this.shouldLoadMeAuthorization()
                            }
                        ].map((t)=>(async function({ shouldLoad: t, action: e }) {
                                if (t) return await e();
                            })(t)), [e, a, n] = await Promise.all(t), s = oe(this.appName);
                        return s && (e.tenantId = s), v({}, e, null != n ? n : {}, {
                            entitlements: a
                        });
                    }, this.generateStepupSession = async (t)=>{
                        const e = await this.post(`${H.v1}/user/step-up/generate`, t);
                        return e.accessToken ? this.generateLoginResponseV3(e) : e;
                    }, this.getGlobalSecurityPolicy = this.securityPolicy.getGlobalSecurityPolicy.bind(this.securityPolicy), this.getMfaPolicy = this.securityPolicy.getMfaPolicy.bind(this.securityPolicy), this.getVendorMfaPolicy = this.securityPolicy.getVendorMfaPolicy.bind(this.securityPolicy), this.saveMfaPolicy = this.securityPolicy.saveMfaPolicy.bind(this.securityPolicy), this.getLockoutPolicy = this.securityPolicy.getLockoutPolicy.bind(this.securityPolicy), this.getVendorLockoutPolicy = this.securityPolicy.getVendorLockoutPolicy.bind(this.securityPolicy), this.saveLockoutPolicy = this.securityPolicy.saveLockoutPolicy.bind(this.securityPolicy), this.getCaptchaPolicy = this.securityPolicy.getCaptchaPolicy.bind(this.securityPolicy), this.getPasswordHistoryPolicy = this.securityPolicy.getPasswordHistoryPolicy.bind(this.securityPolicy), this.getVendorPasswordHistoryPolicy = this.securityPolicy.getVendorPasswordHistoryPolicy.bind(this.securityPolicy), this.savePasswordHistoryPolicy = this.securityPolicy.savePasswordHistoryPolicy.bind(this.securityPolicy), this.getPasswordConfigPolicy = this.securityPolicy.getPasswordConfigPolicy.bind(this.securityPolicy), this.getDomainRestrictions = this.securityPolicy.getDomainRestrictions.bind(this.securityPolicy), this.getDomainRestrictionsConfig = this.securityPolicy.getDomainRestrictionsConfig.bind(this.securityPolicy), this.createDomainRestriction = this.securityPolicy.createDomainRestriction.bind(this.securityPolicy), this.updateDomainRestrictionConfig = this.securityPolicy.updateDomainRestrictionConfig.bind(this.securityPolicy), this.deleteDomainRestriction = this.securityPolicy.deleteDomainRestriction.bind(this.securityPolicy), this.getIPRestrictions = this.securityPolicy.getIPRestrictions.bind(this.securityPolicy), this.getIPRestrictionsConfig = this.securityPolicy.getIPRestrictionsConfig.bind(this.securityPolicy), this.createIPRestriction = this.securityPolicy.createIPRestriction.bind(this.securityPolicy), this.bulkCreateIPRestriction = this.securityPolicy.bulkCreateIPRestriction.bind(this.securityPolicy), this.updateIPRestrictionConfig = this.securityPolicy.updateIPRestrictionConfig.bind(this.securityPolicy), this.deleteIPRestriction = this.securityPolicy.deleteIPRestriction.bind(this.securityPolicy), this.testCurrentIp = this.securityPolicy.testCurrentIp.bind(this.securityPolicy), this.testCurrentIpInAllowList = this.securityPolicy.testCurrentIpInAllowList.bind(this.securityPolicy);
                }
                shouldLoadEntitlements() {
                    return C.for(this.appName).shouldLoadEntitlements();
                }
                shouldLoadMeAuthorization() {
                    const [t] = Xt.getFeatureFlags([
                        qt
                    ], this.appName);
                    return t;
                }
            }
            const fe = new ve("default");
            class me extends Jt {
                constructor(t){
                    super(t), this.getProfile = async (t)=>this.get(`${z.v2}/me`, null != t ? t : {
                            addRoles: !0
                        }), this.updateProfile = async (t)=>this.put(`${z.v2}/me`, t), this.updateProfileImage = async (t)=>this.put(`${lt.v1}/me/image/v1`, t, {
                            responseType: "plain",
                            contentType: void 0
                        }), this.changePassword = async (t)=>this.post(`${z.v1}/passwords/change`, t), this.loadUsers = async (t)=>{
                        var e, a, n, s, i, o;
                        const r = (t.filter || []).reduce((t, e)=>v({}, t, {
                                [e.id]: e.value
                            }), {}), l = null != (e = t.sort) && e.length ? {
                            sortBy: null != (a = null == (n = t.sort) || null == (s = n[0]) ? void 0 : s.id) ? a : "name",
                            sortDirection: null != (i = t.sort) && null != (o = i[0]) && o.desc ? "desc" : "asc"
                        } : null;
                        return this.get(it.v1, v({
                            pageOffset: t.pageOffset,
                            pageSize: t.pageSize
                        }, r, l));
                    }, this.addUser = async (t)=>this.post(z.v2, v({}, t, {
                            provider: "local"
                        })), this.deleteUser = async (t)=>this.delete(`${it.v1}/${t.userId}`), this.updateUser = async (t)=>this.put(it.v1, t), this.updateUserExpirationTime = async (t)=>{
                        const { userId: e, expirationInSeconds: a } = t;
                        return this.put(`${z.temporary.v1}/${e}`, {
                            expirationInSeconds: a
                        });
                    }, this.setPermanentUser = async (t)=>this.delete(`${z.temporary.v1}/${t}`), this.getTemporaryUserConfiguration = async ()=>this.get(z.temporary.configuration.v1), this.createInviteUserLink = async (t)=>this.post(X.invites.user.v1, v({}, t)), this.updateInviteUserLink = async (t)=>this.patch(X.invites.user.v1, v({}, t)), this.deleteInviteUserLink = async ()=>this.delete(X.invites.user.v1), this.getInviteUserLink = async ()=>this.get(X.invites.user.v1), this.getInviteLinkConfiguration = async ()=>this.get(X.invites.configuration.v1), this.loadAvailableRoles = async ()=>this.get(ot.v1), this.loadAvailablePermissions = async ()=>this.get(Y.v1), this.loadStats = async ()=>this.get(`${rt.v1}/members`), this.resendActivationLink = async (t)=>this.post(`${it.v1}/${t.userId}/resendActivationEmail`, {}), this.resendInvitationLink = async (t)=>this.post(z.v2, v({}, t, {
                            provider: "local"
                        })), this.resendInvitationLinkToAllTenants = async (t)=>this.post(z.invitation.resendAll.v1, v({}, t)), this.disableUser = async (t)=>this.post(`${X.users.v1}/${t}/disable`), this.enableUser = async (t)=>this.post(`${X.users.v1}/${t}/enable`);
                }
            }
            const be = new me("default");
            class Ae extends Jt {
                constructor(t){
                    super(t), this.getMetadata = async (t)=>{
                        var e, a;
                        const n = await this.get("/metadata", t);
                        if (null != n && null != (e = n.rows) && e[0]) return null == n || null == (a = n.rows) ? void 0 : a[0];
                        throw new Error(`metadata not found: ${t.entityName}`);
                    }, this.getAdminBoxMetadata = async ()=>this.get("/metadata/admin-box"), this.updateAdminBoxMetadata = async (t)=>this.post("/metadata/admin-box", t), this.getIpMetadata = async (t)=>{
                        const e = await this.get(`/metadata/ip/${t}`);
                        if (e) return e;
                        throw new Error("ip metadata not found");
                    }, this.getCurrentUserIpMetadata = async ()=>{
                        const t = await this.get("/metadata/ipme");
                        if (t) return t;
                        throw new Error("ip metadata not found");
                    }, this.getNotificationsMetadata = async ()=>this.getMetadata({
                            entityName: "notifications"
                        }), this.getSamlMetadata = async ()=>this.getMetadata({
                            entityName: "saml"
                        }), this.getAuditsMetadata = async ()=>this.getMetadata({
                            entityName: "audits"
                        }), this.getIpAdressMetadata = async (t)=>this.getIpMetadata(t);
                }
            }
            const we = new Ae("default"), Te = [
                "dataFilters"
            ], Ee = [
                "templateId",
                "dataFilters"
            ], Ie = [
                "dataFilters"
            ];
            class Oe extends Jt {
                constructor(t){
                    super(t), this.getReports = async (t)=>this.get(`${St.v2}/tenant-reports`, t), this.getReport = async (t)=>this.get(`${St.v2}/${t.id}/tenant-reports`), this.renderReport = async (t)=>{
                        let { dataFilters: e } = t, a = f(t, Te);
                        return {
                            html: await this.get(`${vt.v1}/preview-report`, v({}, a, {
                                dataFilters: btoa(JSON.stringify(e || {})),
                                responseType: "html"
                            }), {
                                responseType: "plain"
                            })
                        };
                    }, this.scheduleReport = async (t)=>{
                        let { templateId: e, dataFilters: a } = t, n = f(t, Ee);
                        return this.post(`${St.v2}/${e}/tenant-reports`, v({}, n, {
                            dataFilters: btoa(JSON.stringify(a || {}))
                        }));
                    }, this.downloadReport = async (t)=>{
                        let { dataFilters: e } = t, a = f(t, Ie);
                        const n = await this.get(`${vt.v1}/preview-report`, v({}, a, {
                            dataFilters: btoa(JSON.stringify(e || {}))
                        }), {
                            responseType: "blob"
                        });
                        let s = "text/html", i = "html";
                        "pdf" === a.responseType ? (s = "application/pdf", i = "pdf") : "image" === a.responseType && (s = "image/jpeg", i = "jpg");
                        const o = new Blob([
                            n
                        ], {
                            type: s
                        }), r = URL.createObjectURL(o), l = document.createElement("a");
                        l.href = r, l.setAttribute("download", `report_${a.name || ""}.${i}`), l.click(), setTimeout(l.remove.bind(l));
                    }, this.sendReport = async (t)=>this.post(`${vt.v1}/tenant-reports`, t);
                }
            }
            const Pe = new Oe("default"), ke = [
                "eventKey"
            ], _e = [
                "eventKey"
            ];
            class Re extends Jt {
                constructor(t){
                    super(t), this.getSlackConfiguration = ()=>this.get(`${gt.v1}/slack`), this.getSlackScope = ()=>this.get(`${gt.v1}/slack/applications`), this.getSlackChannels = ()=>this.get(`${gt.v1}/slack/channels`), this.postSlackConfiguration = (t)=>t.id ? this.patch(`${gt.v1}/slack/subscription/${t.id}`, t) : this.post(`${gt.v1}/slack/subscriptions`, t), this.deleteSlackConfiguration = (t)=>this.delete(`${gt.v1}/slack/subscriptions/${t.id}`), this.postSlackCode = (t)=>this.post(`${gt.v1}/slack/applications/registrations`, {
                            code: t
                        }), this.getEmailConfiguration = ()=>this.get(`${gt.v1}/emails`), this.postEmailConfiguration = (t)=>{
                        let { eventKey: e } = t, a = f(t, ke);
                        return this.post(`${gt.v1}/emails/${e}`, a);
                    }, this.patchEmailConfiguration = ({ eventKey: t, enabled: e })=>this.patch(`${gt.v1}/emails/${t}`, {
                            enabled: e
                        }), this.deleteEmailSubscriptions = (t, e)=>this.delete(`${gt.v1}/emails/${t}/subscriptions/${e}`), this.putEmailSubscriptions = (t, e, a)=>this.put(`${gt.v1}/emails/${e}/subscriptions/${t}`, a), this.deleteEmailConfiguration = (t)=>this.delete(`${gt.v1}/emails/${t}`), this.getSMSConfiguration = ()=>this.get(`${gt.v2}/sms`), this.postSMSConfiguration = (t)=>{
                        let { eventKey: e } = t, a = f(t, _e);
                        return this.post(`${gt.v2}/sms/${e}`, a);
                    }, this.patchSMSConfiguration = ({ eventKey: t, enabled: e })=>this.patch(`${gt.v2}/sms/${t}`, {
                            enabled: e
                        }), this.deleteSMSSubscriptions = (t, e)=>this.delete(`${gt.v2}/sms/${t}/subscriptions/${e}`), this.putSMSSubscriptions = (t, e, a)=>this.put(`${gt.v2}/sms/${e}/subscriptions/${t}`, a), this.deleteSMSConfiguration = (t)=>this.delete(`${gt.v2}/sms/${t}`), this.getWebhooksConfigurations = ()=>this.get(At), this.postWebhooksConfiguration = (t)=>t._id ? this.patch(`${At}/${t._id}`, t) : this.post(`${At}/custom`, t), this.deleteWebhooksConfiguration = (t)=>this.delete(`${At}/${t}`), this.getWebhookLog = (t, e = 0, a = 10)=>{
                        const n = new URLSearchParams({
                            id: t,
                            offset: `${e}`,
                            limit: `${a}`
                        });
                        return this.get(`${At}/logs/?${n.toString()}`);
                    }, this.postWebhookTest = (t)=>this.post(`${At}/test`, t), this.postWebhookRetry = (t)=>this.post(`${At}/logs/${t}/retries`), this.getCategories = ()=>this.get(`${bt.v1}/categories`), this.getChannelMaps = (t)=>this.get(bt.v1, {
                            channels: t
                        });
                }
            }
            const Ce = new Re("default");
            class Le extends Jt {
                constructor(t){
                    super(t), this.getNotifications = async (t)=>this.get(ft, {
                            params: t
                        }), this.updateNotificationStatus = async (t)=>this.put(`${ft}/status`, {
                            params: t
                        }), this.updateNotificationIsPinned = async (t)=>{
                        const { notificationId: e, pinStatus: a } = t;
                        return this.put(`${ft}/${a}`, {
                            notificationId: e
                        });
                    }, this.markAllAsRead = async ()=>this.post(`${ft}/status/mark-all-read`);
                }
            }
            const Ue = new Le("default"), De = [
                "endpoint",
                "headerProps"
            ];
            class Ne extends Jt {
                constructor(t){
                    super(t), this.getAudits = async (t)=>this.get(mt, t), this.getAuditsStats = async (t)=>this.get(`${mt}/stats`, t), this.exportAudits = async (t)=>{
                        const { endpoint: e, headerProps: a } = t, n = f(t, De);
                        return this.postDownload(`${mt}/export/${e}`, {
                            properties: a
                        }, n);
                    };
                }
            }
            const Me = new Ne("default");
            class Fe extends Jt {
                constructor(t){
                    super(t), this.updateSettings = async (t, e)=>this.put(ct.v1, t, {
                            headers: this.extractHeadersFromOptions(e)
                        }), this.getSettings = async (t)=>this.get(ct.v1, void 0, {
                            headers: this.extractHeadersFromOptions(t)
                        }), this.getPublicSettings = async ()=>this.get(`${ct.v1}/public`);
                }
            }
            const xe = new Fe("default"), Ge = [
                "roleId"
            ], $e = [
                "roleId"
            ], je = [
                "permissionId"
            ];
            class Be extends Jt {
                constructor(t){
                    super(t), this.getRoles = async ()=>this.get(Q.v1), this.addRole = async (t)=>this.post(Q.v1, t), this.deleteRole = async ({ roleId: t })=>this.delete(`${Q.v1}/${t}`), this.updateRole = async (t)=>{
                        let { roleId: e } = t, a = f(t, Ge);
                        return this.patch(`${Q.v1}/${e}`, a);
                    }, this.attachPermissionsToRole = async (t)=>{
                        let { roleId: e } = t, a = f(t, $e);
                        return this.put(`${Q.v1}/${e}/permissions`, a);
                    }, this.getPermissions = async ()=>this.get(Y.v1), this.attachPermissionToRoles = async (t)=>{
                        let { permissionId: e } = t, a = f(t, je);
                        return this.put(`${Y.v1}/${e}/roles`, a);
                    }, this.getPermissionCategories = async ()=>this.get(`${Y.v1}/categories`), this.addRoleV2 = async (t)=>this.post(Q.v2, t);
                }
            }
            const Ve = new Be("default");
            class We extends Jt {
                constructor(...t){
                    super(...t), this.getSubscriptionInvoices = async ()=>this.get(pt.invoices.v1), this.getSubscriptionInvoice = async (t)=>this.get(`${pt.invoices.v1}/${t}`), this.getSubscriptionInvoicePdf = async (t, e)=>this.get(`${pt.invoices.v1}/${t}/pdf`, {
                            outputFileName: e
                        }, {
                            responseType: "blob"
                        });
                }
            }
            class He extends Jt {
                constructor(...t){
                    super(...t), this.getManagedSubscription = async (t)=>this.get(`${yt.v1}/${t}`), this.getManagedSubscriptions = async ()=>this.get(yt.v1), this.cancelManagedSubscription = async (t)=>this.put(`${yt.v1}/${t}/cancellations/`, {}), this.renewManagedSubscription = async (t)=>this.put(`${yt.v1}/${t}/renewals/`, {}), this.updateManagedSubscription = async (t, { paymentMethodId: e, planId: a })=>this.put(`${yt.v1}/${t}`, {
                            paymentMethodId: e,
                            planId: a
                        });
                }
            }
            const ze = [
                "email"
            ];
            class Ke extends Jt {
                constructor(...t){
                    super(...t), this.getPaymentMethods = async ()=>this.get(pt.paymentMethods.v1), this.getPaymentMethod = async (t)=>this.get(`${pt.paymentMethods.v1}/${t}`), this.updatePaymentMethodBillingDetails = async (t, e)=>{
                        let { email: a } = e, n = f(e, ze);
                        return this.patch(`${pt.paymentMethods.v1}/${t}/billing-details`, {
                            email: a,
                            address: n
                        });
                    };
                }
            }
            class qe extends Jt {
                constructor(...t){
                    super(...t), this.getPaymentProviders = async ()=>this.get(ht.v1);
                }
            }
            class Je extends Jt {
                constructor(...t){
                    super(...t), this.getSubscriptionPlans = async ()=>this.get(pt.plans.v1), this.getSubscriptionPlan = async (t)=>this.get(`${pt.plans.v1}/${t}`);
                }
            }
            class Ye extends Jt {
                constructor(...t){
                    super(...t), this.getSubscriptions = async ()=>this.get(pt.subscriptions.v1), this.getSubscription = async (t)=>this.get(`${pt.subscriptions.v1}/${t}`), this.cancelSubscription = async (t)=>this.put(`${pt.subscriptions.v1}/${t}/cancellations/`, {}), this.renewSubscription = async (t)=>this.put(`${pt.subscriptions.v1}/${t}/renewals/`, {}), this.updateSubscription = async (t, { paymentMethodId: e, planId: a })=>this.put(`${pt.subscriptions.v1}/${t}`, {
                            paymentMethodId: e,
                            planId: a
                        });
                }
            }
            class Xe extends Jt {
                constructor(...t){
                    super(...t), this.getSubscriptionSummaries = async (t)=>this.get(`${pt.summaries.v1}/${t}`);
                }
            }
            class Qe extends Jt {
                constructor(...t){
                    super(...t), this.getTenantConfiguration = async (t)=>this.get(`${pt.tenantConfiguration.v1}/${t}`), this.createTenantConfiguration = async (t)=>this.post(pt.tenantConfiguration.v1, t);
                }
            }
            class Ze extends Jt {
                constructor(...t){
                    super(...t), this.getVendorPublicConfigurations = async ()=>this.get(pt.configurations.vendorPublicConfigurations.v1);
                }
            }
            class ta extends Jt {
                constructor(...t){
                    super(...t), this.createSubscription = async (t)=>this.post(pt.paymentProviders.stripe.subscriptions.v1, t), this.getStripeCustomer = async (t)=>this.get(`${pt.paymentProviders.stripe.customers.v1}/${t}`), this.createStripeCustomer = async (t)=>this.post(pt.paymentProviders.stripe.customers.v1, t), this.getStripePaymentProviderConfiguration = async ()=>this.get(pt.paymentProviders.stripe.publicConfigurations.v1), this.createStripePaymentMethodSetupIntentSecret = async (t)=>this.post(pt.paymentProviders.stripe.setupIntents.v1, t);
                }
            }
            class ea extends Jt {
                constructor(t){
                    super(t), this.invoicesApi = new We(this.appName), this.managedSubscriptionApi = new He(this.appName), this.paymentMethodsApi = new Ke(this.appName), this.paymentProvidersApi = new qe(this.appName), this.plansApi = new Je(this.appName), this.subscriptionApi = new Ye(this.appName), this.summariesApi = new Xe(this.appName), this.subscriptionTenantConfigApi = new Qe(this.appName), this.vendorPublicConfigApi = new Ze(this.appName), this.stripeProviderApi = new ta(this.appName), this.getSubscriptionInvoices = this.invoicesApi.getSubscriptionInvoices.bind(this.invoicesApi), this.getSubscriptionInvoice = this.invoicesApi.getSubscriptionInvoice.bind(this.invoicesApi), this.getSubscriptionInvoicePdf = this.invoicesApi.getSubscriptionInvoicePdf.bind(this.invoicesApi), this.getManagedSubscription = this.managedSubscriptionApi.getManagedSubscription.bind(this.managedSubscriptionApi), this.getManagedSubscriptions = this.managedSubscriptionApi.getManagedSubscriptions.bind(this.managedSubscriptionApi), this.cancelManagedSubscription = this.managedSubscriptionApi.cancelManagedSubscription.bind(this.managedSubscriptionApi), this.renewManagedSubscription = this.managedSubscriptionApi.renewManagedSubscription.bind(this.managedSubscriptionApi), this.updateManagedSubscription = this.managedSubscriptionApi.updateManagedSubscription.bind(this.managedSubscriptionApi), this.getPaymentMethods = this.paymentMethodsApi.getPaymentMethods.bind(this.paymentMethodsApi), this.getPaymentMethod = this.paymentMethodsApi.getPaymentMethod.bind(this.paymentMethodsApi), this.updatePaymentMethodBillingDetails = this.paymentMethodsApi.updatePaymentMethodBillingDetails.bind(this.paymentMethodsApi), this.getPaymentProviders = this.paymentProvidersApi.getPaymentProviders.bind(this.paymentProvidersApi), this.getSubscriptionPlans = this.plansApi.getSubscriptionPlans.bind(this.plansApi), this.getSubscriptionPlan = this.plansApi.getSubscriptionPlan.bind(this.plansApi), this.getSubscriptions = this.subscriptionApi.getSubscriptions.bind(this.subscriptionApi), this.getSubscription = this.subscriptionApi.getSubscription.bind(this.subscriptionApi), this.cancelSubscription = this.subscriptionApi.cancelSubscription.bind(this.subscriptionApi), this.renewSubscription = this.subscriptionApi.renewSubscription.bind(this.subscriptionApi), this.updateSubscription = this.subscriptionApi.updateSubscription.bind(this.subscriptionApi), this.getSubscriptionSummaries = this.summariesApi.getSubscriptionSummaries.bind(this.summariesApi), this.getTenantConfiguration = this.subscriptionTenantConfigApi.getTenantConfiguration.bind(this.subscriptionTenantConfigApi), this.createTenantConfiguration = this.subscriptionTenantConfigApi.createTenantConfiguration.bind(this.subscriptionTenantConfigApi), this.getVendorPublicConfigurations = this.vendorPublicConfigApi.getVendorPublicConfigurations.bind(this.vendorPublicConfigApi), this.createSubscription = this.stripeProviderApi.createSubscription.bind(this.stripeProviderApi), this.getStripeCustomer = this.stripeProviderApi.getStripeCustomer.bind(this.stripeProviderApi), this.createStripeCustomer = this.stripeProviderApi.createStripeCustomer.bind(this.stripeProviderApi), this.getStripePaymentProviderConfiguration = this.stripeProviderApi.getStripePaymentProviderConfiguration.bind(this.stripeProviderApi), this.createStripePaymentMethodSetupIntentSecret = this.stripeProviderApi.createStripePaymentMethodSetupIntentSecret.bind(this.stripeProviderApi);
                }
            }
            const aa = new ea("default");
            class na extends Jt {
                constructor(t){
                    super(t), this.getVendorPublicInfo = async ()=>this.get("/vendors/public");
                }
            }
            const sa = new na("default");
            class ia extends Jt {
                constructor(t){
                    super(t), this.loadAllUsers = async (t)=>this.get(Z.v1, t), this.addUserToTenantAndSubTenants = async (t)=>this.post(Z.v1, t), this.removeUserFromTenantAndSubTenants = async (t, e)=>this.delete(Z.v1, t, {
                            headers: this.extractHeadersFromOptions(e)
                        }), this.addUserRolesForSubTenants = async (t, e, a)=>this.post(`${Z.v1}/${t}/roles`, e, {
                            headers: this.extractHeadersFromOptions(a)
                        }), this.removeUserRolesFromSubTenants = async (t, e, a)=>this.delete(`${Z.v1}/${t}/roles`, e, {
                            headers: this.extractHeadersFromOptions(a)
                        }), this.setUserRolesForSubTenants = async (t, e, a)=>this.patch(`${Z.v1}/${t}/roles`, e, {
                            headers: this.extractHeadersFromOptions(a)
                        }), this.createSubTenant = async (t, e)=>this.post(dt.v1, t, {
                            headers: this.extractHeadersFromOptions(e)
                        }), this.deleteSubTenant = async (t, e)=>this.delete(`${dt.v1}/${t}`, void 0, {
                            headers: this.extractHeadersFromOptions(e)
                        }), this.updateSubTenant = async ({ tenantId: t }, e, a)=>this.patch(`${dt.v1}/${t}`, e, {
                            headers: this.extractHeadersFromOptions(a)
                        }), this.updateSubTenantManagement = async ({ tenantId: t }, e, a)=>this.put(`${dt.v1}/${t}/management`, e, {
                            headers: this.extractHeadersFromOptions(a)
                        }), this.updateSubAccountAccess = async (t, e, a)=>this.put(`${Z.v1}/${t}/access`, e, {
                            headers: this.extractHeadersFromOptions(a)
                        }), this.addUsersToSubTenant = async (t, e)=>this.post(`${Z.v2}/`, t, {
                            headers: this.extractHeadersFromOptions(e)
                        });
                }
                updateSubTenantHierarchySettings({ tenantId: t }, e, a) {
                    return this.put(`${dt.v1}/${t}/hierarchy-settings`, e, {
                        headers: this.extractHeadersFromOptions(a)
                    });
                }
            }
            const oa = new ia("default");
            class ra extends Jt {
                constructor(t){
                    super(t), this.getConfigs = async ()=>this.get(`${Et}`), this.updateConfiguration = async (t, e)=>this.patch(`${Et}/${t}`, e), this.createConfiguration = async (t)=>this.post(`${Et}`, t), this.deleteConfiguration = async (t)=>this.delete(`${Et}/${t}`), this.countConfigurationUsers = async (t)=>this.get(`${It}/${t}/Users/count`);
                }
            }
            const la = new ra("default");
            class ca extends Jt {
                constructor(t){
                    super(t), this.impersonate = async (t)=>this.post(`${tt.v1}`, t);
                }
            }
            const ua = new ca("default"), da = [
                "groupId"
            ];
            class ga extends Jt {
                constructor(t){
                    super(t), this.getGroupById = async ({ groupId: t }, e)=>this.get(`${at.v1}/${t}`, v({}, e)), this.getGroups = async (t)=>this.get(`${at.v1}`, v({}, t)), this.getGroupsByIds = async (t, e)=>this.post(`${at.getByIds.v1}`, t, {
                            params: e
                        }), this.createGroup = async (t)=>this.post(`${at.v1}`, t), this.updateGroup = async (t)=>{
                        let { groupId: e } = t, a = f(t, da);
                        return this.patch(`${at.v1}/${e}`, a);
                    }, this.deleteGroup = async (t)=>this.delete(`${at.v1}/${t}`), this.addRolesToGroup = async (t, e)=>this.post(`${at.v1}/${t}/roles`, e), this.deleteRolesFromGroup = async (t, e)=>this.delete(`${at.v1}/${t}/roles`, e), this.addUsersToGroup = async (t, e)=>this.post(`${at.v1}/${t}/users`, e), this.deleteUsersFromGroup = async (t, e)=>this.delete(`${at.v1}/${t}/users`, e), this.getGroupConfiguration = async ()=>this.get(`${at.configurations.v1}`), this.updateGroupConfiguration = async (t)=>this.post(`${at.configurations.v1}`, t);
                }
            }
            const pa = new ga("default");
            class ha extends Jt {
                constructor(t){
                    super(t), this.getRecommendations = async ()=>this.get(Pt.v1), this.getInsights = async ()=>this.get(kt.v1);
                }
            }
            const ya = new ha("default");
            class Sa extends Jt {
                constructor(t){
                    super(t), this.getUserPhoneNumbers = async (t)=>this.get(`${nt.v1}`, t), this.getUserOwnPhoneNumbers = async ()=>this.get(`${nt.v1}/me`), this.createPhoneNumber = async (t)=>this.post(`${nt.v1}`, t), this.deletePhoneNumber = async (t)=>this.delete(`${nt.v1}/${t}`), this.preVerifyPhoneNumber = async (t)=>this.post(`${nt.v1}/preverify`, t), this.verifyPhoneNumber = async (t)=>this.post(`${nt.v1}/verify`, t), this.verifyDeletePhoneNumber = async (t, e)=>this.post(`${nt.v1}/${t}/delete/verify`, e);
                }
            }
            const va = new Sa("default");
            class fa extends Jt {
                constructor(t){
                    super(t), this.getUserApplicationsId = async ({ userId: t })=>this.get(`${et.v1}/${t}/apps`), this.getUsersApplicationsId = async ({ userIds: t })=>this.get(`${et.v1}/users-apps`, {
                            userIds: t.join(",")
                        }), this.getTenantsApplications = async ()=>this.get(Rt.v1), this.getApplicationsData = async ({ appIds: t, includeFreeAccess: e = !0 })=>this.get(_t, {
                            ids: t.join(","),
                            _includeFreeAccess: e
                        }), this.assignUserToApplications = async (t)=>this.post(`${et.v1}/apps-user`, t), this.unassignUserFromApplications = async (t)=>this.delete(`${et.v1}/user-apps`, t), this.getUsersOfApplications = async ({ appIds: t })=>this.get(`${et.v1}/apps-users`, {
                            appIds: t.join(",")
                        });
                }
            }
            const ma = new fa("default"), ba = {
                "x-frontegg-api-key": "my-frontegg-api-key",
                "frontegg-vendor-id": "04ae2174-d8d9-4a90-8bab-2548e210a508",
                "frontegg-tenant-id": "02e6ab6f-8b25-48e4-b06d-2c53745ce213",
                "frontegg-user-id": "e5c397a1-7120-4753-9216-e5d7f35d1f2d"
            };
            class Aa extends Jt {
                constructor(t){
                    super(t), this.getAgentsConfig = async ()=>this.get(`${Ct}/config`, void 0, {
                            headers: ba
                        }), this.getConversations = async ()=>this.get(`${Ct}/conversations`, void 0, {
                            headers: ba
                        }), this.getConversationById = async (t)=>this.get(`${Ct}/conversation/${t.id}`, void 0, {
                            headers: ba
                        }), this.createConversation = async (t)=>this.post(`${Ct}/conversations`, {
                            message: t.message,
                            stream: t.stream
                        }, {
                            responseType: !1 === t.stream ? "json" : "stream",
                            headers: ba
                        }), this.sendMessage = async (t)=>this.post(`${Ct}/conversation/${t.conversationId}/messages`, {
                            message: t.message,
                            stream: t.stream
                        }, {
                            responseType: !1 === t.stream ? "json" : "stream",
                            headers: ba
                        }), this.sendApiResponse = async (t)=>this.post(`${Ct}/conversation/${t.conversationId}/response/${t.callId}`, {
                            data: t.data,
                            status: t.status,
                            stream: t.stream
                        }, {
                            responseType: !1 === t.stream ? "json" : "stream",
                            headers: ba
                        }), this.getConversationResource = async (t)=>this.get(`${Ct}/conversation/${t.conversationId}/resource/${t.resourceId}`, void 0, {
                            headers: ba
                        });
                }
            }
            const wa = new Aa("default");
            let Ta, Ea, Ia, Oa, Pa;
            !function(t) {
                t.FRONTEGG = "frontegg", t.SCIM2 = "scim2";
            }(Ta || (Ta = {})), function(t) {
                t.createdAt = "createdAt", t.name = "name", t.tenantId = "tenantId";
            }(Ea || (Ea = {})), function(t) {
                t.CUSTOMER = "customer", t.SPAM = "spam", t.TEST = "test", t.RESELLER = "reseller", t.HEADQUARTER = "headquarter";
            }(Ia || (Ia = {})), function(t) {
                t.NEVER = "NEVER", t.ALWAYS = "ALWAYS", t.ASSIGNABLE = "ASSIGNABLE";
            }(Oa || (Oa = {})), function(t) {
                t.DEFAULT_OFF = "defaultOff", t.DEFAULT_ON = "defaultOn", t.ALWAYS_ON = "alwaysOn";
            }(Pa || (Pa = {}));
            const ka = [
                /^(.*)\/logout$/g,
                "/logout",
                /^\/identity\/resources\/auth\/v[0-9]*\/user\/[^\/]*\/postlogin$/g,
                /^\/identity\/resources\/impersonation\/v[0-9]$/g,
                /^\/identity\/resources\/auth\/v[0-9]*\/passwordless\/[^\/]*\/postlogin$/g,
                /^\/identity\/resources\/auth\/v[0-9]*\/webauthn\/postlogin$/g,
                /^\/identity\/resources\/auth\/v[0-9]*\/user$/g,
                /^\/identity\/resources\/auth\/v[0-9]*\/user\/token\/refresh$/g,
                /^\/identity\/resources\/users\/v[0-9]*\/signUp$/g,
                /^\/identity\/resources\/users\/v[0-9]*\/activate$/g,
                /^\/identity\/resources\/users\/v[0-9]*\/invitation\/accept$/g,
                /^\/identity\/resources\/auth\/v[0-9]*\/user\/mfa\/verify$/g,
                /^\/identity\/resources\/auth\/v[0-9]*\/user\/mfa\/[^\/]*\/[^\/]*\/verify$/g,
                /^\/oauth\/token$/g,
                /^\/oauth\/authorize\/silent$/g
            ], _a = `${H.v1}/user/token/refresh`, Ra = `${wt}/authorize/silent`, Ca = `${z.v2}/me`, La = `${z.v2}/me/tenants`, Ua = `${z.v3}/me/tenants`, Da = Ot;
            let Na, Ma, Fa, xa, Ga;
            !function(t) {
                t.FRONTEGG = "frontegg", t.OKTA = "okta", t.AZURE_AD = "azure-ad", t.OTHER = "other";
            }(Na || (Na = {})), function(t) {
                t.roles = "roles", t.users = "users", t.rolesAndUsers = "rolesAndUsers";
            }(Ma || (Ma = {})), function(t) {
                t.FRONTEGG = "frontegg", t.SCIM2 = "scim2";
            }(Fa || (Fa = {})), function(t) {
                t.createdAt = "createdAt", t.name = "name", t.email = "email", t.id = "id", t.verified = "verified", t.isLocked = "isLocked", t.provider = "provider", t.tenantId = "tenantId";
            }(xa || (xa = {})), function(t) {
                t.MFA_UNENROLLED = "mfa-unenrolled", t.BREACHED_PASSWORDS = "breached-passwords", t.INACTIVE = "inactive";
            }(Ga || (Ga = {}));
            const $a = [
                "local",
                "saml",
                "google",
                "github",
                "facebook",
                "microsoft",
                "scim2",
                "slack"
            ];
            let ja, Ba, Va, Wa, Ha, za, Ka;
            !function(t) {
                t.MISSING_PERMISSION = "MISSING_PERMISSION", t.MISSING_FEATURE = "MISSING_FEATURE", t.BUNDLE_EXPIRED = "BUNDLE_EXPIRED";
            }(ja || (ja = {})), function(t) {
                t.FORCE_MFA = "FORCE_MFA", t.BREACHED_PASSWORDS_EXIST = "BREACHED_PASSWORDS_EXIST", t.ENABLE_USER_LOCKOUT = "ENABLE_USER_LOCKOUT", t.STRENGTHEN_USER_LOCKOUT = "STRENGTHEN_USER_LOCKOUT", t.ENABLE_PASSWORD_HISTORY = "ENABLE_PASSWORD_HISTORY", t.STRENGTHEN_PASSWORD_HISTORY = "STRENGTHEN_PASSWORD_HISTORY", t.ENABLE_FORCE_RELOGIN = "ENABLE_FORCE_RELOGIN", t.SET_FORCE_RELOGIN = "SET_FORCE_RELOGIN", t.ENABLE_SESSION_CONCURRENCY = "ENABLE_SESSION_CONCURRENCY", t.SET_SESSION_CONCURRENCY = "SET_SESSION_CONCURRENCY", t.ENABLE_IDLE_SESSION = "ENABLE_IDLE_SESSION", t.SET_IDLE_SESSION = "SET_IDLE_SESSION", t.ENABLE_IP_RESTRICTIONS = "ENABLE_IP_RESTRICTIONS", t.CHANGE_IP_TO_ALLOWLIST = "CHANGE_IP_TO_ALLOWLIST", t.ENABLE_DOMAIN_RESTRICTIONS = "ENABLE_DOMAIN_RESTRICTIONS", t.CHANGE_DOMAIN_TO_ALLOWLIST = "CHANGE_DOMAIN_TO_ALLOWLIST", t.CONFIGURE_SSO = "CONFIGURE_SSO";
            }(Ba || (Ba = {})), function(t) {
                t.MFA_FORCED = "MFA_FORCED", t.PARTIALLY_FORCED_MFA = "PARTIALLY_FORCED_MFA", t.PARTIAL_MFA_USAGE = "PARTIAL_MFA_USAGE", t.FULL_MFA_USAGE = "FULL_MFA_USAGE", t.BREACHED_PASSWORD_USERS_EXIST = "BREACHED_PASSWORD_USERS_EXIST", t.IMPROVE_LOCKOUT_POLICY = "IMPROVE_LOCKOUT_POLICY", t.IMPROVE_PASSWORD_HISTORY_POLICY = "IMPROVE_PASSWORD_HISTORY_POLICY", t.NO_SESSION_SETTINGS = "NO_SESSION_SETTINGS", t.PARTIAL_SESSION_SETTINGS = "PARTIAL_SESSION_SETTINGS", t.FULL_SESSION_SETTINGS = "FULL_SESSION_SETTINGS", t.NO_IP_RESTRICTIONS = "NO_IP_RESTRICTIONS", t.IP_ALLOWLIST = "IP_ALLOWLIST", t.IP_DENYLIST = "IP_DENYLIST", t.NO_DOMAIN_RESTRICTIONS = "NO_DOMAIN_RESTRICTIONS", t.DOMAIN_ALLOWLIST = "DOMAIN_ALLOWLIST", t.DOMAIN_DENYLIST = "DOMAIN_DENYLIST", t.FULL_PASSWORD_SETTINGS = "FULL_PASSWORD_SETTINGS";
            }(Va || (Va = {})), function(t) {
                t.SEND_RESET_BREACHED_PASSWORD_EMAIL = "SEND_RESET_BREACHED_PASSWORD_EMAIL", t.ADJUST_FORCE_RELOGIN = "ADJUST_FORCE_RELOGIN", t.ADJUST_MAX_CONCURRENT_SESSIONS = "ADJUST_MAX_CONCURRENT_SESSIONS", t.ADJUST_IDLE_TIMEOUT = "ADJUST_IDLE_TIMEOUT";
            }(Wa || (Wa = {})), function(t) {
                t.SEVERE = "SEVERE", t.WARNING = "WARNING", t.INFO = "INFO";
            }(Ha || (Ha = {})), function(t) {
                t.MFA = "MFA", t.SESSIONS = "SESSIONS", t.PASSWORD = "PASSWORD", t.INACTIVITY = "INACTIVITY", t.IP = "IP", t.DOMAIN = "DOMAIN", t.SSO = "SSO";
            }(za || (za = {})), function(t) {
                t.FREE_ACCESS = "FREE_ACCESS", t.MANAGED_ACCESS = "MANAGED_ACCESS";
            }(Ka || (Ka = {}));
            const qa = {
                auth: fe,
                securityPolicy: pe,
                teams: be,
                metadata: we,
                reports: Pe,
                connectivity: Ce,
                notifications: Ue,
                audits: Me,
                tenants: ce,
                accountSettings: xe,
                roles: Ve,
                subscriptions: aa,
                vendor: sa,
                subTenants: oa,
                featureFlags: Zt,
                directory: la,
                impersonate: ua,
                groups: pa,
                users: ne,
                entitlements: de,
                securityCenter: ya,
                userPhoneNumbers: va,
                applications: ma,
                velo: wa
            }, Ja = (t)=>({
                    auth: new ve(t),
                    securityPolicy: new ge(t),
                    teams: new me(t),
                    metadata: new Ae(t),
                    reports: new Oe(t),
                    connectivity: new Re(t),
                    notifications: new Le(t),
                    audits: new Ne(t),
                    tenants: new le(t),
                    accountSettings: new Fe(t),
                    roles: new Be(t),
                    subscriptions: new ea(t),
                    vendor: new na(t),
                    subTenants: new ia(t),
                    featureFlags: new Qt(t),
                    directory: new ra(t),
                    impersonate: new ca(t),
                    groups: new ga(t),
                    users: new ae(t),
                    entitlements: new ue(t),
                    securityCenter: new ha(t),
                    userPhoneNumbers: new Sa(t),
                    applications: new fa(t),
                    velo: new Aa(t)
                }), Ya = {
                fetch: Gt,
                FetchClient: xt,
                ContextHolder: C,
                FronteggContext: U,
                api: qa,
                createApiClient: Ja,
                FronteggApiError: V,
                AuthStrategyEnum: N,
                MachineToMachineAuthStrategy: M,
                SocialLoginProviders: D,
                ISubscriptionCancellationPolicy: G,
                ISubscriptionStatus: F,
                PaymentMethodType: x,
                ProviderType: $
            };
            var Xa = a(2743), Qa = a.n(Xa);
            const Za = (t, e)=>{
                const a = Qa()(t, v({}, e));
                return function(t = {}) {
                    return O(t);
                }(v({
                    __isProxy: !0
                }, a));
            };
            let tn;
            !function(t) {
                t.validate = "validate", t.invalid = "invalid", t.pending = "pending", t.success = "success", t.failed = "failed";
            }(tn || (tn = {}));
            const en = {
                step: tn.validate
            }, an = (t)=>Za(en, t);
            var nn = a(5302), sn = a.n(nn), on = a(1098), rn = a.n(on);
            const ln = "http://schemas.openid.net/pape/policies/2007/06/multi-factor", cn = "mfa", un = [
                "otp",
                "sms",
                "hwk"
            ], dn = "SHOULD_STEP_UP", gn = "maxAge";
            let pn, hn, yn, Sn;
            !function(t) {
                t.preLogin = "preLogin", t.magicLinkPreLoginSuccess = "magicLinkPreLoginSuccess", t.loginWithSmsOtc = "loginWithSmsOtc", t.loginWithQuickSmsOtc = "loginWithQuickSmsOtc", t.loginWithOtc = "loginWithOtc", t.loginWithPassword = "loginWithPassword", t.loginWithTwoFactor = "loginWithTwoFactor", t.redirectToSSO = "redirectToSSO", t.loginWithSSOFailed = "loginWithSSOFailed", t.success = "success", t.forceTwoFactor = "forceTwoFactor", t.recoverTwoFactor = "recoverTwoFactor", t.promptPasskeys = "promptPasskeys", t.breachedPassword = "breachedPassword", t.breachedPasswordSuccess = "breachedPasswordSuccess", t.passwordRotationExpired = "passwordRotationExpired", t.passwordRotationNotification = "passwordRotationNotification", t.magicLinkPostLoginSuccess = "magicLinkPostLoginSuccess";
            }(pn || (pn = {})), function(t) {
                t.Login = "login", t.RegisterQuickLogin = "registerQuickLogin";
            }(hn || (hn = {})), function(t) {
                t.Internal = "internal", t.UsbKey = "usb-key", t.Android = "android", t.Sms = "sms";
            }(yn || (yn = {})), function(t) {
                t["social-login"] = "social-login", t["custom-social-login"] = "custom-social-login", t.direct = "direct";
            }(Sn || (Sn = {}));
            const vn = {
                [N.Code]: pn.loginWithOtc,
                [N.EmailAndPassword]: pn.loginWithPassword,
                [N.MagicLink]: pn.magicLinkPreLoginSuccess,
                [N.SmsCode]: pn.loginWithSmsOtc
            }, fn = {
                authenticatedUrl: "/",
                loginUrl: "/account/login",
                stepUpUrl: "/account/step-up",
                logoutUrl: "/account/logout",
                activateUrl: "/account/activate",
                impersonationUrl: "/account/impersonate",
                acceptInvitationUrl: "/account/invitation/accept",
                forgetPasswordUrl: "/account/forget-password",
                resetPhoneNumberUrl: "/account/reset-phone-number",
                resetPasswordUrl: "/account/reset-password",
                socialLoginCallbackUrl: "/account/social/success",
                signUpUrl: "/account/sign-up",
                oidcRedirectUrl: "/account/oidc/callback",
                samlCallbackUrl: "/account/saml/callback",
                magicLinkCallbackUrl: "/account/login/magic-link",
                hostedLoginRedirectUrl: "/oauth/callback",
                openAppUrl: "/account/redirect",
                unlockAccountUrl: "/account/unlock",
                activateWithOTCUrl: "/account/activate/code",
                acceptInvitationWithOTCUrl: "/account/invitation/code",
                mfaMobileAuthenticator: "/account/mfa-mobile-authenticator"
            }, mn = "FRONTEGG_AFTER_AUTH_REDIRECT_URL", bn = "HOSTED_LOGIN_VERIFIER_KEY", An = {
                retryCount: 3
            }, wn = (t = 500)=>new Promise((e)=>{
                    setTimeout(e, t);
                }), Tn = async (t, e, a, n)=>{
                let s = 0;
                for(; s < e - 1;)try {
                    const i = await t();
                    if (!n || null !== i) return i;
                    if (s++, s >= e) return i;
                    await new Promise((t)=>setTimeout(t, a));
                } catch (t) {
                    if (s++, s >= e) throw t;
                    await new Promise((t)=>setTimeout(t, a));
                }
                return await t();
            }, En = async (t, e)=>e ? Tn(t, e.retryCount, e.delay || 500, e.shouldRetryWhenNull) : t(), In = (t)=>v({}, t, {
                    retryConfig: An
                }), On = (t)=>(null == t ? void 0 : t.traceId) || void 0;
            function Pn(t, e) {
                const a = v({}, t);
                return e.forEach((t)=>{
                    delete a[t];
                }), a;
            }
            function kn(t) {
                if (null != t) return function(t) {
                    const e = typeof t;
                    return (null == t ? void 0 : t.constructor) === ({}).constructor || "undefined" === e || null === t || "boolean" === e || "number" === e || "string" === e || t instanceof Date || t instanceof RegExp || t instanceof Blob || t instanceof File || t instanceof FileList || t instanceof ArrayBuffer || t instanceof ImageData || t instanceof ImageBitmap || t instanceof Array || t instanceof Map || t instanceof Set;
                }(t) && void 0 !== t.__isProxy;
            }
            const _n = (t)=>JSON.parse(JSON.stringify(t)), Rn = (t, e, a)=>{
                const n = _n(a), s = sn()(t, e);
                for(const a in s)"__isProxy" !== a && (a in n ? rn()(t, [
                    ...e,
                    a
                ], n[a]) : rn()(t, [
                    ...e,
                    a
                ], void 0));
            }, Cn = (t)=>Boolean(null == t ? void 0 : t.statusCode), Ln = (t)=>t instanceof Error || (null == t ? void 0 : t.message) && (null == t ? void 0 : t.stack) && "Error" === (null == t ? void 0 : t.name), Un = (t, e)=>t ? Cn(t) ? (console.error(t.message), t) : (Ln(t) ? console.error(t.message) : "string" == typeof t && console.error(t), null != e ? e : new V(Lt, 500, null, Ut)) : e, Dn = (t, e, a)=>{
                const n = (e)=>{
                    Object.assign(t.auth.acceptInvitationState, e);
                };
                return {
                    setAcceptInvitationState: n,
                    resetAcceptInvitationState: ()=>{
                        Rn(t, [
                            "auth",
                            "acceptInvitationState"
                        ], en);
                    },
                    acceptInvitation: async (t)=>{
                        if (t.token && t.userId) try {
                            n({
                                error: void 0,
                                step: tn.pending
                            }), await e.auth.acceptInvitation(t), n({
                                step: tn.success
                            });
                        } catch (t) {
                            n({
                                step: tn.failed,
                                error: Un(t)
                            });
                        }
                        else n({
                            error: void 0,
                            step: tn.invalid
                        });
                    },
                    acceptInvitationWithOTC: async (t)=>{
                        if (t.token && t.userId && t.code) try {
                            n({
                                error: void 0,
                                step: tn.pending
                            }), await e.auth.acceptInvitationWithOTC(t), n({
                                step: tn.success
                            });
                        } catch (t) {
                            n({
                                step: tn.validate,
                                error: Un(t)
                            });
                        }
                        else n({
                            error: void 0,
                            step: tn.invalid
                        });
                    }
                };
            }, Nn = {
                loading: !1
            }, Mn = (t)=>Za(Nn, t), Fn = [
                "activeTenant",
                "tenants"
            ], xn = (t, e, a)=>{
                const n = (e)=>{
                    Object.assign(t.auth.accountSettingsState, e);
                };
                return {
                    setAccountSettingsState: n,
                    resetAccountSettingsState: ()=>{
                        Rn(t, [
                            "auth",
                            "accountSettingsState"
                        ], Nn);
                    },
                    saveAccountSettings: async (s)=>{
                        try {
                            var i;
                            n({
                                loading: !0
                            });
                            const { address: o, timezone: r, dateFormat: l, timeFormat: c, currency: u, logo: d } = t.auth.accountSettingsState, g = await e.accountSettings.updateSettings(v({
                                address: o,
                                timezone: r,
                                dateFormat: l,
                                timeFormat: c,
                                currency: u,
                                logo: d
                            }, s));
                            (({ newSettingValues: e })=>{
                                const n = t.auth.tenantsState, { activeTenant: s, tenants: i } = n, o = f(n, Fn), r = i.map((t)=>t.id !== (null == s ? void 0 : s.id) ? t : v({}, t, e)), l = v({}, s, e);
                                a.setTenantsState(v({}, o, {
                                    tenants: r,
                                    activeTenant: l
                                }));
                            })({
                                newSettingValues: g
                            }), n(v({}, g, {
                                loading: !1
                            })), null == (i = s.callback) || i.call(s, g);
                        } catch (t) {
                            var o;
                            n({
                                loading: !1,
                                error: Un(t)
                            }), null == (o = s.callback) || o.call(s, null, t);
                        }
                    },
                    loadAccountSettings: async (t)=>{
                        n({
                            loading: !(null != t && t.silentLoading),
                            error: null
                        });
                        try {
                            const a = await En(()=>e.accountSettings.getSettings(), null == t ? void 0 : t.retryConfig);
                            n(v({}, a, {
                                loading: !1
                            }));
                        } catch (t) {
                            n({
                                loading: !1,
                                error: Un(t)
                            });
                        }
                    }
                };
            };
            let Gn;
            !function(t) {
                t.activating = "activating", t.success = "success", t.resend = "resend", t.activatingForm = "activatingForm";
            }(Gn || (Gn = {}));
            const $n = {
                step: Gn.activating,
                loading: !1,
                submitting: !1,
                resentEmail: !1,
                activationStrategy: {
                    loading: !1
                }
            }, jn = (t)=>Za($n, t);
            let Bn, Vn, Wn, Hn;
            !function(t) {
                t.LOAD_FEATURE_FLAGS = "LOAD_FEATURE_FLAGS,", t.LOAD_ADMIN_BOX_METADATA = "LOAD_ADMIN_BOX_METADATA,", t.LOAD_SSO_PUBLIC_CONFIGURATION = "LOAD_SSO_PUBLIC_CONFIGURATION,", t.LOAD_PUBLIC_AUTH_STRATEGIES_POLICY = "LOAD_PUBLIC_AUTH_STRATEGIES_POLICY,", t.LOAD_ALLOW_SIGNUPS = "LOAD_ALLOW_SIGNUPS,", t.LOAD_CUSTOM_LOGIN_ROUTES = "LOAD_CUSTOM_LOGIN_ROUTES", t.LOAD_PASSWORD_CONFIGURATION = "LOAD_PASSWORD_CONFIGURATION";
            }(Bn || (Bn = {})), function(t) {
                t.SOCIAL_LOGIN = "SOCIAL_LOGIN", t.PASSWORDLESS = "PASSWORDLESS", t.ACTIVATION_LINK = "ACTIVATION_LINK";
            }(Vn || (Vn = {})), function(t) {
                t.SOCIAL_LOGIN = "SOCIAL_LOGIN", t.PASSWORD = "PASSWORD";
            }(Wn || (Wn = {})), function(t) {
                t.profile = "profile", t.privacy = "privacy", t.personalApiTokens = "personalApiTokens", t.account = "account", t.users = "users", t.groups = "groups", t.security = "security", t.sso = "sso", t.audits = "audits", t.webhooks = "webhooks", t.apiTokens = "apiTokens", t.roles = "roles", t.subscriptions = "subscription", t.allAccounts = "allAccounts";
            }(Hn || (Hn = {}));
            const zn = {
                profile: Hn.profile,
                privacy: Hn.privacy,
                personalApiTokens: Hn.personalApiTokens,
                account: Hn.account,
                users: Hn.users,
                groups: Hn.groups,
                security: Hn.security,
                sso: Hn.sso,
                audits: Hn.audits,
                webhooks: Hn.webhooks,
                apiTokens: Hn.apiTokens,
                roles: Hn.roles,
                subscriptions: Hn.subscriptions,
                allAccounts: Hn.allAccounts
            };
            let Kn, qn;
            function Jn(t, e) {
                var a, n;
                null == (a = (n = window).onFronteggEvent) || a.call(n, t, e);
            }
            !function(t) {
                t.SIGNUP_COMPLETED = "signup_completed", t.USER_VERIFIED = "user_verified";
            }(Kn || (Kn = {})), function(t) {
                t.verify = "verify", t.recoveryCode = "recoveryCode", t.authenticatorApp = "authenticatorApp", t.smsSetPhoneNumber = "smsSetPhoneNumber", t.smsVerifyCode = "smsVerifyCode", t.emailVerifyCode = "emailVerifyCode", t.noMFAEnrolledStepUp = "noMFAEnrolledStepUp";
            }(qn || (qn = {}));
            const Yn = (t)=>{
                try {
                    return new URL(t), !0;
                } catch (t) {
                    return !1;
                }
            }, Xn = ({ authenticatedUrl: t, enforceRedirectToSameSite: e, allowedRedirectOrigins: a, includeQueryParam: n })=>{
                let s = t;
                const i = new URL(window.location.href).searchParams.get("redirectUrl");
                return i ? e && Yn(i) ? ((t, e)=>{
                    const a = new URL(window.location.href), n = new URL(t), s = n.origin === a.origin;
                    return e.includes(n.origin) || s;
                })(i, a) ? s = i : console.warn("The redirect url param is not valid, the origin is a different site") : s = i : n && (s += window.location.search), s;
            }, Qn = (t)=>{
                const { searchParams: e } = new URL(t), a = e.toString();
                if (a) return `?${a}`;
            }, Zn = (t, e = !1)=>{
                const { pathname: a, href: n } = new URL(t);
                if (e) return n;
                const s = Qn(t);
                return s ? a + s : a;
            }, ts = (t)=>{
                const e = new URLSearchParams(window.location.search).get(t);
                return null != e ? e : void 0;
            }, es = "tenantId", as = (t)=>{
                const e = +Boolean(t.webauthn.length), a = +Boolean(t.phones.length), n = +Boolean(t.authenticators.length), s = +Boolean(t.emails.length);
                return {
                    numberOfWebAuthnDevices: e,
                    numberOfPhoneDevices: a,
                    numberOfAuthenticators: n,
                    numberOfEmails: s,
                    totalDevices: e + a + n + s
                };
            }, ns = (t)=>{
                const { numberOfPhoneDevices: e, numberOfAuthenticators: a, numberOfEmails: n, totalDevices: s } = as(t);
                if (1 === s) {
                    if (a) return qn.authenticatorApp;
                    if (e) return qn.smsVerifyCode;
                    if (n) return qn.emailVerifyCode;
                }
                return qn.verify;
            }, ss = (t)=>{
                if (1 === t.length) {
                    const [e] = t;
                    if (e === Kt.AuthenticatorApp) return qn.authenticatorApp;
                    if (e === Kt.SMS) return qn.smsSetPhoneNumber;
                    if (e === Kt.EmailCode) return qn.emailVerifyCode;
                }
                return qn.verify;
            }, is = (t)=>"/oauth/callback" === t;
            function os(t) {
                return "email" in t;
            }
            const rs = (t)=>{
                const e = C.for(t.root.appName).getBasename();
                return null != e && e.endsWith("/") ? e.slice(0, -1) : e;
            }, ls = (t)=>void 0 !== t.passwordExpiresIn && void 0 !== t.notificationPeriod && t.passwordExpiresIn <= t.notificationPeriod, cs = (t, { maxAge: e } = {})=>{
                if (!t) return !1;
                const { amr: a = [], acr: n = "", auth_time: s } = t;
                if (e && s && !(Date.now() / 1e3 - s <= e)) return !1;
                const i = n === ln, o = -1 !== a.indexOf(cn), r = void 0 !== un.find((t)=>a.indexOf(t));
                return i && o && r;
            };
            function us() {
                const t = window.location.pathname + window.location.search;
                window.localStorage.setItem(mn, t);
            }
            const ds = (t, e, a)=>{
                us();
                const n = new URLSearchParams(window.location.search);
                a && n.set(gn, a.toString()), e(`${t}${n ? `?${n}` : ""}`, {
                    refresh: !1
                });
            }, gs = [
                "phoneNumber"
            ], ps = [
                "authenticatedUrl"
            ], hs = (t, e)=>{
                const a = C.for(e);
                return t.mfaRequired && t.mfaToken ? (a.setAccessToken(null), a.setUser(null), !0) : (a.setAccessToken(t.accessToken), a.setUser(t), !1);
            }, ys = (t, e)=>{
                const a = C.for(e);
                return t.resetPasswordToken ? (a.setAccessToken(null), !0) : (a.setAccessToken(t.accessToken), a.setUser(t), !1);
            }, Ss = (t, e = [])=>Object.entries(t).reduce((t, [a, n])=>"object" == typeof n ? [
                        ...t,
                        ...Ss(n, [
                            ...e,
                            a
                        ])
                    ] : [
                        ...t,
                        {
                            type: [
                                ...e,
                                a
                            ].join("/"),
                            payload: n
                        }
                    ], []), vs = (t)=>{
                var e;
                if ("path" === t) return (null != (e = window) ? e : document).location.pathname;
                {
                    var a;
                    const t = ((null != (a = window) ? a : document).location.hash || "#").substring(1);
                    return -1 !== t.indexOf("?") ? t.substring(0, t.indexOf("?")) : t;
                }
            }, fs = (t)=>f(t, gs), ms = (t, e)=>{
                const a = f(v({}, fn, e), ps);
                return Object.values(a).includes(t);
            };
            let bs;
            !function(t) {
                t.USERS = "USERS", t.STATS = "STATS", t.UPDATE_USER = "UPDATE_USER", t.DELETE_USER = "DELETE_USER", t.RESEND_ACTIVATE_LINK = "RESEND_ACTIVATE_LINK", t.RESEND_INVITATION_LINK = "RESEND_INVITATION_LINK", t.ROLES_AND_PERMISSIONS = "ROLES_AND_PERMISSIONS", t.CREATE_TOKEN_LINK = "CREATE_TOKEN_LINK", t.GET_TOKEN_LINK = "GET_TOKEN_LINK", t.UPDATE_TOKEN_LINK = "UPDATE_TOKEN_LINK", t.DELETE_TOKEN_LINK = "DELETE_TOKEN_LINK", t.CONFIG_TOKEN_LINK = "CONFIG_TOKEN_LINK", t.CONFIG_TEMPORARY_USERS = "CONFIG_TEMPORARY_USERS", t.UPDATE_USER_EXPIRATION_TIME = "UPDATE_USER_EXPIRATION_TIME";
            }(bs || (bs = {}));
            const As = [
                "user"
            ], ws = [
                "callback",
                "events"
            ], Ts = [
                "user"
            ], Es = [
                "callback",
                "events"
            ], Is = [
                "user"
            ], Os = [
                "callback"
            ], Ps = [
                "callback"
            ], ks = (t, e, a)=>{
                const n = a, s = (e)=>{
                    Object.assign(t.auth.activateAccountState, e);
                }, i = ()=>{
                    Rn(t, [
                        "auth",
                        "activateAccountState"
                    ], $n);
                }, o = (e)=>{
                    Object.assign(t.auth.activateAccountState.activationStrategy, e);
                }, r = async ({ loginResponse: e, events: a, onRedirectTo: o, routes: r })=>{
                    const { user: l } = e, c = f(e, As);
                    if (l.redirectLocation) window.location.href = l.redirectLocation;
                    else if (hs(l, t.root.appName)) {
                        s({
                            step: Gn.success
                        });
                        const t = await n.getMfaRequiredState(l);
                        n.setAuthState(t), await wn(1e3), o(r.loginUrl, {
                            preserveQueryParams: !0
                        });
                    } else {
                        var u;
                        s({
                            step: Gn.success
                        });
                        const t = {
                            email: l.email,
                            origin: Vn.ACTIVATION_LINK,
                            id: l.id,
                            tenantId: l.tenantId,
                            name: l.name,
                            createdAt: new Date
                        };
                        null == a || null == (u = a.userVerified) || u.call(a, t), Jn(Kn.USER_VERIFIED, t), n.afterAuthenticationStateUpdate(v({
                            user: l
                        }, c), {
                            isAuthenticated: !0
                        }), await wn(5e3), await n.afterAuthNavigation(), i();
                    }
                };
                return {
                    setActivateState: s,
                    resetActivateState: i,
                    setActivateStrategyState: o,
                    activateAccount: async (a)=>{
                        const { callback: n, events: i } = a, o = f(a, ws);
                        s({
                            loading: !0,
                            submitting: !0
                        });
                        try {
                            const a = C.for(t.root.appName).onRedirectTo, l = t.auth.routes, c = await e.auth.activateAccountV2(o), { user: u } = c, d = f(c, Ts);
                            s({
                                submitting: !1
                            }), await r({
                                loginResponse: v({
                                    user: u
                                }, d),
                                events: i,
                                onRedirectTo: a,
                                routes: l
                            }), null == n || n(!0);
                        } catch (t) {
                            s({
                                loading: !1,
                                error: Un(t)
                            });
                        }
                    },
                    preActivateAccount: async (a)=>{
                        const { userId: i, token: r } = a;
                        s({
                            loading: !0,
                            step: Gn.activating
                        });
                        try {
                            t.auth.isAuthenticated && await n.silentLogout();
                            const a = await e.auth.getActivateAccountStrategy({
                                userId: i,
                                token: r
                            });
                            o({
                                strategy: a,
                                loading: !1,
                                error: void 0
                            }), a.shouldSetPassword && s({
                                loading: !1,
                                step: Gn.activatingForm
                            });
                        } catch (t) {
                            s({
                                loading: !1,
                                error: Un(t)
                            });
                        }
                    },
                    getActivateAccountStrategy: async (t)=>{
                        const { callback: a } = t, n = f(t, Os);
                        o({
                            loading: !0
                        });
                        try {
                            const t = await e.auth.getActivateAccountStrategy(n);
                            o({
                                strategy: t,
                                loading: !1,
                                error: void 0
                            }), null == a || a(t);
                        } catch (t) {
                            o({
                                loading: !1,
                                error: Un(t)
                            });
                        }
                    },
                    resendActivationEmail: async (t)=>{
                        const { callback: a } = t, i = f(t, Ps);
                        n.setTeamLoader({
                            key: bs.RESEND_ACTIVATE_LINK,
                            value: i.email
                        }), s({
                            loading: !0
                        });
                        try {
                            await e.auth.resendActivationEmail(i), s({
                                loading: !1,
                                error: void 0,
                                resentEmail: !0
                            }), null == a || a(!0);
                        } catch (t) {
                            s({
                                loading: !1,
                                error: Un(t)
                            }), null == a || a(null, t);
                        } finally{
                            n.setTeamLoader({
                                key: bs.RESEND_ACTIVATE_LINK,
                                value: !1
                            });
                        }
                    },
                    activateAccountWithCode: async (a)=>{
                        const { callback: n, events: i } = a, o = f(a, Es);
                        s({
                            loading: !0,
                            submitting: !0
                        });
                        try {
                            const a = C.for(t.root.appName).onRedirectTo, l = t.auth.routes, c = await e.auth.activateAccountWithOTC(o), { user: u } = c, d = f(c, Is);
                            s({
                                submitting: !1
                            }), await r({
                                loginResponse: v({
                                    user: u
                                }, d),
                                events: i,
                                onRedirectTo: a,
                                routes: l
                            }), null == n || n(!0);
                        } catch (t) {
                            s({
                                loading: !1,
                                error: Un(t),
                                step: Gn.activating
                            });
                        }
                    }
                };
            }, _s = {
                loading: !1,
                error: void 0,
                unlockAccountSuccess: !1
            }, Rs = (t)=>Za(_s, t), Cs = (t, e, a)=>{
                const n = (e)=>{
                    Object.assign(t.auth.unlockAccountState, e);
                };
                return {
                    setUnlockAccountState: n,
                    resetUnlockAccountState: ()=>{
                        Rn(t, [
                            "auth",
                            "activateAccountState"
                        ], _s);
                    },
                    unlockAccount: async (a)=>{
                        const { token: s } = a, i = C.for(t.root.appName).onRedirectTo, o = t.auth.routes;
                        n({
                            loading: !0
                        });
                        try {
                            await e.users.unlockMe({
                                token: s
                            }), n({
                                loading: !1,
                                error: void 0,
                                unlockAccountSuccess: !0
                            }), await wn(5e3), i(o.loginUrl);
                        } catch (t) {
                            n({
                                loading: !1,
                                error: Un(t)
                            });
                        }
                    }
                };
            }, Ls = {
                apiTokenType: null,
                searchValue: "",
                showAddTokenDialog: !1,
                createdByUserIdColumn: "show",
                deleteTokenDialog: {
                    open: !1,
                    clientId: ""
                },
                successDialog: {
                    open: !1,
                    secret: "",
                    clientId: ""
                },
                loaders: {},
                apiTokensDataTenant: [],
                apiTokensDataUser: [],
                roles: [],
                permissions: [],
                errors: {}
            }, Us = (t)=>Za(Ls, t);
            let Ds;
            !function(t) {
                t.LOAD_API_TOKENS = "LOAD_API_TOKENS", t.ADD_API_TOKEN = "ADD_API_TOKEN", t.DELETE_API_TOKEN = "DELETE_API_TOKEN";
            }(Ds || (Ds = {}));
            const Ns = (t, e, a)=>{
                const n = (e)=>{
                    Object.assign(t.auth.apiTokensState, {
                        loaders: v({}, t.auth.apiTokensState.loaders, {
                            [e.key]: e.value
                        })
                    });
                }, s = (e)=>{
                    Object.assign(t.auth.apiTokensState, {
                        errors: v({}, t.auth.apiTokensState.errors, {
                            [e.key]: e.value
                        }),
                        loaders: v({}, t.auth.apiTokensState.loaders, {
                            [e.key]: !1
                        })
                    });
                }, i = (e)=>{
                    Object.assign(t.auth.apiTokensState, e);
                };
                return {
                    setApiTokensLoader: n,
                    setApiTokensError: s,
                    setApiTokensState: i,
                    resetApiTokensState: ()=>{
                        Rn(t, [
                            "auth",
                            "apiTokensState"
                        ], Ls);
                    },
                    loadApiTokens: async (t)=>{
                        null != t && t.silentLoading || n({
                            key: Ds.LOAD_API_TOKENS,
                            value: !0
                        });
                        try {
                            var a;
                            const [s = [], o = []] = await Promise.all([
                                e.auth.getUserApiTokensData(),
                                e.auth.getTenantApiTokensData()
                            ]);
                            i({
                                apiTokensDataUser: s,
                                apiTokensDataTenant: o
                            }), n({
                                key: Ds.LOAD_API_TOKENS,
                                value: !1
                            }), null == t || null == (a = t.callback) || a.call(t, !0);
                        } catch (e) {
                            var o;
                            s({
                                key: Ds.LOAD_API_TOKENS,
                                value: Un(e)
                            }), n({
                                key: Ds.LOAD_API_TOKENS,
                                value: !1
                            }), null == t || null == (o = t.callback) || o.call(t, null, e);
                        }
                    },
                    loadUserApiTokens: async (t)=>{
                        null != t && t.silentLoading || n({
                            key: Ds.LOAD_API_TOKENS,
                            value: !0
                        });
                        try {
                            var a, o;
                            const [s = [], r] = await Promise.all([
                                En(()=>e.auth.getUserApiTokensData(), null == t ? void 0 : t.retryConfig),
                                En(()=>e.auth.getUserAccessTokensData(), null == t ? void 0 : t.retryConfig)
                            ]), l = (null != (a = r.accessTokens) ? a : []).map((t)=>v({}, t, {
                                    type: M.AccessToken
                                })).concat(s.map((t)=>v({}, t, {
                                    type: M.ClientCredentials
                                }))).sort((t, e)=>new Date(e.createdAt) - new Date(t.createdAt));
                            i({
                                apiTokensDataUser: null != l ? l : []
                            }), n({
                                key: Ds.LOAD_API_TOKENS,
                                value: !1
                            }), null == t || null == (o = t.callback) || o.call(t, !0);
                        } catch (e) {
                            var r;
                            s({
                                key: Ds.LOAD_API_TOKENS,
                                value: Un(e)
                            }), n({
                                key: Ds.LOAD_API_TOKENS,
                                value: !1
                            }), null == t || null == (r = t.callback) || r.call(t, null, e);
                        }
                    },
                    loadTenantApiTokens: async (t)=>{
                        null != t && t.silentLoading || n({
                            key: Ds.LOAD_API_TOKENS,
                            value: !0
                        });
                        try {
                            var a, o;
                            const [s = [], r] = await Promise.all([
                                En(()=>e.auth.getTenantApiTokensData(), null == t ? void 0 : t.retryConfig),
                                En(()=>e.auth.getTenantAccessTokensData(), null == t ? void 0 : t.retryConfig)
                            ]), l = (null != (a = null == r ? void 0 : r.accessTokens) ? a : []).map((t)=>v({}, t, {
                                    type: M.AccessToken
                                })).concat(s.map((t)=>v({}, t, {
                                    type: M.ClientCredentials
                                }))).sort((t, e)=>new Date(e.createdAt) - new Date(t.createdAt));
                            i({
                                apiTokensDataTenant: null != l ? l : []
                            }), n({
                                key: Ds.LOAD_API_TOKENS,
                                value: !1
                            }), null == t || null == (o = t.callback) || o.call(t, !0);
                        } catch (e) {
                            var r;
                            s({
                                key: Ds.LOAD_API_TOKENS,
                                value: Un(e)
                            }), n({
                                key: Ds.LOAD_API_TOKENS,
                                value: !1
                            }), null == t || null == (r = t.callback) || r.call(t, null, e);
                        }
                    },
                    addTenantApiToken: async (a)=>{
                        const { description: o, roleIds: r, expires: l, callback: c } = a, u = Ds.ADD_API_TOKEN;
                        n({
                            key: u,
                            value: !0
                        });
                        try {
                            const { policy: a } = t.auth.securityPolicyState.publicPolicy, n = (null == a ? void 0 : a.machineToMachineAuthStrategy) === M.AccessToken;
                            let s, u = null;
                            l && (u = 1440 * l), s = n ? await e.auth.createTenantAccessToken({
                                description: o,
                                expiresInMinutes: u,
                                roleIds: r
                            }) : await e.auth.updateTenantApiTokensData({
                                description: o,
                                roleIds: r,
                                expiresInMinutes: u
                            }), i({
                                showAddTokenDialog: !1
                            }), await wn(200);
                            const d = n ? M.AccessToken : M.ClientCredentials;
                            t.auth.apiTokensState.apiTokensDataTenant.unshift(v({}, s, {
                                type: d
                            })), t.auth.apiTokensState.successDialog = {
                                open: !0,
                                secret: s.secret,
                                clientId: n ? void 0 : s.clientId
                            }, null == c || c(null);
                        } catch (t) {
                            s({
                                key: u,
                                value: Un(t)
                            }), null == c || c(null, t);
                        } finally{
                            n({
                                key: u,
                                value: !1
                            });
                        }
                    },
                    addUserApiToken: async (a)=>{
                        const { description: o, expires: r, callback: l } = a, c = Ds.ADD_API_TOKEN;
                        n({
                            key: c,
                            value: !0
                        });
                        try {
                            const { policy: a } = t.auth.securityPolicyState.publicPolicy, n = (null == a ? void 0 : a.machineToMachineAuthStrategy) === M.AccessToken;
                            let s, c = null;
                            r && (c = 1440 * r), s = n ? await e.auth.createUserAccessToken({
                                description: o,
                                expiresInMinutes: c
                            }) : await e.auth.updateUserApiTokensData({
                                description: o,
                                expiresInMinutes: c
                            }), i({
                                showAddTokenDialog: !1
                            }), await wn(200);
                            const u = n ? M.AccessToken : M.ClientCredentials;
                            t.auth.apiTokensState.apiTokensDataUser.unshift(v({}, s, {
                                type: u
                            })), t.auth.apiTokensState.successDialog = {
                                open: !0,
                                secret: s.secret,
                                clientId: n ? void 0 : s.clientId
                            }, null == l || l(null);
                        } catch (t) {
                            s({
                                key: c,
                                value: Un(t)
                            }), null == l || l(null, t);
                        } finally{
                            n({
                                key: c,
                                value: !1
                            });
                        }
                    },
                    deleteUserApiToken: async (a)=>{
                        const o = Ds.DELETE_API_TOKEN;
                        n({
                            key: o,
                            value: !0
                        });
                        try {
                            const n = t.auth.apiTokensState.apiTokensDataUser;
                            n.some((t)=>t.id === a) ? (await e.auth.deleteUserAccessToken({
                                id: a
                            }), i({
                                apiTokensDataUser: n.filter((t)=>t.id !== a),
                                deleteTokenDialog: {
                                    open: !1,
                                    id: a
                                }
                            })) : (await e.auth.deleteUserApiToken({
                                tokenId: a
                            }), i({
                                apiTokensDataUser: n.filter((t)=>t.clientId !== a),
                                deleteTokenDialog: {
                                    open: !1,
                                    clientId: a
                                }
                            }));
                        } catch (t) {
                            s({
                                key: o,
                                value: Un(t)
                            });
                        } finally{
                            n({
                                key: o,
                                value: !1
                            });
                        }
                    },
                    deleteTenantApiToken: async (a)=>{
                        const o = Ds.DELETE_API_TOKEN;
                        n({
                            key: o,
                            value: !0
                        });
                        try {
                            const n = t.auth.apiTokensState.apiTokensDataTenant;
                            n.some((t)=>t.id === a) ? (await e.auth.deleteTenantAccessToken({
                                id: a
                            }), i({
                                apiTokensDataTenant: n.filter((t)=>t.id !== a),
                                deleteTokenDialog: {
                                    open: !1,
                                    id: a
                                }
                            })) : (await e.auth.deleteTenantApiToken({
                                tokenId: a
                            }), i({
                                apiTokensDataTenant: n.filter((t)=>t.clientId !== a),
                                deleteTokenDialog: {
                                    open: !1,
                                    id: a
                                }
                            }));
                        } catch (t) {
                            s({
                                key: o,
                                value: Un(t)
                            });
                        } finally{
                            n({
                                key: o,
                                value: !1
                            });
                        }
                    }
                };
            }, Ms = {
                loading: !0,
                fetching: !0,
                error: null,
                userApplications: [],
                accountApplications: []
            }, Fs = (t)=>Za(Ms, t), xs = (t)=>{
                var e;
                return null != (e = t.map(({ appIds: t })=>t).reduce((t, e)=>(null == e || e.forEach((e)=>{
                        t && !t.includes(e) && t.push(e);
                    }), t), [])) ? e : [];
            }, Gs = (t, e, a)=>{
                const n = a, s = (e)=>{
                    Object.assign(t.auth.applicationsState, e);
                }, i = async ({ userIds: t, retryConfig: a })=>{
                    try {
                        const n = await En(()=>e.applications.getUsersApplicationsId({
                                userIds: t
                            }), a), s = xs(n), i = await En(()=>e.applications.getApplicationsData({
                                appIds: s
                            }), a);
                        return t.reduce((t, e)=>{
                            var a, s, o;
                            const r = null == (a = n.find((t)=>t.userId == e)) ? void 0 : a.appIds;
                            return t[e] = [
                                ...i.filter((t)=>t.accessType === Ka.FREE_ACCESS),
                                ...null != (s = null == r || null == (o = r.map((t)=>i.find((e)=>t === e.id))) ? void 0 : o.filter((t)=>!!t)) ? s : []
                            ], t;
                        }, {});
                    } catch (t) {
                        s({
                            error: Un(t)
                        });
                    }
                }, o = "Assignment action failed. Try again or contact support.";
                return {
                    setApplicationsState: s,
                    resetApplicationsState: ()=>{
                        Rn(t, [
                            "auth",
                            "applicationsState"
                        ], Ms);
                    },
                    loadUserApplications: async (a)=>{
                        s({
                            loading: !0,
                            fetching: !0
                        });
                        try {
                            var n, i;
                            const o = null != (n = null == (i = t.auth.user) ? void 0 : i.id) ? n : "", r = null == a ? void 0 : a.retryConfig, l = await En(()=>e.applications.getUserApplicationsId({
                                    userId: o
                                }), r), c = await En(()=>e.applications.getApplicationsData({
                                    appIds: l
                                }), r);
                            s({
                                userApplications: c,
                                fetching: !1,
                                loading: !1
                            });
                        } catch (t) {
                            s({
                                loading: !1,
                                fetching: !1,
                                error: Un(t)
                            });
                        }
                    },
                    loadAccountApplications: async (t)=>{
                        const a = null == t ? void 0 : t.retryConfig;
                        s({
                            loading: !0,
                            fetching: !0
                        });
                        try {
                            const t = await En(()=>e.applications.getTenantsApplications(), a), n = xs(t), i = await En(()=>e.applications.getApplicationsData({
                                    appIds: n
                                }), a), o = await En(()=>e.applications.getUsersOfApplications({
                                    appIds: n
                                }), a), r = i.map((t)=>{
                                var e;
                                return v({}, t, {
                                    userIds: null == (e = o.find((e)=>e.appId === t.id)) ? void 0 : e.userIds
                                });
                            });
                            s({
                                accountApplications: r,
                                fetching: !1,
                                loading: !1
                            });
                        } catch (t) {
                            s({
                                loading: !1,
                                fetching: !1,
                                error: Un(t)
                            });
                        }
                    },
                    loadMultipleUsersApplications: i,
                    assignUserToApps: async (n)=>{
                        const { userId: i, appIds: r, callback: l } = n;
                        try {
                            var c, u, d, g, p, h, y, S, f;
                            const n = null != (c = null == (u = t.auth) || null == (d = u.user) ? void 0 : d.tenantId) ? c : "";
                            await e.applications.assignUserToApplications({
                                userId: i,
                                appIds: r,
                                tenantId: n
                            });
                            const s = null == (g = t.auth) || null == (p = g.applicationsState) ? void 0 : p.accountApplications, o = null != (h = null == (y = t.auth) || null == (S = y.teamState) ? void 0 : S.users) ? h : [], m = null != (f = null == s ? void 0 : s.filter((t)=>r.includes(t.id))) ? f : [];
                            null != m && m.length && a.setTeamState({
                                users: o.map((t)=>{
                                    var e;
                                    return t.id === i ? v({}, t, {
                                        applications: [
                                            ...null != (e = t.applications) ? e : [],
                                            ...m
                                        ]
                                    }) : t;
                                })
                            }), null == l || l(!0);
                        } catch (t) {
                            s({
                                error: Un(t, o)
                            }), null == l || l(!1);
                        }
                    },
                    unassignUserFromApps: async (n)=>{
                        const { userId: i, appIds: r, callback: l } = n;
                        try {
                            var c, u, d, g, p, h, y;
                            const n = null != (c = null == (u = t.auth) || null == (d = u.user) ? void 0 : d.tenantId) ? c : "";
                            await e.applications.unassignUserFromApplications({
                                userId: i,
                                appIds: r,
                                tenantId: n
                            });
                            const s = null != (g = null == (p = t.auth) || null == (h = p.teamState) ? void 0 : h.users) ? g : [], o = null == (y = s.find((t)=>t.id === i)) ? void 0 : y.applications;
                            null != o && o.length && r.length && a.setTeamState({
                                users: s.map((t)=>t.id === i ? v({}, t, {
                                        applications: o.filter((t)=>!r.includes(t.id))
                                    }) : t)
                            }), null == l || l(!0);
                        } catch (t) {
                            s({
                                error: Un(t, o)
                            }), null == l || l(!1);
                        }
                    },
                    assignNewUserToApps: async ({ appIds: a, user: s })=>{
                        var i, o, r;
                        const [l] = await n.getFeatureFlags([
                            "multi-apps-admin-portal"
                        ]);
                        if (!l) return;
                        const c = null == (i = t.auth) || null == (o = i.applicationsState) ? void 0 : o.accountApplications, u = null != (r = null == c ? void 0 : c.filter((t)=>t.accessType === Ka.FREE_ACCESS)) ? r : [];
                        if (null != a && a.length) {
                            var d, g, p;
                            const n = null != (d = null == (g = t.auth) || null == (p = g.user) ? void 0 : p.tenantId) ? d : "";
                            return await e.applications.assignUserToApplications({
                                userId: s.id,
                                appIds: a,
                                tenantId: n
                            }), a.map((t)=>{
                                var e;
                                return null != (e = null == c ? void 0 : c.find((e)=>e.id === t)) ? e : [];
                            }).concat(u);
                        }
                        return u;
                    },
                    mapUsersWithApplicationData: async ({ shouldLoadApps: t, users: e, retryConfig: n })=>{
                        const [s] = await a.getFeatureFlags([
                            "multi-apps-admin-portal"
                        ]);
                        if (!s || !t) return e;
                        const o = e.map((t)=>t.id), r = await i({
                            userIds: o,
                            retryConfig: n
                        });
                        return r ? e.map((t)=>null != r && r[t.id] ? v({}, t, {
                                applications: r[t.id]
                            }) : t) : e;
                    }
                };
            }, $s = {
                loading: !0,
                error: null
            }, js = (t)=>Za($s, t), Bs = [
                "callback"
            ], Vs = (t, e, a)=>{
                const n = a, s = (e)=>{
                    Object.assign(t.auth.customLoginState, e);
                }, i = async ()=>{
                    var e, a, n, s, i;
                    return t.auth.isAuthenticated ? null != (s = null == (i = t.auth.tenantsState.activeTenant) ? void 0 : i.hasCustomLogin) && s : !!(null == (e = await (null == (a = C.for(t.root.appName).getContext()) || null == (n = a.tenantResolver) ? void 0 : n.call(a))) ? void 0 : e.tenant);
                };
                return {
                    setCustomLoginState: s,
                    resetCustomLoginState: ()=>{
                        Rn(t, [
                            "auth",
                            "customLoginState"
                        ], $s);
                    },
                    loadTenantMetadata: async ()=>{
                        s({
                            loading: !0
                        });
                        try {
                            const t = await e.metadata.getAdminBoxMetadata();
                            s({
                                tenantMetadata: t,
                                loading: !1
                            });
                        } catch (t) {
                            s({
                                loading: !1,
                                error: Un(t)
                            });
                        }
                    },
                    updateTenantMetadata: async (t)=>{
                        const { callback: a } = t, n = f(t, Bs);
                        try {
                            s({
                                error: null,
                                saving: !0
                            });
                            const t = Ss(n);
                            if (0 === t.length) throw new Error("No changes to update");
                            await e.metadata.updateAdminBoxMetadata({
                                actions: t
                            });
                            const i = await e.metadata.getAdminBoxMetadata();
                            s({
                                tenantMetadata: i,
                                saving: !1
                            }), null == a || a(!0);
                        } catch (t) {
                            s({
                                error: Un(t, "No changes to update"),
                                saving: !1
                            }), null == a || a(null, t);
                        }
                    },
                    customLoginEnabled: i,
                    loadCustomLoginRoutes: async (a)=>{
                        try {
                            var o, r, l;
                            if (!await i()) return void (null == a || null == (l = a.callback) || l.call(a, !0));
                            const u = t.auth.isAuthenticated, { getSettings: d, getPublicSettings: g } = e.accountSettings, { applicationUrl: p } = await En(u ? d : g, null == a ? void 0 : a.retryConfig);
                            var c;
                            if (!p) return void (null == a || null == (c = a.callback) || c.call(a, !0));
                            const h = t.auth.routes, y = null != (o = Qn(p)) ? o : "";
                            n.setAuthState({
                                routes: v({}, h, {
                                    customLoginAuthenticatedUrl: p,
                                    customLoginUrl: h.loginUrl + y
                                })
                            }), s({
                                customLoginSearchParams: null != y ? y : void 0
                            }), null == a || null == (r = a.callback) || r.call(a, !0);
                        } catch (t) {
                            var u;
                            null == a || null == (u = a.callback) || u.call(a, null, t);
                        }
                    }
                };
            };
            let Ws;
            !function(t) {
                t.forgotPassword = "forgotPassword", t.success = "success";
            }(Ws || (Ws = {}));
            const Hs = {
                step: Ws.forgotPassword,
                loading: !1,
                email: "",
                passwordConfig: null
            }, zs = (t)=>Za(Hs, t), Ks = [
                "callback"
            ], qs = (t, e, a)=>{
                const n = (e)=>{
                    Object.assign(t.auth.forgotPasswordState, e);
                };
                return {
                    setForgotPasswordState: n,
                    resetForgotPasswordState: ()=>{
                        Rn(t, [
                            "auth",
                            "forgotPasswordState"
                        ], Hs);
                    },
                    forgotPassword: async (t)=>{
                        n({
                            loading: !0
                        });
                        try {
                            var a;
                            await e.auth.forgotPassword(t), n({
                                loading: !1,
                                error: void 0,
                                step: Ws.success
                            }), null == (a = t.callback) || a.call(t, !0);
                        } catch (e) {
                            var s;
                            n({
                                loading: !1,
                                error: Un(e, "Unknown error occurred")
                            }), null == (s = t.callback) || s.call(t, !1, e);
                        }
                    },
                    resetPassword: async (t)=>{
                        const { callback: a } = t, s = f(t, Ks);
                        n({
                            loading: !0
                        });
                        try {
                            await e.auth.resetPassword(s), n({
                                loading: !1,
                                error: void 0,
                                step: Ws.success
                            }), null == a || a(!0);
                        } catch (t) {
                            n({
                                loading: !1,
                                error: Un(t)
                            }), null == a || a(!1, t);
                        }
                    },
                    loadPasswordConfig: async (t)=>{
                        n({
                            loading: !0
                        });
                        try {
                            const a = await e.auth.loadPasswordConfig(t);
                            n({
                                loading: !1,
                                passwordConfig: a
                            });
                        } catch (t) {
                            n({
                                loading: !1,
                                error: Un(t)
                            });
                        }
                    }
                };
            };
            let Js;
            !function(t) {
                t.success = "success", t.notification = "notification";
            }(Js || (Js = {}));
            const Ys = {
                step: Js.notification
            }, Xs = (t)=>Za(Ys, t), Qs = (t, e, a)=>({
                    setStep: (e)=>{
                        var a;
                        a = {
                            step: e
                        }, Object.assign(t.auth.passwordRotationState, a);
                    }
                }), Zs = {
                loaders: {},
                errors: {},
                groups: [],
                groupsConfiguration: {}
            }, ti = (t)=>Za(Zs, t);
            let ei, ai;
            !function(t) {
                t.CREATE_GROUP = "CREATE_GROUP", t.GET_GROUP = "GET_GROUP", t.GET_GROUPS = "GET_GROUPS", t.DELETE_GROUP = "DELETE_GROUP", t.UPDATE_GROUP = "UPDATE_GROUP", t.ADD_USERS_TO_GROUP = "ADD_USERS_TO_GROUP", t.DELETE_USERS_FROM_GROUP = "DELETE_USERS_FROM_GROUP", t.ADD_ROLES_TO_GROUP = "ADD_ROLES_TO_GROUP", t.DELETE_ROLES_FROM_GROUP = "DELETE_ROLES_FROM_GROUP", t.GET_GROUP_CONFIGURATION = "GET_GROUP_CONFIGURATION", t.UPDATE_GROUP_CONFIGURATION = "UPDATE_GROUP_CONFIGURATION", t.GET_TEAM_USERS = "GET_TEAM_USERS";
            }(ei || (ei = {})), function(t) {
                t.roles = "roles", t.users = "users", t.rolesAndUsers = "rolesAndUsers";
            }(ai || (ai = {}));
            const ni = [
                "roleIds",
                "userIds"
            ], si = (t, e, a)=>{
                const n = (e)=>{
                    Object.assign(t.auth.groupsState, {
                        loaders: v({}, t.auth.groupsState.loaders, {
                            [e.key]: e.value
                        })
                    });
                }, s = (e)=>{
                    Object.assign(t.auth.groupsState, {
                        errors: v({}, t.auth.groupsState.errors, {
                            [e.key]: e.value
                        }),
                        loaders: v({}, t.auth.groupsState.loaders, {
                            [e.key]: !1
                        })
                    });
                }, i = (e)=>{
                    Object.assign(t.auth.groupsState, e);
                }, o = async (a)=>{
                    const o = ei.GET_GROUPS, r = t.auth.groupsState;
                    n({
                        key: o,
                        value: !0
                    });
                    try {
                        const { groups: t } = await En(()=>e.groups.getGroups({
                                _groupsRelations: ai.rolesAndUsers
                            }), null == a ? void 0 : a.retryConfig);
                        i(v({
                            groups: t
                        }, r.selectedGroup && {
                            selectedGroup: t.find((t)=>{
                                var e;
                                return t.id === (null == (e = r.selectedGroup) ? void 0 : e.id);
                            })
                        }));
                    } catch (t) {
                        s({
                            key: o,
                            value: Un(t)
                        });
                    } finally{
                        n({
                            key: o,
                            value: !1
                        });
                    }
                }, r = async (t)=>{
                    const a = ei.ADD_ROLES_TO_GROUP;
                    n({
                        key: a,
                        value: !0
                    });
                    try {
                        var i;
                        await e.groups.addRolesToGroup(t.groupId, {
                            roleIds: t.roleIds
                        }), await o(), null == t || null == (i = t.callback) || i.call(t, !0);
                    } catch (e) {
                        var r;
                        s({
                            key: a,
                            value: Un(e)
                        }), null == t || null == (r = t.callback) || r.call(t, !1);
                    } finally{
                        n({
                            key: a,
                            value: !1
                        });
                    }
                }, l = async (t)=>{
                    const a = ei.ADD_USERS_TO_GROUP;
                    n({
                        key: a,
                        value: !0
                    });
                    try {
                        var i;
                        await e.groups.addUsersToGroup(t.groupId, {
                            userIds: t.userIds
                        }), await o(), null == t || null == (i = t.callback) || i.call(t, !0);
                    } catch (e) {
                        var r;
                        null == t || null == (r = t.callback) || r.call(t, !1), s({
                            key: a,
                            value: Un(e)
                        });
                    } finally{
                        n({
                            key: a,
                            value: !1
                        });
                    }
                }, c = async (t)=>{
                    const a = ei.GET_GROUP_CONFIGURATION;
                    n({
                        key: a,
                        value: !0
                    });
                    try {
                        const a = await En(()=>e.groups.getGroupConfiguration(), null == t ? void 0 : t.retryConfig);
                        i({
                            groupsConfiguration: a
                        });
                    } catch (t) {
                        s({
                            key: a,
                            value: Un(t)
                        });
                    } finally{
                        n({
                            key: a,
                            value: !1
                        });
                    }
                };
                return {
                    setUsersGroupsLoader: n,
                    setUsersGroupsError: s,
                    setGroupsState: i,
                    resetUsersGroupsState: ()=>{
                        Rn(t, [
                            "auth",
                            "groupsState"
                        ], Zs);
                    },
                    loadGroups: o,
                    getGroupById: async (t)=>{
                        const a = ei.GET_GROUP;
                        n({
                            key: a,
                            value: !0
                        });
                        try {
                            const a = await e.groups.getGroupById({
                                groupId: t.groupId
                            }, {
                                _groupsRelations: ai.rolesAndUsers
                            });
                            i({
                                selectedGroup: a
                            });
                        } catch (t) {
                            s({
                                key: a,
                                value: Un(t)
                            });
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    createGroup: async (t)=>{
                        const a = ei.CREATE_GROUP, { roleIds: i, userIds: c } = t, u = f(t, ni);
                        n({
                            key: a,
                            value: !0
                        });
                        try {
                            var d;
                            const a = await e.groups.createGroup(v({
                                name: u.name
                            }, !!u.description && {
                                description: u.description
                            }, {
                                color: u.color
                            }));
                            null != c && c.length && l({
                                groupId: a.id,
                                userIds: c
                            }), null != i && i.length && r({
                                groupId: a.id,
                                roleIds: i
                            }), await o(), null == t || null == (d = t.callback) || d.call(t, !0);
                        } catch (e) {
                            var g;
                            s({
                                key: a,
                                value: Un(e)
                            }), null == t || null == (g = t.callback) || g.call(t, !1);
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    updateGroup: async (t)=>{
                        const a = ei.UPDATE_GROUP;
                        n({
                            key: a,
                            value: !0
                        });
                        try {
                            var i;
                            await e.groups.updateGroup(t), await o(), null == t || null == (i = t.callback) || i.call(t, !0);
                        } catch (e) {
                            var r;
                            s({
                                key: a,
                                value: Un(e)
                            }), null == t || null == (r = t.callback) || r.call(t, !1);
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    deleteGroup: async (t)=>{
                        const a = ei.DELETE_GROUP;
                        n({
                            key: a,
                            value: !0
                        });
                        try {
                            var i;
                            await e.groups.deleteGroup(t.groupId), await o(), null == t || null == (i = t.callback) || i.call(t, !0);
                        } catch (e) {
                            var r;
                            s({
                                key: a,
                                value: Un(e)
                            }), null == t || null == (r = t.callback) || r.call(t, !1, e);
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    addRolesToGroup: r,
                    deleteRolesFromGroup: async (t)=>{
                        const a = ei.DELETE_ROLES_FROM_GROUP;
                        n({
                            key: a,
                            value: !0
                        });
                        try {
                            var i;
                            await e.groups.deleteRolesFromGroup(t.groupId, {
                                roleIds: t.roleIds
                            }), await o(), null == t || null == (i = t.callback) || i.call(t, !0);
                        } catch (e) {
                            var r;
                            s({
                                key: a,
                                value: Un(e)
                            }), null == t || null == (r = t.callback) || r.call(t, !1);
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    addUsersToGroup: l,
                    deleteUsersFromGroup: async (t)=>{
                        const a = ei.DELETE_USERS_FROM_GROUP;
                        n({
                            key: a,
                            value: !0
                        });
                        try {
                            var i;
                            await e.groups.deleteUsersFromGroup(t.groupId, {
                                userIds: t.userIds
                            }), await o(), null == t || null == (i = t.callback) || i.call(t, !0);
                        } catch (e) {
                            var r;
                            s({
                                key: a,
                                value: Un(e)
                            }), null == t || null == (r = t.callback) || r.call(t, !1);
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    getGroupConfiguration: c,
                    updateGroupConfiguration: async (t)=>{
                        const a = ei.UPDATE_GROUP_CONFIGURATION;
                        n({
                            key: a,
                            value: !0
                        });
                        try {
                            await e.groups.updateGroupConfiguration(t), await c();
                        } catch (t) {
                            s({
                                key: a,
                                value: Un(t)
                            });
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    getTeamUsers: async (t)=>{
                        const a = ei.GET_TEAM_USERS;
                        n({
                            key: a,
                            value: !0
                        });
                        try {
                            const { items: a } = await e.users.getUsersV2({
                                _filter: t.filter,
                                _offset: t.pageOffset,
                                _limit: t.pageSize,
                                _includeSubTenants: !1
                            });
                            i({
                                teamUsers: a
                            });
                        } catch (t) {
                            s({
                                key: a,
                                value: Un(t)
                            });
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    }
                };
            }, ii = {
                addGroupDialogState: {
                    loading: !1,
                    open: !1
                },
                editGroupDialogState: {
                    loading: !1,
                    open: !1
                },
                deleteGroupDialogState: {
                    loading: !1,
                    open: !1
                },
                addMembersToGroupDialogState: {
                    loading: !1,
                    open: !1,
                    userIds: []
                },
                deleteMemberFromGroupDialogState: {
                    loading: !1,
                    open: !1
                }
            }, oi = (t)=>Za(ii, t), ri = (t, e, a)=>({
                    setGroupsDialogsState: (e)=>{
                        Object.assign(t.auth.groupsDialogsState, e);
                    },
                    resetGroupsDialogsState: ()=>{
                        Rn(t, [
                            "auth",
                            "groupsDialogsState"
                        ], ii);
                    },
                    openAddGroupDialog: ()=>{
                        t.auth.groupsDialogsState.addGroupDialogState.open = !0;
                    },
                    closeAddGroupDialog: ()=>{
                        Object.assign(t.auth.groupsDialogsState.addGroupDialogState, {
                            open: !1,
                            group: void 0
                        });
                    },
                    openAddMembersToGroupDialog: ()=>{
                        t.auth.groupsDialogsState.addMembersToGroupDialogState.open = !0;
                    },
                    closeAddMembersToGroupDialog: ()=>{
                        Object.assign(t.auth.groupsDialogsState.addMembersToGroupDialogState, {
                            open: !1,
                            userIds: []
                        });
                    },
                    openEditGroupDialog: (e)=>{
                        Object.assign(t.auth.groupsDialogsState.editGroupDialogState, v({}, e, {
                            open: !0
                        }));
                    },
                    closeEditGroupDialog: ()=>{
                        Object.assign(t.auth.groupsDialogsState.editGroupDialogState, {
                            open: !1,
                            loading: !1,
                            group: void 0
                        });
                    },
                    openDeleteGroupDialog: (e)=>{
                        Object.assign(t.auth.groupsDialogsState.deleteGroupDialogState, v({}, e, {
                            open: !0
                        }));
                    },
                    closeDeleteGroupDialog: ()=>{
                        Object.assign(t.auth.groupsDialogsState.deleteGroupDialogState, {
                            open: !1,
                            loading: !1,
                            group: void 0
                        });
                    },
                    openDeleteMemberFromGroupDialog: (e)=>{
                        Object.assign(t.auth.groupsDialogsState.deleteMemberFromGroupDialogState, e);
                    },
                    closeDeleteMemberFromGroupDialog: ()=>{
                        Object.assign(t.auth.groupsDialogsState.deleteMemberFromGroupDialogState, {
                            open: !1,
                            userId: void 0,
                            email: void 0
                        });
                    }
                });
            let li;
            !function(t) {
                t.impersonating = "impersonating", t.success = "success";
            }(li || (li = {}));
            const ci = {
                step: li.impersonating,
                loading: !1
            }, ui = (t)=>Za(ci, t), di = [
                "callback",
                "events"
            ], gi = (t, e, a)=>{
                const n = a, s = (e)=>{
                    Object.assign(t.auth.impersonateState, e);
                }, i = ()=>{
                    Rn(t, [
                        "auth",
                        "impersonateState"
                    ], ci);
                };
                return {
                    setImpersonateState: s,
                    resetImpersonateState: i,
                    impersonate: async (t)=>{
                        const { callback: a } = t, o = f(t, di);
                        s({
                            loading: !0
                        });
                        try {
                            await e.impersonate.impersonate(o), s({
                                step: li.success
                            }), await wn(1e3), await n.afterAuthNavigation({
                                preventRedirectUrlOriginCleaning: !0
                            }), i(), null == a || a(!0);
                        } catch (t) {
                            s({
                                loading: !1,
                                error: Un(t)
                            });
                        }
                    }
                };
            }, pi = {
                flow: hn.Login,
                step: pn.preLogin,
                loading: !1,
                email: "",
                tenants: []
            }, hi = (t)=>Za(pi, t), yi = (t, e, a)=>{
                const n = a;
                const s = async (e, a = {})=>{
                    const { customLoginAuthenticatedUrl: n, forceStepUpUrl: s, shouldStepUpDuringLogin: i, preventRedirectUrlOriginCleaning: o = !1 } = a, r = t.auth.onRedirectTo;
                    let l;
                    if (s) l = s;
                    else {
                        var c;
                        if (i) {
                            const t = window.localStorage.getItem(mn);
                            t && !Yn(t) && (l = t);
                        }
                        l || (l = await async function({ customLoginAuthenticatedUrl: e, preventRedirectUrlOriginCleaning: a }) {
                            const { routes: n, includeQueryParam: s = !1, enforceRedirectToSameSite: i = !1, allowedRedirectOrigins: o = [] } = t.auth, r = window.localStorage.getItem(mn);
                            if (e && !r) return Zn(e, a);
                            const { authenticatedUrl: l, loginUrl: c, logoutUrl: u, socialLoginCallbackUrl: d, activateUrl: g, activateWithOTCUrl: p } = n;
                            let h = r;
                            h && ![
                                c,
                                u,
                                d,
                                g,
                                p
                            ].includes(h) || (h = l);
                            const y = Xn({
                                authenticatedUrl: h,
                                includeQueryParam: s,
                                enforceRedirectToSameSite: i,
                                allowedRedirectOrigins: o
                            });
                            var S, v, f;
                            return a ? y : (S = y).startsWith(null == (v = window) ? void 0 : v.location.origin) ? S.replace(null == (f = window) ? void 0 : f.location.origin, "") : S;
                        }({
                            customLoginAuthenticatedUrl: n,
                            preventRedirectUrlOriginCleaning: o
                        })), null == (c = window) || c.localStorage.removeItem(mn);
                    }
                    await wn(200), await e(), r(l, {
                        refresh: l.startsWith("http")
                    });
                };
                return {
                    afterAuthNavigationUtil: s,
                    afterAuthNavigation: async (e)=>{
                        var a, i;
                        const { customLoginAuthenticatedUrl: o, stepUpUrl: r } = t.auth.routes, l = null == (a = window) ? void 0 : a.localStorage.getItem(dn), c = t.auth.user;
                        var u;
                        if (l && (null == (u = window) || u.localStorage.removeItem(dn)), r && l && !cs(c)) return s(n.resetLoginState, {
                            forceStepUpUrl: r
                        });
                        let d = o;
                        var g;
                        return o || (await n.loadCustomLoginRoutes(), d = null == (g = t.auth.routes) ? void 0 : g.customLoginAuthenticatedUrl), s(n.resetLoginState, {
                            customLoginAuthenticatedUrl: d,
                            shouldStepUpDuringLogin: !!l,
                            preventRedirectUrlOriginCleaning: null != (i = null == e ? void 0 : e.preventRedirectUrlOriginCleaning) && i
                        });
                    },
                    afterStepUpAuthNavigation: async ()=>s(n.resetStepUpState),
                    afterAuthenticationStateUpdate: function({ user: e, tenants: a = [], activeTenant: s }, i = {}) {
                        const o = t.auth.tenantsState;
                        n.setAuthState(v({
                            user: e,
                            tenantsState: v({}, o, {
                                tenants: a,
                                activeTenant: s,
                                loading: !1
                            })
                        }, i));
                    }
                };
            }, Si = [
                "callback"
            ], vi = [
                "callback"
            ], fi = [
                "callback"
            ], mi = [
                "callback",
                "deviceId"
            ], bi = [
                "callback",
                "deviceId"
            ], Ai = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_", wi = new Uint8Array(256);
            for(let t = 0; t < 64; t++)wi[Ai.charCodeAt(t)] = t;
            const Ti = (t)=>{
                const e = new Uint8Array(t), a = e.length;
                let n, s = "";
                for(n = 0; n < a; n += 3)s += Ai[e[n] >> 2], s += Ai[(3 & e[n]) << 4 | e[n + 1] >> 4], s += Ai[(15 & e[n + 1]) << 2 | e[n + 2] >> 6], s += Ai[63 & e[n + 2]];
                return a % 3 == 2 ? s = s.substring(0, s.length - 1) : a % 3 == 1 && (s = s.substring(0, s.length - 2)), s;
            }, Ei = (t)=>{
                const e = .75 * t.length, a = t.length;
                let n, s, i, o, r, l = 0;
                const c = new Uint8Array(e);
                for(n = 0; n < a; n += 4)s = wi[t.charCodeAt(n)], i = wi[t.charCodeAt(n + 1)], o = wi[t.charCodeAt(n + 2)], r = wi[t.charCodeAt(n + 3)], c[l++] = s << 2 | i >> 4, c[l++] = (15 & i) << 4 | o >> 2, c[l++] = (3 & o) << 6 | 63 & r;
                return c.buffer;
            };
            function Ii(t, e = "file") {
                const a = t.match(/^data:image\/([A-Za-z-+\/]+);base64,(.+)$/);
                if (null == a) return null;
                const n = `image/${a[1]}`, s = ((t, e)=>{
                    const a = atob(t), n = [];
                    for(let t = 0; t < a.length; t += 512){
                        const e = a.slice(t, t + 512), s = new Array(e.length);
                        for(let t = 0; t < e.length; t++)s[t] = e.charCodeAt(t);
                        n.push(new Uint8Array(s));
                    }
                    return new Blob(n, {
                        type: e
                    });
                })(a[2], n), i = new FormData;
                return i.append(e, new File([
                    s
                ], e, {
                    type: n
                })), i;
            }
            const Oi = (t)=>{
                if (t instanceof Array) {
                    const e = [];
                    for (const a of t)e.push(Oi(a));
                    return e;
                }
                if (t instanceof ArrayBuffer) return Ti(t);
                if (t instanceof Object) {
                    const e = {};
                    for(const a in t)e[a] = Oi(t[a]);
                    return e;
                }
                return t;
            }, Pi = (t)=>new Promise((e, a)=>{
                    const n = new FileReader;
                    n.readAsText(t), n.onload = ()=>e(n.result), n.onerror = a;
                }), ki = [
                "callback",
                "deviceId"
            ], _i = [
                "callback",
                "deviceId"
            ], Ri = "input is invalid type", Ci = "undefined" != typeof ArrayBuffer, Li = "0123456789abcdef".split(""), Ui = [
                -2147483648,
                8388608,
                32768,
                128
            ], Di = [
                24,
                16,
                8,
                0
            ], Ni = [
                1116352408,
                1899447441,
                3049323471,
                3921009573,
                961987163,
                1508970993,
                2453635748,
                2870763221,
                3624381080,
                310598401,
                607225278,
                1426881987,
                1925078388,
                2162078206,
                2614888103,
                3248222580,
                3835390401,
                4022224774,
                264347078,
                604807628,
                770255983,
                1249150122,
                1555081692,
                1996064986,
                2554220882,
                2821834349,
                2952996808,
                3210313671,
                3336571891,
                3584528711,
                113926993,
                338241895,
                666307205,
                773529912,
                1294757372,
                1396182291,
                1695183700,
                1986661051,
                2177026350,
                2456956037,
                2730485921,
                2820302411,
                3259730800,
                3345764771,
                3516065817,
                3600352804,
                4094571909,
                275423344,
                430227734,
                506948616,
                659060556,
                883997877,
                958139571,
                1322822218,
                1537002063,
                1747873779,
                1955562222,
                2024104815,
                2227730452,
                2361852424,
                2428436474,
                2756734187,
                3204031479,
                3329325298
            ], Mi = [
                "hex",
                "array",
                "digest",
                "arrayBuffer"
            ], Fi = [];
            Array.isArray || (Array.isArray = function(t) {
                return "[object Array]" === Object.prototype.toString.call(t);
            }), Ci && !ArrayBuffer.isView && (ArrayBuffer.isView = function(t) {
                return "object" == typeof t && t.buffer && t.buffer.constructor === ArrayBuffer;
            });
            const xi = function(t) {
                return function(e) {
                    const a = new $i(!0).update(e);
                    return null == a ? void 0 : a[t]();
                };
            }, Gi = function(t) {
                return function(e, a) {
                    const n = new ji(e, !0).update(a);
                    return null == n ? void 0 : n[t]();
                };
            };
            class $i {
                constructor(t = !1){
                    this.blocks = void 0, this.h0 = void 0, this.h1 = void 0, this.h2 = void 0, this.h3 = void 0, this.h4 = void 0, this.h5 = void 0, this.h6 = void 0, this.h7 = void 0, this.block = void 0, this.start = void 0, this.bytes = void 0, this.hBytes = void 0, this.finalized = void 0, this.hashed = void 0, this.first = void 0, this.lastByteIndex = void 0, this.sharedMemory = !1, this.toString = ()=>this.hex(), this.array = ()=>$i.prototype.digest(), t ? (Fi[0] = Fi[16] = Fi[1] = Fi[2] = Fi[3] = Fi[4] = Fi[5] = Fi[6] = Fi[7] = Fi[8] = Fi[9] = Fi[10] = Fi[11] = Fi[12] = Fi[13] = Fi[14] = Fi[15] = 0, this.blocks = Fi) : this.blocks = [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ], this.h0 = 1779033703, this.h1 = 3144134277, this.h2 = 1013904242, this.h3 = 2773480762, this.h4 = 1359893119, this.h5 = 2600822924, this.h6 = 528734635, this.h7 = 1541459225, this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1, this.first = !0, this.sharedMemory = t;
                }
                update(t) {
                    if (this.finalized) return;
                    let e;
                    const a = typeof t;
                    if ("string" !== a) {
                        if ("object" !== a) throw new Error(Ri);
                        if (null === t) throw new Error(Ri);
                        if (Ci && t.constructor === ArrayBuffer) t = new Uint8Array(t);
                        else if (!(Array.isArray(t) || Ci && ArrayBuffer.isView(t))) throw new Error(Ri);
                        e = !0;
                    }
                    let n, s, i = 0;
                    const o = t.length, r = this.blocks;
                    for(; i < o;){
                        if (this.hashed && (this.hashed = !1, r[0] = this.block, r[16] = r[1] = r[2] = r[3] = r[4] = r[5] = r[6] = r[7] = r[8] = r[9] = r[10] = r[11] = r[12] = r[13] = r[14] = r[15] = 0), e) for(s = this.start; i < o && s < 64; ++i)r[s >> 2] |= t[i] << Di[3 & s++];
                        else for(s = this.start; i < o && s < 64; ++i)n = t.charCodeAt(i), n < 128 ? r[s >> 2] |= n << Di[3 & s++] : n < 2048 ? (r[s >> 2] |= (192 | n >> 6) << Di[3 & s++], r[s >> 2] |= (128 | 63 & n) << Di[3 & s++]) : n < 55296 || n >= 57344 ? (r[s >> 2] |= (224 | n >> 12) << Di[3 & s++], r[s >> 2] |= (128 | n >> 6 & 63) << Di[3 & s++], r[s >> 2] |= (128 | 63 & n) << Di[3 & s++]) : (n = 65536 + ((1023 & n) << 10 | 1023 & t.charCodeAt(++i)), r[s >> 2] |= (240 | n >> 18) << Di[3 & s++], r[s >> 2] |= (128 | n >> 12 & 63) << Di[3 & s++], r[s >> 2] |= (128 | n >> 6 & 63) << Di[3 & s++], r[s >> 2] |= (128 | 63 & n) << Di[3 & s++]);
                        this.lastByteIndex = s, this.bytes += s - this.start, s >= 64 ? (this.block = r[16], this.start = s - 64, this.hash(), this.hashed = !0) : this.start = s;
                    }
                    return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 | 0, this.bytes = this.bytes % 4294967296), this;
                }
                finalize() {
                    if (this.finalized) return;
                    this.finalized = !0;
                    const t = this.blocks, e = this.lastByteIndex;
                    t[16] = this.block, t[e >> 2] |= Ui[3 & e], this.block = t[16], e >= 56 && (this.hashed || this.hash(), t[0] = this.block, t[16] = t[1] = t[2] = t[3] = t[4] = t[5] = t[6] = t[7] = t[8] = t[9] = t[10] = t[11] = t[12] = t[13] = t[14] = t[15] = 0), t[14] = this.hBytes << 3 | this.bytes >>> 29, t[15] = this.bytes << 3, this.hash();
                }
                hash() {
                    let t, e, a, n, s, i, o, r, l, c, u, d = this.h0, g = this.h1, p = this.h2, h = this.h3, y = this.h4, S = this.h5, v = this.h6, f = this.h7;
                    const m = this.blocks;
                    for(t = 16; t < 64; ++t)s = m[t - 15], e = (s >>> 7 | s << 25) ^ (s >>> 18 | s << 14) ^ s >>> 3, s = m[t - 2], a = (s >>> 17 | s << 15) ^ (s >>> 19 | s << 13) ^ s >>> 10, m[t] = m[t - 16] + e + m[t - 7] + a | 0;
                    for(u = g & p, t = 0; t < 64; t += 4)this.first ? (r = 704751109, s = m[0] - 210244248, f = s - 1521486534 | 0, h = s + 143694565 | 0, this.first = !1) : (e = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10), a = (y >>> 6 | y << 26) ^ (y >>> 11 | y << 21) ^ (y >>> 25 | y << 7), r = d & g, n = r ^ d & p ^ u, o = y & S ^ ~y & v, s = f + a + o + Ni[t] + m[t], i = e + n, f = h + s | 0, h = s + i | 0), e = (h >>> 2 | h << 30) ^ (h >>> 13 | h << 19) ^ (h >>> 22 | h << 10), a = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7), l = h & d, n = l ^ h & g ^ r, o = f & y ^ ~f & S, s = v + a + o + Ni[t + 1] + m[t + 1], i = e + n, v = p + s | 0, p = s + i | 0, e = (p >>> 2 | p << 30) ^ (p >>> 13 | p << 19) ^ (p >>> 22 | p << 10), a = (v >>> 6 | v << 26) ^ (v >>> 11 | v << 21) ^ (v >>> 25 | v << 7), c = p & h, n = c ^ p & d ^ l, o = v & f ^ ~v & y, s = S + a + o + Ni[t + 2] + m[t + 2], i = e + n, S = g + s | 0, g = s + i | 0, e = (g >>> 2 | g << 30) ^ (g >>> 13 | g << 19) ^ (g >>> 22 | g << 10), a = (S >>> 6 | S << 26) ^ (S >>> 11 | S << 21) ^ (S >>> 25 | S << 7), u = g & p, n = u ^ g & h ^ c, o = S & v ^ ~S & f, s = y + a + o + Ni[t + 3] + m[t + 3], i = e + n, y = d + s | 0, d = s + i | 0;
                    this.h0 = this.h0 + d | 0, this.h1 = this.h1 + g | 0, this.h2 = this.h2 + p | 0, this.h3 = this.h3 + h | 0, this.h4 = this.h4 + y | 0, this.h5 = this.h5 + S | 0, this.h6 = this.h6 + v | 0, this.h7 = this.h7 + f | 0;
                }
                hex() {
                    this.finalize();
                    const t = this.h0, e = this.h1, a = this.h2, n = this.h3, s = this.h4, i = this.h5, o = this.h6, r = this.h7;
                    let l = Li[t >> 28 & 15] + Li[t >> 24 & 15] + Li[t >> 20 & 15] + Li[t >> 16 & 15] + Li[t >> 12 & 15] + Li[t >> 8 & 15] + Li[t >> 4 & 15] + Li[15 & t] + Li[e >> 28 & 15] + Li[e >> 24 & 15] + Li[e >> 20 & 15] + Li[e >> 16 & 15] + Li[e >> 12 & 15] + Li[e >> 8 & 15] + Li[e >> 4 & 15] + Li[15 & e] + Li[a >> 28 & 15] + Li[a >> 24 & 15] + Li[a >> 20 & 15] + Li[a >> 16 & 15] + Li[a >> 12 & 15] + Li[a >> 8 & 15] + Li[a >> 4 & 15] + Li[15 & a] + Li[n >> 28 & 15] + Li[n >> 24 & 15] + Li[n >> 20 & 15] + Li[n >> 16 & 15] + Li[n >> 12 & 15] + Li[n >> 8 & 15] + Li[n >> 4 & 15] + Li[15 & n] + Li[s >> 28 & 15] + Li[s >> 24 & 15] + Li[s >> 20 & 15] + Li[s >> 16 & 15] + Li[s >> 12 & 15] + Li[s >> 8 & 15] + Li[s >> 4 & 15] + Li[15 & s] + Li[i >> 28 & 15] + Li[i >> 24 & 15] + Li[i >> 20 & 15] + Li[i >> 16 & 15] + Li[i >> 12 & 15] + Li[i >> 8 & 15] + Li[i >> 4 & 15] + Li[15 & i] + Li[o >> 28 & 15] + Li[o >> 24 & 15] + Li[o >> 20 & 15] + Li[o >> 16 & 15] + Li[o >> 12 & 15] + Li[o >> 8 & 15] + Li[o >> 4 & 15] + Li[15 & o];
                    return l += Li[r >> 28 & 15] + Li[r >> 24 & 15] + Li[r >> 20 & 15] + Li[r >> 16 & 15] + Li[r >> 12 & 15] + Li[r >> 8 & 15] + Li[r >> 4 & 15] + Li[15 & r], l;
                }
                digest() {
                    this.finalize();
                    const t = this.h0, e = this.h1, a = this.h2, n = this.h3, s = this.h4, i = this.h5, o = this.h6, r = this.h7, l = [
                        t >> 24 & 255,
                        t >> 16 & 255,
                        t >> 8 & 255,
                        255 & t,
                        e >> 24 & 255,
                        e >> 16 & 255,
                        e >> 8 & 255,
                        255 & e,
                        a >> 24 & 255,
                        a >> 16 & 255,
                        a >> 8 & 255,
                        255 & a,
                        n >> 24 & 255,
                        n >> 16 & 255,
                        n >> 8 & 255,
                        255 & n,
                        s >> 24 & 255,
                        s >> 16 & 255,
                        s >> 8 & 255,
                        255 & s,
                        i >> 24 & 255,
                        i >> 16 & 255,
                        i >> 8 & 255,
                        255 & i,
                        o >> 24 & 255,
                        o >> 16 & 255,
                        o >> 8 & 255,
                        255 & o
                    ];
                    return l.push(r >> 24 & 255, r >> 16 & 255, r >> 8 & 255, 255 & r), l;
                }
                arrayBuffer() {
                    this.finalize();
                    const t = new ArrayBuffer(32), e = new DataView(t);
                    return e.setUint32(0, this.h0), e.setUint32(4, this.h1), e.setUint32(8, this.h2), e.setUint32(12, this.h3), e.setUint32(16, this.h4), e.setUint32(20, this.h5), e.setUint32(24, this.h6), e.setUint32(28, this.h7), t;
                }
            }
            class ji extends $i {
                constructor(t, e = !1){
                    let a;
                    super(e), this.inner = void 0, this.oKeyPad = void 0;
                    const n = typeof t;
                    if ("string" === n) {
                        const e = [], n = t.length;
                        let s, i = 0;
                        for(a = 0; a < n; ++a)s = t.charCodeAt(a), s < 128 ? e[i++] = s : s < 2048 ? (e[i++] = 192 | s >> 6, e[i++] = 128 | 63 & s) : s < 55296 || s >= 57344 ? (e[i++] = 224 | s >> 12, e[i++] = 128 | s >> 6 & 63, e[i++] = 128 | 63 & s) : (s = 65536 + ((1023 & s) << 10 | 1023 & t.charCodeAt(++a)), e[i++] = 240 | s >> 18, e[i++] = 128 | s >> 12 & 63, e[i++] = 128 | s >> 6 & 63, e[i++] = 128 | 63 & s);
                        t = e;
                    } else {
                        if ("object" !== n) throw new Error(Ri);
                        if (null === t) throw new Error(Ri);
                        if (Ci && t.constructor === ArrayBuffer) t = new Uint8Array(t);
                        else if (!(Array.isArray(t) || Ci && ArrayBuffer.isView(t))) throw new Error(Ri);
                    }
                    var s;
                    t.length > 64 && (t = null == (s = new $i(!0).update(t)) ? void 0 : s.array());
                    const i = [], o = [];
                    for(a = 0; a < 64; ++a){
                        const e = t[a] || 0;
                        i[a] = 92 ^ e, o[a] = 54 ^ e;
                    }
                    $i.call(this, e), this.update(o), this.oKeyPad = i, this.inner = !0, this.sharedMemory = e;
                }
                finalize() {
                    if (super.finalize(), this.inner) {
                        this.inner = !1;
                        const t = this.array();
                        $i.call(this, this.sharedMemory), this.update(this.oKeyPad), this.update(t), $i.prototype.finalize.call(this);
                    }
                }
            }
            const Bi = function() {
                const t = xi("hex");
                t.create = function() {
                    return new $i;
                }, t.update = function(e) {
                    return t.create().update(e);
                };
                for(let e = 0; e < Mi.length; ++e){
                    const a = Mi[e];
                    t[a] = xi(a);
                }
                return t;
            }(), Vi = function() {
                const t = Gi("hex");
                t.create = function(t) {
                    return new ji(t);
                }, t.update = function(e, a) {
                    return t.create(e).update(a);
                };
                for(let e = 0; e < Mi.length; ++e){
                    const a = Mi[e];
                    t[a] = Gi(a);
                }
                return t;
            }();
            async function Wi(t) {
                const e = Bi.digest((new TextEncoder).encode(t));
                return btoa(String.fromCharCode(...new Uint8Array(e))).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
            }
            async function Hi(t) {
                const e = await crypto.subtle.digest("SHA-256", (new TextEncoder).encode(t));
                return btoa(String.fromCharCode(...new Uint8Array(e))).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
            }
            async function zi(t) {
                var e, a;
                return null != (e = window.crypto) && null != (a = e.subtle) && a.digest ? Hi(t) : (console.warn("Generating CodeChallenge in non-secure domain:", window.location.origin), Wi(t));
            }
            function Ki(t = 16) {
                let e = "";
                for(let a = 0; a < t; a++)e += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".charAt(Math.floor(62 * Math.random()));
                return e;
            }
            var qi = a(8792), Ji = a.n(qi), Yi = a(5875);
            const Xi = (t = "default")=>{
                if (!C.for(t).shouldLoadEntitlements()) throw new Error("You must first enable entitlements via Frontegg options to use this function");
            }, Qi = (t, e, a, n, s = "default")=>(Xi(s), (0, Yi.Me)(e, t, a)), Zi = (t, e, a, n, s = "default")=>(Xi(s), (0, Yi.a_)(e, t, a)), to = (t, e, a, n, s = "default")=>"permissionKey" in e ? Qi(t, e.permissionKey, a, n, s) : Zi(t, e.featureKey, a, n, s);
            function eo(t, e) {
                return Ji()(t, e);
            }
            let ao, no;
            !function(t) {
                t.LOAD_SSO_CONFIGURATIONS = "LOAD_SSO_CONFIGURATIONS", t.SAVE_SSO_CONFIGURATION = "SAVE_SSO_CONFIGURATION", t.UPDATE_SSO_CONFIGURATION = "UPDATE_SSO_CONFIGURATION", t.SAVE_SSO_CONFIGURATION_BY_METADATA = "SAVE_SSO_CONFIGURATION_BY_METADATA", t.UPDATE_SSO_CONFIGURATION_BY_METADATA = "UPDATE_SSO_CONFIGURATION", t.DELETE_SSO_CONFIGURATION = "DELETE_SSO_CONFIGURATION", t.SAVE_SSO_DOMAIN = "SAVE_SSO_DOMAIN", t.DELETE_SSO_DOMAIN = "DELETE_SSO_DOMAIN", t.VALIDATE_SSO_DOMAIN = "VALIDATE_SSO_DOMAIN", t.UPDATE_SSO_DEFAULT_ROLES = "UPDATE_SSO_DEFAULT_ROLES", t.DELETE_SSO_GROUPS = "DELETE_SSO_GROUPS", t.SAVE_SSO_GROUPS = "SAVE_SSO_GROUPS", t.GET_SSO_AUTHORIZATION_ROLES = "GET_SSO_AUTHORIZATION_ROLES";
            }(ao || (ao = {})), function(t) {
                t.Saml = "saml", t.Okta = "okta", t.Azure = "azure", t.Google = "google", t.Oidc = "oidc";
            }(no || (no = {}));
            const so = [
                "callback",
                "error"
            ], io = [
                "callback"
            ], oo = [
                "callback"
            ], ro = [
                "callback"
            ], lo = [
                "callback"
            ], co = [
                "callback",
                "events"
            ], uo = [
                "callback"
            ], go = [
                "callback"
            ], po = [
                "user"
            ], ho = [
                "callback"
            ], yo = [
                "callback"
            ], So = [
                "callback"
            ], vo = [
                "callback"
            ], fo = [
                "callback"
            ], mo = [
                "callback"
            ], bo = (t, e, a)=>{
                const n = a, s = C.for(t.root.appName), i = (e)=>{
                    var a;
                    const { routes: n, loginState: s } = t.auth, i = null != (a = localStorage.getItem("register-quick-login")) ? a : s.quickLoginToRegister;
                    return i && "true" !== localStorage.getItem(`${e.id}-${i}`) && !window.location.pathname.endsWith(n.logoutUrl);
                }, o = async ()=>{
                    t.auth.hostedLoginBox ? await (async ()=>{
                        const a = t.auth.user;
                        if (null == a || !a.refreshToken) return s.setAccessToken(null), s.setUser(null), void n.setAuthState({
                            user: null,
                            isAuthenticated: !1
                        });
                        try {
                            const t = {
                                grant_type: "refresh_token",
                                refresh_token: null == a ? void 0 : a.refreshToken
                            }, s = await e.auth.exchangeOAuthTokensV2(t), i = await r(s.user);
                            n.afterAuthenticationStateUpdate(v({}, s, {
                                user: i
                            }), {
                                isAuthenticated: !0
                            });
                        } catch (t) {
                            s.setAccessToken(null), s.setUser(null), n.setAuthState({
                                user: null,
                                isAuthenticated: !1
                            });
                        }
                    })() : await (async ()=>{
                        try {
                            const { routes: s, loginState: o, onRedirectTo: c } = t.auth, { user: u, tenants: d = [], activeTenant: g } = await e.auth.refreshTokenV3();
                            if (hs(u, t.root.appName)) {
                                const t = await n.getMfaRequiredState(u);
                                n.setAuthState(t), c(s.loginUrl, {
                                    preserveQueryParams: !0
                                });
                            } else {
                                var a;
                                u.id && localStorage.setItem("userId", u.id);
                                const t = null != (a = localStorage.getItem("register-quick-login")) ? a : o.quickLoginToRegister, e = i(u), s = await r(u);
                                n.afterAuthenticationStateUpdate({
                                    user: s,
                                    tenants: d,
                                    activeTenant: g
                                }, {
                                    loginState: v({}, o, {
                                        quickLoginToRegister: t,
                                        flow: e ? hn.RegisterQuickLogin : hn.Login
                                    }),
                                    isAuthenticated: !0
                                }), await l(e);
                            }
                        } catch (t) {
                            s.setAccessToken(null), s.setUser(null), n.setAuthState({
                                user: void 0,
                                isAuthenticated: !1
                            });
                        }
                    })();
                }, r = async (e)=>{
                    var a;
                    const n = null == (a = t.auth.user) ? void 0 : a.entitlements;
                    return eo(n, null == e ? void 0 : e.entitlements) ? v({}, e, {
                        entitlements: n
                    }) : e;
                }, l = async (e)=>{
                    var a;
                    const s = new URL(null == (a = window) ? void 0 : a.location.href), { routes: i, loginState: o, onRedirectTo: r } = t.auth, l = s.searchParams.get("invitationToken"), c = [
                        i.socialLoginCallbackUrl,
                        i.oidcRedirectUrl,
                        i.samlCallbackUrl,
                        i.magicLinkCallbackUrl
                    ];
                    l || c.push(i.loginUrl, i.signUpUrl), e ? r(i.loginUrl) : c.some((t)=>t && window.location.pathname.endsWith(t)) && (o.isNewUser && i.signUpSuccessUrl && i.socialLoginCallbackUrl === window.location.pathname ? r(i.signUpSuccessUrl, {
                        refresh: i.signUpSuccessUrl.startsWith("http")
                    }) : await n.afterAuthNavigation());
                }, c = async (t)=>{
                    try {
                        var a;
                        const { isActive: s } = await En(e.auth.getSSOPublicConfiguration, null == t ? void 0 : t.retryConfig);
                        n.setAuthState({
                            isSSOAuth: s
                        }), null == t || null == (a = t.callback) || a.call(t, {
                            isSSOAuth: s
                        });
                    } catch (e) {
                        var s;
                        n.setAuthState({
                            isSSOAuth: !1
                        }), null == t || null == (s = t.callback) || s.call(t, null, e);
                    }
                }, u = async (t)=>{
                    let a;
                    try {
                        var s;
                        const n = await En(e.metadata.getSamlMetadata, null == t ? void 0 : t.retryConfig);
                        a = null == n || null == (s = n.configuration) ? void 0 : s.acsUrl;
                    } catch (t) {
                        console.error(t);
                    }
                    n.setAuthState({
                        ssoACS: a
                    });
                }, d = (e)=>{
                    Object.assign(t.auth.loginState, e);
                }, g = (t)=>In({
                        callback: (e, a)=>{
                            !a || a.statusCode < 500 || n.setErrorByRequestName({
                                requestName: t,
                                traceId: On(a)
                            });
                        }
                    }), p = async (e)=>{
                    let { callback: a, error: s } = e, i = f(e, so);
                    const o = t.auth.securityPolicyState.publicPolicy.policy;
                    if (null == o || !o.authStrategy) return n.setLoginState({
                        step: pn.loginWithPassword,
                        loading: !1
                    }), void (null == a || a());
                    (null == o ? void 0 : o.authStrategy) === N.EmailAndPassword ? (n.setLoginState({
                        step: pn.loginWithPassword,
                        loading: !1
                    }), null == a || a()) : [
                        N.MagicLink,
                        N.Code,
                        N.SmsCode
                    ].includes(null == o ? void 0 : o.authStrategy) ? await n.passwordlessPreLogin(v({}, i, {
                        type: null == o ? void 0 : o.authStrategy,
                        callback: a
                    })) : (n.setLoginState({
                        step: pn.loginWithPassword,
                        loading: !1,
                        error: Un(s)
                    }), null == a || a());
                }, h = async (t)=>{
                    const { user: e, tenants: a = [], activeTenant: s } = t, i = {
                        step: qn.recoveryCode,
                        loading: !1,
                        error: void 0,
                        saving: !1
                    };
                    null != e && e.recoveryCode && (i.recoveryCode = e.recoveryCode), n.setMfaState(i), n.setUser(e), n.setTenantsState({
                        tenants: a,
                        activeTenant: s,
                        loading: !1
                    }), e.id && localStorage.setItem("userId", e.id);
                };
                return v({
                    setLoginState: d,
                    resetLoginState: ()=>{
                        Rn(t, [
                            "auth",
                            "loginState"
                        ], pi);
                    },
                    requestAuthorize: async (t)=>{
                        const e = [], a = [];
                        e.push(o()), t && (n.setAuthState({
                            isLoading: !0
                        }), e.push(n.loadSocialLoginsConfigurationV2(In())), e.push(n.loadAllowSignUps(g(Bn.LOAD_ALLOW_SIGNUPS))), e.push(n.loadPublicAuthStrategiesPolicy(g(Bn.LOAD_PUBLIC_AUTH_STRATEGIES_POLICY))), e.push(c(g(Bn.LOAD_SSO_PUBLIC_CONFIGURATION))), e.push(n.loadVendorPublicInfo(In())), e.push(u(In())), a.push(n.loadCustomLoginRoutes(g(Bn.LOAD_CUSTOM_LOGIN_ROUTES)))), await Promise.all(e), a.length > 0 && await Promise.all(a), n.setAuthState({
                            isLoading: !1
                        });
                    },
                    requestAuthorizeSSR: async (e)=>{
                        const a = [];
                        a.push(n.loadSocialLoginsConfigurationV2(In())), a.push(n.loadAllowSignUps(g(Bn.LOAD_ALLOW_SIGNUPS))), a.push(c(g(Bn.LOAD_SSO_PUBLIC_CONFIGURATION))), a.push(n.loadVendorPublicInfo(In())), a.push(u()), a.push((async ({ accessToken: e, user: a })=>{
                            if (!e) return void n.setAuthState({
                                user: void 0,
                                isAuthenticated: !1
                            });
                            const { onRedirectTo: s, routes: i } = t.auth;
                            if (hs(a, t.root.appName)) {
                                const t = await n.getMfaRequiredState(a, An, !0);
                                n.setAuthState(t), s(i.loginUrl, {
                                    preserveQueryParams: !0
                                });
                            }
                        })(e)), a.push(n.loadCustomLoginRoutes(g(Bn.LOAD_CUSTOM_LOGIN_ROUTES))), await Promise.all(a);
                    },
                    preLogin: async (a)=>{
                        const { email: n, recaptchaToken: s, invitationToken: i, callback: o } = a;
                        d({
                            loading: !0
                        });
                        try {
                            const a = t.auth.onRedirectTo, r = ts(es), l = await e.auth.preLoginV2({
                                email: n,
                                tenantId: r
                            }), { address: c, idpType: u } = null != l ? l : {};
                            if (c) {
                                let e = c;
                                if (u === no.Oidc && !e.includes("redirect_uri")) {
                                    const { oidcRedirectUrl: a } = t.auth.routes;
                                    e += `&redirect_uri=${window.location.origin}${a}`;
                                }
                                S.isLoginWithSSOAvailable() ? (S.loginWithSSO(n), d({
                                    loading: !1
                                }), null == o || o()) : (d({
                                    step: pn.redirectToSSO,
                                    loading: !1,
                                    ssoRedirectUrl: e
                                }), setTimeout(()=>{
                                    a(e, {
                                        refresh: !0
                                    });
                                }, 2e3));
                            } else await p({
                                email: n,
                                recaptchaToken: s,
                                callback: o,
                                invitationToken: i
                            });
                        } catch (t) {
                            await p({
                                email: n,
                                recaptchaToken: s,
                                callback: o,
                                invitationToken: i,
                                error: t
                            });
                        }
                    },
                    postLogin: async (a)=>{
                        const { onRedirectTo: s, routes: i } = t.auth;
                        d({
                            loading: !0
                        });
                        try {
                            const t = await e.auth.postLogin(a);
                            n.setAuthState({
                                user: t.accessToken ? t : void 0,
                                isAuthenticated: !!t.accessToken
                            }), await n.afterAuthNavigation();
                        } catch (t) {
                            setTimeout(()=>{
                                s(i.authenticatedUrl);
                            }, 1e3), d({
                                step: pn.loginWithSSOFailed,
                                loading: !1
                            });
                        }
                    },
                    login: async (a)=>{
                        const { email: i, password: o, recaptchaToken: r, invitationToken: l, callback: c } = a;
                        d({
                            loading: !0
                        });
                        try {
                            const { user: a, tenants: s = [], activeTenant: u } = await e.auth.loginv2({
                                email: i,
                                password: o,
                                recaptchaToken: r,
                                invitationToken: l
                            }), { onRedirectTo: g, routes: p } = t.auth;
                            if (hs(a, t.root.appName)) {
                                const t = await n.getMfaRequiredState(a, An, !0, i);
                                n.setAuthState(t), g(p.loginUrl, {
                                    preserveQueryParams: !0
                                });
                            } else {
                                const [e, o] = await n.getFeatureFlags([
                                    "security-center-show-login-flows",
                                    "password-rotation"
                                ]);
                                if (o && ys(a, t.root.appName)) d({
                                    step: pn.passwordRotationExpired,
                                    loading: !1,
                                    resetPasswordToken: a.resetPasswordToken,
                                    userId: a.userId
                                });
                                else {
                                    const r = t.auth.loginState, l = !!a.accessToken;
                                    if (a.id && localStorage.setItem("userId", a.id), n.afterAuthenticationStateUpdate({
                                        user: a,
                                        tenants: s,
                                        activeTenant: u
                                    }, {
                                        loginState: {
                                            flow: r.flow,
                                            quickLoginToRegister: r.quickLoginToRegister,
                                            email: i,
                                            loading: !1,
                                            error: void 0,
                                            mfaToken: a.mfaToken,
                                            step: r.flow === hn.Login ? pn.success : r.step,
                                            tenants: s,
                                            tenantsLoading: !0,
                                            isBreachedPassword: a.isBreachedPassword
                                        },
                                        isAuthenticated: l
                                    }), r.flow === hn.Login) {
                                        if (e && a.isBreachedPassword && !l) d({
                                            step: pn.breachedPassword,
                                            loading: !1
                                        });
                                        else if (l) {
                                            const t = ls(a);
                                            o && t ? d({
                                                step: pn.passwordRotationNotification,
                                                loading: !1
                                            }) : await n.__shouldShowPromptPasskeys() ? (d({
                                                step: pn.promptPasskeys,
                                                loading: !1
                                            }), g(p.loginUrl, {
                                                preserveQueryParams: !0
                                            })) : await n.afterAuthNavigation();
                                        }
                                    }
                                }
                            }
                            S.isSuggestSavePasswordAvailable() && S.suggestSavePassword(i, o), localStorage.removeItem("register-quick-login"), null == c || c(!0);
                        } catch (t) {
                            s.setAccessToken(null), s.setUser(null), null == c || c(!1, t), d({
                                email: i,
                                error: Un(t),
                                loading: !1
                            });
                        }
                    },
                    logout: async (a)=>{
                        const i = t.auth.hostedLoginBox;
                        n.setAuthState({
                            isLoading: !0
                        });
                        try {
                            i ? await e.auth.OAuthLogout() : await e.auth.logout();
                        } catch  {}
                        s.isSessionPerTenantEnabled() && ie(), n.resetAuthState(), await n.requestAuthorize(!0), null == a || a();
                    },
                    silentLogout: async (t)=>{
                        var a;
                        try {
                            await e.auth.logout();
                        } catch  {}
                        s.isSessionPerTenantEnabled() && ie(), setTimeout(()=>{
                            var e;
                            return null == t || null == (e = t.callback) ? void 0 : e.call(t, !0);
                        }, null != (a = null == t ? void 0 : t.callbackTimeout) ? a : 500);
                    },
                    recoverMfa: async (t)=>{
                        d({
                            loading: !0
                        });
                        try {
                            var a;
                            await e.auth.recoverMfaToken(t), d({
                                loading: !1,
                                error: void 0,
                                step: pn.preLogin
                            }), n.setAuthState({
                                user: void 0,
                                isAuthenticated: !1
                            }), null == (a = t.callback) || a.call(t, !0);
                        } catch (e) {
                            var s;
                            d({
                                error: Un(e),
                                loading: !1
                            }), null == (s = t.callback) || s.call(t, !1, e);
                        }
                    },
                    quickSmsPasswordlessPreLogin: async (t)=>{
                        const { callback: a } = t, n = f(t, io);
                        try {
                            d({
                                loading: !0
                            });
                            const t = await e.auth.passwordlessPreLogin(v({}, n, {
                                type: N.SmsCode
                            }));
                            d({
                                step: pn.loginWithQuickSmsOtc,
                                loading: !1,
                                phoneNumber: null == t ? void 0 : t.phoneNumber,
                                error: void 0
                            }), null == a || a(!0);
                        } catch (t) {
                            d({
                                error: Un(t),
                                loading: !1
                            }), null == a || a(!1, t);
                        }
                    },
                    changePhoneNumberWithVerification: async (t)=>{
                        const { callback: a } = t, n = f(t, oo);
                        try {
                            d({
                                loading: !0
                            });
                            const t = await e.auth.changePhoneNumberWithVerification(n);
                            d({
                                phoneNumber: n.phoneNumber,
                                loading: !1,
                                changePhoneId: t.changePhoneId,
                                step: pn.loginWithQuickSmsOtc,
                                error: void 0
                            }), null == a || a(!0);
                        } catch (t) {
                            d({
                                error: Un(t),
                                loading: !1
                            });
                        }
                    },
                    verifyChangePhoneNumber: async (t)=>{
                        const { callback: a } = t, n = f(t, ro);
                        try {
                            d({
                                loading: !0
                            }), await e.auth.verifyChangePhoneNumber(n), d({
                                loading: !1
                            }), null == a || a(!0);
                        } catch (t) {
                            d({
                                error: Un(t),
                                loading: !1
                            });
                        }
                    },
                    passwordlessPreLogin: async (t)=>{
                        const { callback: a } = t, n = f(t, lo);
                        try {
                            let t;
                            d({
                                loading: !0
                            }), os(n) && (t = n.email);
                            const s = await e.auth.passwordlessPreLogin(n), i = vn[n.type];
                            d({
                                step: i,
                                loading: !1,
                                phoneNumber: null == s ? void 0 : s.phoneNumber,
                                email: t,
                                error: void 0
                            }), null == a || a();
                        } catch (t) {
                            d({
                                error: Un(t),
                                loading: !1
                            }), null == a || a(null, t);
                        }
                    },
                    passwordlessPostLogin: async (a)=>{
                        const { callback: s, events: i } = a, o = f(a, co);
                        try {
                            d({
                                loading: !0
                            });
                            const { user: l, tenants: c = [], activeTenant: u } = await e.auth.passwordlessPostLoginV2(o), { routes: g, onRedirectTo: p } = t.auth;
                            if (hs(l, t.root.appName)) {
                                const t = await n.getMfaRequiredState(l);
                                n.setAuthState(t), p(g.loginUrl, {
                                    preserveQueryParams: !0
                                });
                            } else {
                                const e = t.auth.loginState;
                                if (l.emailVerified) {
                                    var r;
                                    const t = {
                                        email: l.email,
                                        origin: Vn.PASSWORDLESS,
                                        id: l.id,
                                        tenantId: l.tenantId,
                                        createdAt: new Date,
                                        name: l.name
                                    };
                                    null == i || null == (r = i.userVerified) || r.call(i, t), Jn(Kn.USER_VERIFIED, t);
                                }
                                l.id && localStorage.setItem("userId", l.id), n.afterAuthenticationStateUpdate({
                                    user: l,
                                    tenants: c,
                                    activeTenant: u
                                }), d({
                                    error: void 0
                                }), n.setAuthState({
                                    isLoading: !1
                                }), e.flow === hn.Login ? await n.__shouldShowPromptPasskeys() ? (n.setLoginState({
                                    step: pn.promptPasskeys,
                                    loading: !1
                                }), p(g.loginUrl, {
                                    preserveQueryParams: !0
                                })) : (n.setAuthState({
                                    isAuthenticated: !0
                                }), a.type === N.MagicLink && (n.setLoginState({
                                    step: pn.magicLinkPostLoginSuccess,
                                    loading: !1
                                }), await wn(5e3)), await n.afterAuthNavigation()) : p(g.loginUrl, {
                                    preserveQueryParams: !0
                                }), localStorage.removeItem("register-quick-login"), null == s || s(!0);
                            }
                        } catch (t) {
                            d({
                                error: Un(t, "Failed to authenticate")
                            }), null == s || s(null, t);
                        } finally{
                            d({
                                loading: !1
                            });
                        }
                    },
                    verifyInviteToken: async (t)=>{
                        try {
                            d({
                                loading: !0
                            });
                            const { name: a } = await e.auth.verifyInviteToken(t);
                            d({
                                inviteTokenTenantName: a
                            });
                        } catch (t) {
                            d({
                                inviteTokenError: Un(t, "We couldn't verify your invitation")
                            });
                        } finally{
                            d({
                                loading: !1
                            });
                        }
                    },
                    webAuthnPrelogin: async (t)=>{
                        const { callback: a } = t, s = f(t, uo);
                        try {
                            var i;
                            n.setPasskeysState({
                                loading: !0
                            }), d({
                                loading: !0
                            });
                            const { options: t } = await e.auth.webAuthnPreLogin(s);
                            t.challenge = Ei(t.challenge), t.allowCredentials = null == (i = t.allowCredentials) ? void 0 : i.map((t)=>v({}, t, {
                                    id: Ei(t.id)
                                })), d({
                                error: void 0
                            }), null == a || a(t);
                        } catch (t) {
                            d({
                                error: Un(t)
                            }), null == a || a(null);
                        } finally{
                            n.setPasskeysState({
                                loading: !1
                            }), d({
                                loading: !1
                            });
                        }
                    },
                    webAuthnPostLogin: async (a)=>{
                        const { callback: s } = a, i = f(a, go);
                        try {
                            var o;
                            n.setPasskeysState({
                                loading: !0
                            }), d({
                                loading: !0
                            });
                            const a = Oi(i.publicKey), r = await e.auth.webAuthnPostLoginV2(v({}, a, {
                                response: v({}, a.response, {
                                    userHandle: null != (o = a.response.userHandle) ? o : void 0
                                }),
                                recaptchaToken: i.recaptchaToken,
                                invitationToken: i.invitationToken
                            })), { user: l } = r, c = f(r, po);
                            if (hs(l, t.root.appName)) {
                                const { routes: e, onRedirectTo: a } = t.auth, s = await n.getMfaRequiredState(l);
                                n.setAuthState(s), a(e.loginUrl, {
                                    preserveQueryParams: !0
                                });
                            } else l.id && localStorage.setItem("userId", l.id), n.afterAuthenticationStateUpdate(v({
                                user: l
                            }, c), {
                                isAuthenticated: !0
                            }), d({
                                error: void 0
                            }), await n.afterAuthNavigation(), null == s || s(!0);
                        } catch (t) {
                            d({
                                error: Un(t)
                            }), null == s || s(null);
                        } finally{
                            n.setPasskeysState({
                                loading: !1
                            }), d({
                                loading: !1
                            });
                        }
                    },
                    webAuthnCreateNewDeviceSession: async (t)=>{
                        const { callback: a } = t;
                        try {
                            d({
                                loading: !0
                            });
                            const { options: t } = await e.auth.webAuthnCreateNewDeviceSession();
                            t.user.id = Ei(t.user.id), t.challenge = Ei(t.challenge), t.excludeCredentials = [], null == a || a(t);
                        } catch (t) {
                            d({
                                error: Un(t)
                            }), null == a || a(null);
                        } finally{
                            d({
                                loading: !1
                            });
                        }
                    },
                    webAuthnVerifyNewDeviceSession: async (t)=>{
                        const { callback: a } = t, n = f(t, ho);
                        try {
                            d({
                                loading: !0
                            });
                            const t = Oi(n.publicKey), s = "platform" === (null == t ? void 0 : t.authenticatorAttachment) ? zt.Platform : zt.CrossPlatform;
                            await e.auth.verifyNewDeviceSession({
                                id: t.id,
                                response: t.response,
                                deviceType: s
                            }), null == a || a(!0);
                        } catch (t) {
                            d({
                                error: Un(t)
                            }), null == a || a(null);
                        } finally{
                            d({
                                loading: !1
                            });
                        }
                    },
                    getUserIP: async (t)=>{
                        const { callback: a } = t;
                        try {
                            n.setAuthState({
                                userIpData: {
                                    loading: !0
                                }
                            });
                            const { ip: t, country_code: s } = await e.metadata.getCurrentUserIpMetadata();
                            n.setAuthState({
                                userIpData: {
                                    ip: t,
                                    countryCode: s,
                                    loading: !1
                                }
                            }), n.setAuthState({
                                userIp: t
                            }), null == a || a({
                                ip: t,
                                countryCode: s
                            });
                        } catch (t) {
                            n.setAuthState({
                                userIpData: {
                                    loading: !1
                                }
                            }), null == a || a(!1);
                        }
                    },
                    preEnrollMFAWebAuthnForLogin: async (t)=>{
                        const { callback: a } = t, n = f(t, yo);
                        d({
                            loading: !0
                        });
                        try {
                            var s;
                            const t = await e.auth.preEnrollMFAWebAuthnForLogin(n), i = v({}, t.options, {
                                challenge: Ei(t.options.challenge),
                                user: v({}, t.options.user, {
                                    id: Ei(t.options.user.id)
                                }),
                                excludeCredentials: null == (s = t.options.excludeCredentials) ? void 0 : s.map((t)=>v({}, t, {
                                        id: Ei(t.id)
                                    }))
                            });
                            d({
                                loading: !1
                            }), null == a || a({
                                options: i,
                                webauthnToken: t.webauthnToken
                            });
                        } catch (t) {
                            d({
                                loading: !1,
                                error: Un(t)
                            }), null == a || a(null);
                        }
                    },
                    enrollMFAWebAuthnForLogin: async (t)=>{
                        const { callback: a } = t, n = f(t, So);
                        d({
                            loading: !0
                        });
                        try {
                            const t = Oi(n.publicKey), s = await e.auth.enrollMFAWebAuthnForLoginV2(v({}, n, {
                                options: t
                            }));
                            await h(s), d({
                                loading: !1
                            }), null == a || a(!0);
                        } catch (t) {
                            d({
                                loading: !1,
                                error: Un(t)
                            }), null == a || a(null);
                        }
                    },
                    enrollMFAAuthenticatorAppForLogin: async (t)=>{
                        const { callback: a } = t, n = f(t, vo);
                        d({
                            loading: !0
                        });
                        try {
                            const t = await e.auth.enrollMFAAuthenticatorAppForLoginV2(n);
                            await h(t), d({
                                loading: !1
                            }), null == a || a(!0);
                        } catch (t) {
                            d({
                                loading: !1,
                                error: Un(t)
                            }), null == a || a(null);
                        }
                    },
                    preEnrollMFASMSForLogin: async (t)=>{
                        const { callback: a } = t, s = f(t, fo);
                        d({
                            loading: !0
                        });
                        try {
                            const t = await e.auth.preEnrollMFASMSForLogin(s);
                            n.setMfaState({
                                otcToken: t.otcToken,
                                step: qn.smsVerifyCode,
                                phoneNumber: t.phoneNumber
                            }), d({
                                loading: !1
                            }), null == a || a(!0);
                        } catch (t) {
                            d({
                                loading: !1,
                                error: Un(t)
                            }), null == a || a(null);
                        }
                    },
                    enrollMFASMSForLogin: async (t)=>{
                        const { callback: a } = t, n = f(t, mo);
                        d({
                            loading: !0
                        });
                        try {
                            const t = await e.auth.enrollMFASMSForLoginV2(n);
                            await h(t), d({
                                loading: !1
                            }), null == a || a(!0);
                        } catch (t) {
                            d({
                                loading: !1,
                                error: Un(t)
                            }), null == a || a(null);
                        }
                    },
                    handleEnrollMFAResponse: h,
                    resetBreachedPassword: async (t)=>{
                        d({
                            loading: !0
                        });
                        try {
                            await e.auth.forgotPassword(t), d({
                                loading: !1,
                                error: void 0,
                                step: pn.breachedPasswordSuccess
                            }), n.setAuthState({
                                isAuthenticated: !1
                            });
                        } catch (t) {
                            d({
                                loading: !1,
                                error: Un(t)
                            });
                        }
                    },
                    refreshTokenForSocialLogins: async ()=>{
                        t.auth.hostedLoginBox ? await (async ()=>{
                            const { user: a } = t.auth;
                            if (null == a || !a.refreshToken) return s.setAccessToken(null), s.setUser(null), void n.setAuthState({
                                user: null,
                                isAuthenticated: !1
                            });
                            try {
                                const t = {
                                    grant_type: "refresh_token",
                                    refresh_token: null == a ? void 0 : a.refreshToken
                                }, s = await e.auth.exchangeOAuthTokensV2(t), i = await r(s.user);
                                n.afterAuthenticationStateUpdate(v({}, s, {
                                    user: i
                                }), {
                                    isAuthenticated: !0
                                });
                            } catch (t) {
                                s.setAccessToken(null), s.setUser(null), n.setAuthState({
                                    user: null,
                                    isAuthenticated: !1
                                });
                            }
                        })() : await (async ()=>{
                            try {
                                const { routes: s, loginState: o, onRedirectTo: c } = t.auth, { user: u, tenants: d = [], activeTenant: g } = await e.auth.refreshTokenV3();
                                if (hs(u, t.root.appName)) {
                                    const t = await n.getMfaRequiredState(u);
                                    n.setAuthState(t), c(s.loginUrl, {
                                        preserveQueryParams: !0
                                    });
                                } else {
                                    const t = await r(u);
                                    if (await n.__shouldShowPromptPasskeys()) n.setLoginState({
                                        step: pn.promptPasskeys,
                                        loading: !1
                                    }), n.afterAuthenticationStateUpdate({
                                        user: t,
                                        tenants: d,
                                        activeTenant: g
                                    }, {
                                        isLoading: !1
                                    }), c(s.loginUrl, {
                                        preserveQueryParams: !0
                                    });
                                    else {
                                        var a;
                                        u.id && localStorage.setItem("userId", u.id);
                                        const e = null != (a = localStorage.getItem("register-quick-login")) ? a : o.quickLoginToRegister, s = i(u);
                                        n.afterAuthenticationStateUpdate({
                                            user: t,
                                            tenants: d,
                                            activeTenant: g
                                        }, {
                                            loginState: v({}, o, {
                                                quickLoginToRegister: e,
                                                flow: s ? hn.RegisterQuickLogin : hn.Login
                                            }),
                                            isAuthenticated: !0
                                        }), await l(s);
                                    }
                                }
                            } catch (t) {
                                s.setAccessToken(null), s.setUser(null), n.setAuthState({
                                    user: void 0,
                                    isAuthenticated: !1
                                });
                            }
                        })();
                    },
                    __refreshToken: o
                }, ((t, e, a)=>{
                    const n = a, s = async ()=>{
                        const t = await e.auth.silentOAuthRefreshTokenV2();
                        if (null == t || !t.user) throw new Error("couldn't refresh user token with oauth service");
                        await n.afterAuthenticationStateUpdate(t, {
                            isAuthenticated: !0,
                            isLoading: !1
                        });
                    }, i = async (a)=>{
                        var s;
                        const { routes: i, onRedirectTo: o } = t.auth, { context: r, urlStrategy: l } = t.root;
                        if (vs(l) === i.hostedLoginRedirectUrl) return void console.debug("Calling loginWithRedirect while in hostedLoginCallback route");
                        n.setAuthState({
                            isLoading: !0
                        });
                        const c = Ki(), u = Ki(), d = await zi(u);
                        localStorage.setItem(bn, u);
                        const g = rs(t);
                        let p = `${window.location.origin}${"path" === l ? "" : "#"}${null != g ? g : ""}${i.hostedLoginRedirectUrl}`;
                        await n.loadCustomLoginRoutes();
                        const h = null == (s = t.auth.customLoginState) ? void 0 : s.customLoginSearchParams;
                        h && (p.endsWith("/") && (p = p.slice(0, -1)), p += h);
                        const y = `${e.fetch.getBaseUrl(r, "/oauth/authorize")}/oauth/authorize`, S = v({
                            response_type: "code",
                            client_id: r.appId || r.clientId || "INVALID-CLIENT-ID",
                            scope: "openid email profile",
                            redirect_uri: p,
                            code_challenge: d,
                            code_challenge_method: "S256",
                            nonce: c
                        }, a);
                        if (r.tenantResolver) {
                            var f;
                            const t = await (null == (f = r.tenantResolver) ? void 0 : f.call(r));
                            null != t && t.tenant && (S.organization = t.tenant);
                        }
                        const m = ts(es);
                        m && (S.tenantId = m), o(`${y}?${new URLSearchParams(S).toString()}`, {
                            refresh: !0
                        });
                    };
                    return {
                        requestHostedLoginAuthorize: async (e)=>{
                            var a;
                            null == (a = localStorage) || a.removeItem(dn);
                            const n = t.auth.disableSilentRefresh;
                            if ("login" === (null == e ? void 0 : e.prompt)) return await i(e);
                            try {
                                if (n) throw new Error("silent refresh is disabled");
                                return await s();
                            } catch (t) {
                                return await i(e);
                            }
                        },
                        requestHostedLoginAuthorizeV2: async (e)=>{
                            var a, o;
                            const { shouldRedirectToLogin: r, firstTime: l, loginDirectAction: c } = null != e ? e : {};
                            let { additionalParams: u } = null != e ? e : {};
                            if (null == (a = localStorage) || a.removeItem(dn), l) {
                                const e = t.root.urlStrategy, a = vs(e);
                                if (n.setAuthState({
                                    isLoading: !0
                                }), is(a)) return;
                            }
                            const d = t.auth.disableSilentRefresh;
                            if (c && (u = u || {}, u.login_direct_action = btoa(JSON.stringify(c))), "login" === (null == (o = u) ? void 0 : o.prompt)) return await i(u);
                            try {
                                if (d) throw new Error("silent refresh is disabled");
                                return await s();
                            } catch (t) {
                                return r ? await i(u) : void n.setAuthState({
                                    isLoading: !1
                                });
                            }
                        },
                        __requestHostedLoginAuthorize: i,
                        __requestHostedLoginSilentAuthorize: s,
                        handleHostedLoginCallback: async (a)=>{
                            var s;
                            const i = localStorage.getItem(bn) || "INVALID-CODE-VERIFIER", o = t.auth.routes, r = t.root.urlStrategy, l = rs(t);
                            let c = `${window.location.origin}${"path" === r ? "" : "#"}${null != l ? l : ""}${o.hostedLoginRedirectUrl}`;
                            await n.loadCustomLoginRoutes();
                            const u = null == (s = t.auth.customLoginState) ? void 0 : s.customLoginSearchParams;
                            u && (c.endsWith("/") && (c = c.slice(0, -1)), c += u);
                            const d = {
                                code: a.code,
                                redirect_uri: c,
                                code_verifier: i,
                                grant_type: "authorization_code"
                            };
                            try {
                                const t = await e.auth.exchangeOAuthTokensV2(d);
                                n.afterAuthenticationStateUpdate(t, {
                                    isAuthenticated: !0,
                                    isLoading: !1
                                });
                            } catch (t) {
                                n.setAuthState({
                                    isLoading: !1
                                }), console.error("Failed to exchangeOAuthTokens", t);
                            } finally{
                                const e = t.auth.user, a = window.localStorage.getItem(dn);
                                window.localStorage.removeItem(dn), a && cs(e) ? await n.afterStepUpAuthNavigation() : await n.afterAuthNavigation();
                            }
                        }
                    };
                })(t, e, a), yi(t, 0, a), function(t, e, a) {
                    const n = a, s = async ()=>await n.afterStepUpAuthNavigation(), i = async (e, a)=>{
                        const s = t.auth.loginState, i = t.auth.mfaState.step, [o, r] = await n.getFeatureFlags([
                            "security-center-show-login-flows",
                            "password-rotation"
                        ]);
                        if (s.flow === hn.Login) {
                            if (o && s.isBreachedPassword && !e) return void n.setLoginState({
                                step: pn.breachedPassword,
                                loading: !1
                            });
                            if (r && ys(a, t.root.appName)) return void n.setLoginState({
                                step: pn.passwordRotationExpired,
                                loading: !1,
                                resetPasswordToken: a.resetPasswordToken,
                                userId: a.userId
                            });
                            if (r && ls(a)) return void n.setLoginState({
                                step: pn.passwordRotationNotification,
                                loading: !1
                            });
                            const l = await n.__shouldShowPromptPasskeys();
                            i === qn.smsVerifyCode && l ? n.setLoginState({
                                step: pn.promptPasskeys,
                                loading: !1
                            }) : await n.afterAuthNavigation();
                        }
                    };
                    return {
                        postHandleVerifyMFAResponseForStepUp: s,
                        postHandleVerifyMFAResponseForLogin: i,
                        handleVerifyMFAResponse: async (t, e = !1)=>{
                            const { user: a, tenants: o, activeTenant: r } = t;
                            n.setUser(a), n.setTenantsState({
                                tenants: o,
                                activeTenant: r,
                                loading: !1
                            }), a.id && localStorage.setItem("userId", a.id);
                            const l = !!a.accessToken;
                            return n.setAuthState({
                                isAuthenticated: l
                            }), e ? await s() : await i(l, a);
                        },
                        getFeatureFlags: async (e)=>{
                            const a = t.root.appName;
                            return Xt.getFeatureFlags(e, a);
                        }
                    };
                }(t, 0, a), ((t, e)=>({
                        getMfaRequiredState: async (a, n, s = !1, i)=>{
                            var o, r, l;
                            let c = pn.loginWithTwoFactor;
                            const u = {
                                step: qn.verify,
                                loading: !1,
                                saving: !1
                            }, d = t.auth.loginState;
                            let g, p;
                            try {
                                const t = await En(()=>e.auth.checkIfAllowToRememberMfaDevice(a.mfaToken), n);
                                g = t.isAllowedToRemember, p = t.mfaDeviceExpiration;
                            } catch (t) {
                                if (!s) throw t;
                            }
                            !("mfaEnrolled" in a) || a.mfaEnrolled || (null == (o = a.mfaDevices) || null == (r = o.emails) ? void 0 : r.length) ? Object.assign(u, {
                                mfaDevices: a.mfaDevices,
                                mfaToken: a.mfaToken,
                                step: ns(a.mfaDevices)
                            }) : (Object.assign(u, {
                                step: ss(a.mfaStrategies),
                                qrCode: a.qrCode,
                                recoveryCode: a.recoveryCode,
                                loading: !1,
                                mfaToken: a.mfaToken,
                                mfaStrategies: a.mfaStrategies
                            }), c = pn.forceTwoFactor);
                            let h = {};
                            const y = localStorage.getItem("register-quick-login");
                            return y && (h = {
                                quickLoginToRegister: y,
                                flow: hn.RegisterQuickLogin
                            }), {
                                user: void 0,
                                isAuthenticated: !1,
                                mfaState: u,
                                loginState: v({}, d, h, {
                                    mfaToken: a.mfaToken,
                                    mfaRequired: a.mfaRequired,
                                    loading: !1,
                                    error: void 0,
                                    step: c,
                                    tenantsLoading: !0,
                                    email: null != (l = a.userEmail) ? l : i,
                                    tenants: [],
                                    allowRememberMfaDevice: g,
                                    mfaDeviceExpiration: p,
                                    isBreachedPassword: a.isBreachedPassword
                                })
                            };
                        }
                    }))(t, e), ((t, e, a)=>{
                    const n = a, s = async (a, s, i)=>{
                        let { callback: o } = a, r = f(a, Si);
                        s({
                            loading: !0,
                            error: void 0
                        });
                        try {
                            const { user: a, tenants: l = [], activeTenant: c } = await e.auth.loginWithMfaV2(r), u = !!a.accessToken, d = await async function(e, a, n) {
                                const s = t.auth.loginState;
                                let i = {};
                                if (!n) {
                                    const t = s.flow === hn.Login ? pn.success : s.step;
                                    i = {
                                        loginState: {
                                            flow: s.flow,
                                            quickLoginToRegister: s.quickLoginToRegister,
                                            loading: !1,
                                            step: t,
                                            error: void 0,
                                            tenants: e
                                        }
                                    };
                                }
                                return v({}, i, {
                                    isAuthenticated: a
                                });
                            }(l, u, i);
                            return await n.afterAuthenticationStateUpdate({
                                user: a,
                                tenants: l,
                                activeTenant: c
                            }, d), a.id && localStorage.setItem("userId", a.id), s({
                                loading: !1,
                                error: void 0
                            }), i ? await async function(t) {
                                await n.afterStepUpAuthNavigation(), null == t || t(!0);
                            }(o) : await async function(e, a, s) {
                                const i = t.auth.loginState;
                                if (i.flow !== hn.Login) return;
                                const [o, r] = await n.getFeatureFlags([
                                    "security-center-show-login-flows",
                                    "password-rotation"
                                ]);
                                if (o && i.isBreachedPassword && !e) return n.setLoginState({
                                    step: pn.breachedPassword,
                                    loading: !1
                                }), void (null == s || s(!0));
                                if (r && ys(a, t.root.appName)) return n.setLoginState({
                                    step: pn.passwordRotationExpired,
                                    loading: !1,
                                    resetPasswordToken: a.resetPasswordToken,
                                    userId: a.userId
                                }), void (null == s || s(!0));
                                const l = ls(a);
                                if (r && l) return n.setLoginState({
                                    step: pn.passwordRotationNotification,
                                    loading: !1
                                }), void (null == s || s(!0));
                                await n.__shouldShowPromptPasskeys() ? n.setLoginState({
                                    step: pn.promptPasskeys,
                                    loading: !1
                                }) : await n.afterAuthNavigation(), null == s || s(!0);
                            }(u, a, o);
                        } catch (t) {
                            s({
                                loading: !1,
                                error: Un(t)
                            }), null == o || o(!1, t);
                        }
                    };
                    return {
                        mfaWithAuthenticator: s,
                        loginWithMfa: async (t)=>await s(t, n.setLoginState, !1)
                    };
                })(t, e, a), ((t, e, a)=>{
                    const n = a, s = async (t, a)=>{
                        var s;
                        let { callback: i } = t, o = f(t, vi);
                        (a = null != (s = a) ? s : n.setLoginState)({
                            loading: !0,
                            error: void 0
                        });
                        try {
                            const t = await e.auth.preVerifyMFAEmailCode(o);
                            n.setMfaState({
                                otcToken: t.otcToken,
                                step: qn.emailVerifyCode
                            }), a({
                                loading: !1,
                                error: void 0
                            }), null == i || i(!0);
                        } catch (t) {
                            a({
                                error: Un(t)
                            }), null == i || i(null);
                        }
                    }, i = async (t, a)=>{
                        var s;
                        let { callback: i } = t, o = f(t, fi);
                        (a = null != (s = a) ? s : n.setLoginState)({
                            loading: !0
                        });
                        try {
                            const t = await e.auth.verifyMFAEmailCodeV2(o);
                            await n.handleVerifyMFAResponse(t), a({
                                loading: !1,
                                error: void 0
                            }), null == i || i(!0);
                        } catch (t) {
                            a({
                                loading: !1,
                                error: Un(t)
                            }), null == i || i(null);
                        }
                    };
                    return {
                        preVerifyMFAEmailCode: s,
                        verifyMFAEmailCode: i,
                        preVerifyMFAEmailCodeForLogin: async (t)=>await s(t, n.setLoginState),
                        verifyMFAEmailCodeForLogin: async (t)=>await i(t, n.setLoginState)
                    };
                })(0, e, a), ((t, e, a)=>{
                    const n = a, s = async (t, a)=>{
                        let { callback: s, deviceId: i } = t, o = f(t, mi);
                        a({
                            loading: !1,
                            error: void 0
                        });
                        try {
                            const t = await e.auth.preVerifyMFASMSForLogin(i, o);
                            n.setMfaState({
                                otcToken: t.otcToken,
                                step: qn.smsVerifyCode,
                                phoneNumber: t.phoneNumber
                            }), a({
                                loading: !1,
                                error: void 0
                            }), null == s || s(!0);
                        } catch (t) {
                            a({
                                loading: !1,
                                error: Un(t)
                            }), null == s || s(null);
                        }
                    }, i = async (t, a, s = !1)=>{
                        let { callback: i, deviceId: o } = t, r = f(t, bi);
                        a({
                            loading: !0
                        });
                        try {
                            const t = await e.auth.verifyMFASMSForLoginV2(o, r);
                            await n.handleVerifyMFAResponse(t, s), a({
                                loading: !1,
                                error: void 0
                            }), null == i || i(!0);
                        } catch (t) {
                            a({
                                loading: !1,
                                error: Un(t)
                            }), null == i || i(null);
                        }
                    };
                    return {
                        preVerifyMFASMS: s,
                        verifyMFASMS: i,
                        preVerifyMFASMSForLogin: async (t)=>await s(t, n.setLoginState),
                        verifyMFASMSForLogin: async (t)=>await i(t, n.setLoginState, !1)
                    };
                })(0, e, a), ((t, e, a)=>{
                    const n = a, s = async (t, a)=>{
                        let { callback: n, deviceId: s } = t, i = f(t, ki);
                        a({
                            loading: !0
                        });
                        try {
                            var o;
                            const t = await e.auth.preVerifyMFAWebAuthnForLogin(s, i), r = v({}, t.options, {
                                challenge: Ei(t.options.challenge),
                                allowCredentials: null == (o = t.options.allowCredentials) ? void 0 : o.map((t)=>v({}, t, {
                                        id: Ei(t.id)
                                    }))
                            });
                            a({
                                loading: !1,
                                error: void 0
                            }), null == n || n({
                                options: r,
                                webauthnToken: t.webauthnToken
                            });
                        } catch (t) {
                            a({
                                loading: !1,
                                error: Un(t)
                            }), null == n || n(null);
                        }
                    }, i = async (t, a, s)=>{
                        let { callback: i, deviceId: o } = t, r = f(t, _i);
                        a({
                            loading: !0
                        });
                        try {
                            const t = Oi(r.publicKey), l = await e.auth.verifyMFAWebAuthnForLoginV2(o, v({}, r, {
                                options: t
                            }));
                            await n.handleVerifyMFAResponse(l, s), a({
                                loading: !1,
                                error: void 0
                            }), null == i || i(!0);
                        } catch (t) {
                            a({
                                loading: !1,
                                error: Un(t)
                            }), null == i || i(null);
                        }
                    };
                    return {
                        preVerifyMFAWebAuthn: s,
                        verifyMFAWebAuthn: i,
                        preVerifyMFAWebAuthnForLogin: async (t)=>await s(t, n.setLoginState),
                        verifyMFAWebAuthnForLogin: async (t)=>await i(t, n.setLoginState, !1)
                    };
                })(0, e, a));
            }, Ao = {
                step: qn.verify,
                loading: !1,
                saving: !1
            }, wo = (t)=>Za(Ao, t), To = [
                "callback"
            ], Eo = [
                "callback"
            ], Io = [
                "user"
            ], Oo = [
                "deviceId"
            ], Po = [
                "deviceId"
            ], ko = [
                "callback"
            ], _o = [
                "callback"
            ], Ro = [
                "deviceId",
                "callback"
            ], Co = (t, e, a)=>{
                const n = a;
                async function s(e) {
                    const a = t.auth.mfaState.step;
                    return {
                        step: e.recoveryCode ? qn.recoveryCode : a,
                        loading: !1,
                        saving: !1,
                        error: void 0,
                        recoveryCode: null == e ? void 0 : e.recoveryCode
                    };
                }
                const i = (e)=>{
                    Object.assign(t.auth.mfaState, e);
                };
                return {
                    setMfaState: i,
                    resetMfaState: ()=>{
                        Rn(t, [
                            "auth",
                            "mfaState"
                        ], Ao);
                    },
                    getMFADevices: async ()=>{
                        i({
                            loading: !0
                        });
                        try {
                            const t = await e.auth.getMFADevices();
                            i({
                                loading: !1,
                                error: void 0,
                                mfaDevices: t
                            });
                        } catch (t) {
                            i({
                                loading: !1,
                                error: Un(t)
                            });
                        }
                    },
                    getMFAStrategies: async (t)=>{
                        i({
                            loading: !0
                        });
                        try {
                            const a = (await En(()=>e.auth.getMFAStrategiesConfig(), null == t ? void 0 : t.retryConfig)).strategies.filter(({ isActive: t })=>t).map(({ strategy: t })=>t);
                            i({
                                loading: !1,
                                error: void 0,
                                mfaStrategies: a
                            });
                        } catch (t) {
                            i({
                                loading: !1,
                                error: Un(t)
                            });
                        }
                    },
                    enrollMfa: async ()=>{
                        i({
                            saving: !0
                        });
                        try {
                            const { qrCode: t } = await e.auth.enrollMfa();
                            i({
                                saving: !1,
                                error: void 0,
                                qrCode: t
                            });
                        } catch (t) {
                            i({
                                saving: !1,
                                error: Un(t)
                            });
                        }
                    },
                    verifyMfa: async (a)=>{
                        const { callback: o } = a, r = f(a, To);
                        i({
                            saving: !0
                        });
                        try {
                            const a = t.auth.user, l = await e.auth.verifyMfa(r), c = await e.auth.getMFADevices(), u = await s(l);
                            i(v({}, u, {
                                mfaDevices: c
                            })), n.setUser(v({}, a, {
                                mfaEnrolled: !0
                            })), null == o || o(u.recoveryCode);
                        } catch (t) {
                            i({
                                saving: !1,
                                error: Un(t)
                            }), null == o || o(null, t);
                        }
                    },
                    verifyMfaAfterForce: async (t)=>{
                        const { callback: a } = t, s = f(t, Eo);
                        i({
                            loading: !0
                        });
                        try {
                            const t = await e.auth.loginWithMfaV2(s), { user: o } = t, r = f(t, Io), l = {
                                step: qn.recoveryCode,
                                loading: !1,
                                saving: !1,
                                error: void 0
                            };
                            null != o && o.recoveryCode && (l.recoveryCode = o.recoveryCode), i(l), await n.afterAuthenticationStateUpdate(v({
                                user: o
                            }, r)), null == a || a(l.recoveryCode);
                        } catch (t) {
                            i({
                                loading: !1,
                                error: Un(t)
                            }), null == a || a(null, t);
                        }
                    },
                    disableMfa: async (t)=>{
                        i({
                            saving: !0
                        });
                        try {
                            var a;
                            await e.auth.disableMfa(t);
                            const n = await e.auth.getMFADevices();
                            i({
                                saving: !1,
                                error: void 0,
                                mfaDevices: n
                            }), null == (a = t.callback) || a.call(t, !0);
                        } catch (e) {
                            var n;
                            i({
                                saving: !1,
                                error: Un(e)
                            }), null == (n = t.callback) || n.call(t, !1, e);
                        }
                    },
                    preDisableMfaSms: async (t)=>{
                        const { deviceId: a } = t, n = f(t, Oo);
                        i({
                            saving: !0
                        });
                        try {
                            var s;
                            const t = await e.auth.preDisableMFASMS(a);
                            i({
                                saving: !1,
                                error: void 0,
                                otcToken: t.otcToken,
                                phoneNumber: t.phoneNumber
                            }), null == (s = n.callback) || s.call(n, !0);
                        } catch (t) {
                            var o;
                            i({
                                saving: !1,
                                error: Un(t)
                            }), null == (o = n.callback) || o.call(n, !1, t);
                        }
                    },
                    disableMfaSms: async (t)=>{
                        const { deviceId: a } = t, n = f(t, Po);
                        i({
                            saving: !0
                        });
                        try {
                            var s;
                            await e.auth.disableMFASMS(a, n);
                            const t = await e.auth.getMFADevices();
                            i({
                                saving: !1,
                                error: void 0,
                                mfaDevices: t
                            }), null == (s = n.callback) || s.call(n, !0);
                        } catch (t) {
                            var o;
                            i({
                                saving: !1,
                                error: Un(t)
                            }), null == (o = n.callback) || o.call(n, !1, t);
                        }
                    },
                    preEnrollMfaSms: async (t)=>{
                        i({
                            saving: !0
                        });
                        try {
                            var a;
                            const n = await e.auth.preEnrollMFASMS(t);
                            i({
                                saving: !1,
                                error: void 0,
                                otcToken: n.otcToken,
                                phoneNumber: n.phoneNumber
                            }), null == (a = t.callback) || a.call(t, !0);
                        } catch (e) {
                            var n;
                            i({
                                saving: !1,
                                error: Un(e)
                            }), null == (n = t.callback) || n.call(t, !1, e);
                        }
                    },
                    enrollMfaSms: async (t)=>{
                        const { callback: a } = t, n = f(t, ko);
                        i({
                            saving: !0
                        });
                        try {
                            const t = await e.auth.enrollMFASMS(n), o = await e.auth.getMFADevices(), r = await s(t);
                            i(v({}, r, {
                                mfaDevices: o
                            })), null == a || a(r.recoveryCode);
                        } catch (t) {
                            i({
                                saving: !1,
                                error: Un(t)
                            }), null == a || a(null, t);
                        }
                    },
                    preEnrollMfaWebAuthn: async (t)=>{
                        i({
                            saving: !0
                        });
                        try {
                            var a, n;
                            const s = await e.auth.preEnrollMFAWebAuthn(), o = v({}, s.options, {
                                challenge: Ei(s.options.challenge),
                                user: v({}, s.options.user, {
                                    id: Ei(s.options.user.id)
                                }),
                                excludeCredentials: null == (a = s.options.excludeCredentials) ? void 0 : a.map((t)=>v({}, t, {
                                        id: Ei(t.id)
                                    }))
                            });
                            i({
                                saving: !1
                            }), null == (n = t.callback) || n.call(t, {
                                options: o,
                                webauthnToken: s.webauthnToken
                            });
                        } catch (e) {
                            var s;
                            i({
                                saving: !1,
                                error: Un(e)
                            }), null == (s = t.callback) || s.call(t, null, e);
                        }
                    },
                    enrollMfaWebAuthn: async (t)=>{
                        const { callback: a } = t, n = f(t, _o);
                        i({
                            saving: !0
                        });
                        try {
                            const t = Oi(n.publicKey), o = await e.auth.enrollMFAWebAuthn(v({}, n, {
                                options: t
                            })), r = await e.auth.getMFADevices(), l = await s(o);
                            i(v({}, l, {
                                mfaDevices: r
                            })), null == a || a(l.recoveryCode);
                        } catch (t) {
                            i({
                                saving: !1,
                                error: Un(t)
                            }), null == a || a(null, t);
                        }
                    },
                    preDisableMfaWebAuthn: async (t)=>{
                        const { deviceId: a, callback: n } = t;
                        i({
                            saving: !0
                        });
                        try {
                            var s;
                            const t = await e.auth.preDisableMFAWebAuthn(a), o = v({}, t.options, {
                                challenge: Ei(t.options.challenge),
                                allowCredentials: null == (s = t.options.allowCredentials) ? void 0 : s.map((t)=>v({}, t, {
                                        id: Ei(t.id)
                                    }))
                            });
                            i({
                                saving: !1
                            }), null == n || n({
                                options: o,
                                webauthnToken: t.webauthnToken
                            });
                        } catch (t) {
                            i({
                                saving: !1,
                                error: Un(t)
                            }), null == n || n(null, t);
                        }
                    },
                    disableMfaWebAuthn: async (t)=>{
                        const { deviceId: a, callback: n } = t, s = f(t, Ro);
                        i({
                            saving: !0
                        });
                        try {
                            const t = Oi(s.publicKey);
                            await e.auth.disableMFAWebAuthn(a, v({}, s, {
                                options: t
                            }));
                            const o = await e.auth.getMFADevices();
                            i({
                                saving: !1,
                                error: void 0,
                                mfaDevices: o
                            }), null == n || n(!0);
                        } catch (t) {
                            i({
                                saving: !1,
                                error: Un(t)
                            }), null == n || n(!1, t);
                        }
                    },
                    __getMfaStateAfterEnroll: s
                };
            }, Lo = {
                loaders: {},
                errors: {},
                accounts: {
                    tenantId: "",
                    children: []
                },
                accountsQueryParams: {
                    _limit: 50,
                    _offset: 0,
                    _filter: "",
                    _subTenantId: ""
                },
                searchAccountsData: [],
                rootAccount: {
                    tenantId: ""
                },
                selectedAccount: {
                    tenantId: "",
                    userJwt: {
                        accessToken: "",
                        expiresIn: 0,
                        expires: ""
                    },
                    users: [],
                    usersQueryParams: {
                        _offset: 0,
                        _limit: 10,
                        _order: Ft.DESC,
                        _sortBy: xa.name
                    },
                    usersPageOffset: 0,
                    accountSettings: {}
                }
            }, Uo = (t)=>Za(Lo, t), Do = {
                createSubAccountDialog: {
                    loading: !1,
                    open: !1,
                    error: !1,
                    jwt: "",
                    canSelectParentAccount: !1
                },
                updateSubAccountDialog: {
                    accountId: "",
                    accountName: "",
                    loading: !1,
                    open: !1,
                    error: !1,
                    jwt: ""
                },
                disableSubAccountManagementDialog: {
                    accountId: "",
                    accountName: "",
                    loading: !1,
                    open: !1,
                    error: !1
                },
                enableSubAccountManagementDialog: {
                    accountId: "",
                    accountName: "",
                    loading: !1,
                    open: !1,
                    error: !1
                },
                updateSubAccountHierarchySettingsDialog: {
                    accountId: "",
                    accountName: "",
                    subAccountAccessType: Pa.DEFAULT_OFF,
                    loading: !1,
                    open: !1,
                    error: !1
                },
                deleteSubAccountDialog: {
                    accountId: "",
                    accountName: "",
                    isParentAccount: !1,
                    loading: !1,
                    open: !1,
                    error: !1,
                    jwt: ""
                },
                addUsersToAccountDialog: {
                    loading: !1,
                    open: !1,
                    accountName: "",
                    accountId: "",
                    permissionToGiveAccessToSubAccounts: !1,
                    jwt: ""
                },
                deleteUserFromAccountDialog: {
                    userId: "",
                    userName: "",
                    accountId: "",
                    loading: !1,
                    open: !1,
                    jwt: ""
                },
                editUserRolesDialog: {
                    loading: !1,
                    open: !1,
                    jwt: "",
                    accountId: "",
                    userId: "",
                    userName: "",
                    userRoles: []
                }
            }, No = (t)=>Za(Do, t);
            let Mo;
            !function(t) {
                t.GET_ACCOUNTS = "GET_ACCOUNTS", t.SEARCH_ACCOUNTS = "SEARCH_ACCOUNTS", t.SET_ROOT_ACCOUNT_DATA = "SET_ROOT_ACCOUNT_DATA", t.SET_SELECTED_SUB_ACCOUNT_DATA = "SET_SELECTED_SUB_ACCOUNT_DATA", t.LOAD_NUMBER_OF_USERS_FOR_ACCOUNT = "LOAD_NUMBER_OF_USERS_FOR_ACCOUNT", t.UPDATE_SUB_ACCOUNT_ACCESS_FOR_USER = "UPDATE_SUB_ACCOUNT_ACCESS_FOR_USER", t.CREATE_SUB_ACCOUNT = "CREATE_SUB_ACCOUNT", t.UPDATE_SUB_ACCOUNT = "UPDATE_SUB_ACCOUNT", t.DELETE_SUB_ACCOUNT = "DELETE_SUB_ACCOUNT", t.GET_ACCOUNT_USERS = "GET_ACCOUNT_USERS", t.ADD_USERS_TO_ACCOUNT = "ADD_USERS_TO_ACCOUNT", t.DELETE_USERS_FROM_ACCOUNT = "DELETE_USERS_FROM_ACCOUNT", t.SET_USER_ROLES_FOR_SUB_ACCOUNT = "SET_USER_ROLES_FOR_SUB_ACCOUNT", t.UPDATE_SUB_ACCOUNT_SETTINGS = "UPDATE_SUB_ACCOUNT_SETTINGS", t.UPDATE_SUB_ACCOUNT_MANAGEMENT = "UPDATE_SUB_ACCOUNT_MANAGEMENT", t.UPDATE_SUB_ACCOUNT_HIERARCHY_SETTINGS = "UPDATE_SUB_ACCOUNT_HIERARCHY_SETTINGS", t.GET_USER_JWT = "GET_USER_JWT", t.GET_TEAM_USERS = "GET_TEAM_USERS";
            }(Mo || (Mo = {}));
            const Fo = ({ items: t }, e)=>t.map((t)=>{
                    var a, n;
                    return {
                        name: t.name,
                        tenantId: t.tenantId,
                        numberOfUsers: null != (a = null == (n = e.find((e)=>e.tenantId === t.tenantId)) ? void 0 : n.totalUsers) ? a : 0,
                        createdAt: t.createdAt,
                        metadata: t.metadata,
                        isReseller: t.isReseller,
                        subAccountAccessType: t.subAccountAccessType
                    };
                });
            function xo(t, e, a) {
                var n, s, i;
                return t.tenantId === e ? v({}, t, {
                    children: [
                        ...null != (i = null == t ? void 0 : t.children) ? i : [],
                        ...a
                    ].filter((t, e, a)=>e === a.findIndex((e)=>e.tenantId === t.tenantId))
                }) : v({}, t, {
                    children: null != (n = null == t || null == (s = t.children) ? void 0 : s.map((t)=>xo(t, e, a))) ? n : []
                });
            }
            function Go(t, e) {
                var a;
                return v({}, t, {
                    children: null != (a = t.children) && a.length ? t.children.filter((t)=>t.tenantId !== e).map((t)=>Go(t, e)) : []
                });
            }
            const $o = (t, e, a)=>{
                var n, s;
                return t.tenantId === e ? v({}, t, {
                    subAccountAccessType: a
                }) : v({}, t, {
                    children: null != (n = null == t || null == (s = t.children) ? void 0 : s.map((t)=>$o(t, e, a))) ? n : []
                });
            }, jo = (t, e, a)=>{
                var n, s;
                return t.tenantId === e ? v({}, t, {
                    name: a
                }) : v({}, t, {
                    children: null != (n = null == t || null == (s = t.children) ? void 0 : s.map((t)=>jo(t, e, a))) ? n : []
                });
            }, Bo = (t, e, a)=>{
                var n, s;
                return t ? t.tenantId === e ? v({}, t, {
                    isReseller: a
                }) : v({}, t, {
                    children: null != (n = null == t || null == (s = t.children) ? void 0 : s.map((t)=>Bo(t, e, a))) ? n : []
                }) : {};
            }, Vo = (t, e, a)=>{
                const n = (e)=>{
                    Object.assign(t.auth.allAccountsState, {
                        loaders: v({}, t.auth.allAccountsState.loaders, {
                            [e.key]: e.value
                        })
                    });
                }, s = (e)=>{
                    Object.assign(t.auth.allAccountsState, {
                        errors: v({}, t.auth.allAccountsState.errors, {
                            [e.key]: e.value
                        }),
                        loaders: v({}, t.auth.allAccountsState.loaders, {
                            [e.key]: !1
                        })
                    });
                }, i = (e)=>{
                    Object.assign(t.auth.allAccountsState, e);
                }, o = (e)=>{
                    Object.assign(t.auth.allAccountsState.selectedAccount, e);
                }, r = ()=>t.auth.allAccountsState, l = async (t)=>{
                    var a, i, l, c, u, d, g, p;
                    const { jwt: h, _tenantId: y, _email: S } = t, f = Mo.GET_ACCOUNT_USERS;
                    n({
                        key: f,
                        value: !0
                    });
                    const m = r(), b = null != (a = null != (i = null == t ? void 0 : t._offset) ? i : null == m || null == (l = m.selectedAccount) || null == (c = l.usersQueryParams) ? void 0 : c._offset) ? a : 0, A = null != (u = null != (d = null == t ? void 0 : t._limit) ? d : null == m || null == (g = m.selectedAccount) || null == (p = g.usersQueryParams) ? void 0 : p._limit) ? u : 10, w = v({
                        _offset: b,
                        _limit: A,
                        _tenantId: y,
                        _includeSubTenants: !1
                    }, !!S && {
                        _email: S
                    });
                    try {
                        const { items: t, _metadata: { totalItems: a, totalPages: n } } = await e.users.getUsersV3(w, {
                            jwt: h
                        }), s = {
                            totalUsersItems: a,
                            totalUsersPages: n,
                            usersQueryParams: v({
                                _offset: null != b ? b : 0,
                                _limit: null != A ? A : 10
                            }, !!S && {
                                _email: S
                            })
                        };
                        if (t.length) {
                            const a = t.map((t)=>t.id), n = await e.roles.getRoles(), i = await e.users.getUsersRoles({
                                ids: a
                            }, {
                                jwt: h
                            }), r = t.map((t)=>{
                                var e, a;
                                const s = null == i || null == (e = i.find((e)=>e.userId === t.id)) ? void 0 : e.roleIds;
                                return v({}, t, {
                                    roles: null != (a = null == s ? void 0 : s.map((t)=>{
                                        var e;
                                        return null != (e = null == n ? void 0 : n.find((e)=>e.id === t)) ? e : [];
                                    })) ? a : []
                                });
                            });
                            o(v({
                                users: r
                            }, s));
                        } else o(v({
                            users: []
                        }, s));
                    } catch (t) {
                        s({
                            key: f,
                            value: Un(t)
                        });
                    } finally{
                        n({
                            key: f,
                            value: !1
                        });
                    }
                };
                return {
                    setAllAccountsLoader: n,
                    setAllAccountsError: s,
                    setAllAccountsState: i,
                    setSelectedAccountState: o,
                    resetAllAccountsState: ()=>{
                        Rn(t, [
                            "auth",
                            "allAccountsState"
                        ], Lo);
                    },
                    clearSelectedAccount: ()=>{
                        Rn(t, [
                            "auth",
                            "allAccountsState",
                            "selectedAccount"
                        ], Lo.selectedAccount);
                    },
                    loadAccounts: async (t)=>{
                        const a = Mo.GET_ACCOUNTS;
                        n({
                            key: a,
                            value: !0
                        });
                        const { accountsQueryParams: l } = r(), { jwt: c, _limit: u, _offset: d } = t, g = {
                            _offset: null != d ? d : l._offset,
                            _limit: null != u ? u : l._limit,
                            _subTenantId: null == t ? void 0 : t._subTenantId
                        };
                        try {
                            if (c) {
                                var p;
                                const { selectedAccount: a } = r(), { items: n, _links: s } = await e.tenants.searchSubTenants(g, {
                                    jwt: c
                                }), i = await e.tenants.getTenantsUsersCount({
                                    tenantIds: n.map((t)=>t.tenantId)
                                }, {
                                    jwt: c
                                }), l = Fo({
                                    items: n
                                }, i), u = xo(a.accounts ? a.accounts : a, null != (p = null == t ? void 0 : t._subTenantId) ? p : "", l.map((t)=>({
                                        name: t.name,
                                        tenantId: t.tenantId,
                                        numberOfUsers: t.numberOfUsers,
                                        createdAt: t.createdAt,
                                        metadata: t.metadata,
                                        children: [],
                                        loadMoreLink: null == s ? void 0 : s.next,
                                        isReseller: t.isReseller
                                    })));
                                o({
                                    accounts: u
                                });
                            } else {
                                var h;
                                const { accounts: a } = r(), { items: n, _links: s } = await e.tenants.searchSubTenants(g), o = await e.tenants.getTenantsUsersCount({
                                    tenantIds: n.map((t)=>t.tenantId)
                                }), l = Fo({
                                    items: n
                                }, o), c = xo(a, null != (h = null == t ? void 0 : t._subTenantId) ? h : "", l.map((t)=>({
                                        name: t.name,
                                        tenantId: t.tenantId,
                                        numberOfUsers: t.numberOfUsers,
                                        createdAt: t.createdAt,
                                        metadata: t.metadata,
                                        children: [],
                                        loadMoreLink: null == s ? void 0 : s.next,
                                        isReseller: t.isReseller
                                    })));
                                i({
                                    accounts: c
                                });
                            }
                        } catch (t) {
                            s({
                                key: a,
                                value: Un(t)
                            });
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    searchAccounts: async (t)=>{
                        const { jwt: a } = t, o = Mo.SEARCH_ACCOUNTS;
                        n({
                            key: o,
                            value: !0
                        });
                        const { rootAccount: l } = r();
                        try {
                            if (null != t && t._subTenantId) {
                                var c;
                                const { items: n } = await e.tenants.searchSubTenants({
                                    _offset: 0,
                                    _limit: 50,
                                    _filter: null != (c = null == t ? void 0 : t._filter) ? c : "",
                                    _subTenantId: t._subTenantId
                                }, {
                                    jwt: a
                                });
                                i({
                                    searchAccountsData: [
                                        ...n,
                                        {
                                            name: l.name,
                                            tenantId: l.tenantId
                                        }
                                    ]
                                });
                            }
                        } catch (t) {
                            s({
                                key: o,
                                value: Un(t)
                            });
                        } finally{
                            n({
                                key: o,
                                value: !1
                            });
                        }
                    },
                    updateSubAccountAccessForUser: async (t)=>{
                        const a = Mo.UPDATE_SUB_ACCOUNT_ACCESS_FOR_USER;
                        n({
                            key: a,
                            value: !0
                        });
                        const { selectedAccount: i } = r(), { userId: l, allowAccess: c, jwt: u, callback: d } = t;
                        try {
                            var g;
                            await e.subTenants.updateSubAccountAccess(l, {
                                allowAccess: c
                            }, {
                                jwt: u
                            }), o({
                                users: null == i || null == (g = i.users) ? void 0 : g.map((t)=>t.id === l ? v({}, t, {
                                        subAccountAccessAllowed: c
                                    }) : t)
                            }), null == d || d(!0);
                        } catch (t) {
                            s({
                                key: a,
                                value: Un(t)
                            }), null == d || d(!1);
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    createSubAccount: async (t)=>{
                        const a = Mo.CREATE_SUB_ACCOUNT;
                        n({
                            key: a,
                            value: !0
                        });
                        const { name: l, parentTenantId: c, tenantId: u, jwt: d, callback: g } = t;
                        try {
                            if (d) {
                                const { accounts: t, selectedAccount: a } = r(), n = await e.subTenants.createSubTenant({
                                    name: l,
                                    parentTenantId: c,
                                    tenantId: u
                                }, {
                                    jwt: d
                                }), s = xo(t, null != c ? c : "", [
                                    {
                                        name: n.name,
                                        tenantId: n.tenantId,
                                        numberOfUsers: 0,
                                        createdAt: new Date
                                    }
                                ]), g = xo(v({
                                    name: "",
                                    tenantId: ""
                                }, null == a ? void 0 : a.accounts), null != c ? c : "", [
                                    {
                                        name: n.name,
                                        tenantId: n.tenantId,
                                        numberOfUsers: 0,
                                        createdAt: new Date
                                    }
                                ]);
                                i({
                                    accounts: s
                                }), o({
                                    accounts: g
                                });
                            } else {
                                const { accounts: t } = r(), a = await e.subTenants.createSubTenant({
                                    name: l,
                                    tenantId: u,
                                    parentTenantId: c
                                }), n = xo(t, null != c ? c : "", [
                                    {
                                        name: a.name,
                                        tenantId: a.tenantId,
                                        numberOfUsers: 0,
                                        createdAt: new Date
                                    }
                                ]);
                                i({
                                    accounts: n
                                });
                            }
                            null == g || g(!0);
                        } catch (t) {
                            s({
                                key: a,
                                value: Un(t)
                            }), null == g || g(!1);
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    updateSubAccount: async (t)=>{},
                    deleteSubAccount: async (t)=>{
                        const a = Mo.DELETE_SUB_ACCOUNT;
                        n({
                            key: a,
                            value: !0
                        });
                        const { jwt: l, tenantId: c, callback: u } = t;
                        try {
                            if (l) {
                                const { selectedAccount: t, accounts: a } = r();
                                await e.subTenants.deleteSubTenant(c, {
                                    jwt: l
                                });
                                const n = Go(a, c), s = Go(t.accounts, c);
                                i({
                                    accounts: n
                                }), o({
                                    accounts: s
                                });
                            } else {
                                const { accounts: t } = r();
                                await e.subTenants.deleteSubTenant(c);
                                const a = Go(t, c);
                                i({
                                    accounts: a
                                });
                            }
                            null == u || u(!0);
                        } catch (t) {
                            s({
                                key: a,
                                value: Un(t)
                            }), null == u || u(!1);
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    updateSubAccountSettings: async (t)=>{
                        const a = Mo.UPDATE_SUB_ACCOUNT_HIERARCHY_SETTINGS;
                        n({
                            key: a,
                            value: !0
                        });
                        const { jwt: l, name: c, callback: u, tenantId: d } = t;
                        try {
                            if (l) {
                                const { selectedAccount: t, accounts: a } = r();
                                await e.subTenants.updateSubTenant({
                                    tenantId: d
                                }, {
                                    name: c
                                }, {
                                    jwt: l
                                });
                                const n = jo(t.accounts, d, c);
                                o({
                                    name: c,
                                    accounts: n
                                });
                                const s = jo(a, d, c);
                                i({
                                    accounts: s
                                });
                            } else {
                                const { accounts: t } = r();
                                await e.subTenants.updateSubTenant({
                                    tenantId: d
                                }, {
                                    name: c
                                });
                                const a = jo(t, d, c);
                                i({
                                    accounts: a
                                });
                            }
                            null == u || u(!0);
                        } catch (t) {
                            s({
                                key: a,
                                value: Un(t)
                            }), null == u || u(!1);
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    updateSubAccountManagement: async (r)=>{
                        const l = Mo.UPDATE_SUB_ACCOUNT_MANAGEMENT;
                        a.setAllAccountsLoader({
                            key: l,
                            value: !0
                        });
                        const { jwt: c, isReseller: u, callback: d, tenantId: g, shouldUpdateSelectedAccount: p } = r, h = !!c;
                        try {
                            if (p) {
                                const { selectedAccount: a, accounts: n } = t.auth.allAccountsState;
                                await e.subTenants.updateSubTenantManagement({
                                    tenantId: g
                                }, {
                                    isReseller: u
                                }, c ? {
                                    jwt: c
                                } : void 0);
                                const s = Bo(a.accounts, g, null != u && u);
                                o({
                                    accounts: s
                                }), h || o({
                                    isReseller: u
                                });
                                const r = Bo(n, g, null != u && u);
                                i({
                                    accounts: r
                                });
                            } else {
                                const { accounts: a } = t.auth.allAccountsState;
                                e.subTenants.updateSubTenantManagement({
                                    tenantId: g
                                }, {
                                    isReseller: u
                                }, c ? {
                                    jwt: c
                                } : void 0);
                                const n = Bo(a, g, null != u && u);
                                i({
                                    accounts: n
                                });
                            }
                            null == d || d(!0);
                        } catch (t) {
                            s({
                                key: l,
                                value: Un(t)
                            }), null == d || d(!1);
                        } finally{
                            n({
                                key: l,
                                value: !1
                            });
                        }
                    },
                    updateSubAccountHierarchySettings: async (t)=>{
                        const a = Mo.UPDATE_SUB_ACCOUNT_HIERARCHY_SETTINGS;
                        n({
                            key: a,
                            value: !0
                        });
                        const { jwt: l, callback: c, tenantId: u, subAccountAccessType: d } = t;
                        if (d) try {
                            if (l) {
                                const { selectedAccount: t, accounts: a } = r();
                                await e.subTenants.updateSubTenantHierarchySettings({
                                    tenantId: u
                                }, {
                                    subAccountAccessType: d
                                }, {
                                    jwt: l
                                });
                                const n = $o(t.accounts, u, d);
                                o({
                                    subAccountAccessType: d,
                                    accounts: n
                                });
                                const s = $o(a, u, d);
                                i({
                                    accounts: s
                                });
                            } else {
                                const { accounts: t } = r();
                                await e.subTenants.updateSubTenantHierarchySettings({
                                    tenantId: u
                                }, {
                                    subAccountAccessType: d
                                });
                                const a = $o(t, u, d);
                                i({
                                    accounts: a
                                });
                            }
                            null == c || c(!0);
                        } catch (t) {
                            s({
                                key: a,
                                value: Un(t)
                            }), null == c || c(!1);
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    addUsersToAccount: async (t)=>{
                        const { users: a, tenantId: i, jwt: o, callback: r, allowSubAccountAccess: c = !1, roleIds: u } = t, d = Mo.ADD_USERS_TO_ACCOUNT;
                        try {
                            n({
                                key: d,
                                value: !0
                            }), await e.subTenants.addUsersToSubTenant({
                                users: a,
                                tenantId: i,
                                allowSubAccountAccess: c,
                                roleIds: u
                            }, {
                                jwt: o
                            }), await l({
                                jwt: o,
                                _tenantId: i
                            }), null == r || r(!0);
                        } catch (t) {
                            s({
                                key: d,
                                value: Un(t)
                            }), null == r || r(!1);
                        } finally{
                            n({
                                key: d,
                                value: !1
                            });
                        }
                    },
                    getAccountUsers: l,
                    deleteUsersFromAccount: async (t)=>{
                        const a = Mo.DELETE_USERS_FROM_ACCOUNT;
                        n({
                            key: a,
                            value: !0
                        });
                        const { userId: i, subTenants: o, jwt: r, callback: c } = t;
                        try {
                            await e.subTenants.removeUserFromTenantAndSubTenants({
                                userId: i,
                                subTenants: o
                            }, {
                                jwt: r
                            }), await l({
                                jwt: r,
                                _tenantId: o[0].tenantId
                            }), null == c || c(!0);
                        } catch (t) {
                            s({
                                key: a,
                                value: Un(t)
                            }), null == c || c(!1);
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    setUserRolesForSubAccount: async (t)=>{
                        const { userId: a, subTenantsRoles: i, jwt: o, callback: c } = t, u = Mo.SET_USER_ROLES_FOR_SUB_ACCOUNT;
                        try {
                            n({
                                key: u,
                                value: !0
                            });
                            const { selectedAccount: t } = r();
                            await e.subTenants.setUserRolesForSubTenants(a, {
                                subTenantsRoles: i
                            }, {
                                jwt: o
                            }), await l({
                                jwt: o,
                                _tenantId: t.tenantId
                            }), null == c || c(!0);
                        } catch (t) {
                            s({
                                key: u,
                                value: Un(t)
                            }), null == c || c(!1);
                        } finally{
                            n({
                                key: u,
                                value: !1
                            });
                        }
                    },
                    getUserJwtForSubAccount: async (t)=>{
                        const { tenantId: a, callback: i } = t, r = Mo.GET_USER_JWT;
                        try {
                            n({
                                key: r,
                                value: !0
                            });
                            const t = await e.users.GetUserJwt({
                                tenantId: a
                            });
                            o({
                                userJwt: t,
                                accessPermission: !0
                            }), null == i || i(!0);
                        } catch (t) {
                            s({
                                key: r,
                                value: Un(t)
                            }), o({
                                accessPermission: !1
                            }), null == i || i(!1);
                        } finally{
                            n({
                                key: r,
                                value: !1
                            });
                        }
                    },
                    setRootAccountData: async ()=>{
                        const a = Mo.SET_ROOT_ACCOUNT_DATA;
                        n({
                            key: a,
                            value: !0
                        });
                        const { activeTenant: o } = t.auth.tenantsState, { accounts: l } = r();
                        if (o) try {
                            var c;
                            const t = await e.tenants.getTenantsUsersCount({
                                tenantIds: [
                                    null == o ? void 0 : o.tenantId
                                ]
                            }), a = {
                                name: null == o ? void 0 : o.name,
                                tenantId: null == o ? void 0 : o.tenantId,
                                numberOfUsers: null == (c = t[0]) ? void 0 : c.totalUsers,
                                createdAt: null == o ? void 0 : o.createdAt
                            };
                            i({
                                rootAccount: a,
                                accounts: v({}, l, a)
                            });
                        } catch (t) {
                            s({
                                key: a,
                                value: Un(t)
                            });
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    setSelectedSubAccountData: async (t)=>{
                        const { jwt: a } = t, i = Mo.SET_SELECTED_SUB_ACCOUNT_DATA;
                        try {
                            var r, c, u, d, g, p, h;
                            n({
                                key: i,
                                value: !0
                            });
                            const t = await e.accountSettings.getSettings({
                                jwt: a
                            }), [s, y, S] = await Promise.all([
                                e.tenants.getTenantsUsersCount({
                                    tenantIds: [
                                        null != (r = null == t ? void 0 : t.tenantId) ? r : ""
                                    ]
                                }, {
                                    jwt: a
                                }),
                                e.tenants.getParentTenants({
                                    jwt: a
                                }),
                                e.tenants.getHierarchyMetadata({
                                    _tenantIds: [
                                        null != (c = null == t ? void 0 : t.tenantId) ? c : ""
                                    ]
                                }, {
                                    jwt: a
                                })
                            ]);
                            o({
                                tenantId: null != (u = t.tenantId) ? u : "",
                                name: t.name,
                                numberOfUsersObject: s[0],
                                parentsAccounts: y,
                                numberOfSubAccounts: null == (d = S[0]) ? void 0 : d.totalSubTenants,
                                accountSettings: t,
                                accounts: {
                                    name: t.name,
                                    tenantId: null != (g = t.tenantId) ? g : "",
                                    numberOfUsers: null == (p = s[0]) ? void 0 : p.totalUsers,
                                    createdAt: void 0,
                                    children: []
                                }
                            }), await l({
                                jwt: a,
                                _tenantId: null != (h = null == t ? void 0 : t.tenantId) ? h : ""
                            });
                        } catch (t) {
                            s({
                                key: i,
                                value: Un(t)
                            });
                        } finally{
                            n({
                                key: i,
                                value: !1
                            });
                        }
                    },
                    loadNumberOfUsersForSelectedSubAccount: async (t)=>{
                        const { tenantId: a, jwt: i } = t, r = Mo.LOAD_NUMBER_OF_USERS_FOR_ACCOUNT;
                        try {
                            n({
                                key: r,
                                value: !0
                            });
                            const t = await e.tenants.getTenantsUsersCount({
                                tenantIds: [
                                    a
                                ]
                            }, {
                                jwt: i
                            });
                            o({
                                numberOfUsersObject: t[0]
                            });
                        } catch (t) {
                            s({
                                key: r,
                                value: Un(t)
                            });
                        } finally{
                            n({
                                key: r,
                                value: !1
                            });
                        }
                    }
                };
            }, Wo = (t, e, a)=>({
                    setAllAccountDialogsState: (e)=>{
                        Object.assign(t.auth.allAccountsDialogsState, e);
                    },
                    resetAllAccountDialogsState: ()=>{
                        Rn(t, [
                            "auth",
                            "allAccountsDialogsState"
                        ], Do);
                    },
                    openCreateSubAccountDialog: (e)=>{
                        Object.assign(t.auth.allAccountsDialogsState.createSubAccountDialog, v({}, e, {
                            open: !0
                        }));
                    },
                    closeCreateSubAccountDialog: ()=>{
                        Rn(t, [
                            "auth",
                            "allAccountsDialogsState",
                            "createSubAccountDialog"
                        ], Do.createSubAccountDialog);
                    },
                    openUpdateSubAccountDialog: (e)=>{
                        Object.assign(t.auth.allAccountsDialogsState.updateSubAccountDialog, v({}, e, {
                            open: !0
                        }));
                    },
                    closeUpdateSubAccountDialog: ()=>{
                        Rn(t, [
                            "auth",
                            "allAccountsDialogsState",
                            "updateSubAccountDialog"
                        ], Do.updateSubAccountDialog);
                    },
                    openEnableSubAccountManagementDialog: (e)=>{
                        Object.assign(t.auth.allAccountsDialogsState.enableSubAccountManagementDialog, v({}, e, {
                            open: !0
                        }));
                    },
                    closeEnableSubAccountManagementDialog: ()=>{
                        Rn(t, [
                            "auth",
                            "allAccountsDialogsState",
                            "enableSubAccountManagementDialog"
                        ], Do.enableSubAccountManagementDialog);
                    },
                    openUpdateSubAccountHierarchySettingsDialog: (e)=>{
                        Object.assign(t.auth.allAccountsDialogsState.updateSubAccountHierarchySettingsDialog, v({}, e, {
                            open: !0
                        }));
                    },
                    closeUpdateSubAccountHierarchySettingsDialog: ()=>{
                        Rn(t, [
                            "auth",
                            "allAccountsDialogsState",
                            "updateSubAccountHierarchySettingsDialog"
                        ], Do.updateSubAccountHierarchySettingsDialog);
                    },
                    openDisableSubAccountManagementDialog: (e)=>{
                        Object.assign(t.auth.allAccountsDialogsState.disableSubAccountManagementDialog, v({}, e, {
                            open: !0
                        }));
                    },
                    closeDisableSubAccountManagementDialog: ()=>{
                        Rn(t, [
                            "auth",
                            "allAccountsDialogsState",
                            "disableSubAccountManagementDialog"
                        ], Do.disableSubAccountManagementDialog);
                    },
                    openDeleteSubAccountDialog: (e)=>{
                        Object.assign(t.auth.allAccountsDialogsState.deleteSubAccountDialog, v({}, e, {
                            open: !0
                        }));
                    },
                    closeDeleteSubAccountDialog: ()=>{
                        Rn(t, [
                            "auth",
                            "allAccountsDialogsState",
                            "deleteSubAccountDialog"
                        ], Do.deleteSubAccountDialog);
                    },
                    openAddUsersToAccountDialog: (e)=>{
                        Object.assign(t.auth.allAccountsDialogsState.addUsersToAccountDialog, v({}, e, {
                            open: !0
                        }));
                    },
                    closeAddUsersToAccountDialog: ()=>{
                        Rn(t, [
                            "auth",
                            "allAccountsDialogsState",
                            "addUsersToAccountDialog"
                        ], Do.addUsersToAccountDialog);
                    },
                    openDeleteUserFromAccountDialog: (e)=>{
                        Object.assign(t.auth.allAccountsDialogsState.deleteUserFromAccountDialog, v({}, e, {
                            open: !0
                        }));
                    },
                    closeDeleteUserFromAccountDialog: ()=>{
                        Rn(t, [
                            "auth",
                            "allAccountsDialogsState",
                            "deleteUserFromAccountDialog"
                        ], Do.deleteUserFromAccountDialog);
                    },
                    openEditUserRolesDialog: (e)=>{
                        Object.assign(t.auth.allAccountsDialogsState.editUserRolesDialog, v({}, e, {
                            open: !0
                        }));
                    },
                    closeEditUserRolesDialog: ()=>{
                        Rn(t, [
                            "auth",
                            "allAccountsDialogsState",
                            "editUserRolesDialog"
                        ], Do.editUserRolesDialog);
                    }
                }), Ho = {
                devices: [],
                loading: !1,
                error: null
            }, zo = (t)=>Za(Ho, t), Ko = (t, e, a)=>{
                const n = a, s = (e)=>{
                    Object.assign(t.auth.passkeysState, e);
                };
                return {
                    setPasskeysState: s,
                    resetPasskeysState: ()=>{
                        Rn(t, [
                            "auth",
                            "passkeysState"
                        ], Ho);
                    },
                    loadWebAuthnDevices: async ()=>{
                        s({
                            loading: !0
                        });
                        try {
                            const { devices: t } = await e.auth.getWebAuthnDevices();
                            s({
                                devices: t,
                                loading: !1
                            });
                        } catch (t) {
                            s({
                                loading: !1,
                                error: Un(t, null)
                            });
                        }
                    },
                    deleteWebAuthnDevice: async (a)=>{
                        const { callback: n, deviceId: i } = a;
                        s({
                            loading: !0
                        });
                        try {
                            await e.auth.deleteWebAuthnDevice(i);
                            const a = t.auth.passkeysState.devices.filter((t)=>t.id !== i);
                            s({
                                devices: a,
                                loading: !1
                            }), null == n || n(!0);
                        } catch (t) {
                            s({
                                loading: !1,
                                error: Un(t, null)
                            }), null == n || n(null, t);
                        }
                    },
                    __shouldShowPromptPasskeys: async function() {
                        const { publicAuthStrategyPolicy: a } = t.auth.securityPolicyState, { policy: i } = a, o = await async function(t) {
                            var e;
                            return !(null == t || null == (e = t.secondaryAuthStrategies) || !e.some(({ isActive: t, strategy: e })=>t && e === Ht.Passkeys));
                        }(i), r = "Passkeys" === localStorage.getItem("preferred-login-method"), l = "true" === localStorage.getItem("dont-show-again-prompt-passkeys"), [c] = await n.getFeatureFlags([
                            "show-passkeys-new"
                        ]);
                        if (!c || !o || r || l) return !1;
                        {
                            const { devices: t } = await e.auth.getWebAuthnDevices();
                            return s({
                                devices: null != t ? t : []
                            }), 0 === (null != t && t.length ? t.length : 0);
                        }
                    }
                };
            }, qo = {
                loading: !1,
                error: null
            }, Jo = (t)=>Za(qo, t), Yo = [
                "callback",
                "profilePictureUrl"
            ], Xo = (t, e, a)=>{
                const n = a, s = (e)=>{
                    Object.assign(t.auth.profileState, e);
                };
                return {
                    setProfileState: s,
                    resetProfileState: ()=>{
                        Rn(t, [
                            "auth",
                            "profileState"
                        ], qo);
                    },
                    loadProfile: async ()=>{
                        s({
                            loading: !0
                        });
                        try {
                            const a = await Tn(e.teams.getProfile, 3, 2e3), i = t.auth.user;
                            n.setUser(v({}, i, a)), s({
                                profile: a,
                                loading: !1
                            });
                        } catch (t) {
                            s({
                                loading: !1,
                                error: Un(t)
                            });
                        }
                    },
                    saveProfile: async (a)=>{
                        const { callback: i, profilePictureUrl: o } = a, r = f(a, Yo);
                        s({
                            saving: !0,
                            error: null,
                            loading: !0
                        });
                        try {
                            var l;
                            const a = null != (l = t.auth.profileState.profile) ? l : {};
                            let s = a.profilePictureUrl;
                            if (o !== a.profilePictureUrl && o && (o || "").match(/^data:image\/([A-Za-z-+\/]+);base64,(.+)$/)) {
                                const t = Ii(o, "image");
                                if (t) {
                                    s = await e.teams.updateProfileImage(t);
                                    const a = Date.now().toString(), n = new URL(s);
                                    n.searchParams.set("t", a), s = n.href;
                                }
                            }
                            const c = v({}, a, r, {
                                profilePictureUrl: s
                            }), u = await e.users.updateUserProfileV2(c), d = t.auth.user;
                            n.setUser(v({}, d, u)), n.setProfileState({
                                profile: u,
                                saving: !1,
                                loading: !1
                            }), null == i || i(c);
                        } catch (t) {
                            s({
                                saving: !1,
                                error: Un(t),
                                loading: !1
                            }), null == i || i(null, t);
                        }
                    },
                    changePassword: async (t)=>{
                        s({
                            loading: !0
                        });
                        try {
                            var a;
                            await e.teams.changePassword(t), s({
                                loading: !1,
                                error: void 0
                            }), null == (a = t.callback) || a.call(t, !0);
                        } catch (e) {
                            var n;
                            s({
                                loading: !1,
                                error: Un(e)
                            }), null == (n = t.callback) || n.call(t, null, e);
                        }
                    }
                };
            }, Qo = {
                loading: !1
            }, Zo = (t)=>Za(Qo, t), tr = [
                "callback"
            ], er = [
                "id"
            ], ar = (t, e, a)=>{
                const n = (e)=>{
                    Object.assign(t.auth.provisioningState, e);
                }, s = async (t, a)=>{
                    const { count: n } = await En(()=>e.directory.countConfigurationUsers(t.id), a);
                    return v({}, t, {
                        count: n
                    });
                };
                return {
                    setProvisioningState: n,
                    resetProvisioningState: ()=>{
                        Rn(t, [
                            "auth",
                            "provisioningState"
                        ], Qo);
                    },
                    __loadCountForConnection: s,
                    loadProvisionConnections: async (t)=>{
                        n({
                            loading: !0,
                            error: null
                        });
                        try {
                            const a = null == t ? void 0 : t.retryConfig, i = await En(()=>e.directory.getConfigs(), a), o = await Promise.all(i.map((t)=>s(t, a)));
                            n({
                                connections: o,
                                loading: !1
                            });
                        } catch (t) {
                            n({
                                error: Un(t),
                                loading: !1
                            });
                        }
                    },
                    createProvisionConnection: async (t)=>{
                        const { callback: a } = t, i = f(t, tr);
                        n({
                            loading: !0,
                            error: null
                        });
                        try {
                            const t = await e.directory.createConfiguration(i), o = await e.directory.getConfigs(), r = await Promise.all(o.map((t)=>s(t)));
                            n({
                                connections: r,
                                loading: !1
                            }), null == a || a(t);
                        } catch (t) {
                            n({
                                error: Un(t),
                                loading: !1
                            });
                        }
                    },
                    deleteProvisionConnection: async (t)=>{
                        const { id: a, callback: i } = t;
                        n({
                            loading: !0,
                            error: null
                        });
                        try {
                            await e.directory.deleteConfiguration(a);
                            const t = await e.directory.getConfigs(), o = await Promise.all(t.map((t)=>s(t)));
                            n({
                                connections: o,
                                loading: !1
                            }), null == i || i(!0);
                        } catch (t) {
                            n({
                                error: Un(t),
                                loading: !1
                            }), null == i || i(!1, t);
                        }
                    },
                    updateProvisionConnection: async (t)=>{
                        const { id: a } = t, i = f(t, er);
                        n({
                            loading: !0,
                            error: null
                        });
                        try {
                            await e.directory.updateConfiguration(a, i);
                            const t = await e.directory.getConfigs(), o = await Promise.all(t.map((t)=>s(t)));
                            n({
                                connections: o,
                                loading: !1
                            });
                        } catch (t) {
                            n({
                                error: Un(t),
                                loading: !1
                            });
                        }
                    }
                };
            };
            let nr;
            !function(t) {
                t.ResetPhoneNumber = "ResetPhoneNumber", t.VerifyResetPhoneNumber = "VerifyResetPhoneNumber", t.ChangePhoneNumber = "ChangePhoneNumber";
            }(nr || (nr = {}));
            const sr = {
                step: nr.ResetPhoneNumber,
                loading: !1
            }, ir = (t)=>Za(sr, t), or = [
                "callback"
            ], rr = [
                "callback"
            ], lr = [
                "callback"
            ], cr = (t, e, a)=>{
                const n = a, s = (e)=>{
                    Object.assign(t.auth.resetPhoneNumberState, e);
                };
                return {
                    setResetPhoneNumberState: s,
                    resetResetPhoneNumberState: ()=>{
                        Rn(t, [
                            "auth",
                            "resetPhoneNumberState"
                        ], sr);
                    },
                    resetPhoneNumber: async (t)=>{
                        const { callback: a } = t, i = f(t, or);
                        s({
                            loading: !0
                        });
                        try {
                            const t = await e.auth.resetPhoneNumber(i);
                            s({
                                loading: !1,
                                error: void 0,
                                resetPhoneNumberToken: t.resetPhoneNumberToken,
                                step: nr.VerifyResetPhoneNumber
                            }), n.setLoginState({
                                email: i.email
                            });
                        } catch (t) {
                            s({
                                loading: !1,
                                error: Un(t)
                            }), null == a || a(null, t);
                        }
                    },
                    verifyResetPhoneNumber: async (t)=>{
                        const { callback: a } = t, n = f(t, rr);
                        s({
                            loading: !0
                        });
                        try {
                            const t = await e.auth.verifyResetPhoneNumber(n);
                            s({
                                loading: !1,
                                error: void 0,
                                changePhoneNumberToken: t.changePhoneNumberToken,
                                step: nr.ChangePhoneNumber
                            }), null == a || a(!0);
                        } catch (t) {
                            s({
                                loading: !1,
                                error: Un(t)
                            }), null == a || a(null, t);
                        }
                    },
                    changePhoneNumber: async (a)=>{
                        const { callback: i } = a, o = f(a, lr);
                        s({
                            loading: !0
                        });
                        try {
                            const { onRedirectTo: a, routes: r } = t.auth;
                            await e.auth.changePhoneNumber({
                                phoneNumber: o.phoneNumber,
                                changePhoneNumberToken: o.changePhoneNumberToken
                            }), n.setLoginState({
                                step: pn.loginWithSmsOtc
                            }), await n.passwordlessPreLogin({
                                type: N.SmsCode,
                                email: o.email,
                                recaptchaToken: o.recaptchaToken
                            }), a(r.loginUrl), s({
                                loading: !1
                            }), null == i || i(!0);
                        } catch (t) {
                            s({
                                loading: !1,
                                error: Un(t)
                            }), null == i || i(null, t);
                        }
                    }
                };
            }, ur = {
                loaders: {},
                errors: {},
                roles: [],
                permissions: [],
                permissionCategories: []
            }, dr = (t)=>Za(ur, t);
            let gr;
            !function(t) {
                t.EDIT_ROLE_DIALOG = "editRoleDialog", t.DELETE_ROLE_DIALOG = "deleteRoleDialog", t.LOAD_ROLES = "loadRoles", t.ADD_ROLE = "addRole", t.MANAGE_PERMISSIONS = "managePermissions";
            }(gr || (gr = {}));
            const pr = [
                "callback"
            ], hr = [
                "callback"
            ], yr = [
                "callback"
            ], Sr = [
                "callback"
            ], vr = [
                "callback"
            ], fr = [
                "callback"
            ], mr = (t, e, a)=>{
                const n = (e)=>{
                    Object.assign(t.auth.rolesState, e);
                }, s = (e)=>{
                    Object.assign(t.auth.rolesState, {
                        loaders: v({}, t.auth.rolesState.loaders, {
                            [e.key]: e.value
                        })
                    });
                }, i = (e)=>{
                    Object.assign(t.auth.rolesState, {
                        errors: v({}, t.auth.rolesState.errors, {
                            [e.key]: e.value
                        }),
                        loaders: v({}, t.auth.rolesState.loaders, {
                            [e.key]: !1
                        })
                    });
                }, o = async (a)=>{
                    var o;
                    const r = gr.LOAD_ROLES;
                    s({
                        key: r,
                        value: !(null != (o = null == a ? void 0 : a.silentLoading) && o)
                    });
                    try {
                        const s = null == a ? void 0 : a.retryConfig, [i, o, r] = await Promise.all([
                            En(()=>e.roles.getRoles(), s),
                            En(()=>e.roles.getPermissions(), s),
                            En(()=>e.roles.getPermissionCategories(), s)
                        ]), { selectedRole: l } = t.auth.rolesState, c = null == i ? void 0 : i.find(({ id: t })=>(null == l ? void 0 : l.id) === t);
                        n({
                            roles: i,
                            permissions: o,
                            permissionCategories: r,
                            selectedRole: c
                        });
                    } catch (t) {
                        i({
                            key: r,
                            value: Un(t)
                        });
                    } finally{
                        s({
                            key: r,
                            value: !1
                        });
                    }
                }, r = async (t)=>{
                    const { callback: a } = t, r = f(t, vr), l = gr.MANAGE_PERMISSIONS;
                    s({
                        key: l,
                        value: !0
                    });
                    try {
                        const t = await e.roles.attachPermissionsToRole(r);
                        await o({
                            silentLoading: !0
                        }), n({
                            saving: !1
                        }), null == a || a(t);
                    } catch (t) {
                        i({
                            key: l,
                            value: Un(t)
                        }), null == a || a(null, t);
                    } finally{
                        s({
                            key: l,
                            value: !1
                        });
                    }
                };
                return {
                    setRolesState: n,
                    setRolesStateLoader: s,
                    setRolesStateError: i,
                    resetRolesState: ()=>{
                        Rn(t, [
                            "auth",
                            "rolesState"
                        ], ur);
                    },
                    loadRolesAndPermissions: o,
                    addRole: async (t)=>{
                        const { callback: a } = t, n = f(t, pr), r = gr.ADD_ROLE;
                        s({
                            key: r,
                            value: !0
                        });
                        try {
                            const t = await e.roles.addRole(n);
                            await o({
                                silentLoading: !0
                            }), null == a || a(t);
                        } catch (t) {
                            i({
                                key: r,
                                value: Un(t)
                            }), null == a || a(null, t);
                        } finally{
                            s({
                                key: r,
                                value: !1
                            });
                        }
                    },
                    addRoleV2: async (t)=>{
                        const { callback: a } = t, n = f(t, hr), r = gr.ADD_ROLE;
                        s({
                            key: r,
                            value: !0
                        });
                        try {
                            const t = await e.roles.addRoleV2(n);
                            await o({
                                silentLoading: !0
                            }), null == a || a(t);
                        } catch (t) {
                            i({
                                key: r,
                                value: Un(t)
                            }), null == a || a(null, t);
                        } finally{
                            s({
                                key: r,
                                value: !1
                            });
                        }
                    },
                    updateRole: async (t)=>{
                        const { callback: a } = t, r = f(t, yr), l = gr.EDIT_ROLE_DIALOG;
                        s({
                            key: l,
                            value: !0
                        });
                        try {
                            const t = await e.roles.updateRole(r);
                            await o({
                                silentLoading: !0
                            }), n({
                                saving: !1
                            }), null == a || a(t);
                        } catch (t) {
                            i({
                                key: l,
                                value: Un(t)
                            }), null == a || a(null, t);
                        } finally{
                            s({
                                key: l,
                                value: !1
                            });
                        }
                    },
                    deleteRole: async (t)=>{
                        const { callback: a } = t, r = f(t, Sr), l = gr.DELETE_ROLE_DIALOG;
                        s({
                            key: l,
                            value: !0
                        });
                        try {
                            await e.roles.deleteRole(r), await o({
                                silentLoading: !0
                            }), n({
                                saving: !1
                            }), null == a || a(!0);
                        } catch (t) {
                            i({
                                key: l,
                                value: Un(t)
                            }), null == a || a(!1, t);
                        } finally{
                            s({
                                key: l,
                                value: !1
                            });
                        }
                    },
                    attachPermissionsToRole: r,
                    attachPermissionToRoles: async (t)=>{
                        const { callback: e } = t, a = f(t, fr), n = gr.MANAGE_PERMISSIONS;
                        s({
                            key: n,
                            value: !0
                        });
                        try {
                            await Promise.all(a.roleIds.map((t)=>r({
                                    roleId: t,
                                    permissionIds: [
                                        a.permissionId
                                    ]
                                }))), await o({
                                silentLoading: !0
                            }), null == e || e(!0);
                        } catch (t) {
                            i({
                                key: n,
                                value: Un(t)
                            }), null == e || e(null, t);
                        } finally{
                            s({
                                key: n,
                                value: !1
                            });
                        }
                    }
                };
            }, br = {
                ipRestrictions: {
                    loading: !1,
                    pagination: {
                        _offset: 0,
                        _limit: 4,
                        _filter: Wt.ALLOW
                    },
                    totalPages: 1,
                    userIpValid: !1
                },
                emailDomainRestrictions: {
                    loading: !1
                }
            }, Ar = (t)=>Za(br, t), wr = [
                "callback"
            ], Tr = [
                "callback"
            ], Er = [
                "callback"
            ], Ir = [
                "callback"
            ], Or = (t, e, a)=>{
                const n = a, s = (t)=>{
                    var e, a, n;
                    return {
                        _filter: null != (e = null == t ? void 0 : t._filter) ? e : Wt.ALLOW,
                        _limit: null != (a = null == t ? void 0 : t._limit) ? a : 10,
                        _offset: null != (n = null == t ? void 0 : t._offset) ? n : 0
                    };
                }, i = (t)=>async (...e)=>{
                        const [a] = await n.getFeatureFlags([
                            "security-center-admin-portal-major-version"
                        ]);
                        await t(...e), a && (await n.loadRecommendations(In()), await n.loadInsights(In()));
                    }, o = (e)=>{
                    Object.assign(t.auth.restrictionsState.ipRestrictions, e);
                }, r = (e)=>{
                    Object.assign(t.auth.restrictionsState.emailDomainRestrictions, e);
                }, l = async ()=>{
                    try {
                        const { valid: t } = await e.auth.testCurrentIpInAllowList();
                        o({
                            userIpValid: t
                        });
                    } catch (t) {
                        o({
                            error: Un(t)
                        });
                    }
                }, c = i(async ()=>{
                    o({
                        loading: !0,
                        error: null
                    });
                    try {
                        const a = t.auth.restrictionsState.ipRestrictions, n = await e.auth.getIPRestrictionsConfig(), i = s({
                            _filter: n.strategy,
                            _limit: a.pagination._limit,
                            _offset: a.pagination._offset
                        }), { items: r, _metadata: { totalPages: l } } = await e.auth.getIPRestrictions(i);
                        o({
                            data: {
                                restrictions: r,
                                config: n
                            },
                            totalPages: l,
                            pagination: i,
                            loading: !1
                        });
                    } catch (t) {
                        o({
                            error: Un(t),
                            loading: !1
                        });
                    }
                }), u = i(async (a)=>{
                    const { callback: n } = a, i = f(a, wr);
                    o({
                        saving: !0,
                        error: null
                    });
                    try {
                        var r, c;
                        await e.auth.createIPRestriction(i);
                        const a = t.auth.restrictionsState.ipRestrictions, u = s(a.pagination), { items: d, _metadata: { totalPages: g } } = await e.auth.getIPRestrictions(u), p = d;
                        await l(), o({
                            data: {
                                config: null != (r = null == (c = a.data) ? void 0 : c.config) ? r : {
                                    isActive: !1,
                                    strategy: Wt.ALLOW
                                },
                                restrictions: p
                            },
                            pagination: u,
                            totalPages: g,
                            saving: !1
                        }), null == n || n(!0);
                    } catch (t) {
                        o({
                            saving: !1,
                            error: Un(t)
                        }), null == n || n(null, t);
                    }
                }), d = i(async (a)=>{
                    const { callback: n } = a, i = f(a, Tr);
                    o({
                        saving: !0,
                        error: null
                    });
                    try {
                        await e.auth.updateIPRestrictionConfig(i);
                        const a = t.auth.restrictionsState.ipRestrictions, r = await e.auth.getIPRestrictionsConfig(), c = s(v({}, a.pagination, {
                            _filter: r.strategy
                        })), { items: u, _metadata: { totalPages: d } } = await e.auth.getIPRestrictions(c), g = u;
                        await l(), o({
                            data: {
                                config: r,
                                restrictions: g
                            },
                            pagination: c,
                            totalPages: d,
                            saving: !1
                        }), null == n || n(!0);
                    } catch (t) {
                        o({
                            saving: !1,
                            error: Un(t)
                        }), null == n || n(null, t);
                    }
                }), g = i(async (a)=>{
                    const { id: n, callback: i } = a;
                    o({
                        saving: !0,
                        error: null
                    });
                    try {
                        var r;
                        await e.auth.deleteIPRestriction(n);
                        const a = t.auth.restrictionsState.ipRestrictions, c = s(a.pagination), { items: u, _metadata: { totalPages: d } } = await e.auth.getIPRestrictions(c), g = u;
                        await l(), o({
                            data: {
                                config: (null == (r = a.data) ? void 0 : r.config) || {
                                    isActive: !1,
                                    strategy: Wt.ALLOW
                                },
                                restrictions: g
                            },
                            pagination: c,
                            totalPages: d,
                            saving: !1
                        }), null == i || i(!0);
                    } catch (t) {
                        o({
                            saving: !1,
                            error: Un(t)
                        }), null == i || i(null, t);
                    }
                }), p = i(l), h = i(async (a)=>{
                    const { callback: n } = a;
                    o({
                        saving: !0,
                        error: null
                    });
                    try {
                        var i, r;
                        const a = null != (i = (null == (r = t.auth.userIpData) ? void 0 : r.ip) || t.auth.userIp) ? i : "";
                        await Promise.all([
                            e.auth.createIPRestriction({
                                ip: a,
                                isActive: !0,
                                description: "My IP",
                                strategy: Wt.ALLOW
                            }),
                            e.auth.updateIPRestrictionConfig({
                                isActive: !0
                            })
                        ]);
                        const l = t.auth.restrictionsState.ipRestrictions, c = s(l.pagination), { items: u, _metadata: { totalPages: d } } = await e.auth.getIPRestrictions(c), g = u;
                        o({
                            data: {
                                config: {
                                    isActive: !0,
                                    strategy: Wt.ALLOW
                                },
                                restrictions: g
                            },
                            userIpValid: !0,
                            pagination: c,
                            totalPages: d,
                            saving: !1
                        }), null == n || n(!0);
                    } catch (t) {
                        o({
                            saving: !1,
                            error: t
                        }), null == n || n(!1, t);
                    }
                }), y = i(async ()=>{
                    r({
                        loading: !0,
                        error: null
                    });
                    try {
                        const t = await e.auth.getDomainRestrictionsConfig(), a = (await e.auth.getDomainRestrictions()).items.filter((e)=>e.type === t.listType);
                        r({
                            data: {
                                restrictions: a,
                                config: t
                            },
                            loading: !1
                        });
                    } catch (t) {
                        r({
                            error: Un(t),
                            loading: !1
                        });
                    }
                }), S = i(async (a)=>{
                    const { callback: n } = a, s = f(a, Er);
                    r({
                        saving: !0,
                        error: null
                    });
                    const i = t.auth.restrictionsState.emailDomainRestrictions;
                    try {
                        var o;
                        await e.auth.createDomainRestriction(s);
                        const t = (await e.auth.getDomainRestrictions()).items.filter((t)=>{
                            var e;
                            return t.type === (null == (e = i.data) ? void 0 : e.config.listType);
                        });
                        r({
                            data: {
                                config: (null == (o = i.data) ? void 0 : o.config) || {
                                    active: !1,
                                    blockPublicDomains: !1,
                                    listType: s.type
                                },
                                restrictions: t
                            },
                            saving: !1
                        }), null == n || n(!0);
                    } catch (t) {
                        r({
                            saving: !1,
                            error: Un(t)
                        }), null == n || n(null, t);
                    }
                }), m = i(async (t)=>{
                    const { callback: a } = t, n = f(t, Ir);
                    r({
                        saving: !0,
                        error: null
                    });
                    try {
                        const t = await e.auth.updateDomainRestrictionConfig(n), s = (await e.auth.getDomainRestrictions()).items.filter((e)=>e.type === t.listType);
                        r({
                            data: {
                                config: t,
                                restrictions: s
                            },
                            saving: !1
                        }), null == a || a(!0);
                    } catch (t) {
                        r({
                            saving: !1,
                            error: Un(t)
                        }), null == a || a(null, t);
                    }
                }), b = i(async (a)=>{
                    const { id: n } = a;
                    r({
                        saving: !0,
                        error: null
                    });
                    const s = t.auth.restrictionsState.emailDomainRestrictions;
                    try {
                        var i;
                        await e.auth.deleteDomainRestriction(n);
                        const t = (await e.auth.getDomainRestrictions()).items.filter((t)=>{
                            var e;
                            return t.type === (null == (e = s.data) ? void 0 : e.config.listType);
                        });
                        r({
                            data: {
                                config: (null == (i = s.data) ? void 0 : i.config) || {
                                    active: !1,
                                    blockPublicDomains: !1,
                                    listType: Wt.ALLOW
                                },
                                restrictions: t
                            },
                            saving: !1
                        });
                    } catch (t) {
                        r({
                            saving: !1,
                            error: Un(t)
                        });
                    }
                });
                return {
                    setRestrictionsState: (e)=>{
                        Object.assign(t.auth.restrictionsState, e);
                    },
                    setIpRestrictionsState: o,
                    setEmailDomainRestrictionsState: r,
                    __securityCenterSagaWrapper: i,
                    loadIpRestrictions: c,
                    saveIpRestriction: u,
                    saveIpRestrictionsConfig: d,
                    deleteIpRestriction: g,
                    checkIfUserIpValid: p,
                    addCurrentUserIpAndActivate: h,
                    loadEmailDomainRestrictions: y,
                    saveEmailDomainRestriction: S,
                    saveEmailDomainRestrictionsConfig: m,
                    deleteEmailDomainRestriction: b
                };
            }, Pr = {
                loaders: {},
                errors: {},
                recommendations: void 0,
                insights: void 0,
                hasSecurityChanges: !1,
                score: 0,
                breachedPasswordUsersTable: {
                    users: [],
                    usersPageOffset: 0,
                    totalUsersItems: 0,
                    totalUsersPages: 0,
                    queryParams: {
                        _offset: 0,
                        _limit: 10
                    }
                },
                unenrolledMfaUsersTable: {
                    users: [],
                    usersPageOffset: 0,
                    totalUsersItems: 0,
                    totalUsersPages: 0,
                    queryParams: {
                        _offset: 0,
                        _limit: 10
                    }
                },
                inactiveUsersTable: {
                    users: [],
                    usersPageOffset: 0,
                    totalUsersItems: 0,
                    totalUsersPages: 0,
                    queryParams: {
                        _offset: 0,
                        _limit: 10,
                        _maxInactiveSeconds: 7776e3
                    }
                }
            }, kr = (t)=>Za(Pr, t);
            let _r;
            !function(t) {
                t.RECOMMENDATIONS = "recommendations", t.INSIGHTS = "insights", t.SEND_BULK_RESET_BREACHED_PASSWORD_EMAILS = "sendBulkResetBreachedPasswordEmails", t.SEND_BREACHED_PASSWORD_EMAIL = "sendBreachedPasswordEmail", t.BREACHED_PASSWORD_USERS_TABLE = "breachedPasswordUsersTable", t.UNENROLLED_MFA_USERS_TABLE = "unenrolledMfaUsersTable", t.INACTIVE_USERS_TABLE = "inactiveUsersTable";
            }(_r || (_r = {}));
            const Rr = [
                "callback"
            ], Cr = (t, e, a)=>{
                const n = a, s = async (t)=>{
                    var a, s, l, c;
                    const { key: u, tableState: d, updateStateKey: g, _offset: p, _limit: h, _preset: y, _email: S, _maxInactiveSeconds: f } = t;
                    r({
                        key: u,
                        value: !1
                    }), o({
                        key: u,
                        value: !0
                    });
                    const m = null != (a = null != p ? p : null == d || null == (s = d.queryParams) ? void 0 : s._offset) ? a : 0, b = null != (l = null != h ? h : null == d || null == (c = d.queryParams) ? void 0 : c._limit) ? l : 10, A = v({
                        _offset: m,
                        _limit: b,
                        _includeSubTenants: !1,
                        _preset: y,
                        _maxInactiveSeconds: f
                    }, !!S && {
                        _email: S
                    });
                    try {
                        const { items: t, _metadata: { totalItems: a, totalPages: s } } = await e.users.getUsersV3(A), o = {
                            totalUsersItems: a,
                            totalUsersPages: s,
                            usersPageOffset: m,
                            queryParams: v({
                                _offset: m,
                                _limit: b,
                                _maxInactiveSeconds: f
                            }, !!S && {
                                _email: S
                            })
                        };
                        if (t.length) {
                            const a = await (async (t)=>{
                                const a = t.map((t)=>t.id), n = await e.roles.getRoles(), s = await e.users.getUsersRoles({
                                    ids: a
                                });
                                return t.map((t)=>{
                                    var e, a;
                                    const i = null == s || null == (e = s.find((e)=>e.userId === t.id)) ? void 0 : e.roleIds;
                                    return v({}, t, {
                                        roles: null != (a = null == i ? void 0 : i.map((t)=>{
                                            var e;
                                            return null != (e = null == n ? void 0 : n.find((e)=>e.id === t)) ? e : [];
                                        })) ? a : []
                                    });
                                });
                            })(t);
                            n.setSecurityCenterState({
                                [g]: v({
                                    users: a
                                }, o)
                            });
                        } else i({
                            [g]: v({
                                users: []
                            }, o)
                        });
                    } catch (t) {
                        r({
                            key: u,
                            value: Un(t)
                        });
                    } finally{
                        o({
                            key: u,
                            value: !1
                        });
                    }
                }, i = (e)=>{
                    Object.assign(t.auth.securityCenterState, e);
                }, o = (e)=>{
                    Object.assign(t.auth.securityCenterState, {
                        loaders: v({}, t.auth.securityCenterState.loaders, {
                            [e.key]: e.value
                        })
                    });
                }, r = (e)=>{
                    Object.assign(t.auth.securityCenterState, {
                        errors: v({}, t.auth.securityCenterState.errors, {
                            [e.key]: e.value
                        }),
                        loaders: v({}, t.auth.securityCenterState.loaders, {
                            [e.key]: !1
                        })
                    });
                };
                return {
                    setSecurityCenterState: i,
                    resetSecurityCenterState: ()=>{
                        Rn(t, [
                            "auth",
                            "securityCenterState"
                        ], Pr);
                    },
                    setSecurityCenterStateLoader: o,
                    setSecurityCenterStateError: r,
                    loadRecommendations: async (t)=>{
                        const a = _r.RECOMMENDATIONS;
                        o({
                            key: a,
                            value: !0
                        });
                        try {
                            var n;
                            const { recommendations: a, scoring: s } = await En(()=>e.securityCenter.getRecommendations(), null == t ? void 0 : t.retryConfig);
                            i({
                                recommendations: a.items,
                                score: null != (n = null == s ? void 0 : s.score) ? n : 0
                            });
                        } catch (t) {
                            r({
                                key: a,
                                value: Un(t)
                            });
                        } finally{
                            o({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    loadInsights: async (t)=>{
                        const a = _r.INSIGHTS;
                        o({
                            key: a,
                            value: !0
                        });
                        try {
                            const { insights: a } = await await En(()=>e.securityCenter.getInsights(), null == t ? void 0 : t.retryConfig);
                            i({
                                insights: a.items
                            });
                        } catch (t) {
                            r({
                                key: a,
                                value: Un(t)
                            });
                        } finally{
                            o({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    sendResetBreachedPasswordEmail: async (t)=>{
                        const { callback: a } = t, n = f(t, Rr), s = _r.SEND_BREACHED_PASSWORD_EMAIL;
                        r({
                            key: s,
                            value: !1
                        }), o({
                            key: s,
                            value: !0
                        });
                        try {
                            await e.auth.forgotPassword(n), null == a || a(!0);
                        } catch (t) {
                            r({
                                key: s,
                                value: Un(t)
                            }), null == a || a(!1, t);
                        } finally{
                            o({
                                key: s,
                                value: !1
                            });
                        }
                    },
                    sendBulkResetBreachedPasswordEmails: async (t)=>{
                        const { callback: a } = t, n = _r.SEND_BULK_RESET_BREACHED_PASSWORD_EMAILS;
                        r({
                            key: n,
                            value: !1
                        }), o({
                            key: n,
                            value: !0
                        });
                        try {
                            await e.users.sendResetBreachedPasswordEmails(), null == a || a(!0);
                        } catch (t) {
                            r({
                                key: n,
                                value: Un(t)
                            }), null == a || a(!1);
                        } finally{
                            o({
                                key: n,
                                value: !1
                            });
                        }
                    },
                    loadBreachedPasswordUsers: async (e)=>{
                        var a;
                        const n = _r.BREACHED_PASSWORD_USERS_TABLE, i = null == (a = t.auth.securityCenterState) ? void 0 : a.breachedPasswordUsersTable;
                        await s(v({
                            key: n,
                            updateStateKey: "breachedPasswordUsersTable",
                            _preset: Ga.BREACHED_PASSWORDS,
                            tableState: i
                        }, e));
                    },
                    loadUnenrolledMfaUsers: async (e)=>{
                        var a;
                        const n = _r.UNENROLLED_MFA_USERS_TABLE, i = null == (a = t.auth.securityCenterState) ? void 0 : a.unenrolledMfaUsersTable;
                        await s(v({
                            key: n,
                            updateStateKey: "unenrolledMfaUsersTable",
                            _preset: Ga.MFA_UNENROLLED,
                            tableState: i
                        }, e));
                    },
                    loadInactiveUsers: async (e)=>{
                        var a;
                        const n = _r.INACTIVE_USERS_TABLE, i = null == (a = t.auth.securityCenterState) ? void 0 : a.inactiveUsersTable;
                        await s(v({
                            key: n,
                            updateStateKey: "inactiveUsersTable",
                            _preset: Ga.INACTIVE,
                            tableState: i
                        }, e));
                    },
                    markSecurityCenterStateAsChanged: (t = !0)=>{
                        i({
                            hasSecurityChanges: t
                        });
                    }
                };
            }, Lr = {
                globalPolicy: {
                    loading: !0
                },
                publicPolicy: {
                    loading: !1
                },
                vendorMfaPolicy: {
                    loading: !0
                },
                mfaPolicy: {
                    loading: !0
                },
                vendorLockoutPolicy: {
                    loading: !0
                },
                lockoutPolicy: {
                    loading: !0
                },
                captchaPolicy: {
                    loading: !0
                },
                passwordHistoryPolicy: {
                    loading: !0
                },
                passwordPolicy: {
                    loading: !0
                },
                vendorPasswordHistoryPolicy: {
                    loading: !0
                },
                publicAuthStrategyPolicy: {
                    loading: !0
                },
                passwordRotationPolicy: {
                    loading: !0
                }
            }, Ur = (t)=>Za(Lr, t);
            function Dr(t, e) {
                const a = null != e, n = null != t;
                if (a || n) return a ? n ? Math.min(t, e) : e : t;
            }
            const Nr = [
                "callback"
            ], Mr = [
                "callback"
            ], Fr = [
                "callback"
            ], xr = [
                "callback"
            ], Gr = (t, e, a)=>{
                const n = a, s = async (t, e)=>{
                    var a, s;
                    if (!await n.customLoginEnabled()) return t;
                    const o = await i(e);
                    return null != o && null != (a = o.mainAuthStrategies) && null != (s = a[0]) && s.strategy ? v({}, t, {
                        authStrategy: o.mainAuthStrategies[0].strategy
                    }) : t;
                }, i = async (a)=>{
                    let n;
                    return n = t.auth.isAuthenticated ? await En(e.auth.getPublicAuthStrategiesConfigForAuthenticatedUser, a) : await En(e.auth.getVendorPublicAuthStrategiesConfig, a), n;
                }, o = (e)=>{
                    Object.assign(t.auth.securityPolicyState.globalPolicy, e);
                }, r = (e)=>{
                    Object.assign(t.auth.securityPolicyState.publicPolicy, e);
                }, l = (e)=>{
                    Object.assign(t.auth.securityPolicyState.mfaPolicy, e);
                }, c = (e)=>{
                    Object.assign(t.auth.securityPolicyState.vendorMfaPolicy, e);
                }, u = (e)=>{
                    Object.assign(t.auth.securityPolicyState.lockoutPolicy, e);
                }, d = (e)=>{
                    Object.assign(t.auth.securityPolicyState.vendorLockoutPolicy, e);
                }, g = (e)=>{
                    Object.assign(t.auth.securityPolicyState.captchaPolicy, e);
                }, p = (e)=>{
                    Object.assign(t.auth.securityPolicyState.passwordHistoryPolicy, e);
                }, h = (e)=>{
                    Object.assign(t.auth.securityPolicyState.vendorPasswordHistoryPolicy, e);
                }, y = (e)=>{
                    Object.assign(t.auth.securityPolicyState.passwordRotationPolicy, e);
                }, S = (e)=>{
                    Object.assign(t.auth.securityPolicyState.passwordPolicy, e);
                }, m = (e)=>{
                    Object.assign(t.auth.securityPolicyState.publicAuthStrategyPolicy, e);
                }, b = async (t)=>{
                    o({
                        loading: !0,
                        error: null
                    });
                    try {
                        const a = await En(()=>e.auth.getGlobalSecurityPolicy(), null == t ? void 0 : t.retryConfig);
                        o({
                            policy: a,
                            loading: !1
                        });
                    } catch (t) {
                        o({
                            error: Un(t),
                            loading: !1
                        });
                    }
                }, A = async (t)=>{
                    l({
                        loading: !0,
                        error: null
                    });
                    try {
                        const a = await En(()=>e.auth.getMfaPolicy(), null == t ? void 0 : t.retryConfig);
                        l({
                            policy: a,
                            loading: !1
                        });
                    } catch (t) {
                        l({
                            error: Un(t),
                            loading: !1
                        });
                    }
                }, w = async (t)=>{
                    l({
                        loading: !0,
                        error: null
                    });
                    try {
                        const a = await En(()=>e.auth.getVendorMfaPolicy(), null == t ? void 0 : t.retryConfig);
                        c({
                            policy: a,
                            loading: !1
                        });
                    } catch (t) {
                        c({
                            error: Un(t),
                            loading: !1
                        });
                    }
                }, T = async (t)=>{
                    u({
                        loading: !0,
                        error: null
                    });
                    try {
                        const a = await En(()=>e.auth.getLockoutPolicy(), null == t ? void 0 : t.retryConfig);
                        u({
                            policy: a,
                            loading: !1
                        });
                    } catch (t) {
                        u({
                            error: Un(t),
                            loading: !1
                        });
                    }
                }, E = async (t)=>{
                    d({
                        loading: !0,
                        error: null
                    });
                    try {
                        const a = await En(()=>e.auth.getVendorLockoutPolicy(), null == t ? void 0 : t.retryConfig);
                        d({
                            policy: a,
                            loading: !1
                        });
                    } catch (t) {
                        d({
                            error: Un(t),
                            loading: !1
                        });
                    }
                }, I = async (t)=>{
                    u({
                        loading: !0,
                        error: null
                    });
                    try {
                        const a = await En(()=>e.auth.getCaptchaPolicy(), null == t ? void 0 : t.retryConfig);
                        g({
                            policy: a,
                            loading: !1
                        });
                    } catch (t) {
                        g({
                            error: Un(t),
                            loading: !1
                        });
                    }
                }, O = async (t)=>{
                    h({
                        loading: !0,
                        error: null
                    });
                    try {
                        const a = await En(()=>e.auth.getVendorPasswordHistoryPolicy(), null == t ? void 0 : t.retryConfig);
                        h({
                            policy: a,
                            loading: !1
                        });
                    } catch (t) {
                        h({
                            error: Un(t),
                            loading: !1
                        });
                    }
                }, P = async (e)=>{
                    m({
                        loading: !0,
                        error: null
                    });
                    try {
                        var a, s, o;
                        const l = await i(null == e ? void 0 : e.retryConfig);
                        await (async (e)=>{
                            var a, s;
                            const i = await n.customLoginEnabled();
                            if (!e || !i) return;
                            const { policy: o } = null != (a = null == (s = t.auth.securityPolicyState) ? void 0 : s.publicPolicy) ? a : {
                                policy: null
                            };
                            r({
                                policy: v({}, o, {
                                    authStrategy: e
                                }),
                                loading: !1
                            });
                        })(null == l || null == (a = l.mainAuthStrategies) || null == (s = a[0]) ? void 0 : s.strategy), m({
                            policy: l,
                            loading: !1
                        }), null == e || null == (o = e.callback) || o.call(e, l);
                    } catch (t) {
                        var l;
                        m({
                            error: Un(t),
                            loading: !1
                        }), null == e || null == (l = e.callback) || l.call(e, null, t);
                    }
                };
                return {
                    setSecurityPolicyState: (e)=>{
                        Object.assign(t.auth.securityPolicyState, e);
                    },
                    setSecurityPolicyGlobalState: o,
                    setSecurityPolicyPublicState: r,
                    setSecurityPolicyMfaState: l,
                    setSecurityPolicyVendorMfaState: c,
                    setSecurityPolicyLockoutState: u,
                    setSecurityPolicyVendorLockoutState: d,
                    setSecurityPolicyCaptchaState: g,
                    setSecurityPolicyPasswordHistoryState: p,
                    setSecurityPolicyVendorPasswordHistoryState: h,
                    setSecurityPolicyPasswordRotationState: y,
                    resetSecurityPolicyState: ()=>{
                        Rn(t, [
                            "auth",
                            "securityPolicyState"
                        ], Lr);
                    },
                    setSecurityPolicyPasswordState: S,
                    setSecurityPolicyAuthStrategyPublicState: m,
                    loadSecurityPolicy: async (t)=>{
                        const e = {
                            retryConfig: null == t ? void 0 : t.retryConfig
                        };
                        await Promise.all([
                            b(),
                            A(),
                            w(e),
                            T(e),
                            E(e),
                            O(),
                            I(e),
                            P(e)
                        ]);
                    },
                    loadGlobalSecurityPolicy: b,
                    loadPublicSecurityPolicy: async (t)=>{
                        r({
                            loading: !0,
                            error: null
                        });
                        try {
                            const a = await e.auth.getVendorConfig(), n = await s(a, null == t ? void 0 : t.retryConfig);
                            r({
                                policy: n,
                                loading: !1
                            });
                        } catch (t) {
                            r({
                                error: Un(t),
                                loading: !1
                            });
                        }
                    },
                    loadVendorPasswordConfig: async (t)=>{
                        S({
                            loading: !0,
                            error: null
                        });
                        try {
                            var a;
                            const n = await En(()=>e.auth.getPasswordConfigPolicy(), null == t ? void 0 : t.retryConfig);
                            S({
                                policy: n,
                                loading: !1
                            }), null == t || null == (a = t.callback) || a.call(t, n);
                        } catch (e) {
                            var n;
                            S({
                                error: Un(e),
                                loading: !1
                            }), null == t || null == (n = t.callback) || n.call(t, null, e);
                        }
                    },
                    loadSecurityPolicyMfa: A,
                    loadSecurityPolicyVendorMfa: w,
                    loadSecurityPolicyLockout: T,
                    loadSecurityPolicyVendorLockout: E,
                    loadSecurityPolicyCaptcha: I,
                    loadSecurityPolicyPasswordHistory: async ()=>{
                        p({
                            loading: !0,
                            error: null
                        });
                        try {
                            const t = await e.auth.getPasswordHistoryPolicy();
                            p({
                                policy: t,
                                loading: !1
                            });
                        } catch (t) {
                            p({
                                error: Un(t),
                                loading: !1
                            });
                        }
                    },
                    loadSecurityPolicyVendorPasswordHistory: O,
                    loadSecurityPolicyPasswordRotation: async ()=>{
                        y({
                            loading: !0,
                            error: null
                        });
                        try {
                            const t = await e.securityPolicy.getPasswordRotationPolicy(), a = await e.securityPolicy.getVendorPasswordRotationPolicy(), n = {
                                passwordRotationVendorConfig: a
                            };
                            t && (null != a && a.isActive ? n.passwordRotationTenantConfig = null != t && t.isActive ? v({}, t, {
                                rotationPeriod: Dr(a.rotationPeriod, t.rotationPeriod)
                            }) : a : n.passwordRotationTenantConfig = t), y({
                                policy: v({}, n),
                                loading: !1
                            });
                        } catch (t) {
                            y({
                                error: Un(t),
                                loading: !1
                            });
                        }
                    },
                    loadPublicAuthStrategiesPolicy: P,
                    saveSecurityPolicyMfa: async (t)=>{
                        const { callback: a } = t, n = f(t, Nr);
                        l({
                            saving: !0,
                            error: null
                        });
                        try {
                            const t = await e.auth.securityPolicy.saveMfaPolicy(n);
                            l({
                                policy: t,
                                saving: !1
                            }), null == a || a(t);
                        } catch (t) {
                            l({
                                saving: !1,
                                error: Un(t)
                            }), null == a || a(null, t);
                        }
                    },
                    saveSecurityPolicyLockout: async (t)=>{
                        const { callback: a } = t, n = f(t, Mr);
                        u({
                            saving: !0,
                            error: null
                        });
                        try {
                            const t = await e.auth.saveLockoutPolicy(n);
                            u({
                                policy: t,
                                saving: !1
                            }), null == a || a(t);
                        } catch (t) {
                            u({
                                saving: !1,
                                error: Un(t)
                            }), null == a || a(null, t);
                        }
                    },
                    saveSecurityPolicyPasswordHistory: async (t)=>{
                        const { callback: a } = t, n = f(t, Fr);
                        p({
                            saving: !0,
                            error: null
                        });
                        try {
                            const t = await e.auth.savePasswordHistoryPolicy(n);
                            p({
                                policy: t,
                                saving: !1
                            }), null == a || a(t);
                        } catch (t) {
                            p({
                                saving: !1,
                                error: Un(t)
                            }), null == a || a(null, t);
                        }
                    },
                    saveSecurityPolicyPasswordRotation: async (t)=>{
                        const { callback: a } = t, n = f(t, xr);
                        y({
                            saving: !0,
                            error: null
                        });
                        try {
                            await e.securityPolicy.savePasswordRotationPolicy(n.passwordRotationTenantConfig || {}), y({
                                policy: n,
                                saving: !1
                            }), null == a || a(n);
                        } catch (t) {
                            y({
                                saving: !1,
                                error: Un(t)
                            }), null == a || a(null, t);
                        }
                    },
                    __getSecurityPolicyPublicStateWithCustomLogin: s
                };
            }, $r = {
                loading: !1,
                configurations: {}
            }, jr = (t)=>Za($r, t), Br = [
                "callback"
            ], Vr = (t, e, a)=>{
                const n = a, s = (e)=>{
                    Object.assign(t.auth.sessionsPolicyState, e);
                };
                return {
                    setSessionsPolicyState: s,
                    resetSessionsPolicyState: ()=>{
                        Rn(t, [
                            "auth",
                            "sessionsPolicyState"
                        ], $r);
                    },
                    loadSessionsPolicy: async ()=>{
                        s({
                            loading: !0,
                            error: null
                        });
                        try {
                            const t = await e.auth.getSessionConfigurations();
                            s({
                                configurations: t,
                                loading: !1
                            });
                        } catch (t) {
                            n.setSessionsState({
                                error: t,
                                loading: !1
                            });
                        }
                    },
                    createOrUpdateSessionsPolicy: async (t)=>{
                        const { callback: a } = t, i = f(t, Br);
                        try {
                            s({
                                loading: !0,
                                error: null
                            }), await e.auth.createOrUpdateSessionConfigrations(i), await n.loadSessionsPolicy(), null == a || a(!0);
                        } catch (t) {
                            s({
                                error: t,
                                loading: !1
                            });
                        }
                    }
                };
            }, Wr = {
                loading: !1,
                sessions: []
            }, Hr = (t)=>Za(Wr, t), zr = (t, e, a)=>{
                const n = (e)=>{
                    Object.assign(t.auth.sessionsState, e);
                }, s = async (t)=>{
                    n({
                        loading: !0,
                        error: null
                    });
                    try {
                        const a = await En(()=>e.auth.getCurrentUserSessions(), null == t ? void 0 : t.retryConfig);
                        n({
                            sessions: a,
                            loading: !1
                        });
                    } catch (t) {
                        n({
                            error: Un(t),
                            loading: !1
                        });
                    }
                };
                return {
                    setSessionsState: n,
                    resetSessionsState: ()=>{
                        Rn(t, [
                            "auth",
                            "sessionsState"
                        ], Wr);
                    },
                    loadUserSessions: s,
                    loadCurrentUserSession: async ()=>{
                        n({
                            loading: !0,
                            error: null
                        });
                        try {
                            const t = await e.auth.getCurrentUserSession();
                            n({
                                currentSession: t,
                                loading: !1
                            });
                        } catch (t) {
                            n({
                                error: Un(t),
                                loading: !1
                            });
                        }
                    },
                    deleteUserSession: async (t)=>{
                        const { id: a } = t;
                        n({
                            loading: !0,
                            error: null
                        });
                        try {
                            await e.auth.deleteSessionForUser(a), await s();
                        } catch (t) {
                            n({
                                error: Un(t),
                                loading: !1
                            });
                        }
                    },
                    deleteAllUserSessions: async ()=>{
                        n({
                            loading: !0,
                            error: null
                        });
                        try {
                            await e.auth.deleteAllSessionsForUser(), await s();
                        } catch (t) {
                            n({
                                error: Un(t),
                                loading: !1
                            });
                        }
                    },
                    revokeUserSessions: async (t)=>{
                        const { callback: a, userId: s } = t;
                        n({
                            loading: !0,
                            error: null
                        });
                        try {
                            await e.auth.revokeSessionsForUser(s), n({
                                loading: !1
                            }), null == a || a(!0);
                        } catch (t) {
                            n({
                                error: Un(t),
                                loading: !1
                            }), null == a || a(!1);
                        }
                    }
                };
            };
            let Kr;
            !function(t) {
                t.SignUp = "SignUp", t.SignUpSuccess = "SignUpSuccess";
            }(Kr || (Kr = {}));
            const qr = {
                loading: !1,
                allowSignUps: !1,
                allowNotVerifiedUsersLogin: !1,
                firstLoad: !0,
                stage: Kr.SignUp
            }, Jr = (t)=>Za(qr, t), Yr = [
                "events",
                "url"
            ], Xr = (t, e, a)=>{
                const n = a, s = C.for(t.root.appName), i = (e)=>{
                    Object.assign(t.auth.signUpState, e);
                }, o = ()=>{
                    Rn(t, [
                        "auth",
                        "signUpState"
                    ], qr);
                };
                return {
                    setSignUpState: i,
                    resetSignUpState: o,
                    resetSignUpStateSoft: ()=>{
                        const { allowSignUps: e, allowNotVerifiedUsersLogin: a } = t.auth.signUpState;
                        o(), i({
                            allowSignUps: e,
                            allowNotVerifiedUsersLogin: a
                        });
                    },
                    signUpUser: async (a)=>{
                        const { events: o, url: r } = a, l = f(a, Yr);
                        i({
                            loading: !0
                        });
                        try {
                            const { routes: a, onRedirectTo: s } = t.auth, { shouldActivate: u, user: d, tenantId: g, userId: p, tenants: h = [], activeTenant: y, activationToken: S } = await e.auth.signUpUser(fs(l));
                            if (!l.invitationToken) {
                                var c;
                                const { email: t, name: e, companyName: a, phoneNumber: n } = l, s = {
                                    email: t,
                                    name: e,
                                    companyName: a,
                                    url: r,
                                    phoneNumber: n || void 0,
                                    authenticationType: Wn.PASSWORD,
                                    id: p,
                                    tenantId: g,
                                    createdAt: new Date,
                                    activationToken: S
                                };
                                null == o || null == (c = o.signUpComplete) || c.call(o, s), Jn(Kn.SIGNUP_COMPLETED, s);
                            }
                            if (!u && d && hs(d, t.root.appName)) {
                                const t = await n.getMfaRequiredState(d, An, !0, l.email);
                                n.setAuthState(t), s(a.loginUrl);
                            } else if (u && S) {
                                const t = new URLSearchParams({
                                    userId: p || "",
                                    token: S || ""
                                }), e = `${a.activateWithOTCUrl}?${t.toString()}`;
                                i({
                                    loading: !1,
                                    shouldActivate: u,
                                    stage: Kr.SignUpSuccess
                                }), s(e);
                            } else {
                                const e = t.auth.tenantsState;
                                i({
                                    loading: !1,
                                    shouldActivate: u,
                                    stage: Kr.SignUpSuccess
                                }), n.setAuthState({
                                    user: d,
                                    isAuthenticated: !(null == d || !d.accessToken),
                                    tenantsState: v({}, e, {
                                        tenants: h,
                                        activeTenant: y
                                    })
                                });
                            }
                        } catch (t) {
                            s.setAccessToken(null), s.setUser(null), i({
                                error: Un(t)
                            });
                        } finally{
                            i({
                                loading: !1
                            });
                        }
                    },
                    loadAllowSignUps: async (t)=>{
                        i({
                            loading: !0
                        });
                        try {
                            var a;
                            const s = await En(e.auth.getVendorConfig, null == t ? void 0 : t.retryConfig), o = await n.__getSecurityPolicyPublicStateWithCustomLogin(s, null == t ? void 0 : t.retryConfig), { allowSignups: r, allowNotVerifiedUsersLogin: l } = s;
                            i({
                                loading: !1,
                                allowSignUps: r,
                                allowNotVerifiedUsersLogin: l,
                                firstLoad: !1
                            }), n.setSecurityPolicyPublicState({
                                policy: o,
                                loading: !1
                            }), null == t || null == (a = t.callback) || a.call(t, o || s);
                        } catch (e) {
                            var s;
                            i({
                                loading: !1,
                                error: Un(e),
                                firstLoad: !1
                            }), null == t || null == (s = t.callback) || s.call(t, null, e);
                        }
                    }
                };
            }, Qr = {
                loading: !1,
                error: null,
                phoneNumbers: void 0
            }, Zr = (t)=>Za(Qr, t), tl = [
                "callback"
            ], el = [
                "callback"
            ], al = [
                "callback"
            ], nl = [
                "callback",
                "phoneId"
            ], sl = [
                "callback",
                "phoneId"
            ], il = [
                "callback"
            ], ol = (t, e, a)=>{
                const n = (e)=>{
                    Object.assign(t.auth.smsState, e);
                }, s = async ()=>{
                    n({
                        loading: !0
                    });
                    const t = {
                        _limit: 10,
                        _offset: 0
                    };
                    try {
                        const { items: a } = await e.userPhoneNumbers.getUserPhoneNumbers(t);
                        n({
                            phoneNumbers: a
                        });
                    } catch (t) {
                        n({
                            error: Un(t)
                        });
                    } finally{
                        n({
                            loading: !1
                        });
                    }
                }, i = async ()=>{
                    n({
                        loading: !0
                    });
                    try {
                        const t = await e.userPhoneNumbers.getUserOwnPhoneNumbers();
                        n({
                            phoneNumbers: t
                        });
                    } catch (t) {
                        n({
                            error: Un(t)
                        });
                    } finally{
                        n({
                            loading: !1
                        });
                    }
                };
                return {
                    setSmsState: n,
                    resetSmsState: ()=>{
                        Rn(t, [
                            "auth",
                            "smsState"
                        ], Qr);
                    },
                    loadPhoneNumbers: s,
                    loadUserOwnPhoneNumbers: i,
                    setUpPhoneNumber: async (t)=>{
                        const { callback: a } = t, i = f(t, el);
                        try {
                            const { otcToken: t } = await e.userPhoneNumbers.createPhoneNumber(i);
                            n({
                                otcToken: t
                            }), await s(), null == a || a(!0);
                        } catch (t) {
                            n({
                                error: Un(t)
                            }), null == a || a(!1, t);
                        }
                    },
                    setUpOwnPhoneNumber: async (t)=>{
                        const { callback: a } = t, s = f(t, tl);
                        try {
                            const { otcToken: t } = await e.userPhoneNumbers.createPhoneNumber(s);
                            n({
                                otcToken: t
                            }), await i(), null == a || a(!0);
                        } catch (t) {
                            n({
                                error: Un(t)
                            }), null == a || a(!1, t);
                        }
                    },
                    verifyPhoneNumber: async (t)=>{
                        const { callback: a } = t, i = f(t, al);
                        n({
                            loading: !0
                        });
                        try {
                            await e.userPhoneNumbers.verifyPhoneNumber(i), await s(), null == a || a(!0);
                        } catch (t) {
                            n({
                                error: Un(t)
                            }), null == a || a(!1, t);
                        } finally{
                            n({
                                loading: !1
                            });
                        }
                    },
                    deletePhoneNumber: async (t)=>{
                        const { callback: a, phoneId: s } = t;
                        f(t, nl), n({
                            loading: !0
                        });
                        try {
                            const { otcToken: t } = await e.userPhoneNumbers.deletePhoneNumber(s);
                            n({
                                otcToken: t
                            }), null == a || a(!0);
                        } catch (t) {
                            n({
                                error: Un(t)
                            }), null == a || a(!1, t);
                        } finally{
                            n({
                                loading: !1
                            });
                        }
                    },
                    verifyDeletePhoneNumber: async (t)=>{
                        const { callback: a, phoneId: i } = t, o = f(t, sl);
                        n({
                            loading: !0
                        });
                        try {
                            await e.userPhoneNumbers.verifyDeletePhoneNumber(i, o), await s(), null == a || a(!0);
                        } catch (t) {
                            n({
                                error: Un(t)
                            }), null == a || a(!1, t);
                        } finally{
                            n({
                                loading: !1
                            });
                        }
                    },
                    preVerifyPhoneNumber: async (t)=>{
                        const { callback: a } = t, s = f(t, il);
                        n({
                            loading: !0
                        });
                        try {
                            const { otcToken: t } = await e.userPhoneNumbers.preVerifyPhoneNumber(s);
                            n({
                                otcToken: t
                            }), null == a || a(!0);
                        } catch (t) {
                            n({
                                error: Un(t)
                            }), null == a || a(!1, t);
                        } finally{
                            n({
                                loading: !1
                            });
                        }
                    }
                };
            }, rl = {
                firstLoad: !0,
                loading: !1,
                error: ""
            }, ll = (t)=>Za(rl, t), cl = [
                "authorizationUrl"
            ], ul = [
                "events",
                "url"
            ], dl = (t, e, a)=>{
                const n = a, s = (e)=>{
                    Object.assign(t.auth.socialLoginState, e);
                };
                return {
                    setSocialLoginsState: s,
                    resetSocialLoginsState: ()=>{
                        Rn(t, [
                            "auth",
                            "socialLoginState"
                        ], rl);
                    },
                    setSocialLoginError: (t)=>{
                        s({
                            error: t.error,
                            loading: !1,
                            firstLoad: !1
                        });
                    },
                    loadSocialLoginsConfiguration: async ()=>{
                        try {
                            s({
                                loading: !0
                            });
                            const t = await e.auth.getSocialLoginProviders();
                            s({
                                socialLoginsConfig: t,
                                loading: !1,
                                firstLoad: !1
                            });
                        } catch (t) {
                            s({
                                error: Un(t),
                                loading: !1,
                                firstLoad: !1
                            });
                        }
                    },
                    loadSocialLoginsConfigurationV2: async (a)=>{
                        try {
                            var n;
                            const i = t.root.context;
                            s({
                                loading: !0
                            });
                            const o = await (async (a)=>{
                                let n;
                                return n = t.auth.isAuthenticated ? await En(e.auth.getSocialLoginProvidersV2ForAuthenticatedUser, a) : await En(e.auth.getSocialLoginProvidersV2, a), n;
                            })(null == a ? void 0 : a.retryConfig), { providers: r } = await En(e.auth.getCustomSocialLoginProvidersV1, null == a ? void 0 : a.retryConfig), l = {
                                socialLoginsConfigV2: o.map((t)=>{
                                    let { authorizationUrl: a } = t, n = f(t, cl);
                                    const s = e.fetch.getBaseUrl(i, null != a ? a : "");
                                    return v({}, n, {
                                        authorizationUrl: a ? `${s}${a}` : null
                                    });
                                }),
                                customSocialLoginsConfig: r,
                                loading: !1,
                                firstLoad: !1
                            };
                            s(l), null == a || null == (n = a.callback) || n.call(a, l);
                        } catch (t) {
                            var i;
                            null == a || null == (i = a.callback) || i.call(a, null, t), s({
                                error: Un(t),
                                loading: !1,
                                firstLoad: !1
                            });
                        }
                    },
                    loginViaSocialLogin: async (t)=>{
                        const { events: a, url: i } = t, o = f(t, ul);
                        try {
                            s({
                                loading: !0
                            });
                            const { email: t, isNewUser: c, userId: u, tenantId: d, name: g } = await e.auth.loginViaSocialLogin(o);
                            if (c) {
                                var r, l;
                                const e = {
                                    email: t,
                                    url: i,
                                    createdAt: new Date,
                                    id: u,
                                    tenantId: d
                                }, n = v({}, e, {
                                    socialProvider: o.provider,
                                    authenticationType: Wn.SOCIAL_LOGIN
                                });
                                null == a || null == (r = a.signUpComplete) || r.call(a, n), Jn(Kn.SIGNUP_COMPLETED, n);
                                const s = v({}, e, {
                                    origin: Vn.SOCIAL_LOGIN,
                                    name: g
                                });
                                null == a || null == (l = a.userVerified) || l.call(a, s), Jn(Kn.USER_VERIFIED, s);
                            }
                            u && localStorage.setItem("userId", u), n.setLoginState({
                                email: t,
                                isNewUser: c
                            }), n.refreshTokenForSocialLogins(), localStorage.removeItem("register-quick-login"), s({
                                loading: !1
                            });
                        } catch (t) {
                            s({
                                loading: !1,
                                error: Un(t, "Failed to authenticate"),
                                firstLoad: !1
                            });
                        }
                    }
                };
            }, gl = {
                firstLoad: !0,
                loading: !0,
                saving: !1,
                errors: {},
                loaders: {},
                ssoConfigurations: []
            }, pl = (t)=>Za(gl, t), hl = [
                "callback",
                "samlVendor"
            ], yl = [
                "callback"
            ], Sl = [
                "callback",
                "ssoConfigId"
            ], vl = [
                "callback",
                "ssoConfigId"
            ], fl = [
                "callback",
                "ssoConfigId"
            ], ml = (t, e, a)=>v({}, ((t, e, a)=>{
                    const n = a, s = async ()=>{
                        try {
                            const t = await e.auth.getSamlRoles(), a = await e.auth.getSamlRolesGroups();
                            i({
                                authorizationRoles: t.roleIds,
                                rolesGroups: a,
                                error: void 0
                            });
                        } catch (t) {
                            i({
                                error: Un(t)
                            });
                        }
                    }, i = (e)=>{
                        Object.assign(t.auth.ssoState, e);
                    };
                    return {
                        setSSOState: i,
                        resetSSOState: ()=>{
                            Rn(t, [
                                "auth",
                                "ssoState"
                            ], gl);
                        },
                        setSSOLoader: (e)=>{
                            Object.assign(t.auth.ssoState, {
                                loaders: v({}, t.auth.ssoState.loaders, {
                                    [e.key]: e.value
                                })
                            });
                        },
                        setSSOError: (e)=>{
                            Object.assign(t.auth.ssoState, {
                                errors: v({}, t.auth.ssoState.errors, {
                                    [e.key]: e.value
                                }),
                                loaders: v({}, t.auth.ssoState.loaders, {
                                    [e.key]: !1
                                })
                            });
                        },
                        loadSSOConfigurations: async ()=>{
                            try {
                                var t, a;
                                i({
                                    loading: !0
                                });
                                const n = await e.auth.getSamlConfiguration(), s = await e.auth.getOidcConfiguration(), o = await e.metadata.getSamlMetadata();
                                n.acsUrl = null == o || null == (t = o.configuration) ? void 0 : t.acsUrl, n.spEntityId = null == o || null == (a = o.configuration) ? void 0 : a.spEntityId, n.isSamlActive = null == o ? void 0 : o.isActive, i({
                                    samlConfiguration: n,
                                    oidcConfiguration: s,
                                    loading: !1,
                                    firstLoad: !1
                                });
                            } catch (t) {
                                i({
                                    error: Un(t),
                                    loading: !1
                                });
                            }
                        },
                        saveSSOConfigurations: async (a)=>{
                            const { callback: n, samlVendor: s } = a, o = f(a, hl), r = t.auth.ssoState.samlConfiguration, l = v({}, r, o);
                            let c = "saving";
                            (null == l ? void 0 : l.enabled) !== (null == r ? void 0 : r.enabled) && (c = "loading");
                            try {
                                if (null == l || !l.domain) return void i({
                                    samlConfiguration: v({}, r, l)
                                });
                                if (i({
                                    error: void 0,
                                    [c]: !0
                                }), a.type === no.Saml) {
                                    var u, d;
                                    const t = await e.metadata.getSamlMetadata();
                                    l.acsUrl = null == t || null == (u = t.configuration) ? void 0 : u.acsUrl, l.spEntityId = null == t || null == (d = t.configuration) ? void 0 : d.spEntityId;
                                }
                                const t = Pn(l, [
                                    "validated",
                                    "generatedVerification",
                                    "createdAt",
                                    "updatedAt"
                                ]);
                                (null == r ? void 0 : r.domain) !== (null == t ? void 0 : t.domain) && (t.ssoEndpoint = "", t.publicCertificate = "", t.signRequest = !1), t.type = null == s ? void 0 : s.toLowerCase();
                                const o = await e.auth.updateSamlConfiguration(t);
                                o.isSamlActive = null == r ? void 0 : r.isSamlActive, i({
                                    samlConfiguration: o,
                                    error: void 0,
                                    [c]: !1
                                }), null == n || n(!0);
                            } catch (t) {
                                i({
                                    samlConfiguration: r,
                                    error: Un(t),
                                    [c]: !1
                                }), null == n || n(null, t);
                            }
                        },
                        saveSSOConfigurationsFile: async (a)=>{
                            const n = t.auth.ssoState.samlConfiguration, s = "saving";
                            i({
                                error: void 0,
                                [s]: !0
                            });
                            try {
                                const t = await Pi(a[0]), o = await e.auth.updateSamlVendorMetadata({
                                    metadata: t
                                });
                                o.isSamlActive = null == n ? void 0 : n.isSamlActive, i({
                                    samlConfiguration: o,
                                    error: void 0,
                                    [s]: !1
                                });
                            } catch (t) {
                                i({
                                    samlConfiguration: n,
                                    error: Un(t),
                                    [s]: !1
                                });
                            }
                        },
                        saveSSOConfigurationsFileWithCallback: async (a)=>{
                            const { configFile: n, callback: s } = a, o = t.auth.ssoState.samlConfiguration, r = "saving";
                            i({
                                error: void 0,
                                [r]: !0
                            });
                            try {
                                const t = await Pi(n), a = await e.auth.updateSamlVendorMetadata({
                                    metadata: t
                                });
                                a.isSamlActive = null == o ? void 0 : o.isSamlActive, i({
                                    samlConfiguration: a,
                                    error: void 0,
                                    [r]: !1
                                }), null == s || s(!0);
                            } catch (t) {
                                i({
                                    samlConfiguration: o,
                                    error: Un(t),
                                    [r]: !1
                                }), null == s || s(null, t);
                            }
                        },
                        validateSSODomain: async (a)=>{
                            const { callback: n } = null != a ? a : {}, s = t.auth.ssoState.samlConfiguration;
                            if (!s) {
                                const t = new Error("IllegalState: samlConfiguration is not defined");
                                return console.error(t), void (null == n || n(null, t));
                            }
                            try {
                                i({
                                    error: void 0,
                                    saving: !0
                                }), await e.auth.validateSamlDomain(), i({
                                    samlConfiguration: v({}, s, {
                                        validated: !0
                                    }),
                                    error: void 0,
                                    saving: !1
                                }), null == n || n(!0);
                            } catch (t) {
                                i({
                                    samlConfiguration: v({}, s, {
                                        validated: !1
                                    }),
                                    error: Un(t),
                                    saving: !1
                                }), null == n || n(null, t);
                            }
                        },
                        loadSSOAuthorizationRoles: async ()=>{
                            try {
                                const t = await e.auth.getSamlRoles(), a = await e.auth.getSamlRolesGroups();
                                i({
                                    authorizationRoles: t.roleIds,
                                    rolesGroups: a,
                                    error: void 0
                                });
                            } catch (t) {
                                i({
                                    error: Un(t)
                                });
                            }
                        },
                        updateSSOAuthorizationRoles: async (t)=>{
                            const { callback: a, authorizationRoles: n, groups: o } = t;
                            try {
                                i({
                                    error: void 0,
                                    saving: !0
                                }), await e.auth.updateSamlRoles({
                                    roleIds: n
                                }), o && await (async (t)=>{
                                    try {
                                        await Promise.all(t.map((t)=>e.auth.updateSamlGroup({
                                                id: t.id,
                                                roleIds: t.roleIds,
                                                group: t.group
                                            })));
                                    } catch (t) {
                                        i({
                                            error: Un(t)
                                        });
                                    }
                                })(o), await s(), i({
                                    error: void 0,
                                    saving: !1
                                }), null == a || a(!0);
                            } catch (t) {
                                i({
                                    error: Un(t),
                                    saving: !1
                                }), null == a || a(null, t);
                            }
                        },
                        deleteSamlGroup: async (t)=>{
                            const { id: a, callback: n } = t;
                            try {
                                i({
                                    error: void 0,
                                    saving: !0
                                }), await e.auth.deleteSamlGroup({
                                    id: a
                                }), await s(), i({
                                    error: void 0,
                                    saving: !1
                                }), null == n || n(!0);
                            } catch (t) {
                                i({
                                    error: Un(t),
                                    saving: !1
                                }), null == n || n(null, t);
                            }
                        },
                        createSamlGroup: async (t)=>{
                            const { group: a, roleIds: n, callback: o } = t;
                            try {
                                i({
                                    error: void 0,
                                    saving: !0
                                }), await e.auth.createSamlGroup({
                                    group: a,
                                    roleIds: n
                                }), await s(), i({
                                    error: void 0,
                                    saving: !1
                                }), null == o || o(!0);
                            } catch (t) {
                                i({
                                    error: Un(t),
                                    saving: !1
                                }), null == o || o(null, t);
                            }
                        },
                        oidcPostlogin: async (t)=>{
                            const a = {
                                code: t.code,
                                redirectUri: t.redirectUri,
                                RelayState: t.state
                            };
                            try {
                                i({
                                    loading: !0
                                }), await e.auth.oidcPostLoginV2(a), await n.__refreshToken(), i({
                                    loading: !1
                                });
                            } catch (t) {
                                i({
                                    loading: !1,
                                    error: Un(t, "Failed to authenticate"),
                                    firstLoad: !1
                                });
                            }
                        }
                    };
                })(t, e, a), ((t, e, a)=>{
                    const n = a, s = async (t)=>{
                        try {
                            return await En(()=>e.auth.getOidcConfiguration(), t);
                        } catch (t) {
                            return null;
                        }
                    }, i = async (t)=>{
                        try {
                            return await En(()=>e.metadata.getSamlMetadata(), t);
                        } catch (t) {
                            return null;
                        }
                    }, o = async (t, e, a)=>{
                        n.setSSOLoader({
                            key: t,
                            value: !0
                        });
                        try {
                            await a();
                        } catch (a) {
                            n.setSSOError({
                                key: t,
                                value: Un(a)
                            }), null == e || e(null, a);
                        } finally{
                            n.setSSOLoader({
                                key: t,
                                value: !1
                            });
                        }
                    };
                    return {
                        loadSSOConfigurationsV2: async (t)=>{
                            await o(ao.LOAD_SSO_CONFIGURATIONS, void 0, async ()=>{
                                const [a, o] = await Promise.all([
                                    s(null == t ? void 0 : t.retryConfig),
                                    i(null == t ? void 0 : t.retryConfig)
                                ]), r = await En(()=>e.auth.getSSOConfigurations(), null == t ? void 0 : t.retryConfig);
                                n.setSSOState({
                                    ssoConfigurations: r,
                                    oidcConfiguration: a,
                                    samlMetadata: o
                                });
                            });
                        },
                        saveSSOConfigurationV2: async (a)=>{
                            const { callback: s } = a, i = f(a, yl), r = t.auth.ssoState.ssoConfigurations;
                            await o(ao.SAVE_SSO_CONFIGURATION, s, async ()=>{
                                var t;
                                const a = await e.auth.createSSOConfiguration(v({}, i, {
                                    enabled: null != (t = i.enabled) && t
                                }));
                                n.setSSOState({
                                    ssoConfigurations: [
                                        ...r,
                                        a
                                    ]
                                }), null == s || s(a);
                            });
                        },
                        updateSSOConfiguration: async (a)=>{
                            const { callback: s, ssoConfigId: i } = a, r = f(a, Sl), l = t.auth.ssoState.ssoConfigurations;
                            await o(ao.UPDATE_SSO_CONFIGURATION, s, async ()=>{
                                const t = await e.auth.updateSSOConfiguration(i, r), a = l.map((e)=>e.id === i ? t : e);
                                n.setSSOState({
                                    ssoConfigurations: a
                                }), null == s || s(t);
                            });
                        },
                        deleteSSOConfiguration: async (a)=>{
                            const { ssoConfigId: s, callback: i } = a, r = t.auth.ssoState.ssoConfigurations;
                            await o(ao.DELETE_SSO_CONFIGURATION, i, async ()=>{
                                await e.auth.deleteSSOConfiguration(s), n.setSSOState({
                                    ssoConfigurations: r.filter(({ id: t })=>t !== s)
                                }), null == i || i(!0);
                            });
                        },
                        saveSSODomain: async (a)=>{
                            const { callback: s, ssoConfigId: i } = a, r = f(a, vl), l = t.auth.ssoState.ssoConfigurations;
                            await o(ao.SAVE_SSO_DOMAIN, s, async ()=>{
                                const t = await e.auth.createSSODomain(i, r), a = l.map((e)=>e.id === i ? v({}, e, {
                                        domains: [
                                            ...e.domains,
                                            t
                                        ]
                                    }) : e);
                                n.setSSOState({
                                    ssoConfigurations: a
                                }), null == s || s(t);
                            });
                        },
                        deleteSSODomain: async (a)=>{
                            const { ssoConfigId: s, domainId: i, callback: r } = a, l = t.auth.ssoState.ssoConfigurations;
                            await o(ao.DELETE_SSO_DOMAIN, r, async ()=>{
                                await e.auth.deleteSSODomain(s, i);
                                const t = l.map((t)=>t.id === s ? v({}, t, {
                                        domains: t.domains.filter(({ id: t })=>t !== i)
                                    }) : t);
                                n.setSSOState({
                                    ssoConfigurations: t
                                }), null == r || r(!0);
                            });
                        },
                        validateSSODomainV2: async (a)=>{
                            const { callback: s, domainId: i, ssoConfigId: r } = a;
                            await o(ao.VALIDATE_SSO_DOMAIN, s, async ()=>{
                                const a = t.auth.ssoState.ssoConfigurations;
                                await e.auth.validateSSODomainV2(r, i);
                                const o = a.map((t)=>t.id === r ? v({}, t, {
                                        domains: t.domains.map((t)=>t.id === i ? v({}, t, {
                                                validated: !0
                                            }) : t)
                                    }) : t);
                                n.setSSOState({
                                    ssoConfigurations: o
                                }), null == s || s(!0);
                            });
                        },
                        setSSOGroups: async (a)=>{
                            const { groupsToAdd: s, groupsToDelete: i, ssoConfigId: r, callback: l } = a;
                            await o(ao.SAVE_SSO_GROUPS, l, async ()=>{
                                const a = t.auth.ssoState.ssoConfigurations;
                                await Promise.all(i.map((t)=>e.auth.deleteSSOGroup(r, t))), await Promise.all(s.map((t)=>e.auth.createSSOGroup(r, t)));
                                const o = await e.auth.getSSOGroups(r), c = a.map((t)=>t.id === r ? v({}, t, {
                                        groups: o
                                    }) : t);
                                n.setSSOState({
                                    ssoConfigurations: c
                                }), null == l || l(!0);
                            });
                        },
                        updateSSOGroups: async (t)=>{
                            const { ssoConfigId: a, changedGroups: n, callback: s } = t;
                            await o(ao.SAVE_SSO_GROUPS, s, async ()=>{
                                await Promise.all(n.map((t)=>e.auth.updateSSOGroup(a, t))), null == s || s(!0);
                            });
                        },
                        setSSODefaultRoles: async (a)=>{
                            const { callback: s, ssoConfigId: i, roleIds: r } = a;
                            await o(ao.UPDATE_SSO_DEFAULT_ROLES, s, async ()=>{
                                const a = t.auth.ssoState.ssoConfigurations;
                                await e.auth.setSSODefaultRoles(i, {
                                    roleIds: r
                                });
                                const o = a.map((t)=>t.id === i ? v({}, t, {
                                        roleIds: r
                                    }) : t);
                                n.setSSOState({
                                    ssoConfigurations: o
                                }), null == s || s(!0);
                            });
                        },
                        saveSSOConfigurationByMetadata: async (a)=>{
                            const { configFile: s, callback: i } = a;
                            await o(ao.SAVE_SSO_CONFIGURATION_BY_METADATA, i, async ()=>{
                                const a = t.auth.ssoState.ssoConfigurations, o = await Pi(s), r = await e.auth.createSSOConfigurationByMetadata({
                                    metadata: o
                                });
                                n.setSSOState({
                                    ssoConfigurations: [
                                        ...a,
                                        r
                                    ]
                                }), null == i || i(r);
                            });
                        },
                        updateSSOConfigurationByMetadata: async (a)=>{
                            const { callback: s, ssoConfigId: i, configFile: r } = a;
                            await o(ao.UPDATE_SSO_CONFIGURATION_BY_METADATA, s, async ()=>{
                                const a = t.auth.ssoState.ssoConfigurations, o = await Pi(r), l = await e.auth.updateSSOConfigurationByMetadata(i, {
                                    metadata: o
                                }), c = a.map((t)=>t.id === i ? l : t);
                                n.setSSOState({
                                    ssoConfigurations: c
                                }), null == s || s(l);
                            });
                        },
                        saveSSOConfigurationByUrl: async (a)=>{
                            const { metadataUrl: s, configMetadata: i, ssoConfigId: r, callback: l } = a;
                            await o(ao.SAVE_SSO_CONFIGURATION_BY_METADATA, l, async ()=>{
                                const a = t.auth.ssoState.ssoConfigurations, o = {
                                    url: s,
                                    configMetadata: i
                                };
                                let c, u;
                                r ? (c = await e.auth.updateSSOConfigurationByMetadataUrl(r, o), u = a.map((t)=>t.id === r ? c : t)) : (c = await e.auth.createSSOConfigurationByMetadataUrl(o), u = [
                                    c,
                                    ...a
                                ]), n.setSSOState({
                                    ssoConfigurations: u
                                }), null == l || l(c);
                            });
                        },
                        saveSSOConfigurationByData: async (a)=>{
                            const { callback: s, ssoConfigId: i } = a, r = f(a, fl), l = t.auth.ssoState.ssoConfigurations;
                            await o(ao.SAVE_SSO_CONFIGURATION, s, async ()=>{
                                let t, a;
                                i ? (t = await e.auth.updateSSOConfiguration(i, r), a = l.map((e)=>e.id === i ? t : e)) : (t = await e.auth.createSSOConfiguration(r), a = [
                                    t,
                                    ...l
                                ]), n.setSSOState({
                                    ssoConfigurations: a
                                }), null == s || s(t);
                            });
                        }
                    };
                })(t, e, a)), bl = {
                loading: !1,
                mfaDevices: void 0,
                mfaToken: ""
            }, Al = (t)=>Za(bl, t), wl = (t, e, a)=>{
                const n = a;
                return v({
                    setStepUpState: (e)=>{
                        Object.assign(t.auth.stepUpState, e);
                    },
                    resetStepUpState: ()=>{
                        Rn(t, [
                            "auth",
                            "stepUpState"
                        ], bl);
                    },
                    stepUpWithAuthenticator: async (t)=>{
                        await n.mfaWithAuthenticator(t, n.setStepUpState, !0);
                    },
                    preVerifyMFASMSForStepUp: async (t)=>{
                        await n.preVerifyMFASMS(t, n.setStepUpState);
                    },
                    verifyMFASMSForStepUp: async (t)=>{
                        await n.verifyMFASMS(t, n.setStepUpState, !0);
                    },
                    preVerifyMFAWebAuthnForStepUp: async (t)=>{
                        await n.preVerifyMFAWebAuthn(t, n.setStepUpState);
                    },
                    verifyMFAWebAuthnForStepUp: async (t)=>{
                        await n.verifyMFAWebAuthn(t, n.setStepUpState, !0);
                    },
                    preVerifyMFAEmailCodeForStepUp: async (t)=>{
                        await n.preVerifyMFAEmailCode(t, n.setStepUpState);
                    },
                    verifyMFAEmailCodeForStepUp: async (t)=>{
                        await n.verifyMFAEmailCode(t, n.setStepUpState);
                    }
                }, ((t, e, a)=>{
                    const n = a;
                    return {
                        generateStepUpSession: async (a)=>{
                            const { maxAge: s, callback: i } = a;
                            n.setStepUpState({
                                mfaDevices: void 0,
                                mfaToken: ""
                            });
                            try {
                                const t = await e.auth.generateStepupSession({
                                    maxAge: s
                                });
                                t.hasOwnProperty("user") ? await (async (t)=>{
                                    await n.afterAuthenticationStateUpdate(t), await n.afterStepUpAuthNavigation();
                                })(t) : await (async ({ mfaToken: t, mfaDevices: e })=>{
                                    n.setStepUpState({
                                        mfaDevices: e,
                                        mfaToken: t
                                    });
                                    const a = await ns(e);
                                    n.setMfaState({
                                        step: a
                                    });
                                })(t), null == i || i(!0);
                            } catch (e) {
                                null == i || i(!1), await (async (e)=>{
                                    if (((t)=>"MFA is not enrolled" === (null == t ? void 0 : t.message))(e)) return void n.setMfaState({
                                        step: qn.noMFAEnrolledStepUp
                                    });
                                    window.localStorage.setItem(dn, "true");
                                    const a = t.auth.routes;
                                    C.for(t.root.appName).onRedirectTo(a.logoutUrl, {
                                        preserveQueryParams: !0
                                    });
                                })(e);
                            }
                        }
                    };
                })(t, e, a), ((t, e, a)=>{
                    const n = a;
                    return {
                        stepUpHostedLogin: async (e)=>{
                            var a, s;
                            const i = {
                                acr_values: ln
                            }, { maxAge: o } = e || {};
                            void 0 !== o && (i.max_age = o.toString());
                            const r = null == (a = t.auth.tenantsState) || null == (s = a.activeTenant) ? void 0 : s.alias;
                            r && (i.organization = r), us(), window.localStorage.setItem(dn, "true"), await n.__requestHostedLoginAuthorize(i);
                        }
                    };
                })(t, 0, a));
            }, Tl = {
                loaders: {},
                pageOffset: 0,
                pageSize: 20,
                errors: {},
                users: [],
                allUsers: [],
                roles: [],
                permissions: [],
                totalPages: 0,
                shouldShowSubTenantUsersIfReseller: !1,
                allUsersQueryParams: {
                    _filter: null,
                    _offset: 0,
                    _limit: 20,
                    _order: "DESC",
                    _sortBy: "name"
                },
                addUserDialogState: {
                    loading: !1,
                    open: !1
                },
                deleteUserDialogState: {
                    loading: !1,
                    open: !1
                },
                lockUserDialogState: {
                    loading: !1,
                    open: !1
                },
                enableUserDialogState: {
                    loading: !1,
                    open: !1
                },
                disableUserDialogState: {
                    loading: !1,
                    open: !1
                }
            }, El = (t)=>Za(Tl, t), Il = [
                "callback",
                "appIds"
            ], Ol = [
                "roles"
            ], Pl = [
                "callback",
                "profileImage"
            ], kl = [
                "callback"
            ], _l = [
                "callback"
            ], Rl = [
                "callback"
            ], Cl = [
                "callback",
                "userId"
            ], Ll = [
                "callback"
            ], Ul = [
                "callback"
            ], Dl = [
                "callback"
            ], Nl = [
                "callback"
            ], Ml = [
                "callback"
            ], Fl = [
                "callback"
            ], xl = (t, e, a)=>{
                const n = (e)=>{
                    Object.assign(t.auth.teamState, e);
                };
                return v({
                    setTeamLoader: (e)=>{
                        Object.assign(t.auth.teamState, {
                            loaders: v({}, t.auth.teamState.loaders, {
                                [e.key]: e.value
                            })
                        });
                    },
                    setTeamError: (e)=>{
                        Object.assign(t.auth.teamState, {
                            errors: v({}, t.auth.teamState.errors, {
                                [e.key]: e.value
                            }),
                            loaders: v({}, t.auth.teamState.loaders, {
                                [e.key]: !1
                            })
                        });
                    },
                    setTeamState: n,
                    resetTeamState: ()=>{
                        Rn(t, [
                            "auth",
                            "teamState"
                        ], Tl);
                    },
                    openAddUserDialog: (t)=>{
                        n({
                            addUserDialogState: v({
                                open: !0,
                                loading: !1,
                                error: !1
                            }, t)
                        });
                    },
                    closeAddUserDialog: (e)=>{
                        var a, s;
                        null == (a = (s = t.auth.teamState.addUserDialogState).onClose) || a.call(s, e), n({
                            addUserDialogState: {
                                loading: !1,
                                error: !1,
                                open: !1
                            }
                        });
                    },
                    openDeleteUserDialog: (t)=>{
                        n({
                            deleteUserDialogState: v({
                                open: !0,
                                loading: !1,
                                error: !1
                            }, t)
                        });
                    },
                    closeDeleteUserDialog: (e)=>{
                        var a, s;
                        null == (a = (s = t.auth.teamState.deleteUserDialogState).onClose) || a.call(s, e), n({
                            deleteUserDialogState: {
                                loading: !1,
                                error: !1,
                                open: !1
                            }
                        });
                    },
                    lockUser: async (t)=>{}
                }, ((t, e, a)=>{
                    const n = a, s = async (t)=>{
                        try {
                            const { groups: a } = await En(()=>e.groups.getGroups({
                                    _groupsRelations: Ma.roles
                                }), t);
                            return a;
                        } catch (t) {
                            return [];
                        }
                    }, i = async (t)=>{
                        n.setTeamLoader({
                            key: bs.ROLES_AND_PERMISSIONS,
                            value: !0
                        });
                        try {
                            var a;
                            const s = null == t ? void 0 : t.retryConfig, [{ items: i }, { items: o }] = await Promise.all([
                                En(()=>e.teams.loadAvailableRoles(), s),
                                En(()=>e.teams.loadAvailablePermissions(), s)
                            ]);
                            n.setTeamState({
                                roles: i,
                                permissions: o
                            }), null == t || null == (a = t.callback) || a.call(t, {
                                roles: i,
                                permissions: o
                            });
                        } catch (e) {
                            var s;
                            null == t || null == (s = t.callback) || s.call(t, null, e), n.setTeamError({
                                key: bs.ROLES_AND_PERMISSIONS,
                                value: Un(e)
                            });
                        } finally{
                            n.setTeamLoader({
                                key: bs.ROLES_AND_PERMISSIONS,
                                value: !1
                            });
                        }
                    };
                    return {
                        loadRoles: i,
                        loadUsers: async (a)=>{
                            var s, o, r, l;
                            const { silentLoading: c, callback: u } = a, d = t.auth.teamState, g = null != (s = a.pageSize) ? s : d.pageSize, p = null != (o = a.pageOffset) ? o : d.pageOffset, h = null != (r = a.filter) ? r : d.filter, y = null != (l = a.sort) ? l : d.sort;
                            n.setTeamLoader({
                                key: bs.USERS,
                                value: !c
                            }), n.setTeamState({
                                pageSize: g,
                                pageOffset: p,
                                filter: h,
                                sort: y
                            });
                            try {
                                const [{ items: t, totalPages: a, totalItems: s }] = await Promise.all([
                                    e.teams.loadUsers({
                                        pageSize: g,
                                        pageOffset: p,
                                        filter: h,
                                        sort: y
                                    }),
                                    i()
                                ]);
                                n.setTeamState({
                                    users: t,
                                    totalPages: a,
                                    totalItems: s
                                }), null == u || u(t);
                            } catch (t) {
                                n.setTeamError({
                                    key: bs.USERS,
                                    value: Un(t)
                                }), n.setTeamState({
                                    totalPages: 0,
                                    users: []
                                }), null == u || u(null, t);
                            }
                            n.setTeamLoader({
                                key: bs.USERS,
                                value: !1
                            });
                        },
                        loadUsersV2: async (o)=>{
                            var r, l, c, u, d;
                            const { silentLoading: g, callback: p, shouldLoadRoles: h = !0, shouldLoadApps: y, retryConfig: S } = o, f = t.auth.teamState, m = null != (r = o.pageSize) ? r : f.pageSize, b = null != (l = o.pageOffset) ? l : f.pageOffset, A = null != (c = o.filter) ? c : f.filterV2, w = null != (u = o.sort) ? u : f.sortV2, T = null != (d = null == o ? void 0 : o.shouldShowSubTenantUsersIfReseller) ? d : null == f ? void 0 : f.shouldShowSubTenantUsersIfReseller;
                            n.setTeamLoader({
                                key: bs.USERS,
                                value: !g
                            }), n.setTeamState({
                                pageSize: m,
                                pageOffset: b,
                                filterV2: A,
                                sortV2: w
                            });
                            try {
                                const [{ items: t, _metadata: { totalPages: n, totalItems: r } }, { items: l }, { items: c }, u] = await Promise.all([
                                    En(()=>e.users.getUsersV2(v({}, (null == A ? void 0 : A.length) && {
                                            _filter: A
                                        }, w && {
                                            _sortBy: w
                                        }, o.order && {
                                            _order: o.order
                                        }, {
                                            _offset: b,
                                            _limit: m,
                                            _includeSubTenants: T
                                        })), S),
                                    En(()=>e.teams.loadAvailableRoles(), S),
                                    En(()=>e.teams.loadAvailablePermissions(), S),
                                    s(S),
                                    h ? i({
                                        retryConfig: S
                                    }) : void 0
                                ]), d = t.map((t)=>{
                                    var e;
                                    return v({}, t, {
                                        groups: null == t || null == (e = t.groups) ? void 0 : e.map((t)=>u.filter((e)=>e.id === t.id)).flat()
                                    });
                                }).map((t)=>v({}, t, {
                                        roleIds: t.roles.map((t)=>t.id)
                                    })), g = await a.mapUsersWithApplicationData({
                                    shouldLoadApps: y,
                                    users: d,
                                    retryConfig: S
                                });
                                a.setTeamState({
                                    users: g,
                                    totalPages: n,
                                    totalItems: r,
                                    roles: l,
                                    permissions: c
                                }), null == p || p(t);
                            } catch (t) {
                                console.error("Failed to load users", t), n.setTeamError({
                                    key: bs.USERS,
                                    value: Un(t)
                                }), n.setTeamState({
                                    totalPages: 0,
                                    users: []
                                }), null == p || p(null, t);
                            }
                            n.setTeamLoader({
                                key: bs.USERS,
                                value: !1
                            });
                        },
                        addUser: async (s)=>{
                            const { callback: i, appIds: o } = s, r = f(s, Il), l = t.auth.teamState;
                            n.setTeamState({
                                addUserDialogState: v({}, l.addUserDialogState, {
                                    loading: !0
                                })
                            });
                            try {
                                var c;
                                const t = await e.teams.addUser(r), { roles: s } = t, u = v({}, f(t, Ol), {
                                    roleIds: null != (c = null == s ? void 0 : s.map((t)=>t.id)) ? c : []
                                }), d = await a.assignNewUserToApps({
                                    appIds: o,
                                    user: u
                                });
                                d && (u.applications = d), null == i || i(u), n.setTeamState({
                                    users: [
                                        u,
                                        ...l.users
                                    ],
                                    addUserDialogState: {
                                        open: !1,
                                        loading: !1
                                    }
                                });
                            } catch (t) {
                                console.error("Failed to add user", t), n.setTeamState({
                                    addUserDialogState: v({}, l.addUserDialogState, {
                                        loading: !1,
                                        error: Un(t)
                                    })
                                }), null == i || i(null, t);
                            }
                        },
                        addUsersBulk: async (a)=>{
                            const { callback: s } = a, i = t.auth.teamState;
                            n.setTeamState({
                                addUserDialogState: v({}, i.addUserDialogState, {
                                    loading: !0
                                })
                            });
                            const o = [], r = [], l = a.emails.map((t)=>v({
                                    email: t,
                                    roleIds: a.roleIds
                                }, a.expirationInSeconds && {
                                    expirationInSeconds: a.expirationInSeconds
                                }));
                            n.setTeamState({
                                addUserDialogState: {
                                    open: !0,
                                    loading: !0
                                }
                            });
                            for(let t = 0; t < l.length; t++){
                                const a = l.at(t);
                                try {
                                    await e.teams.addUser(a), o.push(a.email);
                                } catch (t) {
                                    r.push(a.email);
                                }
                            }
                            const c = {
                                pageOffset: 0,
                                pageSize: 10,
                                filter: "",
                                silentLoading: a.emails.length > 0
                            };
                            await n.loadUsersV2(c), n.setTeamState({
                                addUserDialogState: {
                                    loading: !1
                                }
                            }), null == s || s({
                                unallowedEmails: r,
                                allowedEmails: o
                            });
                        },
                        updateUser: async (a)=>{
                            const { callback: s } = a, i = f(a, Pl), { id: o } = i, r = t.auth.teamState, l = r.users.find((t)=>t.id === i.id);
                            if (void 0 !== l) {
                                n.setTeamLoader({
                                    key: bs.UPDATE_USER,
                                    value: o || ""
                                }), n.setTeamState({
                                    addUserDialogState: v({}, r.addUserDialogState, {
                                        loading: !0
                                    })
                                }), n.setTeamState({
                                    addUserDialogState: v({}, r.addUserDialogState, {
                                        loading: !0
                                    }),
                                    users: r.users.map((t)=>t.id === i.id ? v({}, t, i) : t)
                                });
                                try {
                                    var c;
                                    l.roleIds.length > 0 && 0 === (null == (c = i.roleIds) ? void 0 : c.length) && (i.roleIds = [
                                        ""
                                    ]);
                                    const { item: t } = await e.teams.updateUser(i);
                                    null == s || s(t), n.setTeamState({
                                        users: r.users.map((e)=>e.id === t.id ? v({}, e, t, {
                                                groups: e.groups,
                                                createdAt: e.createdAt,
                                                customData: e.customData,
                                                lastLogin: e.lastLogin
                                            }) : e)
                                    }), n.setTeamLoader({
                                        key: bs.UPDATE_USER,
                                        value: !1
                                    });
                                } catch (t) {
                                    n.setTeamState({
                                        addUserDialogState: v({}, r.addUserDialogState, {
                                            loading: !1,
                                            error: Un(t)
                                        }),
                                        users: r.users.map((t)=>t.id === i.id ? v({}, t, l) : t)
                                    }), n.setTeamLoader({
                                        key: bs.UPDATE_USER,
                                        value: !1
                                    }), null == s || s(null, t);
                                }
                            } else null == s || s(null, "User not in state");
                        },
                        deleteUser: async (a)=>{
                            const { callback: s } = a, i = f(a, kl), o = t.auth.teamState;
                            n.setTeamState({
                                deleteUserDialogState: v({}, o.deleteUserDialogState, {
                                    loading: !0
                                })
                            });
                            try {
                                await e.teams.deleteUser(i), null == s || s(!0), n.setTeamState({
                                    users: o.users.filter((t)=>t.id !== i.userId),
                                    deleteUserDialogState: {
                                        open: !1,
                                        loading: !1
                                    }
                                });
                            } catch (t) {
                                n.setTeamState({
                                    deleteUserDialogState: v({}, o.deleteUserDialogState, {
                                        loading: !1,
                                        error: Un(t)
                                    })
                                }), null == s || s(null, t);
                            }
                        },
                        enableUser: async (a)=>{
                            const { callback: s, userId: i } = a, o = t.auth.teamState;
                            n.setTeamState({
                                enableUserDialogState: v({}, o.enableUserDialogState, {
                                    loading: !0
                                })
                            });
                            try {
                                await e.teams.enableUser(i), null == s || s(!0), n.setTeamState({
                                    users: o.users.map((t)=>t.id === i ? v({}, t, {
                                            isDisabled: !1
                                        }) : t),
                                    enableUserDialogState: {
                                        open: !1,
                                        loading: !1
                                    }
                                });
                            } catch (t) {
                                n.setTeamState({
                                    enableUserDialogState: v({}, o.enableUserDialogState, {
                                        loading: !1,
                                        error: Un(t)
                                    })
                                }), null == s || s(null, t);
                            }
                        },
                        disableUser: async (a)=>{
                            const { callback: s, userId: i } = a, o = t.auth.teamState;
                            n.setTeamState({
                                disableUserDialogState: v({}, o.disableUserDialogState, {
                                    loading: !0
                                })
                            });
                            try {
                                await e.teams.disableUser(i), null == s || s(!0), n.setTeamState({
                                    users: o.users.map((t)=>t.id === i ? v({}, t, {
                                            isDisabled: !0
                                        }) : t),
                                    disableUserDialogState: {
                                        open: !1,
                                        loading: !1
                                    }
                                });
                            } catch (t) {
                                n.setTeamState({
                                    disableUserDialogState: v({}, o.disableUserDialogState, {
                                        loading: !1,
                                        error: Un(t)
                                    })
                                }), null == s || s(null, t);
                            }
                        },
                        getTemporaryUsersConfig: async (t)=>{
                            n.setTeamError({
                                key: bs.CONFIG_TEMPORARY_USERS,
                                value: !1
                            });
                            try {
                                const a = await En(()=>e.teams.getTemporaryUserConfiguration(), null == t ? void 0 : t.retryConfig);
                                n.setTeamState({
                                    temporaryUsersConfig: a
                                });
                            } catch (t) {
                                n.setTeamError({
                                    key: bs.CONFIG_TEMPORARY_USERS,
                                    value: Un(t)
                                });
                            }
                        },
                        updateUserExpirationTime: async (a)=>{
                            const { callback: s } = a, i = f(a, _l), o = t.auth.teamState;
                            n.setTeamLoader({
                                key: bs.UPDATE_USER_EXPIRATION_TIME,
                                value: !0
                            });
                            try {
                                const t = await e.teams.updateUserExpirationTime(i);
                                n.setTeamState({
                                    users: o.users.map((e)=>e.id === i.userId ? v({}, e, {
                                            temporaryExpirationDate: new Date(t.temporaryExpirationDate)
                                        }) : e)
                                }), null == s || s(!0);
                            } catch (t) {
                                n.setTeamError({
                                    key: bs.UPDATE_USER_EXPIRATION_TIME,
                                    value: Un(t)
                                }), null == s || s(null, t);
                            } finally{
                                n.setTeamLoader({
                                    key: bs.UPDATE_USER_EXPIRATION_TIME,
                                    value: !1
                                });
                            }
                        },
                        setUserAsPermanent: async (a)=>{
                            const { callback: s } = a, i = f(a, Rl), o = t.auth.teamState;
                            n.setTeamLoader({
                                key: bs.UPDATE_USER_EXPIRATION_TIME,
                                value: !0
                            });
                            try {
                                await e.teams.setPermanentUser(i.userId), n.setTeamState({
                                    users: o.users.map((t)=>t.id === i.userId ? v({}, t, {
                                            temporaryExpirationDate: void 0
                                        }) : t)
                                }), null == s || s(!0);
                            } catch (t) {
                                n.setTeamError({
                                    key: bs.UPDATE_USER_EXPIRATION_TIME,
                                    value: Un(t)
                                }), null == s || s(null, t);
                            } finally{
                                n.setTeamLoader({
                                    key: bs.UPDATE_USER_EXPIRATION_TIME,
                                    value: !1
                                });
                            }
                        }
                    };
                })(t, e, a), ((t, e, a)=>{
                    const n = a;
                    return {
                        loadAllSubTenantsUsers: async (a)=>{
                            var s, i, o, r, l;
                            const { silentLoading: c, callback: u } = a, d = t.auth.teamState.allUsersQueryParams, g = {
                                _limit: (null != (s = a._limit) ? s : d._limit) || 20,
                                _offset: (null != (i = a._offset) ? i : d._offset) || 0,
                                _filter: (null != (o = a._filter) ? o : d._filter) || "",
                                _sortBy: (null != (r = a._sortBy) ? r : d._sortBy) || "name",
                                _order: (null != (l = a._order) ? l : d._order) || "DESC"
                            };
                            n.setTeamLoader({
                                key: bs.USERS,
                                value: !c
                            }), n.setTeamState({
                                allUsersQueryParams: g
                            });
                            try {
                                const [{ items: t, _metadata: { totalPages: a, totalItems: s } }, { items: i }, { items: o }] = await Promise.all([
                                    e.subTenants.loadAllUsers(v({}, g)),
                                    e.teams.loadAvailableRoles(),
                                    e.teams.loadAvailablePermissions()
                                ]);
                                n.setTeamState({
                                    allUsers: t,
                                    totalPages: a,
                                    totalItems: s,
                                    roles: i,
                                    permissions: o
                                }), null == u || u(t);
                            } catch (t) {
                                n.setTeamError({
                                    key: bs.USERS,
                                    value: Un(t)
                                }), n.setTeamState({
                                    totalPages: 0,
                                    users: []
                                }), null == u || u(null, t);
                            }
                            n.setTeamLoader({
                                key: bs.USERS,
                                value: !1
                            });
                        },
                        setUserRolesForSubTenants: async (a)=>{
                            const { callback: s, userId: i } = a, o = f(a, Cl), r = t.auth.teamState;
                            n.setTeamState({
                                addUserDialogState: v({}, r.addUserDialogState, {
                                    loading: !0
                                })
                            });
                            try {
                                await e.subTenants.setUserRolesForSubTenants(i, o);
                                const t = r.allUsers.find((t)=>t.id === i);
                                let a = [];
                                t && (a = t.tenants.map((t)=>{
                                    var e;
                                    return v({}, t, {
                                        roles: (null == (e = o.subTenantsRoles.find((e)=>e.tenantId === t.tenantId)) ? void 0 : e.roleIds.map((t)=>r.roles.find(({ id: e })=>t === e)).filter((t)=>t)) || t.roles
                                    });
                                })), n.setTeamState({
                                    allUsers: [
                                        ...r.allUsers.filter((t)=>t.id !== i),
                                        ...t ? [
                                            v({}, t, {
                                                tenants: a
                                            })
                                        ] : []
                                    ],
                                    addUserDialogState: {
                                        open: !1,
                                        loading: !1
                                    }
                                }), null == s || s(!0);
                            } catch (t) {
                                n.setTeamState({
                                    addUserDialogState: v({}, r.addUserDialogState, {
                                        loading: !1,
                                        error: Un(t)
                                    })
                                }), null == s || s(null, t);
                            }
                        },
                        deleteUserFromSubTenants: async (a)=>{
                            const { callback: s } = a, i = f(a, Ll), o = t.auth.teamState;
                            n.setTeamState({
                                deleteUserDialogState: v({}, o.deleteUserDialogState, {
                                    loading: !0
                                })
                            });
                            try {
                                await e.subTenants.removeUserFromTenantAndSubTenants(i), null == s || s(!0), n.setTeamState({
                                    allUsers: o.allUsers.filter((t)=>t.id !== i.userId && t.tenants.length === i.subTenants.length),
                                    deleteUserDialogState: {
                                        open: !1,
                                        loading: !1
                                    }
                                });
                            } catch (t) {
                                n.setTeamState({
                                    deleteUserDialogState: v({}, o.deleteUserDialogState, {
                                        loading: !1,
                                        error: Un(t)
                                    })
                                }), null == s || s(null, t);
                            }
                        },
                        addUserToSubTenants: async (a)=>{
                            const { callback: s } = a, i = f(a, Ul), o = t.auth.teamState;
                            n.setTeamState({
                                addUserDialogState: v({}, o.addUserDialogState, {
                                    loading: !0
                                })
                            });
                            try {
                                await e.subTenants.addUserToTenantAndSubTenants(i);
                                const { items: t, _metadata: { totalPages: a, totalItems: o } } = await e.subTenants.loadAllUsers({
                                    _limit: 20,
                                    _offset: 0,
                                    _filter: "",
                                    _sortBy: "name",
                                    _order: "DESC"
                                });
                                n.setTeamState({
                                    allUsers: t,
                                    totalPages: a,
                                    totalItems: o,
                                    addUserDialogState: {
                                        open: !1,
                                        loading: !1
                                    }
                                }), null == s || s(null);
                            } catch (t) {
                                n.setTeamState({
                                    addUserDialogState: v({}, o.addUserDialogState, {
                                        loading: !1,
                                        error: Un(t)
                                    })
                                }), null == s || s(null, t);
                            }
                        }
                    };
                })(t, e, a), ((t, e, a)=>{
                    const n = a, s = async (t, e, a, s)=>{
                        n.setTeamLoader({
                            key: t,
                            value: e
                        });
                        try {
                            await s();
                        } catch (e) {
                            n.setTeamError({
                                key: t,
                                value: Un(e)
                            }), null == a || a(null, e);
                        } finally{
                            n.setTeamLoader({
                                key: t,
                                value: !1
                            });
                        }
                    };
                    return {
                        resendActivationLink: async (t)=>{
                            const { callback: a } = t, n = f(t, Dl);
                            await s(bs.RESEND_ACTIVATE_LINK, n.userId, a, async ()=>{
                                await e.teams.resendActivationLink(n), null == a || a(!0);
                            });
                        },
                        resendInvitationLink: async (t)=>{
                            const { callback: a } = t, n = f(t, Nl);
                            await s(bs.RESEND_INVITATION_LINK, n.email, a, async ()=>{
                                await e.teams.resendInvitationLink(n), null == a || a(!0);
                            });
                        },
                        resendInvitationEmail: async (t)=>{
                            const { callback: a } = t, n = f(t, Ml);
                            await s(bs.RESEND_INVITATION_LINK, a, n.email, async ()=>{
                                await e.auth.resendInvitationEmail(n), null == a || a(!0);
                            });
                        },
                        resendInvitationLinkToAllSubTenants: async (t)=>{
                            const { callback: a } = t, n = f(t, Fl);
                            await s(bs.RESEND_INVITATION_LINK, n.email, a, async ()=>{
                                await e.teams.resendInvitationLinkToAllTenants(n), null == a || a(!0);
                            });
                        }
                    };
                })(0, e, a), ((t, e, a)=>{
                    const n = a;
                    return {
                        getInvitationLink: async (a)=>{
                            n.setTeamError({
                                key: bs.GET_TOKEN_LINK,
                                value: !1
                            });
                            try {
                                const s = null == a ? void 0 : a.retryConfig;
                                await (async (t)=>{
                                    n.setTeamError({
                                        key: bs.CONFIG_TOKEN_LINK,
                                        value: !1
                                    });
                                    try {
                                        const a = await En(()=>e.teams.getInviteLinkConfiguration(), t);
                                        n.setTeamState({
                                            inviteTokenState: v({}, a)
                                        });
                                    } catch (t) {
                                        n.setTeamError({
                                            key: bs.CONFIG_TOKEN_LINK,
                                            value: Un(t)
                                        });
                                    }
                                })(s);
                                const i = await En(()=>e.teams.getInviteUserLink(), s), { inviteTokenState: o } = t.auth.teamState;
                                n.setTeamState({
                                    inviteTokenState: v({}, o, i)
                                });
                            } catch (t) {
                                n.setTeamError({
                                    key: bs.GET_TOKEN_LINK,
                                    value: Un(t)
                                });
                            }
                        },
                        createInvitationLink: async (a)=>{
                            const { callback: s } = a;
                            n.setTeamError({
                                key: bs.CREATE_TOKEN_LINK,
                                value: !1
                            });
                            const { inviteTokenState: i } = t.auth.teamState;
                            try {
                                const t = await e.teams.createInviteUserLink({
                                    expiresInMinutes: 43200
                                });
                                n.setTeamState({
                                    inviteTokenState: v({}, i, t)
                                }), null == s || s(t.token);
                            } catch (t) {
                                null == s || s(null, t), n.setTeamError({
                                    key: bs.CREATE_TOKEN_LINK,
                                    value: Un(t)
                                });
                            }
                        },
                        updateInvitationLink: async (a)=>{
                            const { callback: s, expiresInMinutes: i, shouldSendEmail: o } = a;
                            n.setTeamError({
                                key: bs.UPDATE_TOKEN_LINK,
                                value: !1
                            });
                            try {
                                const { inviteTokenState: a } = t.auth.teamState, r = await e.teams.updateInviteUserLink({
                                    expiresInMinutes: i,
                                    shouldSendEmail: o
                                });
                                n.setTeamState({
                                    inviteTokenState: v({}, a, r)
                                }), null == s || s(!0);
                            } catch (t) {
                                null == s || s(null, t), n.setTeamError({
                                    key: bs.UPDATE_TOKEN_LINK,
                                    value: Un(t)
                                });
                            }
                        },
                        deleteInvitationLink: async (t)=>{
                            const { callback: a } = null != t ? t : {};
                            n.setTeamError({
                                key: bs.DELETE_TOKEN_LINK,
                                value: !1
                            });
                            try {
                                await e.teams.deleteInviteUserLink(), n.setTeamState({
                                    inviteTokenState: void 0
                                }), null == a || a(!0);
                            } catch (t) {
                                n.setTeamError({
                                    key: bs.DELETE_TOKEN_LINK,
                                    value: Un(t)
                                }), null == a || a(!1, t);
                            }
                        }
                    };
                })(t, e, a));
            }, Gl = {
                tenants: [],
                subTenants: [],
                switchingTenant: !1,
                loading: !0,
                tenantTree: null
            }, $l = (t)=>Za(Gl, t), jl = (t, e, a)=>{
                const n = a, s = (e)=>{
                    Object.assign(t.auth.tenantsState, e);
                };
                return {
                    setTenantsState: s,
                    resetTenantsState: ()=>{
                        Rn(t, [
                            "auth",
                            "tenantsState"
                        ], Gl);
                    },
                    switchTenant: async (a)=>{
                        const { tenantId: s, silentReload: i, callback: o } = a;
                        i ? n.setTenantsState({
                            switchingTenant: !0
                        }) : n.setAuthState({
                            isLoading: !0
                        });
                        try {
                            await e.tenants.switchTenant({
                                tenantId: s
                            }), i && n.resetAuthState({
                                isLoading: !1,
                                isAuthenticated: !0,
                                user: t.auth.user
                            }), await n.__refreshToken(), (null == o ? void 0 : o(!0)) || (i ? n.setTenantsState({
                                switchingTenant: !1
                            }) : n.setAuthState({
                                isLoading: !1
                            }));
                        } catch (t) {
                            i ? n.setTenantsState({
                                switchingTenant: !1
                            }) : n.setAuthState({
                                isLoading: !1
                            }), null == o || o(!1, t);
                        }
                    },
                    loadTenants: async (e)=>{
                        s({
                            loading: !0
                        });
                        try {
                            var a;
                            const n = re(t.root.appName), i = await n();
                            s({
                                tenants: i.tenants,
                                activeTenant: i.activeTenant,
                                loading: !1
                            }), null == e || null == (a = e.callback) || a.call(e, []);
                        } catch (t) {
                            var n;
                            null == e || null == (n = e.callback) || n.call(e, [], t), s({
                                loading: !1
                            });
                        }
                    },
                    loadSubTenants: async (t)=>{
                        s({
                            loading: !0
                        });
                        try {
                            var a;
                            const n = await retryIfNeeded(()=>e.tenants.getSubTenants(), null == t ? void 0 : t.retryConfig);
                            s({
                                subTenants: n,
                                loading: !1
                            }), null == t || null == (a = t.callback) || a.call(t, !0);
                        } catch (e) {
                            var n;
                            s({
                                loading: !1
                            }), null == t || null == (n = t.callback) || n.call(t, null, e);
                        }
                    },
                    loadSubTenantsTree: async (t)=>{
                        s({
                            loading: !0
                        });
                        try {
                            var a;
                            const n = await e.tenants.getSubTenantsAsTree();
                            s({
                                tenantTree: n,
                                loading: !1
                            }), null == t || null == (a = t.callback) || a.call(t, !0);
                        } catch (e) {
                            var n;
                            s({
                                loading: !1
                            }), null == t || null == (n = t.callback) || n.call(t, null, e);
                        }
                    }
                };
            }, Bl = (t, e, a)=>{
                const n = (e)=>{
                    t.auth.user && (t.auth.user.entitlements = e);
                }, s = (e)=>{
                    var a;
                    eo(null == (a = t.auth.user) ? void 0 : a.entitlements, e) || n(e);
                };
                return {
                    setEntitlements: n,
                    handleFetchedEntitlements: s,
                    loadEntitlements: async (t)=>{
                        const a = null == t ? void 0 : t.callback;
                        try {
                            const t = await e.entitlements.loadEntitlementsV2();
                            s(t), null == a || a(!0);
                        } catch (t) {
                            null == a || a(!1);
                        }
                    }
                };
            }, Vl = [
                "routes"
            ], Wl = [
                "requestName"
            ], Hl = (t)=>{
                const e = null != t ? t : {}, { routes: a } = e, n = f(e, Vl);
                return Za(v({
                    routes: v({}, fn, a),
                    onRedirectTo: ()=>{},
                    isAuthenticated: !1,
                    isLoading: !0,
                    isSSOAuth: !1,
                    user: null,
                    error: void 0,
                    errorByRequest: {},
                    userIp: void 0,
                    userIpData: {
                        loading: !1
                    }
                }, n, {
                    acceptInvitationState: an(null == n ? void 0 : n.acceptInvitationState),
                    accountSettingsState: Mn(null == n ? void 0 : n.accountSettingsState),
                    activateAccountState: jn(null == n ? void 0 : n.activateAccountState),
                    unlockAccountState: Rs(null == n ? void 0 : n.unlockAccountState),
                    apiTokensState: Us(null == n ? void 0 : n.apiTokensState),
                    applicationsState: Fs(null == n ? void 0 : n.applicationsState),
                    customLoginState: js(null == n ? void 0 : n.customLoginState),
                    forgotPasswordState: zs(null == n ? void 0 : n.forgotPasswordState),
                    passwordRotationState: Xs(null == n ? void 0 : n.passwordRotationState),
                    groupsState: ti(null == n ? void 0 : n.groupsState),
                    groupsDialogsState: oi(null == n ? void 0 : n.groupsDialogsState),
                    impersonateState: ui(null == n ? void 0 : n.impersonateState),
                    loginState: hi(null == n ? void 0 : n.loginState),
                    mfaState: wo(null == n ? void 0 : n.mfaState),
                    allAccountsState: Uo(null == n ? void 0 : n.allAccountsState),
                    allAccountsDialogsState: No(null == n ? void 0 : n.allAccountsDialogsState),
                    passkeysState: zo(null == n ? void 0 : n.passkeysState),
                    profileState: Jo(null == n ? void 0 : n.profileState),
                    provisioningState: Zo(null == n ? void 0 : n.provisioningState),
                    resetPhoneNumberState: ir(null == n ? void 0 : n.resetPhoneNumberState),
                    rolesState: dr(null == n ? void 0 : n.rolesState),
                    restrictionsState: Ar(null == n ? void 0 : n.restrictionsState),
                    securityCenterState: kr(null == n ? void 0 : n.securityCenterState),
                    securityPolicyState: Ur(null == n ? void 0 : n.securityPolicyState),
                    sessionsPolicyState: jr(null == n ? void 0 : n.sessionsPolicyState),
                    sessionsState: Hr(null == n ? void 0 : n.sessionsState),
                    signUpState: Jr(null == n ? void 0 : n.signUpState),
                    smsState: Zr(null == n ? void 0 : n.smsState),
                    socialLoginState: ll(null == n ? void 0 : n.socialLoginState),
                    ssoState: pl(null == n ? void 0 : n.ssoState),
                    stepUpState: Al(null == n ? void 0 : n.stepUpState),
                    teamState: El(null == n ? void 0 : n.teamState),
                    tenantsState: $l(null == n ? void 0 : n.tenantsState)
                }));
            }, zl = (t, e, a, n)=>{
                const s = (e)=>{
                    Object.keys(e).forEach((a)=>{
                        const n = a;
                        kn(t.auth[n]) ? Object.assign(t.auth[n], e[n]) : t.auth[n] = e[n];
                    });
                }, i = {
                    acceptInvitationActions: Dn(t, e),
                    accountSettingsActions: xn(t, e, a),
                    activateAccountActions: ks(t, e, a),
                    unlockAccountActions: Cs(t, e),
                    apiTokensActions: Ns(t, e),
                    applicationsActions: Gs(t, e, a),
                    customLoginActions: Vs(t, e, a),
                    entitlementsActions: Bl(t, e),
                    forgotPasswordActions: qs(t, e),
                    passwordRotationActions: Qs(t),
                    groupsActions: si(t, e),
                    groupsDialogsActions: ri(t),
                    impersonateActions: gi(t, e, a),
                    loginActions: bo(t, e, a),
                    mfaActions: Co(t, e, a),
                    allAccountsActions: Vo(t, e, a),
                    allAccountsDialogActions: Wo(t),
                    passkeysActions: Ko(t, e, a),
                    profileActions: Xo(t, e, a),
                    provisioningActions: ar(t, e),
                    resetPhoneNumberActions: cr(t, e, a),
                    rolesActions: mr(t, e),
                    restrictionsActions: Or(t, e, a),
                    securityCenterActions: Cr(t, e, a),
                    securityPolicyActions: Gr(t, e, a),
                    sessionsPolicyActions: Vr(t, e, a),
                    sessionsActions: zr(t, e),
                    signUpActions: Xr(t, e, a),
                    smsActions: ol(t, e),
                    socialLoginActions: dl(t, e, a),
                    ssoActions: ml(t, e, a),
                    stepUpActions: wl(t, e, a),
                    teamActions: xl(t, e, a),
                    tenantsActions: jl(t, e, a)
                };
                return [
                    v({
                        setAuthState: s,
                        setErrorByRequestName: (e)=>{
                            let { requestName: a } = e, n = f(e, Wl);
                            t.auth.errorByRequest = v({}, t.auth.errorByRequest, {
                                [a]: v({}, n, {
                                    isError: !0
                                })
                            });
                        },
                        setState: s,
                        resetAuthState: (e = {})=>{
                            Rn(t, [
                                "auth"
                            ], v({}, n, e));
                        },
                        setUser: (t)=>{
                            s({
                                user: t
                            });
                        }
                    }, Object.values(i).reduce((t, e)=>v({}, t, e), {})),
                    i
                ];
            }, Kl = {
                isLoading: !1,
                isSaving: !1,
                list: [],
                processIds: [],
                slackChannels: {
                    isLoading: !1
                }
            }, ql = (t)=>Za(Kl, t), Jl = [
                "email",
                "slack",
                "sms",
                "webhook"
            ], Yl = {
                sms: {
                    title: "connectivity.sms",
                    events: (t)=>(null == t ? void 0 : t.length) || 0,
                    isActive: (t)=>{
                        var e;
                        return null != (e = null == t ? void 0 : t.some(({ enabled: t })=>t)) && e;
                    },
                    image: "sms"
                },
                email: {
                    title: "common.email",
                    events: (t)=>(null == t ? void 0 : t.length) || 0,
                    isActive: (t)=>{
                        var e;
                        return null != (e = null == t ? void 0 : t.some(({ enabled: t })=>t)) && e;
                    },
                    image: "email"
                },
                slack: {
                    title: "connectivity.slack",
                    events: (t)=>{
                        var e;
                        return (null == t || null == (e = t.slackSubscriptions) ? void 0 : e.length) || 0;
                    },
                    isActive: (t)=>!(null == t || !t.slackSubscriptions.some(({ isActive: t })=>t)),
                    image: "slack"
                },
                webhook: {
                    title: "connectivity.webhook",
                    events: (t)=>(null == t ? void 0 : t.length) || 0,
                    isActive: (t)=>{
                        var e;
                        return null != (e = null == t ? void 0 : t.some(({ isActive: t })=>t)) && e;
                    },
                    image: "webhook"
                }
            }, Xl = [
                "id"
            ], Ql = [
                "id",
                "enabled"
            ], Zl = (t, e, a)=>{
                const n = {
                    slack: e.connectivity.getSlackConfiguration,
                    email: e.connectivity.getEmailConfiguration,
                    sms: e.connectivity.getSMSConfiguration,
                    webhook: e.connectivity.getWebhooksConfigurations,
                    categories: e.connectivity.getCategories,
                    channelMap: e.connectivity.getChannelMaps
                }, s = [
                    "categories",
                    "channelMap"
                ], i = {
                    slack: e.connectivity.postSlackConfiguration,
                    email: e.connectivity.postEmailConfiguration,
                    sms: e.connectivity.postSMSConfiguration,
                    webhook: e.connectivity.postWebhooksConfiguration
                }, o = (e)=>{
                    Object.assign(t.connectivity, e);
                }, r = (e)=>{
                    var a;
                    const n = null != (a = t.connectivity.retryResult) ? a : {};
                    t.connectivity.retryResult = v({}, n, e);
                }, l = ()=>{
                    Rn(t, [
                        "connectivity"
                    ], Kl);
                }, c = async (t, e, a)=>{
                    try {
                        return await En(()=>n[t](e), a);
                    } catch (t) {
                        return;
                    }
                }, u = async ()=>{
                    try {
                        o({
                            slackChannels: {
                                isLoading: !0
                            }
                        });
                        const t = await e.connectivity.getSlackChannels();
                        o({
                            error: void 0,
                            slackChannels: {
                                isLoading: !1,
                                data: t
                            }
                        });
                    } catch (t) {
                        o({
                            error: void 0,
                            slackChannels: {
                                isLoading: !1
                            }
                        });
                    }
                }, d = async (t)=>{
                    const e = null != t ? t : Jl;
                    o({
                        isLoading: !0
                    });
                    try {
                        const t = await Promise.all([
                            ...e.map((t)=>c(t, void 0, An)),
                            c("categories", void 0, An),
                            (async ()=>(await Promise.all(e.map((t)=>c("channelMap", t, An)))).reduce((t, a, n)=>v({}, t, {
                                        [`${e[n]}`]: a
                                    }), {}))()
                        ]), a = await c("webhook", void 0, An), n = t.reduce((a, n, i)=>e[i] ? t[t.length - 1][e[i]].length ? v({}, a, {
                                [`${e[i]}`]: n,
                                list: [
                                    ...a.list,
                                    {
                                        id: i,
                                        key: e[i],
                                        events: Yl[e[i]].events(n),
                                        active: Yl[e[i]].isActive(n),
                                        platform: Yl[e[i]].title,
                                        image: Yl[e[i]].image
                                    }
                                ]
                            }) : a : v({}, a, {
                                [`${s[i - e.length]}`]: n
                            }), {
                            list: [],
                            webhook: a
                        });
                        o(v({}, n, {
                            error: void 0,
                            isSaving: !1,
                            isLoading: !1
                        }));
                    } catch (t) {
                        o({
                            isLoading: !1,
                            error: Un(t)
                        });
                    }
                }, g = async (e, a)=>{
                    const { list: n } = t.connectivity, s = n.find(({ key: t })=>t === e);
                    if (!s) return;
                    const i = Yl[e].isActive(a);
                    i !== s.active && o({
                        list: n.map((t)=>t.key === e ? v({}, t, {
                                active: i
                            }) : t)
                    });
                }, p = async (a)=>{
                    const { platform: n, data: s, callback: r } = a, l = t.connectivity.processIds;
                    try {
                        if (o({
                            isSaving: !0,
                            processIds: "webhook" === n ? [
                                s._id,
                                ...l
                            ] : l
                        }), "slack" === n ? await (async (a)=>{
                            var n;
                            const s = null == (n = t.connectivity.slack) ? void 0 : n.slackSubscriptions;
                            if (!s) return;
                            const { slackSubscriptions: o } = a;
                            await Promise.all([
                                ...o.reduce((t, e)=>{
                                    var a, n;
                                    return !e.id && e.slackEvents && null != (a = e.slackEvents[0].channelIds) && a.length || (null == s ? void 0 : s.find((t)=>{
                                        let { id: a } = t, n = f(t, Xl);
                                        return a === e.id && JSON.stringify(v({
                                            id: a
                                        }, n)) !== JSON.stringify(e);
                                    })) && e.slackEvents && null != (n = e.slackEvents[0].channelIds) && n.length ? [
                                        ...t,
                                        e
                                    ] : t;
                                }, []).map((t)=>i.slack(t)),
                                ...o.reduce((t, e)=>e.id && !e.slackEvents[0].channelIds.length ? [
                                        ...t,
                                        e
                                    ] : t, []).map((t)=>e.connectivity.deleteSlackConfiguration(t))
                            ]);
                        })(s) : [
                            "sms",
                            "email"
                        ].includes(n) ? await (async (a, n)=>{
                            const s = t.connectivity.processIds, i = t.connectivity[n];
                            if (!i) return;
                            let r = [];
                            try {
                                r = await Promise.all([
                                    ...a.reduce((t, e)=>!i.find(({ eventKey: t })=>t === e.eventKey) && e.subscriptions[0].recipients.filter((t)=>t).length ? [
                                            ...t,
                                            e
                                        ] : t, []).map((t)=>"email" === n ? e.connectivity.postEmailConfiguration(t) : e.connectivity.postSMSConfiguration(t)),
                                    ...a.reduce((t, e)=>{
                                        const a = i.find(({ eventKey: t })=>t === e.eventKey);
                                        return a && JSON.stringify(a) !== JSON.stringify(e) ? [
                                            ...t,
                                            e
                                        ] : t;
                                    }, []).map((t)=>{
                                        const { subscriptions: a, eventKey: s } = t, i = a[0], { id: o = "", enabled: r } = i, l = f(i, Ql);
                                        return Promise.all([
                                            "email" === n ? e.connectivity.patchEmailConfiguration({
                                                eventKey: s,
                                                enabled: r
                                            }) : e.connectivity.patchSMSConfiguration({
                                                eventKey: s,
                                                enabled: r
                                            }),
                                            "email" === n ? e.connectivity.putEmailSubscriptions(o, s, v({}, l, {
                                                enabled: r
                                            })) : e.connectivity.putSMSSubscriptions(o, s, v({}, l, {
                                                enabled: r
                                            }))
                                        ]);
                                    }),
                                    ...a.reduce((t, e)=>{
                                        const a = i.find(({ eventKey: t })=>t === e.eventKey);
                                        return a && a.subscriptions[0].recipients.length && !e.subscriptions[0].recipients.filter((t)=>!!t).length ? [
                                            ...t,
                                            e
                                        ] : t;
                                    }, []).map(({ eventKey: t, subscriptions: a })=>"email" === n ? e.connectivity.deleteEmailSubscriptions(t, a[0].id || "") : e.connectivity.deleteSMSSubscriptions(t, a[0].id || ""))
                                ]);
                            } catch  {}
                            if (r.length) {
                                const t = await c(n);
                                o({
                                    error: void 0,
                                    isSaving: !1,
                                    [`${n}`]: t,
                                    processIds: t.id ? s.filter((e)=>e !== t.id) : s
                                }), await g(n, t);
                            } else o({
                                error: void 0,
                                isSaving: !1,
                                [`${n}`]: i,
                                processIds: s
                            });
                        })(s, n) : await i[n](s), ![
                            "sms",
                            "email"
                        ].includes(n)) {
                            const t = await c(n);
                            "webhook" === n && (t.id = s._id), o({
                                error: void 0,
                                isSaving: !1,
                                [`${n}`]: t,
                                processIds: t.id ? l.filter((e)=>e !== t.id) : l
                            }), await g(n, t), null == r || r(!0);
                        }
                    } catch (t) {
                        o({
                            error: Un(t),
                            isSaving: !1,
                            isLoading: !1
                        });
                    }
                }, h = async (t)=>{
                    try {
                        await e.connectivity.postSlackCode(t);
                    } catch  {}
                    o({
                        error: void 0,
                        isSaving: !1
                    });
                }, y = async ()=>{
                    const a = t.connectivity.slackChannels;
                    try {
                        o({
                            slackChannels: v({}, a, {
                                isLoadingScope: !0
                            })
                        });
                        const { clientId: t } = await e.connectivity.getSlackScope();
                        o({
                            slackChannels: {
                                error: void 0,
                                clientId: t,
                                isLoadingScope: !1,
                                isLoading: !1
                            }
                        });
                    } catch  {
                        o({
                            slackChannels: {
                                error: void 0,
                                isLoadingScope: !1,
                                isLoading: !1
                            }
                        });
                    }
                }, S = async (a)=>{
                    const { callback: n, webhookId: s } = a, i = t.connectivity.processIds;
                    try {
                        o({
                            isSaving: !0
                        }), await e.connectivity.deleteWebhooksConfiguration(s);
                    } catch (t) {
                        null == n || n(null, Un(t));
                    }
                    const r = await c("webhook");
                    r && o({
                        error: void 0,
                        isSaving: !1,
                        webhook: r,
                        processIds: r.id ? i.filter((t)=>t !== r.id) : i
                    }), null == n || n(!0);
                }, m = async (t)=>{
                    try {
                        o({
                            isTesting: !0
                        });
                        const { statusCode: a, body: n } = await e.connectivity.postWebhookTest(t);
                        if ([
                            201,
                            200
                        ].includes(a)) {
                            const t = JSON.stringify(n, null, 2);
                            o({
                                isTesting: !1,
                                testResult: {
                                    status: "success",
                                    message: t
                                }
                            });
                        } else o({
                            isTesting: !1,
                            testResult: {
                                status: "failed"
                            }
                        });
                    } catch (t) {
                        o({
                            isTesting: !1,
                            testResult: {
                                status: "failed",
                                message: Un(t)
                            }
                        });
                    }
                }, b = async (t)=>{
                    try {
                        const { statusCode: a } = await e.connectivity.postWebhookRetry(t);
                        r({
                            [t]: {
                                isProcess: !1,
                                success: 202 === a
                            }
                        });
                    } catch (e) {
                        r({
                            [t]: {
                                isProcess: !1,
                                success: !1
                            }
                        });
                    }
                }, A = async (a)=>{
                    const { id: n, limit: s, offset: i } = a, r = t.connectivity.webhookLogs;
                    try {
                        o({
                            webhookLogs: v({}, r, {
                                isLoading: !0
                            })
                        });
                        const t = await e.connectivity.getWebhookLog(n, i, s);
                        o({
                            error: void 0,
                            webhookLogs: v({
                                isLoading: !1
                            }, t)
                        });
                    } catch (t) {
                        o({
                            error: void 0,
                            webhookLogs: {
                                isLoading: !1
                            }
                        });
                    }
                };
                return {
                    setConnectivityState: o,
                    initData: l,
                    resetConnectivityState: l,
                    loadSlackActions: u,
                    loadSlackChannels: u,
                    loadDataAction: d,
                    loadConnectivityChannels: d,
                    postDataAction: p,
                    postChannelData: p,
                    postCodeAction: h,
                    postSlackCode: h,
                    loadScope: y,
                    loadSlackPermissions: y,
                    deleteWebhookConfigAction: S,
                    deleteWebhookConfig: S,
                    postWebhookTestAction: m,
                    postWebhookTest: m,
                    postWebhookRetryAction: b,
                    postWebhookRetry: b,
                    loadWebhookLogsAction: A,
                    loadWebhookLogs: A,
                    cleanWebhookTestData: ()=>{
                        o({
                            testResult: void 0
                        });
                    },
                    cleanWebhookLogsData: async ()=>{
                        o({
                            webhookLogs: void 0
                        });
                    },
                    cleanWebhookTestMessage: async (t)=>{
                        var e;
                        o({
                            testResult: {
                                status: null == (e = t.testResult) ? void 0 : e.status,
                                message: void 0
                            }
                        });
                    },
                    cleanError: async ()=>{
                        o({
                            error: void 0
                        });
                    },
                    cleanSlackData: async ()=>{
                        o({
                            slackChannels: {
                                isLoading: !1
                            }
                        });
                    }
                };
            };
            let tc;
            !function(t) {
                t.UNKNWON = "unknown", t.CARD = "card";
            }(tc || (tc = {}));
            const ec = {
                loading: !1,
                error: null,
                fetching: !0,
                config: null
            }, ac = (t)=>Za(ec, t);
            let nc, sc, ic;
            !function(t) {
                t.STRIPE = "Stripe";
            }(nc || (nc = {})), function(t) {
                t.ACTIVE = "ACTIVE", t.CANCELED = "CANCELED", t.INCOMPLETE = "INCOMPLETE", t.EXPIRED = "EXPIRED", t.TRIALING = "TRIALING";
            }(sc || (sc = {})), function(t) {
                t.AT_PERIOD_END = "atPeriodEnd";
            }(ic || (ic = {}));
            const oc = (t, e, a)=>{
                const n = (e)=>{
                    Object.assign(t.subscriptions.config, e);
                }, s = (e)=>{
                    Object.assign(t.subscriptions.config, {
                        error: e,
                        loading: !1,
                        fetching: !1
                    });
                };
                return {
                    setPaymentConfigState: n,
                    resetPaymentConfigState: ()=>{
                        Rn(t, [
                            "subscriptions",
                            "config"
                        ], ec);
                    },
                    loadPaymentConfiguration: async ()=>{
                        n({
                            loading: !0
                        });
                        try {
                            var t;
                            (null != (t = await e.subscriptions.getPaymentProviders()) ? t : []).find((t)=>"1" === t.status && t.providerType === $.Stripe) ? await (async ()=>{
                                n({
                                    loading: !0
                                });
                                try {
                                    const t = await e.subscriptions.getStripePaymentProviderConfiguration(), a = {
                                        paymentProvider: nc.STRIPE,
                                        apiKey: t.publishableKey
                                    };
                                    n({
                                        config: a
                                    }), n({
                                        loading: !1,
                                        fetching: !1
                                    });
                                } catch (t) {
                                    s(Un(t));
                                }
                            })() : s(Un("Payment provider not configured"));
                        } catch (t) {
                            s(Un(t));
                        }
                    }
                };
            }, rc = {
                loading: !1,
                error: null,
                fetching: !0
            }, lc = (t)=>Za(rc, t);
            function cc({ policy: t }) {
                return {
                    policy: ic.AT_PERIOD_END
                };
            }
            function uc(t) {
                switch(t){
                    case F.ACTIVE:
                        return sc.ACTIVE;
                    case F.INCOMPLETE:
                        return sc.INCOMPLETE;
                    case F.CANCELED:
                        return sc.CANCELED;
                    case F.EXPIRED:
                        return sc.EXPIRED;
                    case F.TRIALING:
                        return sc.TRIALING;
                    default:
                        return sc.EXPIRED;
                }
            }
            const dc = (t, e, a)=>{
                const n = a, s = (e)=>{
                    Object.assign(t.subscriptions.billing.information, e);
                }, i = (t)=>{
                    s({
                        error: t,
                        loading: !1,
                        fetching: !1
                    });
                }, o = async (a, o)=>{
                    s({
                        loading: !0
                    });
                    try {
                        var r, l;
                        const i = await e.subscriptions.getSubscriptionSummaries(a), { currentPlanId: c, externallyManaged: u } = i;
                        let d, g = null;
                        u ? d = await e.subscriptions.getSubscriptionPlan(c) : ([, d] = await Promise.all([
                            n.loadSubscription(),
                            e.subscriptions.getSubscriptionPlan(c)
                        ]), g = t.subscriptions.billing.subscription.subscription || null), s(v({
                            loading: !1,
                            fetching: !1,
                            summary: i
                        }, g ? {
                            subscription: {
                                id: g.id,
                                externalId: g.externalId,
                                startDate: g.startDate,
                                currentPeriodStart: g.currentPeriodStart,
                                currentPeriodEnd: g.currentPeriodEnd,
                                status: o ? sc.ACTIVE : uc(g.status),
                                cancellation: g.cancellation && cc(g.cancellation),
                                trialEnd: g.trialEnd ? g.trialEnd : null
                            }
                        } : {}, d ? {
                            plan: {
                                id: d.id,
                                name: d.name,
                                description: d.description,
                                price: (null == (r = d.price) ? void 0 : r.amount) || 0,
                                currency: (null == (l = d.price) ? void 0 : l.currency) || "usd",
                                recurringInterval: "month",
                                slug: d.slug
                            }
                        } : {}));
                    } catch (t) {
                        i(Un(t));
                    }
                };
                return {
                    setBillingInformationState: s,
                    resetBillingInformationState: ()=>{
                        Rn(t, [
                            "subscriptions",
                            "billing",
                            "information"
                        ], rc);
                    },
                    loadSummaries: o,
                    loadBillingInformation: async (e)=>{
                        var a, n;
                        const s = null == (a = t.subscriptions.config.config) ? void 0 : a.paymentProvider, r = null == (n = t.auth.user) ? void 0 : n.tenantId;
                        s && r ? await o(r, e) : i(new V(s ? "Not authorized" : "Internal feature failure", 500, null));
                    }
                };
            }, gc = {
                loading: !1,
                error: null,
                fetching: !0,
                invoices: [],
                invoiceDownload: {
                    loading: !1,
                    error: null
                }
            }, pc = (t)=>Za(gc, t), hc = (t, e, a)=>{
                const n = (e)=>{
                    Object.assign(t.subscriptions.billing.invoices, e);
                }, s = (e)=>{
                    Object.assign(t.subscriptions.billing.invoices.invoiceDownload, e);
                }, i = async ()=>{
                    n({
                        loading: !0
                    });
                    try {
                        const t = (await e.subscriptions.getSubscriptionInvoices()).map((t)=>({
                                id: t.id,
                                externalId: t.externalId,
                                subscriptionId: t.subscriptionId,
                                paymentDate: new Date(Date.parse(t.paymentDate)),
                                totalAmount: +((t.totalAmount || 0) / 100).toFixed(2),
                                currency: t.currency || "usd",
                                paid: t.paid || !1,
                                receiptNumber: t.receiptNumber
                            }));
                        n({
                            loading: !1,
                            fetching: !1,
                            invoices: t
                        });
                    } catch (e) {
                        t = Un(e), n({
                            error: t,
                            loading: !1,
                            fetching: !1
                        });
                    }
                    var t;
                }, o = async (t)=>{
                    s({
                        loading: !0,
                        error: null
                    });
                    try {
                        await e.subscriptions.getSubscriptionInvoicePdf(t.invoiceId, t.filename), s({
                            loading: !1,
                            error: null
                        });
                    } catch (t) {
                        s({
                            loading: !1,
                            error: Un(t, null)
                        });
                    }
                };
                return {
                    setBillingInvoiceState: n,
                    resetBillingInvoiceState: ()=>{
                        Rn(t, [
                            "subscriptions",
                            "billing",
                            "invoices"
                        ], gc);
                    },
                    loadInvoices: i,
                    loadBillingInvoices: i,
                    downloadInvoice: o,
                    downloadBillingInvoice: o
                };
            }, yc = {
                loading: !1,
                error: null,
                fetching: !0
            }, Sc = (t)=>Za(yc, t), vc = (t, e, a)=>{
                const n = (e)=>{
                    Object.assign(t.subscriptions.billing.paymentMethod, e);
                }, s = (t)=>{
                    n({
                        loading: t
                    });
                }, i = (t)=>{
                    n({
                        error: t,
                        loading: !1,
                        fetching: !1
                    });
                }, o = async ()=>{
                    s(!0);
                    try {
                        const t = (await e.subscriptions.getPaymentMethods())[0];
                        n({
                            paymentMethod: t,
                            loading: !1,
                            fetching: !1
                        });
                    } catch (t) {
                        i(Un(t));
                    }
                };
                return {
                    setBillingPaymentMethodState: n,
                    resetBillingPaymentMethodState: ()=>{
                        Rn(t, [
                            "subscriptions",
                            "billing",
                            "paymentMethod"
                        ], yc);
                    },
                    loadPaymentMethod: o,
                    submitPaymentMethod: async ()=>{
                        s(!0);
                    },
                    submitPaymentMethodError: async (t)=>{
                        i(t);
                    },
                    submitPaymentMethodSuccess: async ()=>await o(),
                    updatePaymentMethodBillingDetails: async (t)=>{
                        s(!0);
                        const { id: a, email: n, address: r, callback: l } = t;
                        try {
                            await e.subscriptions.updatePaymentMethodBillingDetails(a, v({
                                email: n
                            }, r)), await o(), null == l || l(!0);
                        } catch (t) {
                            i(Un(t)), null == l || l(!1, t);
                        } finally{
                            s(!1);
                        }
                    }
                };
            }, fc = {
                loading: !1,
                error: null,
                fetching: !0,
                cancellation: {
                    loading: !1,
                    error: null
                },
                renewal: {
                    loading: !1,
                    error: null
                }
            }, mc = (t)=>Za(fc, t), bc = (t, e, a)=>{
                const n = a, s = (e)=>{
                    Object.assign(t.subscriptions.billing.subscription, e);
                }, i = (t)=>{
                    s({
                        error: t,
                        loading: !1,
                        fetching: !1
                    });
                }, o = (e)=>{
                    Object.assign(t.subscriptions.billing.subscription.cancellation, {
                        loading: e
                    });
                }, r = (e)=>{
                    Object.assign(t.subscriptions.billing.subscription.cancellation, {
                        error: e
                    });
                }, l = (e)=>{
                    Object.assign(t.subscriptions.billing.subscription.renewal, {
                        loading: e
                    });
                }, c = (e)=>{
                    Object.assign(t.subscriptions.billing.subscription.renewal, {
                        error: e
                    });
                }, u = async ()=>{
                    s({
                        loading: !0
                    });
                    try {
                        const [t] = await e.subscriptions.getManagedSubscriptions();
                        s({
                            subscription: t,
                            fetching: !1,
                            loading: !1,
                            error: null
                        });
                    } catch (t) {
                        i(Un(t));
                    }
                };
                return {
                    setBillingSubscriptionState: s,
                    resetBillingSubscriptionState: ()=>{
                        Rn(t, [
                            "subscriptions",
                            "billing",
                            "subscription"
                        ], fc);
                    },
                    setCancellationLoading: o,
                    setCancellationError: r,
                    setRenewalLoading: l,
                    setRenewalError: c,
                    loadSubscription: u,
                    loadSubscriptionTenant: async ()=>{
                        var e;
                        const a = null == (e = t.auth.user) ? void 0 : e.tenantId;
                        a ? await n.loadSummaries(a) : i(new V("TenantId is not defined", 500, null));
                    },
                    cancelSubscription: async ()=>{
                        const { subscription: a } = t.subscriptions.billing.subscription;
                        if (!a) return void r(new V("Subscription not found", 500, null));
                        if (null != a && a.externallyManaged) return void r(new V("Billing is externally managed", 500, null));
                        const { id: n, cancellation: s, status: i } = a || {};
                        if (!s && i === F.ACTIVE) try {
                            o(!0), await e.subscriptions.cancelManagedSubscription(n), await u(), o(!1);
                        } catch (t) {
                            r(Un(t));
                        }
                    },
                    renewSubscription: async ()=>{
                        const { subscription: a } = t.subscriptions.billing.subscription;
                        if (!a) return void c(new V("Subscription not found", 500, null));
                        if (null != a && a.externallyManaged) return void c(new V("Billing is externally managed", 500, null));
                        const { id: n, cancellation: s } = a || {};
                        if ((null == s ? void 0 : s.policy) === G.AT_PERIOD_END) try {
                            l(!0), await e.subscriptions.renewManagedSubscription(n), await u(), l(!1);
                        } catch (t) {
                            c(Un(t));
                        }
                    }
                };
            }, Ac = (t)=>Za({
                    information: lc(null == t ? void 0 : t.information),
                    invoices: pc(null == t ? void 0 : t.invoices),
                    paymentMethod: Sc(null == t ? void 0 : t.paymentMethod),
                    subscription: mc(null == t ? void 0 : t.subscription)
                }), wc = {
                loading: !1,
                error: null,
                fetching: !0,
                plans: []
            }, Tc = (t)=>Za(wc, t), Ec = (t, e, a)=>{
                const n = (e)=>{
                    Object.assign(t.subscriptions.plans, e);
                };
                return {
                    setPlansState: n,
                    resetPlansState: ()=>{
                        Rn(t, [
                            "subscriptions",
                            "plans"
                        ], wc);
                    },
                    loadPlans: async ()=>{
                        n({
                            loading: !0
                        });
                        try {
                            const t = (await e.subscriptions.getSubscriptionPlans()).map((t)=>{
                                var e, a;
                                return {
                                    id: t.id,
                                    name: t.name,
                                    description: t.description,
                                    price: (null == (e = t.price) ? void 0 : e.amount) || 0,
                                    currency: (null == (a = t.price) ? void 0 : a.currency) || "usd",
                                    recurringInterval: "month",
                                    slug: t.slug
                                };
                            });
                            n({
                                fetching: !1,
                                loading: !1,
                                plans: t
                            });
                        } catch (e) {
                            t = Un(e), n({
                                loading: !1,
                                fetching: !1,
                                error: t
                            });
                        }
                        var t;
                    }
                };
            }, Ic = {
                fetching: !0,
                loading: !1,
                error: null,
                confirmed: !1
            }, Oc = (t)=>Za(Ic, t), Pc = (t, e, a)=>{
                const n = a, s = (e)=>{
                    Object.assign(t.subscriptions.checkout, e);
                };
                return {
                    setCheckoutState: s,
                    resetCheckoutState: ()=>{
                        Rn(t, [
                            "subscriptions",
                            "checkout"
                        ], Ic);
                    },
                    loadCheckout: ()=>{
                        s({
                            fetching: !1,
                            loading: !1,
                            error: null,
                            confirmed: !1
                        });
                    },
                    resetCheckout: ()=>{
                        s({
                            loading: !1,
                            error: null,
                            confirmed: !1
                        });
                    },
                    submitCheckout: ()=>{
                        s({
                            loading: !0,
                            error: null
                        });
                    },
                    confirmCheckout: async (a)=>{
                        const { paymentMethodId: i, planId: o } = a, r = t.subscriptions.billing.subscription.subscription, l = t.subscriptions.billing.information.summary, c = (null == r ? void 0 : r.status) === F.TRIALING, u = !(null == l || !l.paymentMethodId);
                        if (r) {
                            if (s({
                                loading: !0,
                                error: null
                            }), c && u) return s({
                                loading: !1,
                                error: null,
                                confirmed: !0
                            }), void n.setBillingSubscriptionState({
                                subscription: v({}, r, {
                                    status: F.ACTIVE
                                })
                            });
                            try {
                                await e.subscriptions.updateManagedSubscription(r.id, {
                                    paymentMethodId: i,
                                    planId: o
                                }), await Promise.all([
                                    n.loadBillingInformation(),
                                    n.loadPaymentMethod(),
                                    n.loadInvoices()
                                ]), s({
                                    loading: !1,
                                    error: null,
                                    confirmed: !0
                                });
                            } catch (t) {
                                s({
                                    loading: !1,
                                    error: Un(t)
                                });
                            }
                        } else s({
                            loading: !1,
                            error: new V("Subscription not found", 500, null)
                        });
                    },
                    errorCheckout: (t)=>{
                        s({
                            loading: !1,
                            error: t
                        });
                    }
                };
            }, kc = {
                loading: !1,
                error: null,
                cardSetupIntentSecret: null
            }, _c = (t)=>Za(kc, t), Rc = (t, e, a)=>{
                const n = (e)=>{
                    Object.assign(t.subscriptions.stripe, e);
                };
                return {
                    createCardSetupIntentSecret: async (a)=>{
                        n({
                            loading: !0,
                            error: null,
                            cardSetupIntentSecret: null
                        });
                        try {
                            const t = {};
                            a && (t.paymentMethodId = a);
                            const { setupIntentSecret: s } = await e.subscriptions.createStripePaymentMethodSetupIntentSecret(t);
                            n({
                                cardSetupIntentSecret: s,
                                loading: !1
                            });
                        } catch (e) {
                            s = Un(e), Object.assign(t.subscriptions.stripe, {
                                error: s,
                                loading: !1,
                                fetching: !1
                            });
                        }
                        var s;
                    },
                    setStripeState: n,
                    resetStripeState: ()=>{
                        Rn(t, [
                            "subscriptions",
                            "stripe"
                        ], kc);
                    }
                };
            }, Cc = {
                loading: !1,
                fetching: !0,
                vendorPublicConfig: null
            }, Lc = (t)=>Za(Cc, t), Uc = (t, e, a)=>{
                const n = (e)=>{
                    Object.assign(t.subscriptions.vendorPublicConfig, e);
                }, s = (e)=>{
                    Object.assign(t.subscriptions.vendorPublicConfig, {
                        error: e,
                        loading: !1,
                        fetching: !1
                    });
                }, i = (e)=>{
                    Object.assign(t.subscriptions.vendorPublicConfig, {
                        error: null,
                        loading: e
                    });
                };
                return {
                    setVendorPublicConfigState: n,
                    resetVendorPublicConfigState: ()=>{
                        Rn(t, [
                            "subscriptions",
                            "vendorPublicConfig"
                        ], Cc);
                    },
                    setVendorPublicConfigError: s,
                    setVendorPublicConfigLoading: i,
                    loadVendorPublicConfiguration: async ()=>{
                        i(!0);
                        try {
                            const t = await e.subscriptions.getVendorPublicConfigurations();
                            n({
                                fetching: !1,
                                loading: !1,
                                vendorPublicConfig: t
                            });
                        } catch (t) {
                            s(Un(t));
                        }
                    }
                };
            }, Dc = (t)=>Za({
                    config: ac(null == t ? void 0 : t.config),
                    billing: Ac(null == t ? void 0 : t.billing),
                    plans: Tc(null == t ? void 0 : t.plans),
                    checkout: Oc(null == t ? void 0 : t.checkout),
                    stripe: _c(null == t ? void 0 : t.stripe),
                    vendorPublicConfig: Lc(null == t ? void 0 : t.vendorPublicConfig)
                }), Nc = (t, e, a)=>{
                const n = oc(t, e), [s, i] = ((t, e, a)=>{
                    const n = dc(t, e, a), s = vc(t, e), i = hc(t, e), o = bc(t, e, a);
                    return [
                        v({}, n, s, i, o),
                        {
                            information: n,
                            invoices: i,
                            paymentMethod: s,
                            subscription: o
                        }
                    ];
                })(t, e, a), o = Ec(t, e), r = Pc(t, e, a), l = Rc(t, e), c = Uc(t, e);
                return [
                    v({}, n, s, o, r, l, c),
                    {
                        config: n,
                        billing: i,
                        plans: o,
                        checkout: r,
                        stripe: l,
                        vendorPublicConfig: c
                    }
                ];
            }, Mc = {
                loading: !1
            }, Fc = (t)=>Za(Mc, t), xc = (t, e, a)=>{
                const n = (e)=>{
                    Object.assign(t.vendor, e);
                }, s = async (t)=>{
                    n({
                        loading: !0
                    });
                    try {
                        var a;
                        const s = await En(()=>e.vendor.getVendorPublicInfo(), null == t ? void 0 : t.retryConfig);
                        s.whiteLabelMode = null != (a = s.whiteLabelMode) && a, n(v({}, s, {
                            loading: !1
                        }));
                    } catch (t) {
                        n({
                            loading: !1
                        }), console.error("failed to getVendorPublicInfo - ", t);
                    }
                };
                return {
                    setVendorState: n,
                    resetVendorState: ()=>{
                        Rn(t, [
                            "vendor"
                        ], Mc);
                    },
                    loadVendorPublicInfo: s,
                    loadVendorPublicConfiguration: s
                };
            }, Gc = {
                loading: !0,
                pageOffset: 0,
                pageSize: 20,
                logs: [],
                sort: [],
                filter: [],
                totalPages: 0,
                isDownloadingCsv: !1
            }, $c = (t)=>Za(Gc, t), jc = (t, e, a)=>{
                const n = a, s = (e)=>{
                    Object.assign(t.auditLogs.auditLogsState, e);
                };
                return {
                    setAuditLogsState: s,
                    resetAuditLogsState: ()=>{
                        Rn(t, [
                            "auditLogs",
                            "auditLogsState"
                        ], Gc);
                    },
                    exportAuditsCsv: async ()=>{
                        const a = t.auditLogs.auditLogsState, { columns: n } = t.auditLogs.auditsMetadataState;
                        try {
                            const t = a.filter, i = a.sort.reduce((t, e)=>v({}, t, {
                                    sortBy: e.id,
                                    sortDirection: e.desc ? "desc" : "asc"
                                }), {}), o = t.reduce((t, e)=>v({}, t, {
                                    [e.id]: e.value
                                }), {});
                            s({
                                isDownloadingCsv: !0
                            });
                            const r = "audits.csv";
                            await e.audits.exportAudits(v({
                                endpoint: "csv/v2",
                                headerProps: n,
                                offset: 0,
                                outputFileName: r
                            }, i, o));
                        } catch (t) {
                            console.error("failed to export audits - ", t);
                        }
                        s({
                            isDownloadingCsv: !1
                        });
                    },
                    loadAuditLogs: async (a)=>{
                        s({
                            loading: !(null != a && a.silentLoading),
                            error: null
                        });
                        const i = t.auditLogs.auditLogsState, o = null == a ? void 0 : a.retryConfig, { columns: r } = t.auditLogs.auditsMetadataState;
                        try {
                            var l, c, u, d, g;
                            const t = null != (l = a.pageSize) ? l : i.pageSize, p = null != (c = a.pageOffset) ? c : i.pageOffset, h = null != (u = a.filter) ? u : i.filter, y = null != (d = a.sort) ? d : i.sort;
                            s({
                                pageSize: t,
                                pageOffset: p,
                                filter: h,
                                sort: y
                            });
                            const S = y.reduce((t, e)=>v({}, t, {
                                    sortBy: e.id,
                                    sortDirection: e.desc ? "desc" : "asc"
                                }), {}), f = h.reduce((t, e)=>v({}, t, {
                                    [e.id]: e.value
                                }), {});
                            r || await n.loadAuditsMetadata({
                                retryConfig: o
                            });
                            const { data: m, total: b } = await En(()=>e.audits.getAudits(v({
                                    offset: p,
                                    count: t
                                }, S, f)), o);
                            s({
                                loading: !1,
                                logs: null != m ? m : [],
                                totalPages: +Math.ceil(b / t)
                            }), null == a || null == (g = a.callback) || g.call(a, !0);
                        } catch (t) {
                            var p;
                            s({
                                loading: !1,
                                error: Un(t)
                            }), null == a || null == (p = a.callback) || p.call(a, null, t);
                        }
                    }
                };
            }, Bc = {
                loading: !0
            }, Vc = (t)=>Za(Bc, t), Wc = (t, e, a)=>{
                const n = (e)=>{
                    Object.assign(t.auditLogs.auditsMetadataState, e);
                };
                return {
                    setAuditsMetadataState: n,
                    resetAuditsMetadataState: ()=>{
                        Rn(t, [
                            "auditLogs",
                            "auditsMetadataState"
                        ], Bc);
                    },
                    loadAuditsMetadata: async (t)=>{
                        n({
                            loading: !0,
                            error: null
                        });
                        try {
                            const { properties: a } = await En(()=>e.metadata.getAuditsMetadata(), null == t ? void 0 : t.retryConfig);
                            n({
                                columns: a,
                                loading: !1
                            });
                        } catch (t) {
                            n({
                                error: t,
                                loading: !1
                            });
                        }
                    }
                };
            }, Hc = (t)=>({
                    auditLogsState: $c(null == t ? void 0 : t.auditLogsState),
                    auditsMetadataState: Vc(null == t ? void 0 : t.auditsMetadataState)
                }), zc = (t, e, a)=>v({}, jc(t, e, a), Wc(t, e)), Kc = {
                total: 0,
                offset: 0,
                filter: "",
                sortBy: "createdAt",
                context: null,
                filters: [],
                rowsData: [],
                lastUpdated: new Date,
                isLoading: !0,
                isFetchMore: !1,
                totalToday: 0,
                currentPage: 0,
                headerProps: [],
                sortDirection: "desc",
                severeThisWeek: 0,
                predefinedFilters: [],
                isDownloadingCsv: !1,
                virtualScroll: !1
            }, qc = (t, e)=>Object.keys(t).reduce((a, n)=>{
                    const s = n;
                    return e.includes(n) ? v({}, a, {
                        [n]: t[s]
                    }) : v({}, a, {
                        [n]: ()=>{
                            console.debug(`Action ${String(n)} was called`);
                        }
                    });
                }, {}), Jc = {
                clientId: "CLIENT_ID_16806d3d-8fc3-4450-be97-abdaf66b723e",
                secret: "SECRET_16806d3d-8fc3-4450-be97-abdaf66b723e",
                createdAt: "createdAt",
                description: "Demo API Token (preview only)"
            }, Yc = v({}, Jc, {
                roleIds: [],
                tenantId: "my-tenant-id",
                createdByUserId: "createdByUserId"
            }), Xc = [
                {
                    id: "a040dcf6-b907-4e83-9970-6bd23c88fd40",
                    key: "ReadOnly",
                    name: "Read Only",
                    description: null,
                    isDefault: !1,
                    createdAt: new Date,
                    updatedAt: new Date,
                    permissions: [
                        "8d71b676-754c-4600-afe7-ca5add1e6809",
                        "04dbcc11-61db-40a9-9577-9b73e50d1d03"
                    ],
                    vendorId: "vendorId"
                },
                {
                    id: "b43b2c4b-e056-4eec-8c55-d200a475bbc0",
                    key: "Admin",
                    name: "Admin",
                    description: null,
                    isDefault: !0,
                    createdAt: new Date,
                    updatedAt: new Date,
                    permissions: [
                        "8d71b676-754c-4600-afe7-ca5add1e6809",
                        "04dbcc11-61db-40a9-9577-9b73e50d1d03",
                        "16647407-ed6f-4ca6-83a0-86225d921959",
                        "f403c6b9-1abe-4ec7-9971-aa032255fc25",
                        "a43e059d-d731-44b1-94bb-fb6b16c62210"
                    ],
                    vendorId: "vendorId"
                },
                {
                    id: "1234",
                    key: "Support",
                    name: "Support",
                    description: null,
                    isDefault: !0,
                    createdAt: new Date,
                    updatedAt: new Date,
                    permissions: [
                        "8d71b676-754c-4600-afe7-ca5add1e6809",
                        "04dbcc11-61db-40a9-9577-9b73e50d1d03",
                        "f26b00f8-ffe0-4739-b15c-7db15c27ea26",
                        "a9c803b0-ebfa-49b9-9607-f0d3a390ee61"
                    ],
                    tenantId: "tenantId",
                    vendorId: "vendorId"
                }
            ], Qc = {
                sub: "",
                tenants: [],
                id: "testId",
                name: "Demo User Name",
                email: "demo-user@frontegg.com",
                mfaEnrolled: !0,
                profilePictureUrl: "https://www.gravatar.com/avatar/42b2ad2bad6fc9b9db5086dfcf8072ac?d=https://ui-avatars.com/api/fe/128/random?t=1617261890875?t=1617261917434",
                roles: [
                    {
                        id: "roleId",
                        key: "admin",
                        isDefault: !1,
                        name: "Admin",
                        description: null,
                        permissions: [
                            "8d71b676-754c-4600-afe7-ca5add1e6809",
                            "04dbcc11-61db-40a9-9577-9b73e50d1d03"
                        ],
                        tenantId: "tenantId",
                        vendorId: "vendorId",
                        createdAt: new Date,
                        updatedAt: new Date
                    }
                ],
                permissions: [
                    {
                        id: "8d71b676-754c-4600-afe7-ca5add1e6809",
                        key: "fe.*",
                        name: "General Admin",
                        description: "description",
                        categoryId: "category",
                        fePermission: !0,
                        createdAt: new Date,
                        updatedAt: new Date,
                        roleIds: []
                    }
                ],
                tenantId: "my-tenant-id",
                tenantIds: [
                    "my-tenant-id"
                ],
                activatedForTenant: !0,
                metadata: JSON.stringify({
                    phoneNumber: "+972-54123456",
                    jobTitle: "Developer",
                    address: {
                        city: "Tel Aviv",
                        country: "Israel"
                    }
                }),
                verified: !1
            }, Zc = v({}, Qc, {
                accessToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI1MTY5YmY0Zi02YmI5LTQ5NGMtOGNkZS05MDc4NDQ0NWY4MDciLCJuYW1lIjoiRHVtbXkgVXNlciIsImVtYWlsIjoiZHVtbXlAZnJvbnRlZ2cuY29tIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsIm1ldGFkYXRhIjp7fSwicm9sZXMiOlsiYWRtaW4iXSwicGVybWlzc2lvbnMiOlsiZmUuKiJdLCJ0ZW5hbnRJZCI6Im15LXRlbmFudC1pZCIsInRlbmFudElkcyI6WyJteS10ZW5hbnQtaWQiXSwicHJvZmlsZVBpY3R1cmVVcmwiOiJodHRwczovL3d3dy5ncmF2YXRhci5jb20vYXZhdGFyLzQyYjJhZDJiYWQ2ZmM5YjlkYjUwODZkZmNmODA3MmFjP2Q9aHR0cHM6Ly91aS1hdmF0YXJzLmNvbS9hcGkvZmUvMTI4L3JhbmRvbT90PTE2MTcyNjE4OTA4NzU_dD0xNjE3MjYxOTE3NDM0IiwidHlwZSI6InVzZXJUb2tlbiIsImlhdCI6MTYxNzkwNjMyNCwiZXhwIjoxNjE3OTkyNzI0LCJpc3MiOiJmcm9udGVnZyJ9.paaXLkpWEWbQmUtoK2P8IwXCxK4WJp7XhXonvzF8g1I",
                expiresIn: 86400,
                mfaRequired: !1,
                refreshToken: "refresh-token-dummy-de39dc9c-9d22-4852-b7f5-c3c0aa613b58",
                type: "userToken",
                iat: 1617906324,
                exp: 1617992724,
                iss: "frontegg",
                email_verified: !0
            }), tu = {
                loading: !1,
                error: void 0,
                saving: !0,
                profile: Qc
            }, eu = {
                id: "id",
                enforceMFAType: "DontForce",
                createdAt: new Date,
                updatedAt: new Date,
                allowOverrideEnforcePasswordHistory: !0,
                allowOverridePasswordComplexity: !1,
                allowOverridePasswordExpiration: !1,
                allowSignups: !0,
                apiTokensEnabled: !0,
                cookieSameSite: "cookieSameSite",
                defaultRefreshTokenExpiration: 0,
                defaultTokenExpiration: 1,
                publicKey: "publicKey"
            }, au = {
                allowSignups: !0,
                allowNotVerifiedUsersLogin: !1,
                apiTokensEnabled: !0,
                forcePermissions: !1,
                authStrategy: N.EmailAndPassword,
                machineToMachineAuthStrategy: M.ClientCredentials
            }, nu = {
                id: "id",
                enforceMFAType: "DontForce",
                createdAt: new Date,
                updatedAt: new Date
            }, su = {
                id: "id",
                enabled: !0,
                maxAttempts: 1,
                createdAt: new Date,
                updatedAt: new Date
            }, iu = {
                id: "id",
                enabled: !0,
                historySize: 1,
                createdAt: new Date,
                updatedAt: new Date
            }, ou = {
                enabled: !0,
                domain: "domain",
                validated: !0,
                generatedVerification: "generatedVerification",
                ssoEndpoint: "ssoEndpoint",
                publicCertificate: "publicCertificate",
                signRequest: !0,
                createdAt: new Date,
                updatedAt: new Date,
                acsUrl: void 0,
                spEntityId: void 0,
                oidcClientId: void 0,
                oidcSecret: void 0,
                type: void 0
            }, ru = {
                id: "id",
                createdAt: "createdAt",
                updatedAt: "updatedAt",
                properties: [],
                vendorId: "vendorId",
                entityName: "saml",
                isActive: !0,
                configuration: {
                    acsUrl: "acsUrl",
                    spEntityId: "spEntityId"
                }
            }, lu = [
                {
                    id: "id",
                    description: "description",
                    key: "key",
                    name: "name",
                    permissions: [],
                    permissionLevel: 1
                }
            ], cu = {
                firstLoad: !1,
                loading: !1,
                error: void 0,
                saving: !1,
                samlConfiguration: ou,
                roles: lu,
                authorizationRoles: [],
                errors: {},
                loaders: {},
                ssoConfigurations: []
            }, uu = [
                {
                    description: "string",
                    fePermission: !0,
                    id: "id",
                    key: "key",
                    name: "name",
                    roleIds: [],
                    createdAt: new Date,
                    updatedAt: new Date,
                    categoryId: "categoryId"
                }
            ], du = {
                id: "id2",
                email: "demo-user2@frontegg.com",
                name: "Demo User Name2",
                phone: void 0,
                profileImage: void 0,
                profileImageUrl: void 0,
                tenantId: "tenantId",
                vendorId: "vendorId",
                roleIds: [],
                activatedForTenant: !0,
                verified: !1,
                createdAt: (new Date).toISOString(),
                customData: void 0,
                lastLogin: void 0,
                mfaEnabled: void 0,
                roles: [
                    Xc[0]
                ],
                groups: [
                    {
                        id: "id2",
                        name: "Developers",
                        color: "#03A9F4",
                        roles: [
                            Xc[0]
                        ],
                        managedBy: Fa.FRONTEGG
                    }
                ]
            }, gu = {
                id: du.id,
                email: du.email,
                name: du.name,
                phoneNumber: void 0,
                profileImage: void 0,
                tenantId: "tenantId",
                activatedForTenant: !0,
                createdAt: new Date(2022, 4, 1),
                verified: !0,
                lastLogin: new Date(2022, 5, 25),
                mfaEnrolled: !1,
                roles: [
                    Xc[1]
                ],
                tenantIds: [],
                metadata: "",
                sub: "",
                tenants: []
            }, pu = {
                id: "id",
                email: "demo-user@frontegg.com",
                name: "Demo User Name",
                phone: void 0,
                profileImage: void 0,
                profileImageUrl: void 0,
                tenantId: "tenantId",
                vendorId: "vendorId",
                roleIds: [],
                activatedForTenant: !0,
                createdAt: new Date(2022, 4, 1).toISOString(),
                verified: !0,
                customData: void 0,
                lastLogin: new Date(2022, 5, 25).toISOString(),
                mfaEnabled: void 0,
                roles: [
                    Xc[1]
                ],
                groups: [
                    {
                        id: "id1",
                        name: "Designers",
                        color: "#E1F5E2",
                        roles: [
                            Xc[0]
                        ],
                        managedBy: Fa.FRONTEGG
                    }
                ]
            }, hu = {
                id: pu.id,
                email: pu.email,
                name: pu.name,
                phoneNumber: void 0,
                profileImage: void 0,
                tenantId: "tenantId",
                activatedForTenant: !0,
                createdAt: new Date(2022, 4, 1),
                verified: !0,
                lastLogin: new Date(2022, 5, 25),
                mfaEnrolled: !1,
                roles: [
                    Xc[1]
                ],
                tenantIds: [],
                metadata: "",
                sub: "",
                tenants: []
            }, yu = {
                metadata: "",
                mfaEnrolled: !1,
                provider: "",
                sub: "",
                tenantIds: [],
                tenants: [],
                verified: !1,
                id: "id",
                email: "email",
                name: "name",
                tenantId: "tenantId",
                createdAt: new Date
            }, Su = [
                pu,
                du
            ], vu = [
                hu,
                gu
            ], fu = [
                yu
            ], mu = [
                {
                    id: "my-tenant-id",
                    isReseller: !1,
                    name: "Frontegg demo",
                    deletedAt: null,
                    metadata: void 0,
                    tenantId: "my-tenant-id",
                    vendorId: "vendorId",
                    createdAt: new Date,
                    updatedAt: new Date,
                    address: void 0,
                    timezone: void 0,
                    dateFormat: void 0,
                    timeFormat: void 0,
                    currency: void 0,
                    logo: void 0
                }
            ], bu = [
                {
                    id: "laptop",
                    userAgent: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_6) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.0 Safari/605.1.15",
                    createdAt: new Date,
                    ipAddress: "190.194.88.251",
                    current: !0
                },
                {
                    id: "iphone",
                    userAgent: "Mozilla/5.0 (iPhone; CPU iPhone OS 15_2_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.2 Mobile/15E148 Safari/604.1",
                    createdAt: new Date(Date.now() - 1e4),
                    ipAddress: "191.49.203.21"
                },
                {
                    id: "tablet",
                    userAgent: "Mozilla/5.0 (Linux; Android 6.0.1; SGP771 Build/32.2.A.0.253; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/52.0.2743.98 Safari/537.36",
                    createdAt: new Date(Date.now() - 3e4),
                    ipAddress: "130.19.196.136"
                },
                {
                    id: "anotherlaptop",
                    userAgent: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_6) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.0 Safari/605.1.15",
                    createdAt: new Date(Date.now() - 1002232300),
                    ipAddress: "2.228.163.92"
                }
            ], Au = {
                isActive: !0,
                strategy: Wt.ALLOW
            }, wu = [
                {
                    updatedAt: new Date,
                    createdAt: new Date,
                    id: "1",
                    ip: "255.255.255.255",
                    isActive: !0,
                    strategy: Wt.ALLOW,
                    description: "My IP"
                },
                {
                    updatedAt: new Date,
                    createdAt: new Date,
                    id: "2",
                    ip: "255.255.255.254",
                    isActive: !0,
                    strategy: Wt.ALLOW,
                    description: "IP 2"
                },
                {
                    updatedAt: new Date,
                    createdAt: new Date,
                    id: "3",
                    ip: "255.255.255.253",
                    isActive: !0,
                    strategy: Wt.BLOCK,
                    description: "IP 3"
                },
                {
                    updatedAt: new Date,
                    createdAt: new Date,
                    id: "4",
                    ip: "255.255.255.253",
                    isActive: !0,
                    strategy: Wt.BLOCK,
                    description: "IP 4"
                }
            ], Tu = (t)=>{
                const e = [];
                return Array.from({
                    length: t
                }).forEach((t, a)=>{
                    e.push(v({}, pu, {
                        name: "Demo User",
                        id: `id${a}`,
                        profilePictureUrl: null,
                        createdAt: new Date
                    }));
                }), e;
            }, Eu = (t)=>({
                    id: "b43b2c4b-e056-4eec-8c55-d200a475bbc0" + t,
                    key: t,
                    name: t,
                    description: null,
                    isDefault: !0,
                    createdAt: new Date,
                    updatedAt: new Date,
                    permissions: [],
                    tenantId: "tenantId",
                    vendorId: "vendorId"
                }), Iu = [
                {
                    id: "id1",
                    name: "Designers",
                    color: "#E1F5E2",
                    description: "The whole design team",
                    users: Tu(6),
                    roles: [
                        Eu("Editor")
                    ],
                    metadata: '{"lastTermsCheck":"2022-08-16T10:31:11.270Z"}',
                    managedBy: Fa.FRONTEGG
                },
                {
                    id: "id2",
                    name: "Developers",
                    color: "#03A9F4",
                    description: "All frontend and backend developers",
                    users: Tu(44),
                    roles: [
                        Eu("Editor")
                    ],
                    managedBy: Fa.FRONTEGG
                },
                {
                    id: "id3",
                    name: "Product",
                    color: "#E1583E",
                    description: "PMs and team leads",
                    users: Tu(8),
                    roles: [
                        Eu("Viewer")
                    ],
                    managedBy: Fa.FRONTEGG
                },
                {
                    id: "id4",
                    name: "Management",
                    color: "#9AE0FF",
                    description: "Executives",
                    users: Tu(5),
                    roles: [
                        Eu("Admin")
                    ],
                    managedBy: Fa.FRONTEGG
                },
                {
                    id: "id5",
                    name: "Sales",
                    color: "#ED8E7C",
                    users: Tu(21),
                    description: "BDR, AE, and inside sales",
                    roles: [
                        Eu("Viewer")
                    ],
                    managedBy: Fa.FRONTEGG
                },
                {
                    id: "id6",
                    name: "Support",
                    color: "#A79D7B",
                    users: Tu(23),
                    description: "Dev success and customer success",
                    roles: [
                        Eu("Admin")
                    ],
                    managedBy: Fa.FRONTEGG
                },
                {
                    id: "id7",
                    name: "Marketing",
                    color: "#2CA744",
                    users: Tu(10),
                    description: "The marketing department",
                    roles: [
                        Eu("Viewer")
                    ],
                    managedBy: Fa.FRONTEGG
                },
                {
                    id: "id8",
                    name: "HR",
                    color: "#EAE1C2",
                    users: Tu(4),
                    description: "Human resources",
                    roles: [
                        Eu("Viewer")
                    ],
                    managedBy: Fa.FRONTEGG
                },
                {
                    id: "id9",
                    name: "Finance",
                    color: "#5587C0",
                    users: Tu(3),
                    roles: [
                        Eu("Viewer")
                    ],
                    managedBy: Fa.FRONTEGG
                },
                {
                    id: "id10",
                    name: "Operations",
                    color: "#B1CAE7",
                    users: Tu(8),
                    roles: [
                        Eu("Editor")
                    ],
                    managedBy: Fa.FRONTEGG
                },
                {
                    id: "id11",
                    name: "Legal",
                    color: "#2CA744",
                    users: Tu(4),
                    roles: [
                        Eu("Viewer")
                    ],
                    managedBy: Fa.FRONTEGG
                }
            ], Ou = {
                scoring: {
                    score: 79
                },
                recommendations: {
                    items: [
                        {
                            code: Ba.FORCE_MFA,
                            severity: Ha.WARNING,
                            category: za.MFA
                        },
                        {
                            code: Ba.ENABLE_FORCE_RELOGIN,
                            severity: Ha.WARNING,
                            category: za.SESSIONS
                        }
                    ]
                }
            }, Pu = {
                insights: {
                    items: [
                        {
                            category: za.MFA,
                            code: Va.PARTIALLY_FORCED_MFA,
                            metadata: {
                                totalUsers: 2,
                                mfa: {
                                    enrolledUsersCount: 1
                                }
                            }
                        },
                        {
                            category: za.SESSIONS,
                            code: Va.PARTIAL_SESSION_SETTINGS,
                            metadata: {
                                totalUsers: 2,
                                sessions: {
                                    idleTimeoutRecommendation: 1800
                                }
                            }
                        },
                        {
                            category: za.PASSWORD,
                            code: Va.IMPROVE_PASSWORD_HISTORY_POLICY,
                            metadata: {
                                password: {
                                    userLockoutRecommendation: 5,
                                    historyRecommendations: 5
                                }
                            }
                        },
                        {
                            category: za.DOMAIN,
                            code: Va.NO_IP_RESTRICTIONS,
                            metadata: {
                                restrictions: {
                                    ipsCount: 1,
                                    domainsCount: 1
                                }
                            }
                        }
                    ]
                }
            }, ku = {
                users: vu,
                totalUsersItems: 2,
                totalUsersPages: 1,
                usersPageOffset: 0
            }, _u = {
                users: [
                    vu[0]
                ],
                totalUsersItems: 1,
                totalUsersPages: 1,
                usersPageOffset: 0,
                queryParams: {
                    _maxInactiveSeconds: 7776e3
                }
            }, Ru = {
                users: [
                    vu[1]
                ],
                totalUsersItems: 1,
                totalUsersPages: 1,
                usersPageOffset: 0
            };
            Oa.ASSIGNABLE, Oa.ASSIGNABLE, Oa.ASSIGNABLE, Oa.ASSIGNABLE, Oa.ASSIGNABLE, Oa.ASSIGNABLE, Oa.ASSIGNABLE, Oa.ASSIGNABLE, Oa.ASSIGNABLE, Oa.ASSIGNABLE, Oa.ASSIGNABLE, Oa.ASSIGNABLE, Oa.ASSIGNABLE, Oa.ASSIGNABLE, Oa.ASSIGNABLE, Oa.ASSIGNABLE, Oa.ASSIGNABLE, Oa.ASSIGNABLE, Oa.ASSIGNABLE, Oa.ASSIGNABLE, Oa.ASSIGNABLE, Oa.ASSIGNABLE;
            var Cu, Lu = new Uint8Array(16);
            function Uu() {
                if (!Cu && !(Cu = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
                return Cu(Lu);
            }
            const Du = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
            for(var Nu = [], Mu = 0; Mu < 256; ++Mu)Nu.push((Mu + 256).toString(16).substr(1));
            const Fu = function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, a = (Nu[t[e + 0]] + Nu[t[e + 1]] + Nu[t[e + 2]] + Nu[t[e + 3]] + "-" + Nu[t[e + 4]] + Nu[t[e + 5]] + "-" + Nu[t[e + 6]] + Nu[t[e + 7]] + "-" + Nu[t[e + 8]] + Nu[t[e + 9]] + "-" + Nu[t[e + 10]] + Nu[t[e + 11]] + Nu[t[e + 12]] + Nu[t[e + 13]] + Nu[t[e + 14]] + Nu[t[e + 15]]).toLowerCase();
                if (!function(t) {
                    return "string" == typeof t && Du.test(t);
                }(a)) throw TypeError("Stringified UUID is invalid");
                return a;
            }, xu = function(t, e, a) {
                var n = (t = t || {}).random || (t.rng || Uu)();
                if (n[6] = 15 & n[6] | 64, n[8] = 63 & n[8] | 128, e) {
                    a = a || 0;
                    for(var s = 0; s < 16; ++s)e[a + s] = n[s];
                    return e;
                }
                return Fu(n);
            }, Gu = [
                "callback"
            ], $u = [
                "callback"
            ], ju = [
                "callback",
                "profilePictureUrl"
            ], Bu = [
                "callback"
            ], Vu = [
                "callback"
            ], Wu = [
                "callback"
            ], Hu = [
                "callback"
            ], zu = [
                "callback"
            ], Ku = [
                "callback"
            ], qu = [
                "callback"
            ], Ju = [
                "callback"
            ], Yu = [
                "callback",
                "samlVendor"
            ], Xu = [
                "callback"
            ], Qu = [
                "callback"
            ], Zu = [
                "callback",
                "profileImage"
            ], td = [
                "callback"
            ], ed = [
                "callback"
            ], ad = [
                "callback"
            ], nd = [
                "callback"
            ], sd = [
                "callback"
            ], id = [
                "callback"
            ], od = [
                "callback"
            ], rd = [
                "callback"
            ], ld = [
                "requestName"
            ], cd = (t)=>"createdAt" !== t.id, ud = {
                total: 20,
                data: Array.from(Array(5).keys()).map((t)=>v({
                        ip: "198.143.51.1",
                        user: "Demo User Name",
                        email: "demo-user@frontegg.com"
                    }, (()=>{
                        switch(Math.floor(6 * Math.random())){
                            case 0:
                                return {
                                    action: "Updated profile",
                                    description: "User updated profile details",
                                    severity: "Info"
                                };
                            case 1:
                                return {
                                    action: "User logged in",
                                    severity: "Info",
                                    description: "User logged in to the product"
                                };
                            case 2:
                                return {
                                    action: "User failed to login",
                                    severity: "High",
                                    description: "User failed to login with password"
                                };
                            case 3:
                                return {
                                    action: "Added user",
                                    severity: "Info",
                                    description: "Added user david+535@frontegg.com to tenant"
                                };
                            case 4:
                                return {
                                    action: "Assigned roles",
                                    severity: "Info",
                                    description: "Assigned 0 roles for user"
                                };
                            case 5:
                                return {
                                    action: "Removed user david+108@frontegg.com from account",
                                    severity: "Info",
                                    description: "Removed access from the account for user david+108@frontegg.com"
                                };
                        }
                    })(), {
                        json: {
                            key1: "value1",
                            key2: "value2",
                            key3: "value3",
                            key4: "value4"
                        },
                        tenantId: "my-tenant-id",
                        vendorId: "my-vendor-id",
                        userAgent: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/89.0.4389.114 Safari/537.36",
                        createdAt: `2022-04-07 10:${50 - t}:40.201`
                    }))
            }, dd = {
                properties: [
                    {
                        showInTable: !0,
                        name: "createdAt",
                        displayName: "Time",
                        type: "Timestamp",
                        sortable: !0,
                        filterable: !0,
                        showInMoreInfo: "Always",
                        chosen: !1,
                        selected: !1,
                        isPredefined: !1
                    },
                    {
                        showInTable: !0,
                        name: "email",
                        displayName: "User",
                        type: "Email",
                        filterable: !0,
                        sortable: !0,
                        isPredefined: !0,
                        chosen: !1,
                        selected: !1
                    },
                    {
                        showInTable: !0,
                        name: "action",
                        displayName: "Action",
                        type: "AlphaNumeric",
                        sortable: !0,
                        filterable: !0,
                        showInMoreInfo: "Always",
                        chosen: !1,
                        selected: !1,
                        isPredefined: !0
                    },
                    {
                        showInTable: !0,
                        name: "description",
                        type: "AlphaNumeric",
                        sortable: !1,
                        filterable: !1,
                        displayName: "Description",
                        isPredefined: !0,
                        chosen: !1,
                        selected: !1
                    },
                    {
                        showInTable: !0,
                        name: "ip",
                        displayName: "IP Address",
                        type: "IpAddress",
                        sortable: !0,
                        filterable: !0,
                        showInMoreInfo: "Always",
                        chosen: !1,
                        selected: !1,
                        isPredefined: !0
                    },
                    {
                        showInTable: !1,
                        name: "severity",
                        displayName: "Severity",
                        type: "Severity",
                        sortable: !0,
                        filterable: !0,
                        showInMoreInfo: "Always",
                        chosen: !1,
                        selected: !1,
                        isPredefined: !0
                    },
                    {
                        showInTable: !1,
                        name: "userAgent",
                        displayName: "User Agent",
                        type: "AlphaNumeric",
                        filterable: !0,
                        sortable: !0,
                        isPredefined: !0,
                        chosen: !1,
                        selected: !1
                    },
                    {
                        showInTable: !1,
                        name: "json",
                        type: "Json",
                        sortable: !0,
                        filterable: !0,
                        displayName: "Json Data",
                        showInMoreInfo: "Always",
                        isPredefined: !1
                    }
                ]
            }, gd = (t, e, a)=>{
                const n = ((t, e, a)=>{
                    const n = jc(t, e, a), s = qc(n, [
                        "setAuditLogsState",
                        "resetAuditLogsState"
                    ]);
                    return s.loadAuditLogs = async (e)=>{
                        s.setAuditLogsState({
                            loading: !e.silentLoading,
                            error: null
                        });
                        const n = t.auditLogs.auditLogsState, { columns: i } = t.auditLogs.auditsMetadataState;
                        try {
                            var o, r, l, c, u;
                            const t = null != (o = e.pageSize) ? o : n.pageSize, d = null != (r = e.pageOffset) ? r : n.pageOffset, g = null != (l = e.filter) ? l : n.filter, p = null != (c = e.sort) ? c : n.sort;
                            s.setAuditLogsState({
                                pageSize: t,
                                pageOffset: d,
                                filter: g,
                                sort: p
                            }), i || await a.loadAuditsMetadata();
                            const { data: h, total: y } = ((t, e)=>{
                                const { data: a } = ud;
                                let n = a.filter(((t)=>(e)=>t.filter(cd).every((t)=>e[t.id].includes(t.value)))(t));
                                if (e.length) {
                                    const { id: t, desc: a = !1 } = e[0];
                                    n = n.sort(((t, e)=>(a, n)=>a[t] > n[t] ? e ? -1 : 1 : n[t] > a[t] ? e ? 1 : -1 : 0)(t, a));
                                }
                                return {
                                    data: n,
                                    total: n.length
                                };
                            })(g, p);
                            s.setAuditLogsState({
                                loading: !1,
                                logs: null != h ? h : [],
                                totalPages: +Math.ceil(y / t)
                            }), null == e || null == (u = e.callback) || u.call(e, !0);
                        } catch (t) {
                            var d;
                            s.setAuditLogsState({
                                loading: !1,
                                error: Un(t)
                            }), null == e || null == (d = e.callback) || d.call(e, null, t);
                        }
                    }, s;
                })(t, e, a), s = ((t, e)=>{
                    const a = Wc(t, e), n = qc(a, [
                        "setAuditsMetadataState",
                        "resetAuditsMetadataState"
                    ]);
                    return n.loadAuditsMetadata = async ()=>{
                        n.setAuditsMetadataState({
                            loading: !0,
                            error: null
                        });
                        try {
                            const { properties: t } = dd;
                            n.setAuditsMetadataState({
                                columns: t,
                                loading: !1
                            });
                        } catch (t) {
                            n.setAuditsMetadataState({
                                error: t,
                                loading: !1
                            });
                        }
                    }, n;
                })(t, e);
                return v({}, n, s);
            }, pd = {
                id: "sub_1JbhYVEwsu4qiqnnfMhYAdY6",
                externalId: "sub_1JbhYVEwsu4qiqnnfMhYAdY6",
                startDate: "2021-09-20T08:08:51.000Z",
                status: F.ACTIVE,
                externallyManaged: !1,
                cancellation: null,
                currentPeriodStart: "2021-09-20T08:08:51.000Z",
                currentPeriodEnd: "2021-10-20T08:08:51.000Z",
                plan: {
                    slug: "test"
                }
            }, hd = [
                {
                    id: "prod_J60fUEvI7qV1eL",
                    externalId: "prod_J60fUEvI7qV1eL",
                    name: "Premium",
                    description: "",
                    price: {
                        id: "price_1IToe8Ewsu4qiqnndAV76J69",
                        externalId: "price_1IToe8Ewsu4qiqnndAV76J69",
                        currency: "usd",
                        amount: 1e4
                    },
                    slug: "premium"
                },
                {
                    id: "prod_J60duauCpXfcur",
                    externalId: "prod_J60duauCpXfcur",
                    name: "Free",
                    description: "Totally free plan. Nothing to pay.",
                    price: {
                        id: "price_1ITocfEwsu4qiqnnnBHDx9fQ",
                        externalId: "price_1ITocfEwsu4qiqnnnBHDx9fQ",
                        currency: "usd",
                        amount: 0
                    },
                    slug: "free"
                }
            ], yd = [
                {
                    id: "in_1JbhYWEwsu4qiqnnrUh6hsHa",
                    externalId: "in_1JbhYWEwsu4qiqnnrUh6hsHa",
                    subscriptionId: "sub_1JbhYVEwsu4qiqnnfMhYAdY6",
                    paymentDate: "2021-09-20T08:08:51.000Z",
                    totalAmount: 1e4,
                    currency: "usd",
                    paid: !0,
                    receiptNumber: ""
                },
                {
                    id: "in_1JbhYWEwsu4qiqnnrUh6hsHa",
                    externalId: "in_1JbhYWEwsu4qiqnnrUh6hsHa",
                    subscriptionId: "sub_1JbhYVEwsu4qiqnnfMhYAdY6",
                    paymentDate: "2021-08-20T08:08:51.000Z",
                    totalAmount: 1e4,
                    currency: "usd",
                    paid: !0,
                    receiptNumber: ""
                }
            ], Sd = [
                {
                    id: "id",
                    externalId: "externalId",
                    type: x.CARD,
                    isDefault: !0,
                    last4: "4242",
                    expMonth: 11,
                    expYear: 25,
                    brand: "visa",
                    billingDetails: {
                        name: "Dummy",
                        email: "dummy@email.com"
                    }
                }
            ], vd = {
                allowPlanDowngrade: !0,
                allowPlanCancellation: !0
            }, fd = (t, e, a)=>{
                const n = ((t, e)=>{
                    const a = oc(t, e), n = qc(a, [
                        "setPaymentConfigState",
                        "resetPaymentConfigState"
                    ]);
                    return n.loadPaymentConfiguration = async ()=>{
                        n.setPaymentConfigState({
                            loading: !0
                        }), await wn(500), n.setPaymentConfigState({
                            loading: !1,
                            fetching: !1,
                            config: {
                                paymentProvider: nc.STRIPE,
                                apiKey: ""
                            }
                        });
                    }, n;
                })(t, e), [s, i] = ((t, e, a)=>{
                    const n = ((t, e, a)=>{
                        const n = dc(t, e, a), s = qc(n, [
                            "setBillingInformationState",
                            "resetBillingInformationState"
                        ]);
                        return s.loadBillingInformation = async ()=>{
                            var t, e;
                            s.setBillingInformationState({
                                loading: !0
                            }), await wn(500), s.setBillingInformationState({
                                loading: !1,
                                fetching: !1,
                                summary: {
                                    subscriptionId: pd.id,
                                    paymentMethodId: "mockPaymentMethodId",
                                    tenantConfigurationId: "mockTenantConfigurationId",
                                    providerType: $.Stripe,
                                    externallyManaged: !1,
                                    currentPlanId: hd[0].id,
                                    defaultPlanId: hd[0].id
                                },
                                plan: v({}, hd[0], {
                                    price: null == (t = hd[0].price) ? void 0 : t.amount,
                                    currency: null == (e = hd[0].price) ? void 0 : e.currency,
                                    recurringInterval: "month"
                                })
                            });
                        }, s;
                    })(t, e, a), s = ((t, e)=>{
                        const a = vc(t, e), n = qc(a, [
                            "setBillingPaymentMethodState",
                            "resetBillingPaymentMethodState"
                        ]);
                        return n.loadPaymentMethod = async ()=>{
                            n.setBillingPaymentMethodState({
                                loading: !0
                            }), await wn(500), n.setBillingPaymentMethodState({
                                paymentMethod: Sd[0],
                                loading: !1,
                                fetching: !1
                            });
                        }, n;
                    })(t, e), i = ((t, e)=>{
                        const a = hc(t, e), n = qc(a, [
                            "setBillingInvoiceState",
                            "resetBillingInvoiceState"
                        ]);
                        return n.loadBillingInvoices = async ()=>{
                            n.setBillingInvoiceState({
                                loading: !0
                            }), await wn(500), n.setBillingInvoiceState({
                                loading: !1,
                                fetching: !1,
                                invoices: yd.map((t)=>v({}, t, {
                                        selectedPlan: "Premium",
                                        paymentDate: new Date(Date.parse(t.paymentDate)),
                                        totalAmount: +((t.totalAmount || 0) / 100).toFixed(2)
                                    }))
                            });
                        }, n.loadInvoices = n.loadBillingInvoices, n;
                    })(t, e), o = ((t, e, a)=>{
                        const n = bc(t, e, a), s = qc(n, [
                            "setBillingSubscriptionState",
                            "resetBillingSubscriptionState",
                            "setCancellationLoading",
                            "setCancellationError",
                            "setRenewalLoading",
                            "setRenewalError"
                        ]);
                        return s.loadSubscription = async ()=>{
                            s.setBillingSubscriptionState({
                                loading: !0
                            }), await wn(500), s.setBillingSubscriptionState({
                                subscription: pd,
                                fetching: !1,
                                loading: !1,
                                error: null
                            });
                        }, s;
                    })(t, e, a);
                    return [
                        v({}, n, s, i, o),
                        {
                            information: n,
                            invoices: i,
                            paymentMethod: s,
                            subscription: o
                        }
                    ];
                })(t, e, a), o = ((t, e)=>{
                    const a = Ec(t, e), n = qc(a, [
                        "setPlansState",
                        "resetPlansState"
                    ]);
                    return n.loadPlans = async ()=>{
                        n.setPlansState({
                            loading: !0
                        }), await wn(500), n.setPlansState({
                            fetching: !1,
                            loading: !1,
                            plans: hd.map((t)=>{
                                var e, a;
                                return v({}, t, {
                                    price: (null == (e = t.price) ? void 0 : e.amount) || 0,
                                    currency: (null == (a = t.price) ? void 0 : a.currency) || "usd",
                                    recurringInterval: "month"
                                });
                            })
                        });
                    }, n;
                })(t, e), r = ((t, e, a)=>{
                    const n = Pc(t, e, a);
                    return qc(n, [
                        "setCheckoutState",
                        "resetCheckoutState",
                        "errorCheckout",
                        "resetCheckout"
                    ]);
                })(t, e, a), l = ((t, e)=>{
                    const a = Rc(t, e);
                    return qc(a, []);
                })(t, e), c = ((t, e)=>{
                    const a = Uc(t, e), n = qc(a, [
                        "setVendorPublicConfigState",
                        "resetVendorPublicConfigState",
                        "setVendorPublicConfigError",
                        "setVendorPublicConfigLoading"
                    ]);
                    return n.loadVendorPublicConfiguration = async ()=>{
                        n.setVendorPublicConfigLoading(!0), await wn(), n.setVendorPublicConfigState({
                            fetching: !1,
                            loading: !1,
                            vendorPublicConfig: vd
                        });
                    }, n;
                })(t, e);
                return [
                    v({}, n, s, o, r, l, c),
                    {
                        config: n,
                        billing: i,
                        plans: o,
                        checkout: r,
                        stripe: l,
                        vendorPublicConfig: c
                    }
                ];
            }, md = (t, e, a, n)=>{
                const { authActions: s, authStateActions: i } = ((t, e, a, n)=>{
                    const s = ((t, e)=>{
                        const a = Dn(t, e);
                        return qc(a, [
                            "setAcceptInvitationState",
                            "resetAcceptInvitationState"
                        ]);
                    })(t, e), i = ((t, e, a)=>{
                        const n = xn(t, e, a), s = qc(n, [
                            "setAccountSettingsState",
                            "resetAccountSettingsState"
                        ]);
                        return s.saveAccountSettings = async (e)=>{
                            var a;
                            s.setAccountSettingsState({
                                loading: !0
                            }), await wn();
                            const n = t.auth.accountSettingsState, { address: i, timezone: o, dateFormat: r, timeFormat: l, currency: c, logo: u } = n, d = v({
                                address: i,
                                timezone: o,
                                dateFormat: r,
                                timeFormat: l,
                                currency: c,
                                logo: u
                            }, e);
                            s.setAccountSettingsState(v({}, d, {
                                loading: !1
                            })), null == (a = e.callback) || a.call(e, d);
                        }, s.loadAccountSettings = async (t)=>{
                            s.setAccountSettingsState({
                                loading: !(null != t && t.silentLoading),
                                error: null
                            }), await wn(), s.setAccountSettingsState(v({
                                address: "Tel-aviv",
                                timezone: "Asia/Jerusalem",
                                dateFormat: "DD/MM/YYYY",
                                timeFormat: "HH:mm",
                                currency: "USD",
                                loading: !1
                            }, t));
                        }, s;
                    })(t, e, a), o = ((t, e)=>{
                        const a = Cs(t, e);
                        return qc(a, [
                            "setUnlockAccountState",
                            "resetUnlockAccountState"
                        ]);
                    })(t, e), r = ((t, e, a)=>{
                        const n = ks(t, e, a);
                        return qc(n, [
                            "setActivateState",
                            "resetActivateState",
                            "setActivateStrategyState"
                        ]);
                    })(t, e, a), l = ((t, e, a)=>{
                        const n = Vo(t, e, a);
                        return qc(n, [
                            "setAllAccountsLoader",
                            "setAllAccountsError",
                            "setAllAccountsState",
                            "setSelectedAccountState",
                            "resetAllAccountsState",
                            "clearSelectedAccount"
                        ]);
                    })(t, e, a), c = Wo(t), u = ((t, e)=>{
                        const a = Ns(t, e), n = qc(a, [
                            "setApiTokensState",
                            "resetApiTokensState",
                            "setApiTokensLoader",
                            "setApiTokensError"
                        ]);
                        return n.addTenantApiToken = async (e)=>{
                            const { description: a, roleIds: s, callback: i } = e;
                            n.setApiTokensLoader({
                                key: Ds.ADD_API_TOKEN,
                                value: !0
                            });
                            const { apiTokensDataTenant: o } = t.auth.apiTokensState, r = v({}, Yc, {
                                description: a,
                                roleIds: s,
                                clientId: `CLIENT_ID_${xu()}`
                            });
                            n.setApiTokensState({
                                showAddTokenDialog: !1
                            }), await wn(200), n.setApiTokensState({
                                apiTokensDataTenant: [
                                    ...o,
                                    r
                                ],
                                successDialog: {
                                    open: !0,
                                    secret: r.secret,
                                    clientId: r.clientId
                                }
                            }), await wn(200), n.setApiTokensLoader({
                                key: Ds.ADD_API_TOKEN,
                                value: !1
                            }), null == i || i(null);
                        }, n.deleteTenantApiToken = async (t)=>{
                            n.setApiTokensLoader({
                                key: Ds.DELETE_API_TOKEN,
                                value: !0
                            }), await wn(200);
                            const e = [
                                Yc
                            ];
                            n.setApiTokensState({
                                apiTokensDataTenant: e.filter((e)=>e.clientId !== t),
                                deleteTokenDialog: {
                                    open: !1,
                                    clientId: t
                                }
                            }), n.setApiTokensLoader({
                                key: Ds.DELETE_API_TOKEN,
                                value: !1
                            });
                        }, n.loadApiTokens = async (t)=>{
                            var e;
                            null != t && t.silentLoading || n.setApiTokensLoader({
                                key: Ds.LOAD_API_TOKENS,
                                value: !0
                            });
                            const a = [
                                Jc
                            ], s = [
                                Yc
                            ];
                            n.setApiTokensState({
                                apiTokensDataUser: a,
                                apiTokensDataTenant: s
                            }), await wn(200), n.setApiTokensLoader({
                                key: Ds.LOAD_API_TOKENS,
                                value: !1
                            }), null == t || null == (e = t.callback) || e.call(t, !0);
                        }, n.loadUserApiTokens = async (t)=>{
                            var e;
                            null != t && t.silentLoading || n.setApiTokensLoader({
                                key: Ds.LOAD_API_TOKENS,
                                value: !0
                            });
                            const a = [
                                Jc
                            ];
                            n.setApiTokensState({
                                apiTokensDataUser: a
                            }), await wn(200), n.setApiTokensLoader({
                                key: Ds.LOAD_API_TOKENS,
                                value: !1
                            }), null == t || null == (e = t.callback) || e.call(t, !0);
                        }, n.loadTenantApiTokens = async (t)=>{
                            var e;
                            null != t && t.silentLoading || n.setApiTokensLoader({
                                key: Ds.LOAD_API_TOKENS,
                                value: !0
                            });
                            const a = [
                                Yc
                            ];
                            n.setApiTokensState({
                                apiTokensDataTenant: a
                            }), await wn(200), n.setApiTokensLoader({
                                key: Ds.LOAD_API_TOKENS,
                                value: !1
                            }), null == t || null == (e = t.callback) || e.call(t, !0);
                        }, n;
                    })(t, e), d = ((t, e, a)=>{
                        const n = Gs(t, e, a);
                        return qc(n, [
                            "setApplicationsState",
                            "resetApplicationsState"
                        ]);
                    })(t, e, a), g = ((t, e, a)=>{
                        const n = Vs(t, e, a), s = qc(n, [
                            "setCustomLoginState",
                            "resetCustomLoginState"
                        ]);
                        return s.loadTenantMetadata = async ()=>{
                            s.setCustomLoginState({
                                loading: !0
                            }), await wn(), s.setCustomLoginState({
                                loading: !1
                            });
                        }, s.updateTenantMetadata = async (t)=>{
                            const { callback: e } = t;
                            s.setCustomLoginState({
                                loading: !0,
                                error: null
                            }), await wn(), s.setCustomLoginState({
                                loading: !1,
                                error: null
                            }), null == e || e(!0);
                        }, s;
                    })(t, e, a), p = ((t, e)=>{
                        const a = Bl(t, e);
                        return qc(a, [
                            "setEntitlements",
                            "handleFetchedEntitlements"
                        ]);
                    })(t, e), h = ((t, e)=>{
                        const a = qs(t, e), n = qc(a, [
                            "setForgotPasswordState",
                            "resetForgotPasswordState"
                        ]);
                        return n.loadPasswordConfig = async (t)=>{
                            n.setForgotPasswordState({
                                loading: !0
                            });
                            try {
                                n.setForgotPasswordState({
                                    loading: !1,
                                    passwordConfig: {
                                        allowPassphrases: !0,
                                        maxLength: 128,
                                        minLength: 6,
                                        minPhraseLength: 6,
                                        minOptionalTestsToPass: 1
                                    }
                                });
                            } catch (t) {
                                n.setForgotPasswordState({
                                    loading: !1,
                                    error: Un(t)
                                });
                            }
                        }, n;
                    })(t, e), y = ((t)=>{
                        const e = Qs(t), a = qc(e, [
                            "setStep"
                        ]);
                        return a.setStep(Js.success), a;
                    })(t), S = ((t, e)=>{
                        const a = si(t, e), n = qc(a, [
                            "setGroupsState",
                            "resetUsersGroupsState",
                            "setUsersGroupsLoader",
                            "setUsersGroupsError"
                        ]);
                        return n.loadGroups = async ()=>{
                            const t = ei.GET_GROUPS;
                            n.setUsersGroupsLoader({
                                key: t,
                                value: !0
                            });
                            const e = Iu;
                            n.setGroupsState({
                                groups: e
                            }), n.setUsersGroupsLoader({
                                key: t,
                                value: !1
                            });
                        }, n.createGroup = async (e)=>{
                            var a;
                            const s = ei.CREATE_GROUP, { groups: i } = t.auth.groupsState;
                            n.setUsersGroupsLoader({
                                key: s,
                                value: !0
                            }), await wn(500), n.setGroupsState({
                                groups: [
                                    v({}, e, {
                                        id: `${e.name}ID`,
                                        managedBy: Fa.FRONTEGG
                                    }),
                                    ...null != i ? i : []
                                ]
                            }), null == e || null == (a = e.callback) || a.call(e, !0), n.setUsersGroupsLoader({
                                key: s,
                                value: !1
                            });
                        }, n.updateGroup = async (e)=>{
                            var a, s, i, o, r;
                            const l = ei.UPDATE_GROUP, c = t.auth.groupsState;
                            n.setUsersGroupsLoader({
                                key: l,
                                value: !0
                            }), await wn(500), n.setGroupsState({
                                groups: null == c || null == (a = c.groups) ? void 0 : a.map((t)=>{
                                    var a;
                                    return t.id === e.groupId ? v({}, e, {
                                        id: e.groupId,
                                        name: null != (a = null == e ? void 0 : e.name) ? a : "",
                                        managedBy: Fa.FRONTEGG
                                    }) : t;
                                }),
                                selectedGroup: v({}, null == c ? void 0 : c.selectedGroup, {
                                    name: null != (s = null == e ? void 0 : e.name) ? s : "",
                                    color: null != (i = null == e ? void 0 : e.color) ? i : "",
                                    description: null != (o = null == e ? void 0 : e.description) ? o : ""
                                })
                            }), null == e || null == (r = e.callback) || r.call(e, !0), n.setUsersGroupsLoader({
                                key: l,
                                value: !1
                            });
                        }, n.deleteGroup = async (e)=>{
                            var a, s;
                            const i = ei.DELETE_GROUP, o = t.auth.groupsState;
                            n.setUsersGroupsLoader({
                                key: i,
                                value: !0
                            }), await wn(500), n.setGroupsState({
                                groups: null == o || null == (a = o.groups) ? void 0 : a.filter((t)=>t.id !== e.groupId)
                            }), null == e || null == (s = e.callback) || s.call(e, !0), n.setUsersGroupsLoader({
                                key: i,
                                value: !1
                            });
                        }, n.addRolesToGroup = async (e)=>{
                            var a, s;
                            const i = ei.ADD_ROLES_TO_GROUP, o = t.auth.groupsState;
                            n.setUsersGroupsLoader({
                                key: i,
                                value: !0
                            }), await wn(500), n.setGroupsState({
                                groups: null == o || null == (a = o.groups) ? void 0 : a.map((t)=>{
                                    var a;
                                    return t.id === e.groupId ? v({}, t, {
                                        roles: [
                                            ...null != (a = null == t ? void 0 : t.roles) ? a : [],
                                            ...e.roleIds.map((t)=>({
                                                    id: t,
                                                    name: t
                                                }))
                                        ]
                                    }) : t;
                                })
                            }), null == e || null == (s = e.callback) || s.call(e, !0), n.setUsersGroupsLoader({
                                key: i,
                                value: !1
                            });
                        }, n.deleteRolesFromGroup = async (e)=>{
                            var a, s;
                            const i = ei.DELETE_ROLES_FROM_GROUP, o = t.auth.groupsState;
                            n.setUsersGroupsLoader({
                                key: i,
                                value: !0
                            }), await wn(500), n.setGroupsState({
                                groups: null == o || null == (a = o.groups) ? void 0 : a.map((t)=>{
                                    var a;
                                    return t.id === e.groupId ? v({}, t, {
                                        roles: null == t || null == (a = t.roles) ? void 0 : a.filter((t)=>!e.roleIds.includes(t.id))
                                    }) : t;
                                })
                            }), null == e || null == (s = e.callback) || s.call(e, !0), n.setUsersGroupsLoader({
                                key: i,
                                value: !1
                            });
                        }, n.addUsersToGroup = async (e)=>{
                            var a, s;
                            const i = ei.ADD_USERS_TO_GROUP, o = t.auth.groupsState;
                            n.setUsersGroupsLoader({
                                key: i,
                                value: !0
                            }), await wn(500), n.setGroupsState({
                                groups: null == o || null == (a = o.groups) ? void 0 : a.map((t)=>{
                                    var a;
                                    return t.id === e.groupId ? v({}, t, {
                                        users: [
                                            ...null != (a = null == t ? void 0 : t.users) ? a : [],
                                            ...e.userIds.map((t)=>({
                                                    id: t,
                                                    name: t
                                                }))
                                        ]
                                    }) : t;
                                })
                            }), null == e || null == (s = e.callback) || s.call(e, !0), n.setUsersGroupsLoader({
                                key: i,
                                value: !1
                            });
                        }, n.deleteUsersFromGroup = async (e)=>{
                            var a, s;
                            const i = ei.DELETE_USERS_FROM_GROUP, o = t.auth.groupsState;
                            n.setUsersGroupsLoader({
                                key: i,
                                value: !0
                            }), await wn(500), n.setGroupsState({
                                groups: null == o || null == (a = o.groups) ? void 0 : a.map((t)=>{
                                    var a;
                                    return t.id === e.groupId ? v({}, t, {
                                        users: null == t || null == (a = t.users) ? void 0 : a.filter((t)=>!e.userIds.includes(t.id))
                                    }) : t;
                                })
                            }), null == e || null == (s = e.callback) || s.call(e, !0), n.setUsersGroupsLoader({
                                key: i,
                                value: !1
                            });
                        }, n.getGroupConfiguration = async ()=>{
                            const e = ei.GET_GROUP_CONFIGURATION, { groupsConfiguration: a } = t.auth.groupsState;
                            n.setUsersGroupsLoader({
                                key: e,
                                value: !0
                            }), a && n.setGroupsState({
                                groupsConfiguration: v({}, a)
                            }), n.setUsersGroupsLoader({
                                key: e,
                                value: !1
                            });
                        }, n.updateGroupConfiguration = async (e)=>{
                            const a = ei.UPDATE_GROUP_CONFIGURATION, { groupsConfiguration: s } = t.auth.groupsState;
                            n.setUsersGroupsLoader({
                                key: a,
                                value: !0
                            }), s && n.setGroupsState({
                                groupsConfiguration: v({}, s, e)
                            }), n.setUsersGroupsLoader({
                                key: a,
                                value: !1
                            });
                        }, n;
                    })(t, e), m = ri(t), b = ((t, e, a)=>{
                        const n = gi(t, e, a);
                        return qc(n, [
                            "setImpersonateState",
                            "resetImpersonateState"
                        ]);
                    })(t, e, a), A = ((t, e, a)=>{
                        const n = a, s = bo(t, e, n), i = qc(s, [
                            "setLoginState",
                            "resetLoginState",
                            "afterAuthNavigation"
                        ]);
                        return i.requestAuthorize = async (t)=>{
                            t && n.setAuthState({
                                isLoading: !0
                            });
                            const e = Zc;
                            await n.loadTenants(), n.setAuthState({
                                user: e,
                                isAuthenticated: !0,
                                isLoading: !1
                            });
                        }, i.getUserIP = async (t)=>{
                            const { callback: e } = t;
                            try {
                                const { ip: t } = wu[0];
                                await n.setAuthState({
                                    userIpData: {
                                        ip: t
                                    },
                                    userIp: t
                                }), null == e || e(!0, t);
                            } catch (t) {
                                null == e || e(!1, t);
                            }
                        }, i;
                    })(t, e, a), w = ((t, e, a)=>{
                        const n = a, s = Co(t, e, n), i = qc(s, [
                            "setMfaState",
                            "resetMfaState"
                        ]);
                        return i.enrollMfa = async ()=>{
                            i.setMfaState({
                                saving: !0
                            }), i.setMfaState({
                                saving: !1,
                                error: void 0,
                                qrCode: "test"
                            });
                        }, i.verifyMfa = async (e)=>{
                            const { callback: a } = e, { mfaDevices: s = {
                                webauthn: [],
                                phones: [],
                                authenticators: [],
                                emails: []
                            } } = (f(e, Gu), t.auth.mfaState);
                            i.setMfaState({
                                saving: !0
                            }), await wn();
                            const o = {
                                token: "token",
                                recoveryCode: "recoveryCode"
                            }, r = {
                                step: qn.recoveryCode,
                                loading: !1,
                                error: void 0,
                                saving: !1,
                                mfaDevices: v({}, s, {
                                    authenticators: [
                                        {
                                            id: "authenticator-id"
                                        }
                                    ]
                                })
                            };
                            null != o && o.recoveryCode && (r.recoveryCode = o.recoveryCode), i.setMfaState(r), n.setUser(v({}, Zc, {
                                mfaEnrolled: !0
                            })), null == a || a(r.recoveryCode);
                        }, i.disableMfa = async (e)=>{
                            var a;
                            const { mfaDevices: s = {
                                webauthn: [],
                                phones: [],
                                authenticators: [],
                                emails: []
                            } } = t.auth.mfaState;
                            i.setMfaState({
                                saving: !0
                            }), await wn(), i.setMfaState({
                                saving: !1,
                                error: void 0,
                                mfaDevices: v({}, s, {
                                    authenticators: []
                                })
                            }), n.setUser(v({}, Zc)), null == (a = e.callback) || a.call(e, !0);
                        }, i.verifyMfaAfterForce = async (t)=>{
                            const { callback: e } = t, a = f(t, $u);
                            i.setMfaState({
                                loading: !0
                            }), await wn();
                            const s = v({}, a, {
                                recoveryCode: "recoveryCode"
                            }), o = {
                                step: qn.recoveryCode,
                                loading: !1,
                                error: void 0,
                                saving: !1
                            };
                            null != s && s.recoveryCode && (o.recoveryCode = s.recoveryCode), i.setMfaState(o), await wn(), n.setUser(v({}, Zc, {
                                mfaEnrolled: !0
                            })), null == e || e(o.recoveryCode);
                        }, i.preDisableMfaSms = async (t)=>{
                            i.setMfaState({
                                saving: !0
                            });
                            try {
                                var e;
                                i.setMfaState({
                                    saving: !1,
                                    error: void 0,
                                    otcToken: "otc-token",
                                    phoneNumber: "+972504589346"
                                }), null == (e = t.callback) || e.call(t, !0);
                            } catch (e) {
                                var a;
                                i.setMfaState({
                                    saving: !1,
                                    error: Un(e)
                                }), null == (a = t.callback) || a.call(t, !1, e);
                            }
                        }, i.disableMfaSms = async (e)=>{
                            var a;
                            const { mfaDevices: s = {
                                webauthn: [],
                                phones: [],
                                authenticators: [],
                                emails: []
                            } } = t.auth.mfaState;
                            i.setMfaState({
                                saving: !0
                            }), await wn(), i.setMfaState({
                                loading: !1,
                                error: void 0,
                                mfaDevices: v({}, s, {
                                    phones: []
                                })
                            }), n.setUser(v({}, Zc)), null == (a = e.callback) || a.call(e, !0);
                        }, i.preEnrollMfaSms = async (t)=>{
                            var e;
                            i.setMfaState({
                                saving: !0
                            }), await wn(), i.setMfaState({
                                saving: !1,
                                error: void 0,
                                otcToken: "otc-token",
                                phoneNumber: "+972504589346"
                            }), null == (e = t.callback) || e.call(t, !0);
                        }, i.enrollMfaSms = async (e)=>{
                            const { callback: a } = e, { mfaDevices: s = {
                                webauthn: [],
                                phones: [],
                                authenticators: [],
                                emails: []
                            } } = t.auth.mfaState;
                            i.setMfaState({
                                saving: !0
                            }), await wn();
                            const o = {
                                token: "token",
                                recoveryCode: "recoveryCode"
                            }, r = {
                                step: qn.recoveryCode,
                                loading: !1,
                                error: void 0,
                                saving: !1,
                                mfaDevices: v({}, s, {
                                    phones: [
                                        {
                                            id: "phone-id",
                                            phoneNumber: "+972504589346"
                                        }
                                    ]
                                })
                            };
                            null != o && o.recoveryCode && (r.recoveryCode = o.recoveryCode), i.setMfaState(r), n.setUser(v({}, Zc, {
                                mfaEnrolled: !0
                            })), null == a || a(r.recoveryCode);
                        }, i;
                    })(t, e, a), T = ((t, e, a)=>{
                        const n = Ko(t, e, a);
                        return qc(n, [
                            "setPasskeysState",
                            "resetPasskeysState"
                        ]);
                    })(t, e, a), E = ((t, e, a)=>{
                        const n = Xo(t, e, a), s = qc(n, [
                            "setProfileState",
                            "resetProfileState"
                        ]);
                        return s.loadProfile = async ()=>{
                            s.setProfileState({
                                loading: !0
                            }), await wn(), a.setUser(v({}, Zc, Qc)), s.setProfileState({
                                loading: !1,
                                profile: Qc
                            });
                        }, s.saveProfile = async (t)=>{
                            const { callback: e, profilePictureUrl: n } = t, i = f(t, ju);
                            s.setProfileState({
                                saving: !0,
                                error: null
                            });
                            const o = tu;
                            let r = o.profile.profilePictureUrl;
                            n !== o.profile.profilePictureUrl && n && (n || "").match(/^data:image\/([A-Za-z-+\/]+);base64,(.+)$/) && (r = n);
                            const l = v({}, o.profile, i, {
                                profilePictureUrl: r
                            }), c = Zc;
                            await wn(), a.setUser(v({}, c, l)), s.setProfileState({
                                loading: !1,
                                error: null,
                                saving: !1,
                                profile: l
                            }), null == e || e(l);
                        }, s.changePassword = async (t)=>{
                            var e;
                            s.setProfileState({
                                loading: !0
                            }), await wn(), s.setProfileState({
                                loading: !1,
                                error: void 0
                            }), null == (e = t.callback) || e.call(t, !0);
                        }, s;
                    })(t, e, a), I = ((t, e)=>{
                        const a = ar(t, e);
                        return qc(a, [
                            "setProvisioningState",
                            "resetProvisioningState"
                        ]);
                    })(t, e), O = ((t, e, a)=>{
                        const n = cr(t, e, a);
                        return qc(n, [
                            "setResetPhoneNumberState",
                            "resetResetPhoneNumberState"
                        ]);
                    })(t, e, a), P = ((t, e, a)=>{
                        const n = Or(t, e, a), s = qc(n, [
                            "setRestrictionsState",
                            "setIpRestrictionsState",
                            "setEmailDomainRestrictionsState"
                        ]);
                        return s.loadIpRestrictions = async ()=>{
                            s.setIpRestrictionsState({
                                loading: !0,
                                error: null
                            }), s.setIpRestrictionsState({
                                data: {
                                    restrictions: wu.filter((t)=>t.strategy === Au.strategy),
                                    config: Au
                                },
                                totalPages: 1,
                                pagination: {
                                    _filter: Wt.ALLOW,
                                    _limit: 50,
                                    _offset: 0
                                },
                                loading: !1
                            });
                        }, s.loadEmailDomainRestrictions = async ()=>{
                            s.setEmailDomainRestrictionsState({
                                loading: !0,
                                error: null
                            }), s.setEmailDomainRestrictionsState({
                                loading: !1,
                                data: {
                                    restrictions: [
                                        {
                                            domain: "mock.com",
                                            id: "1",
                                            type: Wt.ALLOW
                                        }
                                    ],
                                    config: {
                                        active: !0,
                                        listType: Wt.ALLOW,
                                        blockPublicDomains: !1
                                    }
                                }
                            });
                        }, s.saveIpRestriction = async (e)=>{
                            var a, n, i;
                            const { callback: o } = e, r = f(e, Bu);
                            s.setIpRestrictionsState({
                                saving: !0,
                                error: null
                            });
                            const l = t.auth.restrictionsState.ipRestrictions, c = l.data.restrictions.filter((t)=>t.ip !== r.ip);
                            s.setIpRestrictionsState({
                                data: {
                                    config: null != (a = null == (n = l.data) ? void 0 : n.config) ? a : {
                                        isActive: !1,
                                        strategy: Wt.ALLOW
                                    },
                                    restrictions: [
                                        ...c,
                                        v({}, r, {
                                            createdAt: new Date,
                                            updatedAt: new Date,
                                            id: xu(),
                                            isActive: null == (i = r.isActive) || i,
                                            strategy: l.data.config.strategy
                                        })
                                    ]
                                },
                                totalPages: 1,
                                pagination: {
                                    _filter: Wt.ALLOW,
                                    _limit: 50,
                                    _offset: 0
                                },
                                saving: !1
                            }), null == o || o(!0);
                        }, s.saveIpRestrictionsConfig = async (e)=>{
                            var a, n, i;
                            const { callback: o } = e, r = f(e, Vu), l = t.auth.restrictionsState.ipRestrictions;
                            s.setIpRestrictionsState({
                                saving: !0,
                                error: null
                            }), s.setIpRestrictionsState({
                                data: {
                                    config: v({}, null == (a = l.data) ? void 0 : a.config, r),
                                    restrictions: null != (n = null == (i = l.data) ? void 0 : i.restrictions) ? n : []
                                },
                                pagination: {
                                    _filter: Wt.ALLOW,
                                    _limit: 50,
                                    _offset: 0
                                },
                                totalPages: 1,
                                saving: !1
                            }), s.setIpRestrictionsState({
                                saving: !1,
                                error: null
                            }), null == o || o(!0);
                        }, s.deleteIpRestriction = async (e)=>{
                            var a;
                            const { callback: n, id: i } = e;
                            s.setIpRestrictionsState({
                                saving: !0,
                                error: null
                            });
                            const o = t.auth.restrictionsState.ipRestrictions;
                            s.setIpRestrictionsState({
                                data: {
                                    config: (null == (a = o.data) ? void 0 : a.config) || {
                                        isActive: !1,
                                        strategy: Wt.ALLOW
                                    },
                                    restrictions: o.data.restrictions.filter((t)=>t.id !== i)
                                },
                                pagination: {
                                    _filter: Wt.ALLOW,
                                    _limit: 50,
                                    _offset: 0
                                },
                                totalPages: 1,
                                saving: !1,
                                error: null
                            }), null == n || n(!0);
                        }, s.checkIfUserIpValid = async ()=>{
                            s.setIpRestrictionsState({
                                loading: !0,
                                error: null
                            });
                            try {
                                const e = t.auth.restrictionsState.ipRestrictions, a = wu[0].ip, n = !!e.data.restrictions.find((t)=>t.isActive && t.ip === a);
                                s.setIpRestrictionsState({
                                    userIpValid: n,
                                    loading: !1
                                });
                            } catch (t) {
                                s.setIpRestrictionsState({
                                    error: Un(t),
                                    loading: !1
                                });
                            }
                        }, s.saveEmailDomainRestriction = async (e)=>{
                            var a, n;
                            const { callback: i } = e, o = f(e, Wu), r = t.auth.restrictionsState.emailDomainRestrictions;
                            s.setEmailDomainRestrictionsState({
                                saving: !0,
                                error: null
                            }), await wn(), null == i || i(!0), s.setEmailDomainRestrictionsState({
                                data: {
                                    config: (null == (a = r.data) ? void 0 : a.config) || {
                                        active: !1,
                                        blockPublicDomains: !1,
                                        listType: o.type
                                    },
                                    restrictions: [
                                        ...(null == (n = r.data) ? void 0 : n.restrictions) || [],
                                        v({}, o, {
                                            id: Date.now().toString()
                                        })
                                    ]
                                },
                                saving: !1
                            });
                        }, s.saveEmailDomainRestrictionsConfig = async (e)=>{
                            var a;
                            const { callback: n } = e, i = f(e, Hu), o = t.auth.restrictionsState.emailDomainRestrictions;
                            s.setEmailDomainRestrictionsState({
                                saving: !0,
                                error: null
                            }), await wn(), null == n || n(!0), s.setEmailDomainRestrictionsState({
                                data: {
                                    config: {
                                        active: i.active,
                                        blockPublicDomains: i.blockPublicDomains || !1,
                                        listType: i.type || Wt.ALLOW
                                    },
                                    restrictions: [
                                        ...(null == (a = o.data) ? void 0 : a.restrictions) || []
                                    ]
                                },
                                saving: !1
                            });
                        }, s.deleteEmailDomainRestriction = async (e)=>{
                            var a, n;
                            const { id: i } = e, o = t.auth.restrictionsState.emailDomainRestrictions;
                            s.setEmailDomainRestrictionsState({
                                saving: !0,
                                error: null
                            }), await wn(), s.setEmailDomainRestrictionsState({
                                data: {
                                    config: (null == (a = o.data) ? void 0 : a.config) || {
                                        active: !1,
                                        blockPublicDomains: !1,
                                        listType: Wt.ALLOW
                                    },
                                    restrictions: ((null == (n = o.data) ? void 0 : n.restrictions) || []).filter((t)=>t.id === i)
                                },
                                saving: !1
                            });
                        }, s;
                    })(t, e, a), k = ((t, e)=>{
                        const a = mr(t, e), n = qc(a, [
                            "setRolesState",
                            "setRolesStateError",
                            "setRolesStateLoader",
                            "resetRolesState"
                        ]);
                        return n.loadRolesAndPermissions = async (t)=>{
                            var e;
                            const a = gr.LOAD_ROLES;
                            n.setRolesStateLoader({
                                key: a,
                                value: !(null != (e = null == t ? void 0 : t.silentLoading) && e)
                            });
                            try {
                                n.setRolesState({
                                    roles: Xc
                                });
                            } catch (t) {
                                n.setRolesStateError({
                                    key: a,
                                    value: Un(t)
                                });
                            } finally{
                                n.setRolesStateLoader({
                                    key: a,
                                    value: !1
                                });
                            }
                        }, n;
                    })(t, e), _ = ((t, e, a)=>{
                        const n = Cr(t, e, a), s = qc(n, [
                            "setSecurityCenterState",
                            "setSecurityCenterStateError",
                            "setSecurityCenterStateLoader",
                            "resetSecurityCenterState"
                        ]);
                        return s.loadRecommendations = async ()=>{
                            const t = _r.RECOMMENDATIONS;
                            s.setSecurityCenterStateLoader({
                                key: t,
                                value: !0
                            }), await wn(), s.setSecurityCenterState({
                                recommendations: Ou.recommendations.items,
                                score: Ou.scoring.score
                            }), s.setSecurityCenterStateLoader({
                                key: t,
                                value: !1
                            });
                        }, s.loadInsights = async ()=>{
                            const t = _r.INSIGHTS;
                            s.setSecurityCenterStateLoader({
                                key: t,
                                value: !0
                            }), await wn(), s.setSecurityCenterState({
                                insights: Pu.insights.items
                            }), s.setSecurityCenterStateLoader({
                                key: t,
                                value: !1
                            });
                        }, s.loadBreachedPasswordUsers = async ()=>{
                            const t = _r.BREACHED_PASSWORD_USERS_TABLE;
                            s.setSecurityCenterStateLoader({
                                key: t,
                                value: !0
                            }), await wn(), s.setSecurityCenterState({
                                breachedPasswordUsersTable: ku
                            }), s.setSecurityCenterStateLoader({
                                key: t,
                                value: !1
                            });
                        }, s.loadUnenrolledMfaUsers = async ()=>{
                            const t = _r.UNENROLLED_MFA_USERS_TABLE;
                            s.setSecurityCenterStateLoader({
                                key: t,
                                value: !0
                            }), await wn(), s.setSecurityCenterState({
                                unenrolledMfaUsersTable: Ru
                            }), s.setSecurityCenterStateLoader({
                                key: t,
                                value: !1
                            });
                        }, s.loadInactiveUsers = async ()=>{
                            const t = _r.INACTIVE_USERS_TABLE;
                            s.setSecurityCenterStateLoader({
                                key: t,
                                value: !0
                            }), await wn(), s.setSecurityCenterState({
                                inactiveUsersTable: _u
                            }), s.setSecurityCenterStateLoader({
                                key: t,
                                value: !1
                            });
                        }, s.sendResetBreachedPasswordEmail = async (t)=>{
                            const { callback: e } = t, a = _r.SEND_BREACHED_PASSWORD_EMAIL;
                            s.setSecurityCenterStateLoader({
                                key: a,
                                value: !0
                            }), await wn(), null == e || e(!0), s.setSecurityCenterStateLoader({
                                key: a,
                                value: !1
                            });
                        }, s;
                    })(t, e, a), R = ((t, e, a)=>{
                        const n = Gr(t, e, a), s = qc(n, [
                            "setSecurityPolicyState",
                            "setSecurityPolicyGlobalState",
                            "setSecurityPolicyPublicState",
                            "setSecurityPolicyMfaState",
                            "setSecurityPolicyVendorMfaState",
                            "setSecurityPolicyLockoutState",
                            "setSecurityPolicyVendorLockoutState",
                            "setSecurityPolicyCaptchaState",
                            "setSecurityPolicyPasswordHistoryState",
                            "setSecurityPolicyVendorPasswordHistoryState",
                            "resetSecurityPolicyState",
                            "setSecurityPolicyPasswordState",
                            "setSecurityPolicyAuthStrategyPublicState"
                        ]);
                        return s.loadSecurityPolicy = async ()=>{
                            s.setSecurityPolicyGlobalState({
                                loading: !0,
                                error: null
                            }), await Promise.all([
                                s.loadSecurityPolicyMfa(),
                                s.loadSecurityPolicyVendorMfa(),
                                s.loadSecurityPolicyLockout(),
                                s.loadSecurityPolicyVendorLockout(),
                                s.loadSecurityPolicyPasswordHistory(),
                                s.loadSecurityPolicyVendorPasswordHistory(),
                                s.loadSecurityPolicyCaptcha()
                            ]), await wn(), s.setSecurityPolicyGlobalState({
                                policy: eu,
                                loading: !1
                            });
                        }, s.loadPublicSecurityPolicy = async ()=>{
                            s.setSecurityPolicyPublicState({
                                loading: !0,
                                error: null
                            });
                            try {
                                s.setSecurityPolicyPublicState({
                                    policy: au,
                                    loading: !1
                                });
                            } catch (t) {
                                s.setSecurityPolicyPublicState({
                                    error: Un(t),
                                    loading: !1
                                });
                            }
                        }, s.saveSecurityPolicyMfa = async (t)=>{
                            var e;
                            const { callback: a } = t, n = f(t, zu);
                            s.setSecurityPolicyMfaState({
                                saving: !0,
                                error: null
                            });
                            const i = v({}, su, {
                                id: null != (e = n.id) ? e : su.id,
                                enforceMFAType: n.enforceMFAType
                            });
                            await wn(), s.setSecurityPolicyMfaState({
                                policy: i,
                                saving: !1
                            }), null == a || a(i);
                        }, s.loadSecurityPolicyMfa = async ()=>{
                            s.setSecurityPolicyMfaState({
                                loading: !0,
                                error: null
                            }), await wn(), s.setSecurityPolicyMfaState({
                                policy: nu,
                                loading: !1
                            });
                        }, s.loadSecurityPolicyVendorMfa = async ()=>{
                            s.setSecurityPolicyVendorMfaState({
                                loading: !0,
                                error: null
                            }), await wn(), s.setSecurityPolicyVendorMfaState({
                                policy: nu,
                                loading: !1
                            });
                        }, s.saveSecurityPolicyLockout = async (t)=>{
                            const { callback: e } = t, a = f(t, Ku);
                            s.setSecurityPolicyLockoutState({
                                saving: !0,
                                error: null
                            }), await wn();
                            const n = v({}, su, a, {
                                id: a.id ? a.id : su.id
                            });
                            null == e || e(n), s.setSecurityPolicyLockoutState({
                                policy: n,
                                saving: !1
                            });
                        }, s.loadSecurityPolicyLockout = async ()=>{
                            s.setSecurityPolicyLockoutState({
                                loading: !0,
                                error: null
                            }), await wn(), s.setSecurityPolicyLockoutState({
                                policy: su,
                                loading: !1
                            });
                        }, s.loadSecurityPolicyVendorLockout = async ()=>{
                            s.setSecurityPolicyVendorLockoutState({
                                loading: !0,
                                error: null
                            }), await wn(), s.setSecurityPolicyVendorLockoutState({
                                policy: su,
                                loading: !1
                            });
                        }, s.loadSecurityPolicyCaptcha = async ()=>{
                            s.setSecurityPolicyLockoutState({
                                loading: !0,
                                error: null
                            }), await wn(), s.setSecurityPolicyLockoutState({
                                policy: su,
                                loading: !1
                            });
                        }, s.saveSecurityPolicyPasswordHistory = async (t)=>{
                            const { callback: e } = t, a = f(t, qu);
                            s.setSecurityPolicyPasswordHistoryState({
                                saving: !0,
                                error: null
                            }), await wn();
                            const n = v({}, iu, a, {
                                id: a.id ? a.id : iu.id
                            });
                            null == e || e(n), s.setSecurityPolicyPasswordHistoryState({
                                policy: n,
                                saving: !1
                            });
                        }, s.loadSecurityPolicyPasswordHistory = async ()=>{
                            s.setSecurityPolicyPasswordHistoryState({
                                loading: !0,
                                error: null
                            }), await wn(), s.setSecurityPolicyPasswordHistoryState({
                                policy: iu,
                                loading: !1
                            });
                        }, s.loadSecurityPolicyVendorPasswordHistory = async ()=>{
                            s.setSecurityPolicyVendorPasswordHistoryState({
                                loading: !0,
                                error: null
                            }), await wn(), s.setSecurityPolicyVendorPasswordHistoryState({
                                policy: iu,
                                loading: !1
                            });
                        }, s;
                    })(t, e, a), C = ((t, e)=>{
                        const a = zr(t, e), n = qc(a, [
                            "setSessionsState",
                            "resetSessionsState"
                        ]);
                        return n.loadUserSessions = async ()=>{
                            n.setSessionsState({
                                loading: !0,
                                error: null
                            }), n.setSessionsState({
                                sessions: bu,
                                loading: !1
                            });
                        }, n.deleteUserSession = async (e)=>{
                            const { id: a } = e;
                            n.setSessionsState({
                                loading: !0,
                                error: null
                            });
                            const s = t.auth.sessionsState.sessions.filter((t)=>t.id !== a);
                            n.setSessionsState({
                                sessions: s,
                                loading: !1
                            });
                        }, n.deleteAllUserSessions = async ()=>{
                            n.setSessionsState({
                                loading: !0,
                                error: null
                            });
                            const t = bu.filter((t)=>t.current);
                            n.setSessionsState({
                                sessions: t,
                                loading: !1
                            });
                        }, n;
                    })(t, e), L = ((t, e, a)=>{
                        const n = Vr(t, e, a), s = qc(n, [
                            "setSessionsPolicyState",
                            "resetSessionsPolicyState"
                        ]);
                        return s.loadSessionsPolicy = async ()=>{
                            s.setSessionsPolicyState({
                                loading: !0,
                                error: null
                            });
                            const e = t.auth.sessionsPolicyState;
                            s.setSessionsPolicyState(v({}, e, {
                                loading: !1
                            }));
                        }, s.createOrUpdateSessionsPolicy = async (t)=>{
                            const { callback: e } = t, a = f(t, Ju);
                            s.setSessionsPolicyState({
                                loading: !0,
                                error: null
                            }), null == e || e(!0), s.setSessionsPolicyState({
                                configurations: a,
                                loading: !1
                            });
                        }, s;
                    })(t, e, a), U = ((t, e, a)=>{
                        const n = Xr(t, e, a);
                        return qc(n, [
                            "setSignUpState",
                            "resetSignUpState",
                            "resetSignUpStateSoft"
                        ]);
                    })(t, e, a), D = ((t, e)=>{
                        const a = ol(t, e);
                        return qc(a, [
                            "setSmsState",
                            "resetSmsState"
                        ]);
                    })(t, e), N = ((t, e, a)=>{
                        const n = dl(t, e, a);
                        return qc(n, [
                            "setSocialLoginsState",
                            "resetSocialLoginsState",
                            "setSocialLoginError"
                        ]);
                    })(t, e, a), M = ((t, e, a)=>{
                        const n = ml(t, e, a), s = qc(n, [
                            "setSSOState",
                            "resetSSOState"
                        ]);
                        return s.loadSSOConfigurations = async ()=>{
                            s.setSSOState({
                                loading: !0
                            }), await wn(), s.setSSOState({
                                samlConfiguration: ou,
                                loading: !1,
                                firstLoad: !1
                            });
                        }, s.saveSSOConfigurations = async (t)=>{
                            var e, a;
                            const { callback: n, samlVendor: i } = t, o = f(t, Yu), r = cu.samlConfiguration, l = v({}, r, o);
                            let c = "saving";
                            if ((null == l ? void 0 : l.enabled) !== r.enabled && (c = "loading"), null == l || !l.domain) return void s.setSSOState({
                                samlConfiguration: v({}, r, l)
                            });
                            s.setSSOState({
                                error: void 0,
                                [c]: !0
                            }), await wn(), l.acsUrl = null == ru || null == (e = ru.configuration) ? void 0 : e.acsUrl, l.spEntityId = null == ru || null == (a = ru.configuration) ? void 0 : a.spEntityId;
                            const u = Pn(l, [
                                "validated",
                                "generatedVerification",
                                "createdAt",
                                "updatedAt"
                            ]);
                            (null == r ? void 0 : r.domain) !== (null == u ? void 0 : u.domain) && (u.ssoEndpoint = "", u.publicCertificate = "", u.signRequest = !1), u.type = null == i ? void 0 : i.toLowerCase(), await wn(), s.setSSOState({
                                samlConfiguration: u,
                                error: void 0,
                                [c]: !1
                            }), null == n || n(!0);
                        }, s.saveSSOConfigurationsFile = async (e)=>{
                            const a = "saving";
                            s.setSSOState({
                                error: void 0,
                                [a]: !0
                            });
                            const n = v({}, t.auth.ssoState.samlConfiguration, {
                                enabled: !0
                            }, e[0]);
                            s.setSSOState({
                                samlConfiguration: n,
                                error: void 0,
                                [a]: !1
                            });
                        }, s.validateSSODomain = async (t)=>{
                            const { callback: e } = null != t ? t : {}, a = cu.samlConfiguration;
                            s.setSSOState({
                                error: void 0,
                                saving: !0
                            }), await wn(), s.setSSOState({
                                samlConfiguration: v({}, a, {
                                    validated: !0
                                }),
                                error: void 0,
                                saving: !1
                            }), null == e || e(!0);
                        }, s.loadSSOAuthorizationRoles = async ()=>{
                            await wn(), s.setSSOState({
                                authorizationRoles: [
                                    "1",
                                    "2",
                                    "3"
                                ],
                                error: void 0
                            });
                        }, s.updateSSOAuthorizationRoles = async (t)=>{
                            const { callback: e, authorizationRoles: a } = t;
                            s.setSSOState({
                                error: void 0,
                                saving: !0
                            }), await wn(), s.setSSOState({
                                authorizationRoles: a,
                                error: void 0,
                                saving: !1
                            }), null == e || e(!0);
                        }, s;
                    })(t, e, a), F = ((t, e, a)=>{
                        const n = wl(t, e, a);
                        return qc(n, [
                            "setStepUpState",
                            "resetStepUpState"
                        ]);
                    })(t, e, a), x = ((t, e, a)=>{
                        const n = xl(t, e, a), s = qc(n, [
                            "setTeamState",
                            "resetTeamState",
                            "setTeamLoader",
                            "setTeamError",
                            "openAddUserDialog",
                            "closeAddUserDialog",
                            "openDeleteUserDialog",
                            "closeDeleteUserDialog"
                        ]);
                        return s.loadUsersV2 = async (e)=>{
                            var a, n, i, o;
                            const { silentLoading: r, callback: l } = e, c = t.auth.teamState, u = null != (a = e.pageSize) ? a : c.pageSize, d = null != (n = e.pageOffset) ? n : c.pageOffset, g = null != (i = e.filter) ? i : c.filterV2, p = null != (o = e.sort) ? o : c.sortV2;
                            s.setTeamLoader({
                                key: bs.USERS,
                                value: !r
                            }), s.setTeamState({
                                pageSize: u,
                                pageOffset: d,
                                filterV2: g,
                                sortV2: p
                            }), await wn(), s.setTeamState({
                                users: Su,
                                totalPages: 2,
                                totalItems: 10,
                                roles: lu,
                                permissions: uu
                            }), s.setTeamLoader({
                                key: bs.USERS,
                                value: !1
                            }), null == l || l(Su);
                        }, s.loadAllSubTenantsUsers = async (e)=>{
                            var a, n, i, o, r;
                            const { silentLoading: l, callback: c } = e, u = t.auth.teamState, d = null != (a = e._limit) ? a : u.allUsersQueryParams._limit, g = null != (n = e._offset) ? n : u.allUsersQueryParams._offset, p = null != (i = e._filter) ? i : u.allUsersQueryParams._filter, h = null != (o = e._sortBy) ? o : u.allUsersQueryParams._sortBy, y = null != (r = e._order) ? r : u.allUsersQueryParams._order;
                            s.setTeamLoader({
                                key: bs.USERS,
                                value: !l
                            }), s.setTeamState({
                                allUsersQueryParams: {
                                    _limit: d,
                                    _offset: g,
                                    _filter: p,
                                    _sortBy: h,
                                    _order: y
                                }
                            }), await wn(), s.setTeamState({
                                allUsers: fu,
                                totalPages: 2,
                                totalItems: 10,
                                roles: lu,
                                permissions: uu
                            }), s.setTeamLoader({
                                key: bs.USERS,
                                value: !1
                            }), null == c || c(fu);
                        }, s.loadRoles = async (t)=>{
                            var e;
                            s.setTeamLoader({
                                key: bs.ROLES_AND_PERMISSIONS,
                                value: !0
                            }), await wn(), s.setTeamState({
                                roles: lu,
                                permissions: uu
                            }), s.setTeamLoader({
                                key: bs.ROLES_AND_PERMISSIONS,
                                value: !0
                            }), null == t || null == (e = t.callback) || e.call(t, {
                                roles: lu,
                                permissions: uu
                            });
                        }, s.addUser = async (e)=>{
                            const { callback: a } = e, n = f(e, Xu), i = t.auth.teamState;
                            s.setTeamState({
                                addUserDialogState: v({}, i.addUserDialogState, {
                                    loading: !0
                                })
                            }), await wn();
                            const o = new Date, r = v({}, pu, {
                                groups: []
                            }, n, {
                                id: `${xu()}`,
                                temporaryExpirationDate: n.expirationInSeconds ? new Date(o.setSeconds(o.getSeconds() + n.expirationInSeconds)) : void 0
                            });
                            null == a || a(r), s.setTeamState({
                                users: [
                                    r,
                                    ...i.users
                                ],
                                addUserDialogState: {
                                    open: !1,
                                    loading: !1
                                }
                            });
                        }, s.addUserToSubTenants = async (e)=>{
                            const { callback: a } = e, n = f(e, Qu), i = t.auth.teamState;
                            s.setTeamState({
                                addUserDialogState: v({}, i.addUserDialogState, {
                                    loading: !0
                                })
                            }), await wn();
                            const o = v({}, pu, n, {
                                id: `${xu()}`
                            });
                            s.setTeamState({
                                users: [
                                    o,
                                    ...i.users
                                ],
                                addUserDialogState: {
                                    open: !1,
                                    loading: !1
                                }
                            }), null == a || a(null);
                        }, s.updateUser = async (e)=>{
                            var a;
                            const { callback: n } = e, i = f(e, Zu), { id: o } = i, r = t.auth.teamState, l = r.users.find((t)=>t.id === i.id);
                            s.setTeamLoader({
                                key: bs.UPDATE_USER,
                                value: o || ""
                            }), s.setTeamState({
                                addUserDialogState: v({}, r.addUserDialogState, {
                                    loading: !0
                                })
                            }), s.setTeamState({
                                addUserDialogState: v({}, r.addUserDialogState, {
                                    loading: !0
                                }),
                                users: r.users.map((t)=>t.id === i.id ? v({}, t, i) : t)
                            }), l.roleIds.length > 0 && 0 === (null == (a = i.roleIds) ? void 0 : a.length) && (i.roleIds = [
                                ""
                            ]), await wn();
                            const c = v({}, l, i);
                            null == n || n(c), s.setTeamState({
                                users: r.users.map((t)=>t.id === c.id ? v({}, t, c, {
                                        createdAt: t.createdAt,
                                        customData: t.customData,
                                        lastLogin: t.lastLogin
                                    }) : t)
                            }), s.setTeamLoader({
                                key: bs.UPDATE_USER,
                                value: !1
                            });
                        }, s.deleteUser = async (e)=>{
                            const { callback: a } = e, n = f(e, td), i = t.auth.teamState;
                            s.setTeamState({
                                deleteUserDialogState: v({}, i.deleteUserDialogState, {
                                    loading: !0
                                })
                            }), await wn(), null == a || a(!0), s.setTeamState({
                                users: i.users.filter((t)=>t.id !== n.userId),
                                deleteUserDialogState: {
                                    open: !1,
                                    loading: !1
                                }
                            });
                        }, s.updateUserExpirationTime = async (e)=>{
                            const { callback: a } = e, n = f(e, ed), i = t.auth.teamState;
                            s.setTeamLoader({
                                key: bs.UPDATE_USER_EXPIRATION_TIME,
                                value: !0
                            });
                            const o = new Date;
                            s.setTeamState({
                                users: i.users.map((t)=>t.id === n.userId ? v({}, t, {
                                        temporaryExpirationDate: n.expirationInSeconds ? new Date(o.setSeconds(o.getSeconds() + n.expirationInSeconds)) : void 0
                                    }) : t)
                            }), await wn(), null == a || a(!0), s.setTeamLoader({
                                key: bs.UPDATE_USER_EXPIRATION_TIME,
                                value: !1
                            });
                        }, s.setUserAsPermanent = async (e)=>{
                            const { callback: a } = e, n = f(e, ad), i = t.auth.teamState;
                            s.setTeamLoader({
                                key: bs.UPDATE_USER_EXPIRATION_TIME,
                                value: !0
                            }), s.setTeamState({
                                users: i.users.map((t)=>t.id === n.userId ? v({}, t, {
                                        temporaryExpirationDate: void 0
                                    }) : t)
                            }), await wn(), null == a || a(!0), s.setTeamLoader({
                                key: bs.UPDATE_USER_EXPIRATION_TIME,
                                value: !1
                            });
                        }, s.deleteUserFromSubTenants = async (e)=>{
                            const { callback: a } = e, n = f(e, nd), i = t.auth.teamState;
                            s.setTeamState({
                                deleteUserDialogState: v({}, i.deleteUserDialogState, {
                                    loading: !0
                                })
                            }), await wn(), null == a || a(!0), s.setTeamState({
                                allUsers: i.allUsers.filter((t)=>t.id !== n.userId),
                                deleteUserDialogState: {
                                    open: !1,
                                    loading: !1
                                }
                            });
                        }, s.resendActivationLink = async (t)=>{
                            const { callback: e } = t, a = f(t, sd);
                            s.setTeamLoader({
                                key: bs.RESEND_ACTIVATE_LINK,
                                value: a.userId
                            }), await wn(), null == e || e(!0), s.setTeamLoader({
                                key: bs.RESEND_ACTIVATE_LINK,
                                value: !1
                            });
                        }, s.resendInvitationLink = async (t)=>{
                            const { callback: e } = t, a = f(t, id);
                            s.setTeamLoader({
                                key: bs.RESEND_INVITATION_LINK,
                                value: a.email
                            }), await wn(), null == e || e(!0), s.setTeamLoader({
                                key: bs.RESEND_INVITATION_LINK,
                                value: !1
                            });
                        }, s.resendInvitationEmail = async (t)=>{
                            const { callback: e } = t, a = f(t, od);
                            s.setTeamLoader({
                                key: bs.RESEND_INVITATION_LINK,
                                value: a.email
                            }), await wn(), null == e || e(!0), s.setTeamLoader({
                                key: bs.RESEND_INVITATION_LINK,
                                value: !1
                            });
                        }, s.resendInvitationLinkToAllSubTenants = async (t)=>{
                            const { callback: e } = t, a = f(t, rd);
                            s.setTeamLoader({
                                key: bs.RESEND_INVITATION_LINK,
                                value: a.email
                            }), await wn(), null == e || e(!0), s.setTeamLoader({
                                key: bs.RESEND_INVITATION_LINK,
                                value: !1
                            });
                        }, s;
                    })(t, e, a), G = ((t, e, a)=>{
                        const n = jl(t, e, a), s = qc(n, [
                            "setTenantsState",
                            "resetTenantsState"
                        ]);
                        return s.loadTenants = async ()=>{
                            s.setTenantsState({
                                loading: !0
                            }), s.setTenantsState({
                                tenants: mu,
                                activeTenant: mu[0],
                                loading: !1
                            });
                        }, s;
                    })(t, e, a), $ = {
                        acceptInvitationActions: s,
                        accountSettingsActions: i,
                        unlockAccountActions: o,
                        activateAccountActions: r,
                        allAccountsActions: l,
                        allAccountsDialogActions: c,
                        apiTokensActions: u,
                        applicationsActions: d,
                        customLoginActions: g,
                        entitlementsActions: p,
                        forgotPasswordActions: h,
                        passwordRotationActions: y,
                        groupsActions: S,
                        groupsDialogsActions: m,
                        impersonateActions: b,
                        loginActions: A,
                        mfaActions: w,
                        passkeysActions: T,
                        profileActions: E,
                        provisioningActions: I,
                        resetPhoneNumberActions: O,
                        restrictionsActions: P,
                        rolesActions: k,
                        securityCenterActions: _,
                        securityPolicyActions: R,
                        sessionsActions: C,
                        sessionsPolicyActions: L,
                        signUpActions: U,
                        smsActions: D,
                        socialLoginActions: N,
                        ssoActions: M,
                        stepUpActions: F,
                        teamActions: x,
                        tenantsActions: G
                    }, j = (e)=>{
                        Object.keys(e).forEach((a)=>{
                            const n = a;
                            kn(t.auth[n]) ? Object.assign(t.auth[n], e[n]) : t.auth[n] = e[n];
                        });
                    };
                    return {
                        authActions: v({
                            setState: j,
                            setAuthState: j,
                            setErrorByRequestName: (e)=>{
                                let { requestName: a } = e, n = f(e, ld);
                                t.auth.errorByRequest = v({}, t.auth.errorByRequest, {
                                    [a]: v({}, n, {
                                        isError: !0
                                    })
                                });
                            },
                            resetAuthState: ()=>{
                                Rn(t, [
                                    "auth"
                                ], n);
                            },
                            setUser: (t)=>{
                                j({
                                    user: t
                                });
                            }
                        }, s, i, r, o, l, c, u, d, g, p, h, y, S, m, b, A, w, T, E, I, O, P, k, _, R, C, L, U, D, N, M, F, x, G),
                        authStateActions: $
                    };
                })(t, e, a, n), o = ((t, e, a)=>{
                    const n = Zl(t, e, a);
                    return qc(n, [
                        "setConnectivityState",
                        "resetConnectivityState",
                        "initData",
                        "resetConnectivityState",
                        "cleanWebhookTestData",
                        "cleanWebhookLogsData",
                        "cleanWebhookTestMessage",
                        "cleanError",
                        "cleanSlackData"
                    ]);
                })(t, e, a), [r, l] = fd(t, e, a), c = ((t, e, a)=>{
                    const n = xc(t, e, a), s = qc(n, [
                        "setVendorState",
                        "resetVendorState"
                    ]);
                    return s.loadVendorPublicInfo = async ()=>{
                        try {
                            s.setVendorState({
                                whiteLabelMode: !1
                            }), await wn();
                        } catch (t) {
                            console.error("failed to getVendorPublicInfo - ", t);
                        }
                    }, s.loadVendorPublicConfiguration = s.loadVendorPublicInfo, s;
                })(t, e, a);
                return {
                    authActions: s,
                    authStateActions: i,
                    connectivityActions: o,
                    subscriptionsActions: r,
                    subscriptionsStateActions: l,
                    vendorActions: c,
                    auditsActions: gd(t, e, a)
                };
            }, bd = (t, e, a = !1, n, s, i = !1, o = "path")=>Ad({
                    name: t.appName,
                    context: t.context,
                    storeHolder: e,
                    previewMode: a,
                    builderMode: i,
                    urlStrategy: o,
                    initialState: {
                        root: v({}, t),
                        auth: v({}, null == s ? void 0 : s.auth, n),
                        connectivity: v({}, null == s ? void 0 : s.connectivity),
                        subscriptions: v({}, null == s ? void 0 : s.subscriptions),
                        vendor: v({}, null == s ? void 0 : s.vendor),
                        auditLogs: v({}, null == s ? void 0 : s.auditLogs),
                        audits: v({}, null == s ? void 0 : s.audits)
                    }
                }), Ad = (t)=>{
                var e, a, n, s, i, o, r;
                const { storeHolder: l } = t;
                let c = l;
                if ("undefined" == typeof window && null == l) throw Error("createFronteggStore(initState, storeHolder) failed, storeHolder must not be null in Server-Side rendering");
                if (c || (c = window), c.store) return c.store;
                const u = t.name || "default", { context: d, previewMode: g = !1, builderMode: p = !1, urlStrategy: h = "path" } = t, y = C.for(u);
                g || p || y.setContext(d), void 0 === d.requestCredentials && (d.requestCredentials = "include");
                const S = Hl(null == (e = t.initialState) ? void 0 : e.auth), m = ql(null == (a = t.initialState) ? void 0 : a.connectivity), b = Dc(null == (n = t.initialState) ? void 0 : n.subscriptions), A = Fc(null == (s = t.initialState) ? void 0 : s.vendor), w = Hc(null == (i = t.initialState) ? void 0 : i.auditLogs), T = (E = null == (o = t.initialState) ? void 0 : o.audits, Za(Kc, E));
                var E;
                const I = null == (r = t.initialState) ? void 0 : r.auth;
                I && Object.keys(I).forEach((t)=>{
                    rn()(S, t, I[t], {
                        merge: !0
                    });
                });
                const O = JSON.parse(JSON.stringify(S)), L = Za({
                    root: {
                        appName: u,
                        context: d,
                        urlStrategy: h,
                        previewMode: g
                    },
                    auth: S,
                    connectivity: m,
                    subscriptions: b,
                    vendor: A,
                    auditLogs: w,
                    audits: T
                });
                "undefined" != typeof window && window.localStorage && "true" === window.localStorage.DEBUG_FRONTEGG_STORE && function(t, e) {
                    "string" == typeof e && (e = {
                        name: e
                    });
                    const a = e || {}, { enabled: n, name: s = "" } = a, i = f(a, _);
                    let o;
                    try {
                        o = n && window.__REDUX_DEVTOOLS_EXTENSION__;
                    } catch  {}
                    if (!o) return;
                    let r = !1;
                    const l = o.connect(v({
                        name: s
                    }, i));
                    P(t, (e)=>{
                        const a = e.filter(([t, e])=>e[0] !== R).map(([t, e])=>`${t}:${e.map(String).join(".")}`).join(", ");
                        if (a) {
                            if (r) r = !1;
                            else {
                                const e = Object.assign({}, k(t));
                                delete e[R], l.send({
                                    type: a,
                                    updatedAt: (new Date).toLocaleString()
                                }, e);
                            }
                        }
                    }), l.subscribe((e)=>{
                        var a, n;
                        if ("ACTION" === e.type && e.payload) try {
                            Object.assign(t, JSON.parse(e.payload));
                        } catch (t) {
                            console.error("please dispatch a serializable value that JSON.parse() and proxy() support\n", t);
                        }
                        if ("DISPATCH" === e.type && e.state) {
                            var s, i;
                            if ("JUMP_TO_ACTION" === (null == (s = e.payload) ? void 0 : s.type) || "JUMP_TO_STATE" === (null == (i = e.payload) ? void 0 : i.type)) {
                                r = !0;
                                const a = JSON.parse(e.state);
                                Object.assign(t, a);
                            }
                            t[R] = e;
                        } else if ("DISPATCH" === e.type && "COMMIT" === (null == (a = e.payload) ? void 0 : a.type)) l.init(k(t));
                        else if ("DISPATCH" === e.type && "IMPORT_STATE" === (null == (n = e.payload) ? void 0 : n.type)) {
                            var o, c;
                            const a = null == (o = e.payload.nextLiftedState) ? void 0 : o.actionsById, n = (null == (c = e.payload.nextLiftedState) ? void 0 : c.computedStates) || [];
                            r = !0, n.forEach(({ state: e }, n)=>{
                                const s = a[n] || "No action found";
                                Object.assign(t, e), 0 === n ? l.init(k(t)) : l.send(s, k(t));
                            });
                        }
                    });
                    l.init(k(t));
                }(L, {
                    name: `${u} Store`,
                    enabled: !0
                });
                const U = {}, D = {};
                y.setContext(t.context), y.setAppName(u);
                const N = v({}, Ja(u), {
                    fetch: new xt(u)
                });
                if (t.previewMode || t.builderMode) {
                    const { authActions: e, authStateActions: a, connectivityActions: n, subscriptionsActions: s, subscriptionsStateActions: i, vendorActions: o, auditsActions: r } = md(L, N, D, O);
                    U.auth = a, U.connectivity = n, U.subscriptions = i, U.vendor = o, U.auditLogs = r, U.audits = {}, Object.assign(D, v({}, e, n, s, o, r));
                    const l = {
                        dispatch: (t)=>{
                            setTimeout(()=>{
                                const [a, ...i] = t.type.split("/"), r = i.join("/");
                                "auth" === a && "function" == typeof e[r] ? e[r](t.payload) : "connectivity" === a && "function" == typeof n[r] ? n[r](t.payload) : "subscriptions" === a && "function" == typeof s[r] ? s[r](t.payload) : "vendor" === a && "function" == typeof o[r] && o[r](t.payload);
                            });
                        },
                        getState: ()=>L,
                        subscribe: (t)=>P(L, t),
                        subscribeStateChanged: (t)=>P(L, ()=>t(L)),
                        store: L,
                        actions: D,
                        stateActions: U
                    };
                    return t.previewMode && l.dispatch({
                        type: "auth/requestAuthorize",
                        payload: !0
                    }), c && (c.store = l), l;
                }
                {
                    const [t, e] = zl(L, N, D, O), a = Zl(L, N, D), [n, s] = Nc(L, N, D), i = xc(L, N, D), o = zc(L, N, D), r = ((t, e)=>{
                        const a = ()=>{
                            t.audits.isLoading = !1;
                        }, n = (e)=>{
                            var a;
                            t.audits.error = null != (a = t.audits.error) ? a : {}, Object.assign(t.audits.error, {
                                [e.name]: e.error
                            });
                        }, s = (e)=>{
                            t.audits.filters = e, t.audits.currentPage = 0, t.audits.offset = 0, t.audits.isLoading = !0;
                        }, i = async ()=>{
                            const { sortBy: a, sortDirection: s } = t.audits;
                            try {
                                i = await e.audits.getAuditsStats({
                                    sortBy: a,
                                    sortDirection: s,
                                    count: 20
                                }), t.audits.error = void 0, t.audits.totalToday = i.totalToday, t.audits.severeThisWeek = i.severeThisWeek;
                            } catch (t) {
                                const e = {
                                    name: "stats",
                                    error: t
                                };
                                console.error("failed to load stats - ", t), n(e);
                            }
                            var i;
                        }, o = async ()=>{
                            try {
                                a = await e.metadata.getAuditsMetadata(), t.audits.error = {}, t.audits.headerProps = a.properties, t.audits.themeAudits = a.theme ? a.theme.styles : {};
                            } catch (t) {
                                const e = {
                                    name: "metadata",
                                    error: t
                                };
                                console.error("failed to load metadata - ", t), n(e);
                            }
                            var a;
                        }, r = (t)=>t.reduce((t, e)=>(t[e.key] = e.value, t), {}), l = async (s)=>{
                            const { filters: i, sortBy: o, sortDirection: l, filter: c, offset: u, virtualScroll: d } = t.audits, { appendMode: g = d, onlyOneLoad: p = !0, offset: h = 0 } = s || {}, { rowsData: y } = g ? t.audits : {
                                rowsData: []
                            };
                            try {
                                const n = r(i), { data: s, total: g } = await e.audits.getAudits(v({}, d && {
                                    paginationMode: "virtual"
                                }, {
                                    sortDirection: l,
                                    sortBy: o,
                                    filter: c
                                }, n, {
                                    offset: d ? y.length + h || y.length + u : h || u,
                                    count: 20
                                }));
                                ((e)=>{
                                    t.audits.error = {}, t.audits.rowsData = e.rowsData, t.audits.lastUpdated = new Date, t.audits.total = e.total;
                                })({
                                    rowsData: [
                                        ...y,
                                        ...s
                                    ],
                                    total: g
                                }), p && a();
                            } catch (t) {
                                const e = {
                                    name: "audits",
                                    error: t
                                };
                                console.error("failed to load audits - ", t), n(e);
                            }
                        };
                        return {
                            initData: async ()=>{
                                t.audits.isLoading = !0, await Promise.all([
                                    i(),
                                    o(),
                                    l({
                                        onlyOneLoad: !1
                                    })
                                ]), a();
                            },
                            loadAudits: l,
                            removeFilter: async (e)=>{
                                const { filters: a } = t.audits, n = a.findIndex((t)=>t.key === e.key);
                                if (n < 0) return;
                                const i = [
                                    ...a.slice(0, n),
                                    ...a.slice(n + 1)
                                ];
                                s(i);
                            },
                            filterData: async (e)=>{
                                const { filters: a } = t.audits;
                                let n = a.findIndex((t)=>t.key === e.key);
                                n < 0 && (n = a.length);
                                const i = [
                                    ...a.slice(0, n),
                                    e,
                                    ...a.slice(n + 1)
                                ];
                                s(i);
                            },
                            exportCSV: async ()=>{
                                const { filters: a, sortBy: n, sortDirection: s, filter: i, headerProps: o = [] } = t.audits, l = r(a);
                                t.audits.isDownloadingCsv = !0;
                                try {
                                    await e.audits.exportAudits(v({
                                        endpoint: "csv/v2",
                                        headerProps: o,
                                        sortDirection: s,
                                        sortBy: n,
                                        filter: i
                                    }, l, {
                                        offset: 0,
                                        outputFileName: "audits.csv"
                                    }));
                                } catch (t) {
                                    console.error("failed to export audits - ", t);
                                } finally{
                                    t.audits.isDownloadingCsv = !1;
                                }
                            }
                        };
                    })(L, N);
                    return U.auth = e, U.connectivity = a, U.subscriptions = s, U.vendor = i, U.auditLogs = o, U.audits = r, Object.assign(D, v({}, t, a, n, i, o)), {
                        dispatch: (e)=>{
                            const [s, ...o] = e.type.split("/"), r = o.join("/");
                            "auth" === s && "function" == typeof t[r] ? t[r](e.payload) : "connectivity" === s && "function" == typeof a[r] ? a[r](e.payload) : "subscriptions" === s && "function" == typeof n[r] ? n[r](e.payload) : "vendor" === s && "function" == typeof i[r] && i[r](e.payload);
                        },
                        getState: ()=>L,
                        subscribe: (t)=>P(L, t),
                        subscribeStateChanged: (t)=>P(L, ()=>t(L)),
                        store: L,
                        actions: D,
                        stateActions: U
                    };
                }
            };
            let wd, Td, Ed, Id, Od, Pd, kd, _d, Rd, Cd, Ld, Ud, Dd;
            !function(t) {
                t.phoneNumber = "phoneNumber";
            }(wd || (wd = {})), function(t) {
                t.Name = "name", t.PhoneNumber = "phoneNumber", t.Address = "address", t.JobTitle = "jobTitle";
            }(Td || (Td = {})), function(t) {
                t.LoginSessions = "loginSessions", t.Mfa = "mfa";
            }(Ed || (Ed = {})), function(t) {
                t.Name = "name", t.PhoneNumber = "phoneNumber";
            }(Id || (Id = {})), function(t) {
                t.CompanyName = "companyName", t.Address = "address", t.Website = "website", t.Timezone = "timezone", t.Currency = "currency";
            }(Od || (Od = {})), function(t) {
                t.User = "user", t.Applications = "applications", t.Groups = "groups", t.Roles = "roles", t.JoinedAt = "joinedAt", t.LastSeen = "lastSeen", t.ManagedBy = "managedBy";
            }(Pd || (Pd = {})), function(t) {
                t.Invoices = "invoices";
            }(kd || (kd = {})), function(t) {
                t.SessionManagement = "sessionManagement", t.GeneralSettings = "generalSettings", t.IpRestrictions = "ipRestrictions", t.DomainRestrictions = "domainRestrictions";
            }(_d || (_d = {})), function(t) {
                t.IdleSessionTimeout = "idleSessionTimeout", t.ForceReLogin = "forceReLogin", t.MaximumConcurrentSessions = "maximumConcurrentSessions";
            }(Rd || (Rd = {})), function(t) {
                t.Mfa = "mfa", t.UserLockout = "userLockout", t.PasswordHistory = "passwordHistory";
            }(Cd || (Cd = {})), function(t) {
                t.IpAddressRestrictions = "ipAddressRestrictions";
            }(Ld || (Ld = {})), function(t) {
                t.RestrictSignupByEmailDomain = "restrictSignupByEmailDomain";
            }(Ud || (Ud = {})), function(t) {
                t.Settings = "settings", t.CustomLogin = "customLogin";
            }(Dd || (Dd = {}));
            const Nd = {
                hidden: "hidden",
                viewOnly: "viewOnly",
                edit: "edit"
            }, Md = {
                hidden: "hidden",
                edit: "edit"
            };
            function Fd(t, e = 0, a = 1) {
                return Math.min(Math.max(e, t), a);
            }
            function xd(t) {
                if (t.type) return t;
                if ("#" === t.charAt(0)) return xd(function(t) {
                    t = t.substr(1);
                    const e = new RegExp(`.{1,${t.length >= 6 ? 2 : 1}}`, "g");
                    let a = t.match(e);
                    return a && 1 === a[0].length && (a = a.map((t)=>t + t)), a ? `rgb${4 === a.length ? "a" : ""}(${a.map((t, e)=>e < 3 ? parseInt(t, 16) : Math.round(parseInt(t, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
                }(t));
                const e = t.indexOf("("), a = t.substring(0, e);
                if (-1 === [
                    "rgb",
                    "rgba",
                    "hsl",
                    "hsla",
                    "color"
                ].indexOf(a)) throw new Error("MUI: Unsupported `%s` color.\nThe following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color(). " + t);
                const n = t.substring(e + 1, t.length - 1);
                let s, i;
                if ("color" === a) {
                    if (i = n.split(" "), s = i.shift(), 4 === i.length && "/" === i[3].charAt(0) && (i[3] = i[3].substr(1)), -1 === [
                        "srgb",
                        "display-p3",
                        "a98-rgb",
                        "prophoto-rgb",
                        "rec-2020"
                    ].indexOf(s)) throw new Error("MUI: unsupported `%s` color space.\nThe following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020." + s);
                } else i = n.split(",");
                return {
                    type: a,
                    values: i.map((t)=>parseFloat(t)),
                    colorSpace: s
                };
            }
            function Gd(t) {
                const { type: e, colorSpace: a } = t;
                let { values: n } = t;
                return -1 !== e.indexOf("rgb") ? n = n.map((t, e)=>e < 3 ? parseInt(t, 10) : t) : -1 !== e.indexOf("hsl") && (n[1] = `${n[1]}%`, n[2] = `${n[2]}%`), n = -1 !== e.indexOf("color") ? `${a} ${n.join(" ")}` : `${n.join(", ")}`, `${e}(${n})`;
            }
            function $d(t) {
                if (0 === t.indexOf("#")) return t;
                const { values: e } = xd(t);
                return `#${e.map((t, e)=>(function(t) {
                        const e = t.toString(16);
                        return 1 === e.length ? `0${e}` : e;
                    })(3 === e ? Math.round(255 * t) : t)).join("")}`;
            }
            function jd(t, e) {
                return t = xd(t), e = Fd(e), "rgb" !== t.type && "hsl" !== t.type || (t.type += "a"), "color" === t.type ? t.values[3] = `/${e}` : t.values[3] = e, Gd(t);
            }
            function Bd(t, e) {
                if (t = xd(t), e = Fd(e), -1 !== t.type.indexOf("hsl")) t.values[2] *= 1 - e;
                else if (-1 !== t.type.indexOf("rgb") || -1 !== t.type.indexOf("color")) for(let a = 0; a < 3; a += 1)t.values[a] *= 1 - e;
                return Gd(t);
            }
            function Vd(t, e) {
                if (t = xd(t), e = Fd(e), -1 !== t.type.indexOf("hsl")) t.values[2] += (100 - t.values[2]) * e;
                else if (-1 !== t.type.indexOf("rgb")) for(let a = 0; a < 3; a += 1)t.values[a] += (255 - t.values[a]) * e;
                else if (-1 !== t.type.indexOf("color")) for(let a = 0; a < 3; a += 1)t.values[a] += (1 - t.values[a]) * e;
                return Gd(t);
            }
            const Wd = (t)=>{
                if (t) return {
                    main: t,
                    light: $d(Vd(t, .4)),
                    dark: $d(Bd(t, .15)),
                    hover: $d(Bd(t, .15)),
                    active: $d(Bd(t, .2))
                };
            }, Hd = (t)=>{
                if (t) return {
                    main: t,
                    light: Vd(t, .7),
                    dark: Bd(t, .2)
                };
            }, zd = (t, e)=>{
                var a, n, s, i, o, r, l, c, u, d, g, p;
                return null != t && t.palette && "string" == typeof (null == t || null == (a = t.palette) ? void 0 : a.primary) ? v({}, e, {
                    palette: {
                        primary: v({}, Wd(null == t || null == (n = t.palette) ? void 0 : n.primary), {
                            contrastText: null != (s = null == t || null == (i = t.palette) ? void 0 : i.primaryText) ? s : "#000000"
                        }),
                        secondary: v({}, Wd(null == t || null == (o = t.palette) ? void 0 : o.secondary), {
                            contrastText: null != (r = null == t || null == (l = t.palette) ? void 0 : l.secondaryText) ? r : "#000000"
                        }),
                        danger: v({}, Wd(null == t || null == (c = t.palette) ? void 0 : c.error), {
                            contrastText: "#FFF"
                        }),
                        success: v({}, Hd(null == t || null == (u = t.palette) ? void 0 : u.success), {
                            contrastText: "#FFF"
                        }),
                        error: v({}, Hd(null == t || null == (d = t.palette) ? void 0 : d.error), {
                            contrastText: "#FFF"
                        }),
                        warning: v({}, Hd(null == t || null == (g = t.palette) ? void 0 : g.warning), {
                            contrastText: "#FFF"
                        }),
                        info: v({}, Hd(null == t || null == (p = t.palette) ? void 0 : p.info), {
                            contrastText: "#FFF"
                        })
                    }
                }) : {};
            }, Kd = {
                theme: {},
                themeV2: {},
                localizations: {},
                navigation: {
                    usage: {
                        visibility: "hidden",
                        permissions: [
                            "fe.usage.read"
                        ],
                        featureFlag: "fe-usage-page"
                    },
                    webhooks: {
                        visibility: "hidden",
                        permissions: [
                            "fe.connectivity.read.webhooks"
                        ]
                    },
                    roles: {
                        visibility: "hidden",
                        permissions: [
                            "fe.secure.read.roles"
                        ]
                    },
                    users: {
                        visibility: "always",
                        permissions: [
                            "fe.secure.read.users"
                        ],
                        inviteDialog: {
                            phoneNumberField: "optional"
                        }
                    },
                    personalApiTokens: {
                        visibility: "hidden",
                        permissions: [
                            "fe.secure.read.userApiTokens"
                        ]
                    },
                    apiTokens: {
                        visibility: "hidden",
                        permissions: [
                            "fe.secure.read.tenantApiTokens"
                        ]
                    },
                    profile: {
                        visibility: "always"
                    },
                    privacy: {
                        visibility: "always"
                    },
                    account: {
                        visibility: "always",
                        permissions: [
                            "fe.secure.read.accountSettings"
                        ]
                    },
                    security: {
                        visibility: "always",
                        permissions: [
                            "fe.secure.read.securityPolicy"
                        ]
                    },
                    sso: {
                        visibility: "hidden",
                        permissions: [
                            "fe.secure.read.samlConfiguration"
                        ]
                    },
                    provisioning: {
                        visibility: "hidden",
                        permissions: [
                            "fe.secure.read.provisioningConfiguration"
                        ]
                    },
                    audits: {
                        visibility: "always",
                        permissions: [
                            "fe.secure.read.audits"
                        ]
                    },
                    subscriptions: {
                        visibility: "hidden",
                        permissions: [
                            "fe.subscriptions.*"
                        ]
                    },
                    allAccounts: {
                        visibility: "byPermissions",
                        permissions: [
                            "fe.account-hierarchy.read.subAccount"
                        ]
                    },
                    groups: {
                        visibility: "hidden",
                        permissions: [
                            "fe.secure.read.groups"
                        ]
                    }
                }
            };
            class qd {
                constructor(){
                    this._theme = Kd.theme, this._themeV2 = Kd.themeV2, this._navigation = Kd.navigation, this._localizations = Kd.localizations, this._integrations = Kd.integrations;
                }
                static getInstance(t = "default") {
                    return this._instances[t];
                }
                static set(t, e = "default") {
                    const a = new qd;
                    return a.set(t), qd._instances[e] = a, a;
                }
                get theme() {
                    var t;
                    return null != (t = this._theme) ? t : {};
                }
                get themeV2() {
                    var t;
                    return null != (t = this._themeV2) ? t : {};
                }
                get navigation() {
                    var t;
                    return null != (t = this._navigation) ? t : {};
                }
                get localizations() {
                    var t;
                    return null != (t = this._localizations) ? t : {};
                }
                get integrations() {
                    var t;
                    return null != (t = this._integrations) ? t : {};
                }
                set(t) {
                    try {
                        var e, a, n, s, i, o, r, l, c;
                        this._navigation = Qa().all([
                            null != (e = Kd.navigation) ? e : {},
                            null != (a = null == t ? void 0 : t.navigation) ? a : {}
                        ]), this._theme = Qa().all([
                            null != (n = Kd.theme) ? n : {},
                            zd(null == t ? void 0 : t.theme, Kd.theme)
                        ]), this._themeV2 = Qa().all([
                            null != (s = Kd.themeV2) ? s : {},
                            null != (i = null == t ? void 0 : t.themeV2) ? i : {}
                        ]), this._localizations = Qa().all([
                            null != (o = Kd.localizations) ? o : {},
                            null != (r = null == t ? void 0 : t.localizations) ? r : {}
                        ]), this._integrations = Qa().all([
                            null != (l = Kd.integrations) ? l : {},
                            null != (c = null == t ? void 0 : t.integrations) ? c : {}
                        ]);
                    } catch (t) {
                        this._navigation = Kd.navigation, this._theme = Kd.theme, this._themeV2 = Kd.themeV2, this._localizations = Kd.localizations, this._integrations = Kd.integrations;
                    }
                }
            }
            qd._instances = {};
            var Jd = function(t) {
                return t.replace(/\W+/g, " ").split(/ |\B(?=[A-Z])/).map(function(t) {
                    return t.toLowerCase();
                }).join("");
            }, Yd = function(t, e) {
                var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, n = document.createElement(e);
                return Object.keys(a).forEach(function(t) {
                    return n.setAttribute(t, a[t]);
                }), t.appendChild(n), n;
            }, Xd = function(t) {
                return new Promise(function(e, a) {
                    var n = 4e3, s = setInterval(function() {
                        return null != t.themeSetter ? (clearInterval(s), void e(!0)) : n < 0 ? (a("Failed to load Renderer with themeSetter"), void clearInterval(s)) : void (n -= 50);
                    }, 50);
                });
            }, Qd = function(t) {
                var e = t.toString();
                if (e) {
                    var a = new URL(window.location.href);
                    a.search = e, window.history.pushState(null, "", a.toString());
                }
            };
            const Zd = "7.66.0";
            var tg = {
                admin_portal_ip_restrictions: "on",
                admin_portal_domain_restrictions: "on",
                "new-mfa-pages": "on",
                "show-passkeys-new": "on",
                "groups-admin-box-new": "on",
                "msp-all-accounts-new": "on",
                "temporary-users": "on"
            }, eg = function(t) {
                var e, a = qd.getInstance(t), n = null == a || null == (e = a.integrations) ? void 0 : e.gtm;
                null == n || n.filter(function(t) {
                    var e = t.id;
                    return t.enabled && /^GTM-[a-zA-Z0-9]+$/.test(e);
                }).forEach(function(t) {
                    var e = t.id, a = document.createElement("script");
                    a.innerHTML = "\n        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n        })(window,document,'script','dataLayer','".concat(e, "');\n      "), document.body.appendChild(a);
                });
            }, ag = function() {
                var t = p(y().mark(function t(e, a, n) {
                    var s, i, o, r;
                    return y().wrap(function(_t1) {
                        for(;;)switch(_t1.prev = _t1.next){
                            case 0:
                                if (i = null == (s = e.metadataOverrides) ? void 0 : s.url) {
                                    _t1.next = 3;
                                    break;
                                }
                                return _t1.abrupt("return", e);
                            case 3:
                                return _t1.prev = 3, _t1.next = 6, En(function() {
                                    return a.sendRequest({
                                        url: i,
                                        method: "GET",
                                        credentials: "omit"
                                    });
                                }, n);
                            case 6:
                                if (!(o = _t1.sent)) {
                                    _t1.next = 10;
                                    break;
                                }
                                return r = Qa()(e, o), _t1.abrupt("return", r);
                            case 10:
                                _t1.next = 15;
                                break;
                            case 12:
                                _t1.prev = 12, _t1.t0 = _t1.catch(3), console.error("Failed to get metadata overrides", _t1.t0);
                            case 15:
                                return _t1.abrupt("return", e);
                            case 16:
                            case "end":
                                return _t1.stop();
                        }
                    }, t, null, [
                        [
                            3,
                            12
                        ]
                    ]);
                }));
                return function(e, a, n) {
                    return t.apply(this, arguments);
                };
            }(), ng = function() {
                function a(t, e) {
                    var n, s, o, r = this, l = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], u = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                    i(this, a), this.name = void 0, this.iframeRendering = void 0, this.options = void 0, this.loading = !0, this.cdnUrl = "https://assets.frontegg.com/admin-box/".concat(Zd), this.assetsUrl = "https://adminBox.frontegg.com/admin-box/".concat(Zd), this.customElementName = "", this.adminPortalEl = void 0, this.adminPortalRenderer = void 0, this.loginBoxEl = void 0, this.checkoutDialogEl = void 0, this.checkoutDialogRenderer = void 0, this.adminPortalContainer = void 0, this.loginBoxContainer = void 0, this.checkoutDialogContainer = void 0, this.loginBoxRenderer = void 0, this.store = void 0, this.loadingListeners = [], this.fetchClient = void 0, this.apiClient = void 0, this.updateLocalizations = void 0, this.loadAdminBoxMetadata = p(y().mark(function t() {
                        var e, a, n, s, i;
                        return y().wrap(function(_t1) {
                            for(;;)switch(_t1.prev = _t1.next){
                                case 0:
                                    if (r.options.metadata) {
                                        _t1.next = 21;
                                        break;
                                    }
                                    return _t1.prev = 1, _t1.next = 4, En(function() {
                                        return r.fetchClient.get("/metadata", {
                                            entityName: "adminBox"
                                        });
                                    }, An);
                                case 4:
                                    return s = _t1.sent, i = null != (e = null == s || null == (a = s.rows) || null == (n = a[0]) ? void 0 : n.configuration) ? e : {}, _t1.prev = 6, _t1.next = 9, ag(i, r.fetchClient, An);
                                case 9:
                                    r.options.metadata = _t1.sent, _t1.next = 15;
                                    break;
                                case 12:
                                    _t1.prev = 12, _t1.t0 = _t1.catch(6), console.error("failed to get admin portal overridden metadata", _t1.t0);
                                case 15:
                                    _t1.next = 21;
                                    break;
                                case 17:
                                    _t1.prev = 17, _t1.t1 = _t1.catch(1), console.error("failed to get admin portal metadata", _t1.t1), r.dispatchErrorByRequestName(_t1.t1, Bn.LOAD_ADMIN_BOX_METADATA);
                                case 21:
                                    qd.set(r.options.metadata, r.name);
                                case 22:
                                case "end":
                                    return _t1.stop();
                            }
                        }, t, null, [
                            [
                                1,
                                17
                            ],
                            [
                                6,
                                12
                            ]
                        ]);
                    })), this.requestAuthorize = p(y().mark(function t() {
                        var e, a, n;
                        return y().wrap(function(_t1) {
                            for(;;)switch(_t1.prev = _t1.next){
                                case 0:
                                    n = null == (e = r.options.authOptions) || null == (a = e.hostedLoginOptions) ? void 0 : a.loadUserOnFirstLoad, r.options.builderMode || "nextjs" === r.options.framework || (r.options.hostedLoginBox && !r.options.customLoginBox ? n && r.store.dispatch({
                                        type: "auth/requestHostedLoginAuthorizeV2",
                                        payload: {
                                            shouldRedirectToLogin: !1,
                                            firstTime: !0
                                        }
                                    }) : r.store.dispatch({
                                        type: "auth/requestAuthorize",
                                        payload: !0
                                    }));
                                case 2:
                                case "end":
                                    return _t1.stop();
                            }
                        }, t);
                    })), this.loadFeatureFlags = p(y().mark(function t() {
                        var e;
                        return y().wrap(function(_t1) {
                            for(;;)switch(_t1.prev = _t1.next){
                                case 0:
                                    if (!r.options.previewMode && !r.options.builderMode) {
                                        _t1.next = 4;
                                        break;
                                    }
                                    Xt.set(tg, r.name), _t1.next = 16;
                                    break;
                                case 4:
                                    return _t1.prev = 4, _t1.next = 7, En(function() {
                                        return r.apiClient.featureFlags.loadFeatureFlags();
                                    }, An);
                                case 7:
                                    e = _t1.sent, r.options.overrideFeatureFlags && Object.assign(e, r.options.overrideFeatureFlags), Xt.set(e, r.name), _t1.next = 16;
                                    break;
                                case 12:
                                    _t1.prev = 12, _t1.t0 = _t1.catch(4), console.error("failed to get admin portal feature flags", _t1.t0), r.dispatchErrorByRequestName(_t1.t0, Bn.LOAD_FEATURE_FLAGS);
                                case 16:
                                case "end":
                                    return _t1.stop();
                            }
                        }, t, null, [
                            [
                                4,
                                12
                            ]
                        ]);
                    })), this.setFeatureFlagsForPreview = function(t) {
                        Xt.set(Object.assign({}, tg, t), r.name);
                    }, this.queryFeatureFlags = function(t) {
                        return Xt.getFeatureFlags(t, r.name);
                    }, this.updateLocalizationsSetter = function(t) {
                        r.updateLocalizations = t;
                    }, this.getEntitlementsFromStore = function() {
                        var t;
                        return null == (t = r.store.getState().auth.user) ? void 0 : t.entitlements;
                    }, this.getUserFromStore = function() {
                        return r.store.getState().auth.user;
                    }, this.getEntitlementsQueryData = function(t) {
                        var e = r.getUserFromStore();
                        return {
                            entitlements: r.getEntitlementsFromStore(),
                            attributes: {
                                custom: t,
                                jwt: e
                            }
                        };
                    };
                    var d = Jd(e), g = "frontegg-app-".concat(d);
                    this.iframeRendering = l, this.name = d, this.options = Object.assign({}, t, {
                        contextOptions: Object.assign({
                            requestCredentials: "include"
                        }, t.contextOptions)
                    }), this.fetchClient = new xt(this.name), this.apiClient = Ja(this.name), this.options.cdnUrl && (this.cdnUrl = this.options.cdnUrl), this.options.assetsUrl && (this.assetsUrl = this.options.assetsUrl), C.for(this.name).setCdnUrl(this.cdnUrl), C.for(this.name).setAssetsUrl(this.assetsUrl), this.customElementName = g;
                    var h, S, v = this.options.authOptions ? Object.assign({}, this.options.authOptions, {
                        hostedLoginBox: this.options.hostedLoginBox
                    }) : {
                        hostedLoginBox: this.options.hostedLoginBox
                    };
                    if (v.onRedirectTo = t.onRedirectTo, v.disableSilentRefresh = null == (n = this.options.authOptions) ? void 0 : n.disableSilentRefresh, this.options.store) {
                        if (this.store = this.options.store, !u && this.options.store.getState().root.appName !== e) throw Error("Mismatch in store names");
                    } else this.store = Ad({
                        context: this.options.contextOptions,
                        name: this.name,
                        builderMode: this.options.builderMode,
                        previewMode: this.options.previewMode,
                        storeHolder: this,
                        urlStrategy: this.options.urlStrategy,
                        initialState: {
                            auth: Object.assign({}, v, null != (h = this.options.authOptions) ? h : {}),
                            auditLogs: Object.assign({}, null != (S = this.options.auditsOptions) ? S : {})
                        }
                    });
                    c.setInstance(d, this);
                    var f = C.for(d);
                    f.setAppName(d), this.setEntitlementsOptions(t.entitlementsOptions), this.setSessionContext({
                        enableSessionPerTenant: null == (s = t.authOptions) ? void 0 : s.enableSessionPerTenant,
                        skipUserLoading: null == (o = t.authOptions) ? void 0 : o.skipUserLoading
                    });
                    var m = t.basename;
                    m && f.setBasename(m);
                }
                var n, o, r, u;
                return l(a, [
                    {
                        key: "setEntitlementsOptions",
                        value: function(t) {
                            C.for(this.name).setEntitlementsOptions(Object.assign({}, t));
                        }
                    },
                    {
                        key: "setSessionContext",
                        value: function(t) {
                            C.for(this.name).setSessionContext(Object.assign({}, t));
                        }
                    },
                    {
                        key: "dispatchErrorByRequestName",
                        value: function(t, e) {
                            (null == t ? void 0 : t.statusCode) < 500 || this.store.dispatch({
                                type: "auth/setErrorByRequestName",
                                payload: {
                                    requestName: e,
                                    traceId: On(t)
                                }
                            });
                        }
                    },
                    {
                        key: "initContainers",
                        value: (u = p(y().mark(function t(e) {
                            return y().wrap(function(_t1) {
                                for(;;)switch(_t1.prev = _t1.next){
                                    case 0:
                                        this.adminPortalEl = e.adminPortalEl, this.loginBoxEl = e.loginBoxEl, this.checkoutDialogEl = e.checkoutDialogEl, this.adminPortalContainer = e.adminPortalContainer, this.loginBoxContainer = e.loginBoxContainer, this.checkoutDialogContainer = e.checkoutDialogContainer;
                                        try {
                                            "nextjs" !== this.options.framework && document.body.classList.add("frontegg-loading");
                                        } catch (t) {
                                            console.error("Failed to add frontegg-loading to body classList");
                                        }
                                        return _t1.next = 9, Promise.all([
                                            this.loadFeatureFlags(),
                                            this.loadAdminBoxMetadata(),
                                            this.requestAuthorize()
                                        ]);
                                    case 9:
                                        this.options.previewMode || this.options.customLoginBox || (this.loadLoginBox(), eg(this.name)), this.options.lazyLoadAdminPortal || this.loadScript("FronteggAdminPortal");
                                    case 11:
                                    case "end":
                                        return _t1.stop();
                                }
                            }, t, this);
                        })), function(t) {
                            return u.apply(this, arguments);
                        })
                    },
                    {
                        key: "updateMetadata",
                        value: function(t) {
                            var e;
                            qd.set(t, this.name), null != t && t.localizations && (null == (e = this.updateLocalizations) || e.call(this, t.localizations));
                        }
                    },
                    {
                        key: "addOnLoadedListener",
                        value: function(t) {
                            this.loading ? this.loadingListeners.push(t) : t();
                        }
                    },
                    {
                        key: "ready",
                        value: function(t) {
                            this.loading ? t() : this.addOnLoadedListener(t);
                        }
                    },
                    {
                        key: "loginWithRedirect",
                        value: function() {
                            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            this.store.dispatch({
                                type: "auth/setState",
                                payload: {
                                    isLoading: !0
                                }
                            }), this.store.dispatch({
                                type: "auth/requestHostedLoginAuthorize",
                                payload: t
                            });
                        }
                    },
                    {
                        key: "loginWithRedirectV2",
                        value: function(t) {
                            this.store.dispatch({
                                type: "auth/requestHostedLoginAuthorizeV2",
                                payload: t
                            });
                        }
                    },
                    {
                        key: "logout",
                        value: function(t) {
                            this.store.dispatch({
                                type: "auth/setState",
                                payload: {
                                    isLoading: !0
                                }
                            }), this.store.dispatch({
                                type: "auth/logout",
                                payload: t
                            });
                        }
                    },
                    {
                        key: "loadScript",
                        value: function(a) {
                            var n = this;
                            return new Promise(function(i, o) {
                                var r = window;
                                if (r[a]) i(r[a]);
                                else {
                                    var l = document.createElement("script");
                                    l.src = "".concat(n.cdnUrl, "/").concat({
                                        FronteggLoginBox: "login-box/index.js",
                                        FronteggAdminPortal: "admin-portal/index.js"
                                    }[a]), l.setAttribute("id", "".concat(a, "Script")), l.setAttribute("cdn-url", n.cdnUrl), l.onload = function() {
                                        r["".concat(a, "Init")] ? i(r["".concat(a, "Init")]({
                                            FronteggRestApi: t,
                                            FronteggTypes: s,
                                            FronteggReduxStore: e
                                        })) : i(r[a]);
                                    }, l.onerror = function(t) {
                                        console.log("Profile page error", t), o(t);
                                    }, document.body.append(l);
                                }
                            });
                        }
                    },
                    {
                        key: "loadLoginBox",
                        value: (r = p(y().mark(function t() {
                            return y().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return t.next = 2, this.loadScript("FronteggLoginBox");
                                    case 2:
                                        t.sent.render(this.loginBoxEl, {
                                            injector: this,
                                            options: this.options
                                        }), this.loading = !1, this.loadingListeners.forEach(function(_t1) {
                                            try {
                                                _t1();
                                            } catch (t) {
                                                console.error("Failed to call loadLoginBoxListener", t);
                                            }
                                        }), this.loadingListeners = [];
                                    case 7:
                                    case "end":
                                        return t.stop();
                                }
                            }, t, this);
                        })), function() {
                            return r.apply(this, arguments);
                        })
                    },
                    {
                        key: "showAdminPortal",
                        value: (o = p(y().mark(function t(e) {
                            var a, n, s, i, o;
                            return y().wrap(function(_t1) {
                                for(;;)switch(_t1.prev = _t1.next){
                                    case 0:
                                        return a = (null != e ? e : {
                                            isMultiApp: !1
                                        }).isMultiApp, n = this.queryFeatureFlags([
                                            "multi-apps-admin-portal"
                                        ]), s = d(n, 1), i = s[0], C.for(this.name).setRequestSource(Nt.AdminPortal), _t1.next = 5, this.loadScript("FronteggAdminPortal");
                                    case 5:
                                        o = _t1.sent, this.adminPortalRenderer = o.render(this.adminPortalEl, {
                                            injector: this,
                                            options: Object.assign({
                                                isMultiApp: i && a
                                            }, this.options)
                                        });
                                    case 7:
                                    case "end":
                                        return _t1.stop();
                                }
                            }, t, this);
                        })), function(t) {
                            return o.apply(this, arguments);
                        })
                    },
                    {
                        key: "openHostedAdminPortal",
                        value: function() {
                            var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], e = this.options.contextOptions.baseUrl, a = "".concat(e, "/oauth/portal");
                            t ? window.open(a, "_blank") : window.location.href = a;
                        }
                    },
                    {
                        key: "hideAdminPortal",
                        value: function() {
                            try {
                                var t, e = new URLSearchParams(window.location.search);
                                null == (t = this.adminPortalRenderer) || t.unmount(), Qd(e), C.for(this.name).setRequestSource(null);
                            } catch (t) {
                                console.error("Failed to unmount admin portal", t);
                            }
                        }
                    },
                    {
                        key: "showCheckoutDialog",
                        value: (n = p(y().mark(function t(e) {
                            var a;
                            return y().wrap(function(_t1) {
                                for(;;)switch(_t1.prev = _t1.next){
                                    case 0:
                                        return _t1.next = 2, this.loadScript("FronteggAdminPortal");
                                    case 2:
                                        a = _t1.sent, this.checkoutDialogRenderer = a.renderCheckoutDialog(this.checkoutDialogEl, Object.assign({
                                            injector: this
                                        }, e, {
                                            options: this.options
                                        }));
                                    case 4:
                                    case "end":
                                        return _t1.stop();
                                }
                            }, t, this);
                        })), function(t) {
                            return n.apply(this, arguments);
                        })
                    },
                    {
                        key: "hideCheckoutDialog",
                        value: function() {
                            try {
                                var t;
                                null == (t = this.checkoutDialogRenderer) || t.unmount();
                            } catch (t) {
                                console.error("Failed to unmount checkout dialog", t);
                            }
                        }
                    },
                    {
                        key: "getFeatureEntitlements",
                        value: function(t, e) {
                            var a = this.getEntitlementsQueryData(e), n = a.entitlements, s = a.attributes;
                            return Zi(n, t, s);
                        }
                    },
                    {
                        key: "getPermissionEntitlements",
                        value: function(t, e) {
                            var a = this.getEntitlementsQueryData(e), n = a.entitlements, s = a.attributes;
                            return Qi(n, t, s);
                        }
                    },
                    {
                        key: "getEntitlements",
                        value: function(t, e) {
                            return "permissionKey" in t ? this.getPermissionEntitlements(t.permissionKey, e) : this.getFeatureEntitlements(t.featureKey, e);
                        }
                    },
                    {
                        key: "loadEntitlements",
                        value: function(t) {
                            this.store.dispatch({
                                type: "auth/loadEntitlements",
                                payload: {
                                    callback: t
                                }
                            });
                        }
                    },
                    {
                        key: "stepUp",
                        value: function(t) {
                            var e = this.store.getState(), a = (null == e ? void 0 : e.auth) || {}, n = a.hostedLoginBox, s = a.routes.stepUpUrl;
                            n ? this.store.dispatch({
                                type: "auth/stepUpHostedLogin",
                                payload: t
                            }) : ds(s, e.auth.onRedirectTo, null == t ? void 0 : t.maxAge);
                        }
                    },
                    {
                        key: "isSteppedUp",
                        value: function() {
                            var t, e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, a = ((null == (t = this.store.getState()) ? void 0 : t.auth) || {}).user;
                            return cs(a, e);
                        }
                    },
                    {
                        key: "switchTenant",
                        value: function(t) {
                            this.store.dispatch({
                                type: "auth/switchTenant",
                                payload: t
                            });
                        }
                    },
                    {
                        key: "close",
                        value: function() {
                            this.hideAdminPortal(), this.hideCheckoutDialog();
                        }
                    }
                ]), a;
            }(), sg = function() {
                function t() {
                    i(this, t);
                }
                return l(t, null, [
                    {
                        key: "setAuthentication",
                        value: function(t, e, a) {
                            var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "default", s = c.getInstance(n), i = C.for(n);
                            t && e ? (i.setAccessToken(e), i.setUser(Object.assign({}, a, {
                                accessToken: e
                            })), s.store.actions.setAuthState({
                                isLoading: !1,
                                isAuthenticated: t,
                                user: a
                            }), s.store.actions.loadTenants()) : (i.setAccessToken(null), i.setUser(null), s.store.actions.setAuthState({
                                isLoading: !1,
                                isAuthenticated: !1,
                                user: null
                            }));
                        }
                    }
                ]), t;
            }(), ig = function() {
                function t() {
                    i(this, t);
                }
                return l(t, null, [
                    {
                        key: "show",
                        value: function() {
                            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "default";
                            c.getInstance(t).showAdminPortal();
                        }
                    },
                    {
                        key: "showMultiApp",
                        value: function() {
                            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "default";
                            c.getInstance(t).showAdminPortal({
                                isMultiApp: !0
                            });
                        }
                    },
                    {
                        key: "openHosted",
                        value: function() {
                            var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default";
                            c.getInstance(e).openHostedAdminPortal(t);
                        }
                    },
                    {
                        key: "hide",
                        value: function() {
                            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "default";
                            c.getInstance(t).hideAdminPortal();
                        }
                    }
                ]), t;
            }(), og = function() {
                function t() {
                    i(this, t);
                }
                return l(t, null, [
                    {
                        key: "show",
                        value: function(t) {
                            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default";
                            c.getInstance(e).showCheckoutDialog(t);
                        }
                    },
                    {
                        key: "hide",
                        value: function() {
                            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "default";
                            c.getInstance(t).hideCheckoutDialog();
                        }
                    }
                ]), t;
            }(), rg = function(t) {
                var e;
                return null != (e = window.FronteggAdminPortal.adminPortalStaticThemesDefaults[t]) ? e : void 0;
            }, lg = function() {
                function t(e, a, n, s) {
                    var o = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4];
                    i(this, t), this.app = void 0, this.options = void 0, this.store = void 0, this.setRoute = function() {}, this.themeSetter = void 0, this.themeOptions = {};
                    var r = {
                        baseUrl: "preview"
                    };
                    if (n) {
                        if (this.store = n, !o && n.getState().root.appName !== e) throw Error("Mismatch in store names");
                    } else this.store = bd({
                        context: r,
                        appName: e
                    }, this, !0, void 0, void 0, !0);
                    this.options = Object.assign({
                        themeOptions: a,
                        iframeRendering: !0,
                        metadata: {},
                        previewMode: !0,
                        builderMode: !0,
                        store: this.store,
                        contextOptions: r
                    }, s), this.app = new ng(this.options, e, !0), qd.set({}, e);
                }
                var e;
                return l(t, [
                    {
                        key: "render",
                        value: (e = p(y().mark(function t(e) {
                            var a, n, s, i, o = this;
                            return y().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return (a = e.querySelector("#root")) || ((a = e.ownerDocument.createElement("div")).setAttribute("id", "root"), e.appendChild(a)), this.app.adminPortalContainer = e, this.app.adminPortalEl = a, n = function(t) {
                                            o.themeSetter = t;
                                        }, s = function(_t1) {
                                            o.setRoute = _t1;
                                        }, t.next = 8, this.app.loadScript("FronteggAdminPortal");
                                    case 8:
                                        return i = t.sent, this.app.adminPortalRenderer = i.renderPage(a, {
                                            options: this.options,
                                            injector: this.app,
                                            setThemeSetter: n,
                                            setStaticRouteSetter: s
                                        }), this.app.loading = !1, t.next = 13, Xd(this);
                                    case 13:
                                    case "end":
                                        return t.stop();
                                }
                            }, t, this);
                        })), function(t) {
                            return e.apply(this, arguments);
                        })
                    },
                    {
                        key: "setStaticRoute",
                        value: function(t) {
                            var e;
                            null == (e = this.setRoute) || e.call(this, t);
                        }
                    },
                    {
                        key: "unmount",
                        value: function() {
                            try {
                                var t;
                                null == (t = this.app.adminPortalRenderer) || t.unmount();
                            } catch (t) {
                                console.error("Failed to unmount admin Portal renderer", t);
                            }
                        }
                    },
                    {
                        key: "setTheme",
                        value: function(t) {
                            var e;
                            this.themeOptions = t, this.themeSetter || console.warn("this.themeSetter is not defined yet"), null == (e = this.themeSetter) || e.call(this, this.themeOptions);
                        }
                    }
                ]), t;
            }(), cg = "modern", ug = function(t) {
                var e, a = window.FronteggAdminPortal.themes;
                return null != (e = a[t]) ? e : a[cg];
            }, dg = function() {
                function t(e, a, n, s) {
                    var o = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4];
                    i(this, t), this.app = void 0, this.options = void 0, this.store = void 0, this.themeSetter = void 0, this.setRoute = function() {}, this.themeOptions = {};
                    var r = {
                        baseUrl: "preview"
                    };
                    if (n) {
                        if (this.store = n, !o && n.getState().root.appName !== e) throw Error("Mismatch in store names");
                    } else this.store = bd({
                        context: r,
                        appName: e
                    }, this, !0, void 0, void 0, !0);
                    this.options = Object.assign({
                        themeOptions: a,
                        iframeRendering: !0,
                        metadata: {},
                        previewMode: !0,
                        builderMode: !0,
                        store: this.store,
                        contextOptions: r,
                        onRedirectTo: function() {
                            console.debug("path");
                        }
                    }, s), this.app = new ng(this.options, e, !0, o), qd.set({}, e);
                }
                var e;
                return l(t, [
                    {
                        key: "render",
                        value: (e = p(y().mark(function t(e) {
                            var a, n, s, i, o = this;
                            return y().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return (a = e.querySelector("#root")) || ((a = e.ownerDocument.createElement("div")).setAttribute("id", "root"), e.appendChild(a)), this.app.loginBoxContainer = e, this.app.loginBoxEl = a, n = function(t) {
                                            o.themeSetter = t;
                                        }, s = function(_t1) {
                                            o.setRoute = _t1;
                                        }, t.next = 8, this.app.loadScript("FronteggLoginBox");
                                    case 8:
                                        return i = t.sent, this.app.loginBoxRenderer = i.renderPage(a, {
                                            options: this.options,
                                            injector: this.app,
                                            setThemeSetter: n,
                                            setStaticRouteSetter: s,
                                            staticRoute: "/account/login"
                                        }), t.next = 12, Xd(this);
                                    case 12:
                                    case "end":
                                        return t.stop();
                                }
                            }, t, this);
                        })), function(t) {
                            return e.apply(this, arguments);
                        })
                    },
                    {
                        key: "unmount",
                        value: function() {
                            try {
                                var t;
                                null == (t = this.app.loginBoxRenderer) || t.unmount();
                            } catch (t) {
                                console.error("Failed to unmount login box renderer", t);
                            }
                        }
                    },
                    {
                        key: "setTheme",
                        value: function(t) {
                            var e;
                            this.themeOptions = t, this.themeSetter || console.warn("this.themeSetter is not defined yet"), null == (e = this.themeSetter) || e.call(this, this.themeOptions);
                        }
                    },
                    {
                        key: "setStaticRoute",
                        value: function(t) {
                            var e;
                            this.setRoute || console.warn("this.setRoute is not defined yet"), null == (e = this.setRoute) || e.call(this, t);
                        }
                    },
                    {
                        key: "setStore",
                        value: function(t) {
                            this.store.dispatch({
                                type: "auth/setState",
                                payload: t
                            });
                        }
                    }
                ]), t;
            }();
            function gg(t, e) {
                return gg = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
                    return t.__proto__ = e, t;
                }, gg(t, e);
            }
            function pg(t) {
                return pg = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                }, pg(t);
            }
            function hg(t, e, a) {
                return hg = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }() ? Reflect.construct.bind() : function(t, e, a) {
                    var n = [
                        null
                    ];
                    n.push.apply(n, e);
                    var s = new (Function.bind.apply(t, n));
                    return a && gg(s, a.prototype), s;
                }, hg.apply(null, arguments);
            }
            function yg(t) {
                var e = "function" == typeof Map ? new Map : void 0;
                return yg = function(t) {
                    if (null === t || (a = t, -1 === Function.toString.call(a).indexOf("[native code]"))) return t;
                    var a;
                    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                    if (void 0 !== e) {
                        if (e.has(t)) return e.get(t);
                        e.set(t, n);
                    }
                    function n() {
                        return hg(t, arguments, pg(this).constructor);
                    }
                    return n.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: n,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), gg(n, t);
                }, yg(t);
            }
            function Sg(t) {
                var e = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }();
                return function() {
                    var a, n = pg(t);
                    if (e) {
                        var s = pg(this).constructor;
                        a = Reflect.construct(n, arguments, s);
                    } else a = n.apply(this, arguments);
                    return function(t, e) {
                        if (e && ("object" === o(e) || "function" == typeof e)) return e;
                        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(t) {
                            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return t;
                        }(t);
                    }(this, a);
                };
            }
            var vg = function(t) {
                var e = new ng(t, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default");
                if ("undefined" != typeof document) {
                    var a;
                    if (!t.contextOptions.baseUrl) {
                        var n = new Error('Edit <FronteggProvider/> options { ContextOptions: { baseUrl: "" } } in order to connect your application');
                        throw document.body.innerHTML = "", alert(n.message), n;
                    }
                    if (!customElements.get("frontegg-app")) {
                        var s = function(t) {
                            !function(t, e) {
                                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                                t.prototype = Object.create(e && e.prototype, {
                                    constructor: {
                                        value: t,
                                        writable: !0,
                                        configurable: !0
                                    }
                                }), Object.defineProperty(t, "prototype", {
                                    writable: !1
                                }), e && gg(t, e);
                            }(a, t);
                            var e = Sg(a);
                            function a() {
                                var t;
                                i(this, a);
                                for(var n = arguments.length, s = new Array(n), o = 0; o < n; o++)s[o] = arguments[o];
                                return (t = e.call.apply(e, [
                                    this
                                ].concat(s))).app = null, t;
                            }
                            return l(a, [
                                {
                                    key: "connectedCallback",
                                    value: function() {
                                        this.updateContent();
                                    }
                                },
                                {
                                    key: "attributeChangedCallback",
                                    value: function(t, e, a) {
                                        if ("app-name" === t) {
                                            if (null === e) return;
                                            if (e === a) return;
                                            this.innerHTML = "", null === a ? this.remove() : this.updateContent();
                                        }
                                        console.debug("attributeChangedCallback", t, e, a);
                                    }
                                },
                                {
                                    key: "updateContent",
                                    value: function() {
                                        var t, e = null != (t = this.getAttribute("app-name")) ? t : "default", a = c.getInstance(e);
                                        if (null === a) throw Error("FronteggApp not found for appName: '".concat(e, "'"));
                                        this.setAttribute("id", "frontegg-app-".concat(a.name));
                                        var n = Yd(this, "div", {
                                            id: "frontegg-admin-portal-container-".concat(a.name)
                                        }), s = Yd(this, "div", {
                                            id: "frontegg-login-box-container-".concat(a.name)
                                        }), i = Yd(this, "div", {
                                            id: "frontegg-checkout-dialog-container-".concat(a.name)
                                        }), o = n.attachShadow({
                                            mode: "open"
                                        }), r = s.attachShadow({
                                            mode: "open"
                                        }), l = i.attachShadow({
                                            mode: "open"
                                        }), u = Yd(o, "div", {
                                            id: "frontegg-admin-portal-".concat(a.name),
                                            class: "frontegg-root-content"
                                        }), d = Yd(r, "div", {
                                            id: "frontegg-login-box-".concat(a.name),
                                            class: "frontegg-root-content"
                                        }), g = Yd(l, "div", {
                                            id: "frontegg-checkout-dialog-".concat(a.name),
                                            class: "frontegg-root-content"
                                        });
                                        a.initContainers({
                                            adminPortalEl: u,
                                            loginBoxEl: d,
                                            adminPortalContainer: n,
                                            loginBoxContainer: s,
                                            checkoutDialogContainer: i,
                                            checkoutDialogEl: g
                                        });
                                    }
                                }
                            ], [
                                {
                                    key: "observedAttributes",
                                    get: function() {
                                        return [
                                            "app-name"
                                        ];
                                    }
                                }
                            ]), a;
                        }(yg(HTMLElement));
                        customElements.define("frontegg-app", s);
                    }
                    null == (a = document.querySelector('frontegg-app[app-name="'.concat(e.name, '"]'))) || a.remove();
                    var o = document.createElement("frontegg-app");
                    o.setAttribute("app-name", e.name), document.body.appendChild(o);
                }
                return e;
            };
        })(), n;
    })());

//# sourceMappingURL=provider-portal.a59d347d.js.map
